import { useQuery, UseQueryOptions } from '@tanstack/react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };

function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(
      'https://cg.optimizely.com/content/v2?auth=pcZfBa1JEeUt3xYzJJE1kGmOaqXu2OMELLhr2acNjMjoZARU',
      {
        method: 'POST',
        body: JSON.stringify({ query, variables })
      }
    );

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  };
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Bool: { input: any; output: any };
  Date: { input: any; output: any };
};

/** telling about the author's details */
export type AboutAuthor = IContent &
  IData & {
    __typename?: 'AboutAuthor';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    AuthorArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** telling about the author's details */
export type AboutAuthorAuthorAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** telling about the author's details */
export type AboutAuthorHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** telling about the author's details */
export type AboutAuthorNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** telling about the author's details */
export type AboutAuthor_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** telling about the author's details */
export type AboutAuthor_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type AboutAuthorAutocomplete = {
  __typename?: 'AboutAuthorAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AboutAuthorAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AboutAuthorAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AboutAuthorAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AboutAuthorAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AboutAuthorAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AboutAuthorAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AboutAuthorAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AboutAuthorAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AboutAuthorAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AboutAuthorAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AboutAuthorAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AboutAuthorAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AboutAuthorAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AboutAuthorFacet = {
  __typename?: 'AboutAuthorFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AuthorArea?: Maybe<ContentAreaItemModelSearchFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type AboutAuthorFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AboutAuthorFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AboutAuthorFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AboutAuthorFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AboutAuthorFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AboutAuthorFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AboutAuthorFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AboutAuthorFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AboutAuthorFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AboutAuthorFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AboutAuthorFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AboutAuthorFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AboutAuthorFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AboutAuthorFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AboutAuthorFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AboutAuthorFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AboutAuthorFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AboutAuthorFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AboutAuthorFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AboutAuthorFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AboutAuthorFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AboutAuthorFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AboutAuthorFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AboutAuthorFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AboutAuthorFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type AboutAuthorOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AuthorArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type AboutAuthorOutput = {
  __typename?: 'AboutAuthorOutput';
  autocomplete?: Maybe<AboutAuthorAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<AboutAuthorFacet>;
  item?: Maybe<AboutAuthor>;
  items?: Maybe<Array<Maybe<AboutAuthor>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type AboutAuthorOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AboutAuthorWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AuthorArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<AboutAuthorWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<AboutAuthorWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<AboutAuthorWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Module that displays content within an accordions, that can be opened or closed. */
export type AccordionBlock = IContent &
  IData & {
    __typename?: 'AccordionBlock';
    AccordionSections?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Module that displays content within an accordions, that can be opened or closed. */
export type AccordionBlockAccordionSectionsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Module that displays content within an accordions, that can be opened or closed. */
export type AccordionBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Module that displays content within an accordions, that can be opened or closed. */
export type AccordionBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Module that displays content within an accordions, that can be opened or closed. */
export type AccordionBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Module that displays content within an accordions, that can be opened or closed. */
export type AccordionBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Module that displays content within an accordions, that can be opened or closed. */
export type AccordionBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type AccordionBlockAutocomplete = {
  __typename?: 'AccordionBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AccordionBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccordionBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccordionBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccordionBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccordionBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccordionBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccordionBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccordionBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccordionBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccordionBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccordionBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccordionBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccordionBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccordionBlockFacet = {
  __typename?: 'AccordionBlockFacet';
  AccordionSections?: Maybe<ContentAreaItemModelSearchFacet>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type AccordionBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AccordionBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AccordionBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AccordionBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AccordionBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AccordionBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AccordionBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type AccordionBlockOrderByInput = {
  AccordionSections?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type AccordionBlockOutput = {
  __typename?: 'AccordionBlockOutput';
  autocomplete?: Maybe<AccordionBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<AccordionBlockFacet>;
  item?: Maybe<AccordionBlock>;
  items?: Maybe<Array<Maybe<AccordionBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type AccordionBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccordionBlockWhereInput = {
  AccordionSections?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<AccordionBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<AccordionBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<AccordionBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Accordion Section with Headline and Body that can be added to an Accordion container. */
export type AccordionSectionBlock = IContent &
  IData & {
    __typename?: 'AccordionSectionBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Body?: Maybe<Scalars['String']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Accordion Section with Headline and Body that can be added to an Accordion container. */
export type AccordionSectionBlockBodyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Accordion Section with Headline and Body that can be added to an Accordion container. */
export type AccordionSectionBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Accordion Section with Headline and Body that can be added to an Accordion container. */
export type AccordionSectionBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Accordion Section with Headline and Body that can be added to an Accordion container. */
export type AccordionSectionBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Accordion Section with Headline and Body that can be added to an Accordion container. */
export type AccordionSectionBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type AccordionSectionBlockAutocomplete = {
  __typename?: 'AccordionSectionBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AccordionSectionBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccordionSectionBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccordionSectionBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccordionSectionBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccordionSectionBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccordionSectionBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccordionSectionBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccordionSectionBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccordionSectionBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccordionSectionBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccordionSectionBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccordionSectionBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccordionSectionBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccordionSectionBlockFacet = {
  __typename?: 'AccordionSectionBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Body?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type AccordionSectionBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionSectionBlockFacetBodyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionSectionBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AccordionSectionBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionSectionBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AccordionSectionBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionSectionBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionSectionBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionSectionBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionSectionBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionSectionBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionSectionBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AccordionSectionBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionSectionBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionSectionBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionSectionBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionSectionBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AccordionSectionBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionSectionBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionSectionBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionSectionBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AccordionSectionBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionSectionBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AccordionSectionBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionSectionBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccordionSectionBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type AccordionSectionBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Body?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type AccordionSectionBlockOutput = {
  __typename?: 'AccordionSectionBlockOutput';
  autocomplete?: Maybe<AccordionSectionBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<AccordionSectionBlockFacet>;
  item?: Maybe<AccordionSectionBlock>;
  items?: Maybe<Array<Maybe<AccordionSectionBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type AccordionSectionBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccordionSectionBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Body?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<AccordionSectionBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<AccordionSectionBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<AccordionSectionBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Listing the Advisors on the site */
export type AdvisorListingBlock = IContent &
  IData & {
    __typename?: 'AdvisorListingBlock';
    AdvisorSearchTitle?: Maybe<Scalars['String']['output']>;
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    ByLocationTabLabel?: Maybe<Scalars['String']['output']>;
    ByNameTabLabel?: Maybe<Scalars['String']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    FilterByText?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MainImage?: Maybe<ContentModelReference>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    /** Text to display when user clicks on Meet Advisor link. Format is 'Meet Text' Advisor First Name. */
    MeetAdvisorText?: Maybe<Scalars['String']['output']>;
    MilesAwayLabel?: Maybe<Scalars['String']['output']>;
    Name?: Maybe<Scalars['String']['output']>;
    NoResultsMessage?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    /** Request Appointment link comes from Reference Page Settings. */
    RequestAppointmentText?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    SearchBarInputTextByLocation?: Maybe<Scalars['String']['output']>;
    SearchBarInputTextByName?: Maybe<Scalars['String']['output']>;
    SearchButtonLabel?: Maybe<Scalars['String']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    ShowingAllLabel?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Listing the Advisors on the site */
export type AdvisorListingBlockAdvisorSearchTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Advisors on the site */
export type AdvisorListingBlockByLocationTabLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Advisors on the site */
export type AdvisorListingBlockByNameTabLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Advisors on the site */
export type AdvisorListingBlockFilterByTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Advisors on the site */
export type AdvisorListingBlockMeetAdvisorTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Advisors on the site */
export type AdvisorListingBlockMilesAwayLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Advisors on the site */
export type AdvisorListingBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Advisors on the site */
export type AdvisorListingBlockNoResultsMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Advisors on the site */
export type AdvisorListingBlockRequestAppointmentTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Advisors on the site */
export type AdvisorListingBlockSearchBarInputTextByLocationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Advisors on the site */
export type AdvisorListingBlockSearchBarInputTextByNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Advisors on the site */
export type AdvisorListingBlockSearchButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Advisors on the site */
export type AdvisorListingBlockShowingAllLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Advisors on the site */
export type AdvisorListingBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Advisors on the site */
export type AdvisorListingBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type AdvisorListingBlockAutocomplete = {
  __typename?: 'AdvisorListingBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MainImage?: Maybe<ContentModelReferenceAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AdvisorListingBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AdvisorListingBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AdvisorListingBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AdvisorListingBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AdvisorListingBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AdvisorListingBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AdvisorListingBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AdvisorListingBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AdvisorListingBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AdvisorListingBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AdvisorListingBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AdvisorListingBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AdvisorListingBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AdvisorListingBlockFacet = {
  __typename?: 'AdvisorListingBlockFacet';
  AdvisorSearchTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  ByLocationTabLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ByNameTabLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FilterByText?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainImage?: Maybe<ContentModelReferenceFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MeetAdvisorText?: Maybe<Array<Maybe<StringFacet>>>;
  MilesAwayLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NoResultsMessage?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RequestAppointmentText?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchBarInputTextByLocation?: Maybe<Array<Maybe<StringFacet>>>;
  SearchBarInputTextByName?: Maybe<Array<Maybe<StringFacet>>>;
  SearchButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  ShowingAllLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type AdvisorListingBlockFacetAdvisorSearchTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorListingBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorListingBlockFacetByLocationTabLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorListingBlockFacetByNameTabLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorListingBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AdvisorListingBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorListingBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AdvisorListingBlockFacetFilterByTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorListingBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorListingBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorListingBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorListingBlockFacetMeetAdvisorTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorListingBlockFacetMilesAwayLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorListingBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorListingBlockFacetNoResultsMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorListingBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorListingBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AdvisorListingBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorListingBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorListingBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorListingBlockFacetRequestAppointmentTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorListingBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorListingBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AdvisorListingBlockFacetSearchBarInputTextByLocationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorListingBlockFacetSearchBarInputTextByNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorListingBlockFacetSearchButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorListingBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorListingBlockFacetShowingAllLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorListingBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorListingBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorListingBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AdvisorListingBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorListingBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AdvisorListingBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorListingBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorListingBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type AdvisorListingBlockOrderByInput = {
  AdvisorSearchTitle?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  ByLocationTabLabel?: InputMaybe<OrderBy>;
  ByNameTabLabel?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FilterByText?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MeetAdvisorText?: InputMaybe<OrderBy>;
  MilesAwayLabel?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NoResultsMessage?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RequestAppointmentText?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchBarInputTextByLocation?: InputMaybe<OrderBy>;
  SearchBarInputTextByName?: InputMaybe<OrderBy>;
  SearchButtonLabel?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  ShowingAllLabel?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type AdvisorListingBlockOutput = {
  __typename?: 'AdvisorListingBlockOutput';
  autocomplete?: Maybe<AdvisorListingBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<AdvisorListingBlockFacet>;
  item?: Maybe<AdvisorListingBlock>;
  items?: Maybe<Array<Maybe<AdvisorListingBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type AdvisorListingBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdvisorListingBlockWhereInput = {
  AdvisorSearchTitle?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  ByLocationTabLabel?: InputMaybe<SearchableStringFilterInput>;
  ByNameTabLabel?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FilterByText?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainImage?: InputMaybe<ContentModelReferenceWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MeetAdvisorText?: InputMaybe<SearchableStringFilterInput>;
  MilesAwayLabel?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NoResultsMessage?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RequestAppointmentText?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchBarInputTextByLocation?: InputMaybe<SearchableStringFilterInput>;
  SearchBarInputTextByName?: InputMaybe<SearchableStringFilterInput>;
  SearchButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  ShowingAllLabel?: InputMaybe<SearchableStringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<AdvisorListingBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<AdvisorListingBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<AdvisorListingBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPage = IContent &
  IData & {
    __typename?: 'AdvisorPage';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    AuthorMetaData?: Maybe<Scalars['String']['output']>;
    BreadcrumbsTitle?: Maybe<Scalars['String']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Certifications?: Maybe<Scalars['String']['output']>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContactEmail?: Maybe<Scalars['String']['output']>;
    ContactPhone?: Maybe<Scalars['String']['output']>;
    ContentBlock?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    DisableIndexing?: Maybe<Scalars['Bool']['output']>;
    /** This will determine whether or not to show on search. */
    ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
    /** This will determine whether or not to show on the Sitemap. */
    ExcludeFromSitemap?: Maybe<Scalars['Bool']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    FirstName?: Maybe<Scalars['String']['output']>;
    FooterOverride?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    HeaderOverride?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    /** This will determine whether or not to be dispalyed in breadcrumbs. */
    HideInBreadcrumbs?: Maybe<Scalars['Bool']['output']>;
    HideSiteFooter?: Maybe<Scalars['Bool']['output']>;
    HideSiteHeader?: Maybe<Scalars['Bool']['output']>;
    Highlight?: Maybe<Scalars['Bool']['output']>;
    Industry?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Keywords?: Maybe<Scalars['String']['output']>;
    /** Container for Schema Field */
    LDJsonContainer?: Maybe<Scalars['String']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    LastName?: Maybe<Scalars['String']['output']>;
    ListingShortDescription?: Maybe<Scalars['String']['output']>;
    MainContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    MetaContentType?: Maybe<Scalars['String']['output']>;
    MetaTitle?: Maybe<Scalars['String']['output']>;
    Name?: Maybe<Scalars['String']['output']>;
    NavigationTitle?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Description value that has been managed for the current page */
    OpenGraphDescription?: Maybe<Scalars['String']['output']>;
    /** Page template will always inherit the OpenGraph image from the parent page, recursively, until an image is managed for the current page */
    OpenGraphImage?: Maybe<ContentModelReference>;
    /** If managed, this field will overwrite the Image Height value that has been managed for the current page */
    OpenGraphImageHeight?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Image Type value that has been managed for the current page */
    OpenGraphImageType?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Image Width  value that has been managed for the current page */
    OpenGraphImageWidth?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Site value that has been managed for the current page */
    OpenGraphSite?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Title value that has been managed for the current page */
    OpenGraphTitle?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Url value that has been managed for the current page */
    OpenGraphUrl?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Type value that has been managed for the current page */
    OpenGraphtype?: Maybe<Scalars['String']['output']>;
    OtherLocationsPages?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    PageDescription?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    Picture?: Maybe<ContentModelReference>;
    PrimaryLocation?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    ShortDescriptionForAdvisorsAtBranch?: Maybe<Scalars['String']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SignUpToNewsletterForm?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SimpleMasthead?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    TeaserText?: Maybe<Scalars['String']['output']>;
    Title?: Maybe<Scalars['String']['output']>;
    Topic?: Maybe<FilterCategoryModel>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageAuthorMetaDataArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageCertificationsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageContactEmailArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageContactPhoneArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageContentBlockArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageFirstNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageFooterOverrideArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageHeaderOverrideArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageIndustryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageKeywordsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageLdJsonContainerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageLastNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageListingShortDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageMainContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageMetaContentTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageNavigationTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageOpenGraphDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageOpenGraphImageHeightArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageOpenGraphImageTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageOpenGraphImageWidthArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageOpenGraphSiteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageOpenGraphTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageOpenGraphUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageOpenGraphtypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageOtherLocationsPagesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPagePageDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageShortDescriptionForAdvisorsAtBranchArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageSignUpToNewsletterFormArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageSimpleMastheadArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageTeaserTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPageTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with financial advisor's description and contact details. */
export type AdvisorPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type AdvisorPageAutocomplete = {
  __typename?: 'AdvisorPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  OpenGraphImage?: Maybe<ContentModelReferenceAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  Picture?: Maybe<ContentModelReferenceAutocomplete>;
  PrimaryLocation?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Topic?: Maybe<FilterCategoryModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AdvisorPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AdvisorPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AdvisorPageAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AdvisorPageAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AdvisorPageAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AdvisorPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AdvisorPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AdvisorPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AdvisorPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AdvisorPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AdvisorPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AdvisorPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AdvisorPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AdvisorPageFacet = {
  __typename?: 'AdvisorPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AuthorMetaData?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Certifications?: Maybe<Array<Maybe<StringFacet>>>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContactEmail?: Maybe<Array<Maybe<StringFacet>>>;
  ContactPhone?: Maybe<Array<Maybe<StringFacet>>>;
  ContentBlock?: Maybe<ContentAreaItemModelSearchFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DisableIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSitemap?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FirstName?: Maybe<Array<Maybe<StringFacet>>>;
  FooterOverride?: Maybe<ContentAreaItemModelSearchFacet>;
  HeaderOverride?: Maybe<ContentAreaItemModelSearchFacet>;
  HideInBreadcrumbs?: Maybe<Array<Maybe<StringFacet>>>;
  HideSiteFooter?: Maybe<Array<Maybe<StringFacet>>>;
  HideSiteHeader?: Maybe<Array<Maybe<StringFacet>>>;
  Highlight?: Maybe<Array<Maybe<StringFacet>>>;
  Industry?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Keywords?: Maybe<Array<Maybe<StringFacet>>>;
  LDJsonContainer?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LastName?: Maybe<Array<Maybe<StringFacet>>>;
  ListingShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MainContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaContentType?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NavigationTitle?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphDescription?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphImage?: Maybe<ContentModelReferenceFacet>;
  OpenGraphImageHeight?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphImageType?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphImageWidth?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphSite?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphTitle?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphUrl?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphtype?: Maybe<Array<Maybe<StringFacet>>>;
  OtherLocationsPages?: Maybe<ContentAreaItemModelSearchFacet>;
  PageDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  Picture?: Maybe<ContentModelReferenceFacet>;
  PrimaryLocation?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  ShortDescriptionForAdvisorsAtBranch?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SignUpToNewsletterForm?: Maybe<ContentAreaItemModelSearchFacet>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleMasthead?: Maybe<ContentAreaItemModelSearchFacet>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TeaserText?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Topic?: Maybe<FilterCategoryModelFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type AdvisorPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetAuthorMetaDataArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetCertificationsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AdvisorPageFacetContactEmailArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetContactPhoneArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AdvisorPageFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetDisableIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetExcludeFromSitemapArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetFirstNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetHideInBreadcrumbsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetHideSiteFooterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetHideSiteHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetHighlightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetIndustryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetKeywordsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetLdJsonContainerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetLastNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetListingShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetMetaContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetNavigationTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetOpenGraphDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetOpenGraphImageHeightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetOpenGraphImageTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetOpenGraphImageWidthArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetOpenGraphSiteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetOpenGraphTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetOpenGraphUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetOpenGraphtypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetPageDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AdvisorPageFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AdvisorPageFacetShortDescriptionForAdvisorsAtBranchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AdvisorPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AdvisorPageFacetTeaserTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AdvisorPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type AdvisorPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AuthorMetaData?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Certifications?: InputMaybe<OrderBy>;
  Changed?: InputMaybe<OrderBy>;
  ContactEmail?: InputMaybe<OrderBy>;
  ContactPhone?: InputMaybe<OrderBy>;
  ContentBlock?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DisableIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExcludeFromSitemap?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FirstName?: InputMaybe<OrderBy>;
  FooterOverride?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  HeaderOverride?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  HideInBreadcrumbs?: InputMaybe<OrderBy>;
  HideSiteFooter?: InputMaybe<OrderBy>;
  HideSiteHeader?: InputMaybe<OrderBy>;
  Highlight?: InputMaybe<OrderBy>;
  Industry?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Keywords?: InputMaybe<OrderBy>;
  LDJsonContainer?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LastName?: InputMaybe<OrderBy>;
  ListingShortDescription?: InputMaybe<OrderBy>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaContentType?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NavigationTitle?: InputMaybe<OrderBy>;
  OpenGraphDescription?: InputMaybe<OrderBy>;
  OpenGraphImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  OpenGraphImageHeight?: InputMaybe<OrderBy>;
  OpenGraphImageType?: InputMaybe<OrderBy>;
  OpenGraphImageWidth?: InputMaybe<OrderBy>;
  OpenGraphSite?: InputMaybe<OrderBy>;
  OpenGraphTitle?: InputMaybe<OrderBy>;
  OpenGraphUrl?: InputMaybe<OrderBy>;
  OpenGraphtype?: InputMaybe<OrderBy>;
  OtherLocationsPages?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  PageDescription?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Picture?: InputMaybe<ContentModelReferenceOrderByInput>;
  PrimaryLocation?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  ShortDescriptionForAdvisorsAtBranch?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SignUpToNewsletterForm?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SimpleMasthead?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TeaserText?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Topic?: InputMaybe<FilterCategoryModelOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type AdvisorPageOutput = {
  __typename?: 'AdvisorPageOutput';
  autocomplete?: Maybe<AdvisorPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<AdvisorPageFacet>;
  item?: Maybe<AdvisorPage>;
  items?: Maybe<Array<Maybe<AdvisorPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type AdvisorPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdvisorPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AuthorMetaData?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Certifications?: InputMaybe<SearchableStringFilterInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContactEmail?: InputMaybe<SearchableStringFilterInput>;
  ContactPhone?: InputMaybe<SearchableStringFilterInput>;
  ContentBlock?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DisableIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExcludeFromSitemap?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FirstName?: InputMaybe<SearchableStringFilterInput>;
  FooterOverride?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  HeaderOverride?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  HideInBreadcrumbs?: InputMaybe<BoolFilterInput>;
  HideSiteFooter?: InputMaybe<BoolFilterInput>;
  HideSiteHeader?: InputMaybe<BoolFilterInput>;
  Highlight?: InputMaybe<BoolFilterInput>;
  Industry?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Keywords?: InputMaybe<SearchableStringFilterInput>;
  LDJsonContainer?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LastName?: InputMaybe<SearchableStringFilterInput>;
  ListingShortDescription?: InputMaybe<SearchableStringFilterInput>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaContentType?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NavigationTitle?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphDescription?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphImage?: InputMaybe<ContentModelReferenceWhereInput>;
  OpenGraphImageHeight?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphImageType?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphImageWidth?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphSite?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphTitle?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphUrl?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphtype?: InputMaybe<SearchableStringFilterInput>;
  OtherLocationsPages?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  PageDescription?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Picture?: InputMaybe<ContentModelReferenceWhereInput>;
  PrimaryLocation?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  ShortDescriptionForAdvisorsAtBranch?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SignUpToNewsletterForm?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SimpleMasthead?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TeaserText?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Topic?: InputMaybe<FilterCategoryModelWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<AdvisorPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<AdvisorPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<AdvisorPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Banner that appear at the top of pages, providing a prominent space for important announcements. */
export type AlertBannerBlock = IContent &
  IData & {
    __typename?: 'AlertBannerBlock';
    AlertType?: Maybe<Scalars['String']['output']>;
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    BodyCopy?: Maybe<Scalars['String']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Heading?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Banner that appear at the top of pages, providing a prominent space for important announcements. */
export type AlertBannerBlockAlertTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Banner that appear at the top of pages, providing a prominent space for important announcements. */
export type AlertBannerBlockBodyCopyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Banner that appear at the top of pages, providing a prominent space for important announcements. */
export type AlertBannerBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Banner that appear at the top of pages, providing a prominent space for important announcements. */
export type AlertBannerBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Banner that appear at the top of pages, providing a prominent space for important announcements. */
export type AlertBannerBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Banner that appear at the top of pages, providing a prominent space for important announcements. */
export type AlertBannerBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type AlertBannerBlockAutocomplete = {
  __typename?: 'AlertBannerBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AlertBannerBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AlertBannerBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AlertBannerBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AlertBannerBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AlertBannerBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AlertBannerBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AlertBannerBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AlertBannerBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AlertBannerBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AlertBannerBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AlertBannerBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AlertBannerBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AlertBannerBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AlertBannerBlockFacet = {
  __typename?: 'AlertBannerBlockFacet';
  AlertType?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BodyCopy?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type AlertBannerBlockFacetAlertTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AlertBannerBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AlertBannerBlockFacetBodyCopyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AlertBannerBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AlertBannerBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AlertBannerBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AlertBannerBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AlertBannerBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AlertBannerBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AlertBannerBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AlertBannerBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AlertBannerBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AlertBannerBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AlertBannerBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AlertBannerBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AlertBannerBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AlertBannerBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AlertBannerBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AlertBannerBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AlertBannerBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AlertBannerBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AlertBannerBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AlertBannerBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AlertBannerBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AlertBannerBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AlertBannerBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AlertBannerBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type AlertBannerBlockOrderByInput = {
  AlertType?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  BodyCopy?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type AlertBannerBlockOutput = {
  __typename?: 'AlertBannerBlockOutput';
  autocomplete?: Maybe<AlertBannerBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<AlertBannerBlockFacet>;
  item?: Maybe<AlertBannerBlock>;
  items?: Maybe<Array<Maybe<AlertBannerBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type AlertBannerBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AlertBannerBlockWhereInput = {
  AlertType?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  BodyCopy?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<AlertBannerBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<AlertBannerBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<AlertBannerBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Block for creating anchors */
export type AnchorBlock = IContent &
  IData & {
    __typename?: 'AnchorBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /** Name of the anchor */
    AnchorName?: Maybe<Scalars['String']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Block for creating anchors */
export type AnchorBlockAnchorNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Block for creating anchors */
export type AnchorBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Block for creating anchors */
export type AnchorBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Block for creating anchors */
export type AnchorBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type AnchorBlockAutocomplete = {
  __typename?: 'AnchorBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AnchorBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AnchorBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AnchorBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AnchorBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AnchorBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AnchorBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AnchorBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AnchorBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AnchorBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AnchorBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AnchorBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AnchorBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AnchorBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AnchorBlockFacet = {
  __typename?: 'AnchorBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorName?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type AnchorBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AnchorBlockFacetAnchorNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AnchorBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AnchorBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AnchorBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AnchorBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AnchorBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AnchorBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AnchorBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AnchorBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AnchorBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AnchorBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AnchorBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AnchorBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AnchorBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AnchorBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AnchorBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AnchorBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AnchorBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AnchorBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AnchorBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AnchorBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AnchorBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AnchorBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AnchorBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type AnchorBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AnchorName?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type AnchorBlockOutput = {
  __typename?: 'AnchorBlockOutput';
  autocomplete?: Maybe<AnchorBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<AnchorBlockFacet>;
  item?: Maybe<AnchorBlock>;
  items?: Maybe<Array<Maybe<AnchorBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type AnchorBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnchorBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AnchorName?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<AnchorBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<AnchorBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<AnchorBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Dialog that show when leaving from the website */
export type AreYouMemberModal = IContent &
  IData & {
    __typename?: 'AreYouMemberModal';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    /** Add websites list with comma separator example: www.abc.com,www.xyz.com */
    IncludeWebsitesUrlList?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    /** Where navigate when user is Member */
    IsMemberTargetUrl?: Maybe<Scalars['String']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    /** No Button Label */
    NoButtonLabel?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** Yes Button Label */
    YesButtonLabel?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Dialog that show when leaving from the website */
export type AreYouMemberModalHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Dialog that show when leaving from the website */
export type AreYouMemberModalIncludeWebsitesUrlListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Dialog that show when leaving from the website */
export type AreYouMemberModalIsMemberTargetUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Dialog that show when leaving from the website */
export type AreYouMemberModalNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Dialog that show when leaving from the website */
export type AreYouMemberModalNoButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Dialog that show when leaving from the website */
export type AreYouMemberModalYesButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Dialog that show when leaving from the website */
export type AreYouMemberModal_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Dialog that show when leaving from the website */
export type AreYouMemberModal_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type AreYouMemberModalAutocomplete = {
  __typename?: 'AreYouMemberModalAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AreYouMemberModalAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AreYouMemberModalAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AreYouMemberModalAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AreYouMemberModalAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AreYouMemberModalAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AreYouMemberModalAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AreYouMemberModalAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AreYouMemberModalAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AreYouMemberModalAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AreYouMemberModalAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AreYouMemberModalAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AreYouMemberModalAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AreYouMemberModalAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AreYouMemberModalFacet = {
  __typename?: 'AreYouMemberModalFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IncludeWebsitesUrlList?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsMemberTargetUrl?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NoButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  YesButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type AreYouMemberModalFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AreYouMemberModalFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AreYouMemberModalFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AreYouMemberModalFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AreYouMemberModalFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AreYouMemberModalFacetIncludeWebsitesUrlListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AreYouMemberModalFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AreYouMemberModalFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AreYouMemberModalFacetIsMemberTargetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AreYouMemberModalFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AreYouMemberModalFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AreYouMemberModalFacetNoButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AreYouMemberModalFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AreYouMemberModalFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AreYouMemberModalFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AreYouMemberModalFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AreYouMemberModalFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AreYouMemberModalFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AreYouMemberModalFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AreYouMemberModalFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AreYouMemberModalFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AreYouMemberModalFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AreYouMemberModalFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AreYouMemberModalFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AreYouMemberModalFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AreYouMemberModalFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AreYouMemberModalFacetYesButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AreYouMemberModalFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AreYouMemberModalFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type AreYouMemberModalOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  IncludeWebsitesUrlList?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsMemberTargetUrl?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NoButtonLabel?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  YesButtonLabel?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type AreYouMemberModalOutput = {
  __typename?: 'AreYouMemberModalOutput';
  autocomplete?: Maybe<AreYouMemberModalAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<AreYouMemberModalFacet>;
  item?: Maybe<AreYouMemberModal>;
  items?: Maybe<Array<Maybe<AreYouMemberModal>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type AreYouMemberModalOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AreYouMemberModalWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IncludeWebsitesUrlList?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsMemberTargetUrl?: InputMaybe<SearchableStringFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NoButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  YesButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<AreYouMemberModalWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<AreYouMemberModalWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<AreYouMemberModalWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Pages with Author heading and description and author details. */
export type AuthorPage = IContent &
  IData & {
    __typename?: 'AuthorPage';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    AuthorMetaData?: Maybe<Scalars['String']['output']>;
    AuthorName?: Maybe<Scalars['String']['output']>;
    BreadcrumbsTitle?: Maybe<Scalars['String']['output']>;
    CTA?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentBlock?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    DisableIndexing?: Maybe<Scalars['Bool']['output']>;
    /** This will determine whether or not to show on search. */
    ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
    /** This will determine whether or not to show on the Sitemap. */
    ExcludeFromSitemap?: Maybe<Scalars['Bool']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    FooterOverride?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    HeaderOverride?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    /** This will determine whether or not to be dispalyed in breadcrumbs. */
    HideInBreadcrumbs?: Maybe<Scalars['Bool']['output']>;
    HideSiteFooter?: Maybe<Scalars['Bool']['output']>;
    HideSiteHeader?: Maybe<Scalars['Bool']['output']>;
    Highlight?: Maybe<Scalars['Bool']['output']>;
    Image?: Maybe<ContentModelReference>;
    Industry?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Keywords?: Maybe<Scalars['String']['output']>;
    /** Container for Schema Field */
    LDJsonContainer?: Maybe<Scalars['String']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MainContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    MetaContentType?: Maybe<Scalars['String']['output']>;
    MetaTitle?: Maybe<Scalars['String']['output']>;
    Name?: Maybe<Scalars['String']['output']>;
    NavigationTitle?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Description value that has been managed for the current page */
    OpenGraphDescription?: Maybe<Scalars['String']['output']>;
    /** Page template will always inherit the OpenGraph image from the parent page, recursively, until an image is managed for the current page */
    OpenGraphImage?: Maybe<ContentModelReference>;
    /** If managed, this field will overwrite the Image Height value that has been managed for the current page */
    OpenGraphImageHeight?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Image Type value that has been managed for the current page */
    OpenGraphImageType?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Image Width  value that has been managed for the current page */
    OpenGraphImageWidth?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Site value that has been managed for the current page */
    OpenGraphSite?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Title value that has been managed for the current page */
    OpenGraphTitle?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Url value that has been managed for the current page */
    OpenGraphUrl?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Type value that has been managed for the current page */
    OpenGraphtype?: Maybe<Scalars['String']['output']>;
    Overview?: Maybe<Scalars['String']['output']>;
    PageDescription?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SignUptoNewsletterForm?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    TeaserText?: Maybe<Scalars['String']['output']>;
    Title?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Pages with Author heading and description and author details. */
export type AuthorPageAuthorMetaDataArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with Author heading and description and author details. */
export type AuthorPageAuthorNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with Author heading and description and author details. */
export type AuthorPageCtaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with Author heading and description and author details. */
export type AuthorPageContentBlockArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with Author heading and description and author details. */
export type AuthorPageFooterOverrideArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with Author heading and description and author details. */
export type AuthorPageHeaderOverrideArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with Author heading and description and author details. */
export type AuthorPageIndustryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with Author heading and description and author details. */
export type AuthorPageKeywordsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with Author heading and description and author details. */
export type AuthorPageLdJsonContainerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with Author heading and description and author details. */
export type AuthorPageMainContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with Author heading and description and author details. */
export type AuthorPageMetaContentTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with Author heading and description and author details. */
export type AuthorPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with Author heading and description and author details. */
export type AuthorPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with Author heading and description and author details. */
export type AuthorPageNavigationTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with Author heading and description and author details. */
export type AuthorPageOpenGraphDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with Author heading and description and author details. */
export type AuthorPageOpenGraphImageHeightArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with Author heading and description and author details. */
export type AuthorPageOpenGraphImageTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with Author heading and description and author details. */
export type AuthorPageOpenGraphImageWidthArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with Author heading and description and author details. */
export type AuthorPageOpenGraphSiteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with Author heading and description and author details. */
export type AuthorPageOpenGraphTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with Author heading and description and author details. */
export type AuthorPageOpenGraphUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with Author heading and description and author details. */
export type AuthorPageOpenGraphtypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with Author heading and description and author details. */
export type AuthorPageOverviewArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with Author heading and description and author details. */
export type AuthorPagePageDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with Author heading and description and author details. */
export type AuthorPageSignUptoNewsletterFormArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with Author heading and description and author details. */
export type AuthorPageTeaserTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with Author heading and description and author details. */
export type AuthorPageTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with Author heading and description and author details. */
export type AuthorPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with Author heading and description and author details. */
export type AuthorPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type AuthorPageAutocomplete = {
  __typename?: 'AuthorPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  OpenGraphImage?: Maybe<ContentModelReferenceAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AuthorPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AuthorPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AuthorPageAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AuthorPageAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AuthorPageAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AuthorPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AuthorPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AuthorPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AuthorPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AuthorPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AuthorPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AuthorPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AuthorPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AuthorPageFacet = {
  __typename?: 'AuthorPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AuthorMetaData?: Maybe<Array<Maybe<StringFacet>>>;
  AuthorName?: Maybe<Array<Maybe<StringFacet>>>;
  CTA?: Maybe<ContentAreaItemModelSearchFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentBlock?: Maybe<ContentAreaItemModelSearchFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSitemap?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FooterOverride?: Maybe<ContentAreaItemModelSearchFacet>;
  HeaderOverride?: Maybe<ContentAreaItemModelSearchFacet>;
  HideInBreadcrumbs?: Maybe<Array<Maybe<StringFacet>>>;
  HideSiteFooter?: Maybe<Array<Maybe<StringFacet>>>;
  HideSiteHeader?: Maybe<Array<Maybe<StringFacet>>>;
  Highlight?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  Industry?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Keywords?: Maybe<Array<Maybe<StringFacet>>>;
  LDJsonContainer?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaContentType?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NavigationTitle?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphDescription?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphImage?: Maybe<ContentModelReferenceFacet>;
  OpenGraphImageHeight?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphImageType?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphImageWidth?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphSite?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphTitle?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphUrl?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphtype?: Maybe<Array<Maybe<StringFacet>>>;
  Overview?: Maybe<Array<Maybe<StringFacet>>>;
  PageDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SignUptoNewsletterForm?: Maybe<ContentAreaItemModelSearchFacet>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TeaserText?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type AuthorPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetAuthorMetaDataArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetAuthorNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AuthorPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AuthorPageFacetDisableIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetExcludeFromSitemapArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetHideInBreadcrumbsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetHideSiteFooterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetHideSiteHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetHighlightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetIndustryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetKeywordsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetLdJsonContainerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetMetaContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetNavigationTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetOpenGraphDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetOpenGraphImageHeightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetOpenGraphImageTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetOpenGraphImageWidthArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetOpenGraphSiteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetOpenGraphTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetOpenGraphUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetOpenGraphtypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetOverviewArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetPageDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AuthorPageFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AuthorPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AuthorPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AuthorPageFacetTeaserTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type AuthorPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AuthorMetaData?: InputMaybe<OrderBy>;
  AuthorName?: InputMaybe<OrderBy>;
  CTA?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentBlock?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExcludeFromSitemap?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FooterOverride?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  HeaderOverride?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  HideInBreadcrumbs?: InputMaybe<OrderBy>;
  HideSiteFooter?: InputMaybe<OrderBy>;
  HideSiteHeader?: InputMaybe<OrderBy>;
  Highlight?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  Industry?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Keywords?: InputMaybe<OrderBy>;
  LDJsonContainer?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaContentType?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NavigationTitle?: InputMaybe<OrderBy>;
  OpenGraphDescription?: InputMaybe<OrderBy>;
  OpenGraphImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  OpenGraphImageHeight?: InputMaybe<OrderBy>;
  OpenGraphImageType?: InputMaybe<OrderBy>;
  OpenGraphImageWidth?: InputMaybe<OrderBy>;
  OpenGraphSite?: InputMaybe<OrderBy>;
  OpenGraphTitle?: InputMaybe<OrderBy>;
  OpenGraphUrl?: InputMaybe<OrderBy>;
  OpenGraphtype?: InputMaybe<OrderBy>;
  Overview?: InputMaybe<OrderBy>;
  PageDescription?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SignUptoNewsletterForm?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TeaserText?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type AuthorPageOutput = {
  __typename?: 'AuthorPageOutput';
  autocomplete?: Maybe<AuthorPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<AuthorPageFacet>;
  item?: Maybe<AuthorPage>;
  items?: Maybe<Array<Maybe<AuthorPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type AuthorPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AuthorPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AuthorMetaData?: InputMaybe<SearchableStringFilterInput>;
  AuthorName?: InputMaybe<SearchableStringFilterInput>;
  CTA?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentBlock?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExcludeFromSitemap?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FooterOverride?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  HeaderOverride?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  HideInBreadcrumbs?: InputMaybe<BoolFilterInput>;
  HideSiteFooter?: InputMaybe<BoolFilterInput>;
  HideSiteHeader?: InputMaybe<BoolFilterInput>;
  Highlight?: InputMaybe<BoolFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  Industry?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Keywords?: InputMaybe<SearchableStringFilterInput>;
  LDJsonContainer?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaContentType?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NavigationTitle?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphDescription?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphImage?: InputMaybe<ContentModelReferenceWhereInput>;
  OpenGraphImageHeight?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphImageType?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphImageWidth?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphSite?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphTitle?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphUrl?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphtype?: InputMaybe<SearchableStringFilterInput>;
  Overview?: InputMaybe<SearchableStringFilterInput>;
  PageDescription?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SignUptoNewsletterForm?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TeaserText?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<AuthorPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<AuthorPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<AuthorPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Auto Affordability calculator. */
export type AutoAffordabilityCalculatorBlock = IContent &
  IData & {
    __typename?: 'AutoAffordabilityCalculatorBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Term?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Auto Affordability calculator. */
export type AutoAffordabilityCalculatorBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Auto Affordability calculator. */
export type AutoAffordabilityCalculatorBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Auto Affordability calculator. */
export type AutoAffordabilityCalculatorBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Auto Affordability calculator. */
export type AutoAffordabilityCalculatorBlockTermArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Auto Affordability calculator. */
export type AutoAffordabilityCalculatorBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Auto Affordability calculator. */
export type AutoAffordabilityCalculatorBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type AutoAffordabilityCalculatorBlockAutocomplete = {
  __typename?: 'AutoAffordabilityCalculatorBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AutoAffordabilityCalculatorBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoAffordabilityCalculatorBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoAffordabilityCalculatorBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoAffordabilityCalculatorBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoAffordabilityCalculatorBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoAffordabilityCalculatorBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoAffordabilityCalculatorBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoAffordabilityCalculatorBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoAffordabilityCalculatorBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoAffordabilityCalculatorBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoAffordabilityCalculatorBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoAffordabilityCalculatorBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoAffordabilityCalculatorBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoAffordabilityCalculatorBlockFacet = {
  __typename?: 'AutoAffordabilityCalculatorBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Term?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type AutoAffordabilityCalculatorBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoAffordabilityCalculatorBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAffordabilityCalculatorBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoAffordabilityCalculatorBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAffordabilityCalculatorBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoAffordabilityCalculatorBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoAffordabilityCalculatorBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoAffordabilityCalculatorBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoAffordabilityCalculatorBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoAffordabilityCalculatorBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoAffordabilityCalculatorBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoAffordabilityCalculatorBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAffordabilityCalculatorBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoAffordabilityCalculatorBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoAffordabilityCalculatorBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoAffordabilityCalculatorBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoAffordabilityCalculatorBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAffordabilityCalculatorBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoAffordabilityCalculatorBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoAffordabilityCalculatorBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoAffordabilityCalculatorBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAffordabilityCalculatorBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoAffordabilityCalculatorBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAffordabilityCalculatorBlockFacetTermArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoAffordabilityCalculatorBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoAffordabilityCalculatorBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoAffordabilityCalculatorBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type AutoAffordabilityCalculatorBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Term?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type AutoAffordabilityCalculatorBlockOutput = {
  __typename?: 'AutoAffordabilityCalculatorBlockOutput';
  autocomplete?: Maybe<AutoAffordabilityCalculatorBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<AutoAffordabilityCalculatorBlockFacet>;
  item?: Maybe<AutoAffordabilityCalculatorBlock>;
  items?: Maybe<Array<Maybe<AutoAffordabilityCalculatorBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type AutoAffordabilityCalculatorBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AutoAffordabilityCalculatorBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Term?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<AutoAffordabilityCalculatorBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<AutoAffordabilityCalculatorBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<AutoAffordabilityCalculatorBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Auto Payment Calculator. */
export type AutoPaymentCalculatorBlock = IContent &
  IData & {
    __typename?: 'AutoPaymentCalculatorBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Term?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Auto Payment Calculator. */
export type AutoPaymentCalculatorBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Auto Payment Calculator. */
export type AutoPaymentCalculatorBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Auto Payment Calculator. */
export type AutoPaymentCalculatorBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Auto Payment Calculator. */
export type AutoPaymentCalculatorBlockTermArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Auto Payment Calculator. */
export type AutoPaymentCalculatorBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Auto Payment Calculator. */
export type AutoPaymentCalculatorBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type AutoPaymentCalculatorBlockAutocomplete = {
  __typename?: 'AutoPaymentCalculatorBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AutoPaymentCalculatorBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoPaymentCalculatorBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoPaymentCalculatorBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoPaymentCalculatorBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoPaymentCalculatorBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoPaymentCalculatorBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoPaymentCalculatorBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoPaymentCalculatorBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoPaymentCalculatorBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoPaymentCalculatorBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoPaymentCalculatorBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoPaymentCalculatorBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoPaymentCalculatorBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoPaymentCalculatorBlockFacet = {
  __typename?: 'AutoPaymentCalculatorBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Term?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type AutoPaymentCalculatorBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoPaymentCalculatorBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoPaymentCalculatorBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoPaymentCalculatorBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoPaymentCalculatorBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoPaymentCalculatorBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoPaymentCalculatorBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoPaymentCalculatorBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoPaymentCalculatorBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoPaymentCalculatorBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoPaymentCalculatorBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoPaymentCalculatorBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoPaymentCalculatorBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoPaymentCalculatorBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoPaymentCalculatorBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoPaymentCalculatorBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoPaymentCalculatorBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoPaymentCalculatorBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoPaymentCalculatorBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoPaymentCalculatorBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoPaymentCalculatorBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoPaymentCalculatorBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoPaymentCalculatorBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoPaymentCalculatorBlockFacetTermArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoPaymentCalculatorBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoPaymentCalculatorBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoPaymentCalculatorBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type AutoPaymentCalculatorBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Term?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type AutoPaymentCalculatorBlockOutput = {
  __typename?: 'AutoPaymentCalculatorBlockOutput';
  autocomplete?: Maybe<AutoPaymentCalculatorBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<AutoPaymentCalculatorBlockFacet>;
  item?: Maybe<AutoPaymentCalculatorBlock>;
  items?: Maybe<Array<Maybe<AutoPaymentCalculatorBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type AutoPaymentCalculatorBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AutoPaymentCalculatorBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Term?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<AutoPaymentCalculatorBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<AutoPaymentCalculatorBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<AutoPaymentCalculatorBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Auto Refinance Calculator. */
export type AutoRefinanceCalculatorBlock = IContent &
  IData & {
    __typename?: 'AutoRefinanceCalculatorBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Term?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Auto Refinance Calculator. */
export type AutoRefinanceCalculatorBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Auto Refinance Calculator. */
export type AutoRefinanceCalculatorBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Auto Refinance Calculator. */
export type AutoRefinanceCalculatorBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Auto Refinance Calculator. */
export type AutoRefinanceCalculatorBlockTermArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Auto Refinance Calculator. */
export type AutoRefinanceCalculatorBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Auto Refinance Calculator. */
export type AutoRefinanceCalculatorBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type AutoRefinanceCalculatorBlockAutocomplete = {
  __typename?: 'AutoRefinanceCalculatorBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AutoRefinanceCalculatorBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoRefinanceCalculatorBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoRefinanceCalculatorBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoRefinanceCalculatorBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoRefinanceCalculatorBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoRefinanceCalculatorBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoRefinanceCalculatorBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoRefinanceCalculatorBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoRefinanceCalculatorBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoRefinanceCalculatorBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoRefinanceCalculatorBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoRefinanceCalculatorBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoRefinanceCalculatorBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AutoRefinanceCalculatorBlockFacet = {
  __typename?: 'AutoRefinanceCalculatorBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Term?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type AutoRefinanceCalculatorBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoRefinanceCalculatorBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoRefinanceCalculatorBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoRefinanceCalculatorBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoRefinanceCalculatorBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoRefinanceCalculatorBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoRefinanceCalculatorBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoRefinanceCalculatorBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoRefinanceCalculatorBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoRefinanceCalculatorBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoRefinanceCalculatorBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoRefinanceCalculatorBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoRefinanceCalculatorBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoRefinanceCalculatorBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoRefinanceCalculatorBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoRefinanceCalculatorBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoRefinanceCalculatorBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoRefinanceCalculatorBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoRefinanceCalculatorBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoRefinanceCalculatorBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoRefinanceCalculatorBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoRefinanceCalculatorBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoRefinanceCalculatorBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoRefinanceCalculatorBlockFacetTermArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoRefinanceCalculatorBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoRefinanceCalculatorBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AutoRefinanceCalculatorBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type AutoRefinanceCalculatorBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Term?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type AutoRefinanceCalculatorBlockOutput = {
  __typename?: 'AutoRefinanceCalculatorBlockOutput';
  autocomplete?: Maybe<AutoRefinanceCalculatorBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<AutoRefinanceCalculatorBlockFacet>;
  item?: Maybe<AutoRefinanceCalculatorBlock>;
  items?: Maybe<Array<Maybe<AutoRefinanceCalculatorBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type AutoRefinanceCalculatorBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AutoRefinanceCalculatorBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Term?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<AutoRefinanceCalculatorBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<AutoRefinanceCalculatorBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<AutoRefinanceCalculatorBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type BlobModel = {
  __typename?: 'BlobModel';
  Id?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
};

export type BlobModelAutocomplete = {
  __typename?: 'BlobModelAutocomplete';
  Id?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type BlobModelAutocompleteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlobModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlobModelFacet = {
  __typename?: 'BlobModelFacet';
  Id?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
};

export type BlobModelFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlobModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlobModelOrderByInput = {
  Id?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
};

export type BlobModelWhereInput = {
  Id?: InputMaybe<StringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
};

/** Cards that includes options to display an image, a headline, a brief description, and a link to view a more detailed description. */
export type BlockContentPodExpandCardBlock = IContent &
  IData & {
    __typename?: 'BlockContentPodExpandCardBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    ExpandTextLabel?: Maybe<Scalars['String']['output']>;
    ExpandableLineCount?: Maybe<Scalars['String']['output']>;
    Headline?: Maybe<Scalars['String']['output']>;
    Image?: Maybe<ContentModelReference>;
    ImageAlignment?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    ShortDescription?: Maybe<Scalars['String']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Cards that includes options to display an image, a headline, a brief description, and a link to view a more detailed description. */
export type BlockContentPodExpandCardBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Cards that includes options to display an image, a headline, a brief description, and a link to view a more detailed description. */
export type BlockContentPodExpandCardBlockExpandTextLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Cards that includes options to display an image, a headline, a brief description, and a link to view a more detailed description. */
export type BlockContentPodExpandCardBlockExpandableLineCountArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Cards that includes options to display an image, a headline, a brief description, and a link to view a more detailed description. */
export type BlockContentPodExpandCardBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Cards that includes options to display an image, a headline, a brief description, and a link to view a more detailed description. */
export type BlockContentPodExpandCardBlockImageAlignmentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Cards that includes options to display an image, a headline, a brief description, and a link to view a more detailed description. */
export type BlockContentPodExpandCardBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Cards that includes options to display an image, a headline, a brief description, and a link to view a more detailed description. */
export type BlockContentPodExpandCardBlockShortDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Cards that includes options to display an image, a headline, a brief description, and a link to view a more detailed description. */
export type BlockContentPodExpandCardBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Cards that includes options to display an image, a headline, a brief description, and a link to view a more detailed description. */
export type BlockContentPodExpandCardBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type BlockContentPodExpandCardBlockAutocomplete = {
  __typename?: 'BlockContentPodExpandCardBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type BlockContentPodExpandCardBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodExpandCardBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodExpandCardBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodExpandCardBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodExpandCardBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodExpandCardBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodExpandCardBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodExpandCardBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodExpandCardBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodExpandCardBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodExpandCardBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodExpandCardBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodExpandCardBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodExpandCardBlockFacet = {
  __typename?: 'BlockContentPodExpandCardBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandTextLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ExpandableLineCount?: Maybe<Array<Maybe<StringFacet>>>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  ImageAlignment?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  ShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type BlockContentPodExpandCardBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodExpandCardBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockContentPodExpandCardBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodExpandCardBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockContentPodExpandCardBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodExpandCardBlockFacetExpandTextLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodExpandCardBlockFacetExpandableLineCountArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodExpandCardBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodExpandCardBlockFacetImageAlignmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodExpandCardBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodExpandCardBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodExpandCardBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodExpandCardBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodExpandCardBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodExpandCardBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockContentPodExpandCardBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodExpandCardBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodExpandCardBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodExpandCardBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodExpandCardBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockContentPodExpandCardBlockFacetShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodExpandCardBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodExpandCardBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodExpandCardBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodExpandCardBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockContentPodExpandCardBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodExpandCardBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockContentPodExpandCardBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodExpandCardBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodExpandCardBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type BlockContentPodExpandCardBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandTextLabel?: InputMaybe<OrderBy>;
  ExpandableLineCount?: InputMaybe<OrderBy>;
  Headline?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageAlignment?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  ShortDescription?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type BlockContentPodExpandCardBlockOutput = {
  __typename?: 'BlockContentPodExpandCardBlockOutput';
  autocomplete?: Maybe<BlockContentPodExpandCardBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<BlockContentPodExpandCardBlockFacet>;
  item?: Maybe<BlockContentPodExpandCardBlock>;
  items?: Maybe<Array<Maybe<BlockContentPodExpandCardBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type BlockContentPodExpandCardBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockContentPodExpandCardBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandTextLabel?: InputMaybe<SearchableStringFilterInput>;
  ExpandableLineCount?: InputMaybe<SearchableStringFilterInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageAlignment?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  ShortDescription?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<BlockContentPodExpandCardBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<BlockContentPodExpandCardBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<BlockContentPodExpandCardBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Module used to add different Block Content Pod cards. */
export type BlockContentPodGroupBlock = IContent &
  IData & {
    __typename?: 'BlockContentPodGroupBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    BlockContentPodIcons?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    /** If the option is checked, a gray background will be applied; otherwise, the default background will be displayed. */
    GrayBackground?: Maybe<Scalars['Bool']['output']>;
    /** If the option is checked, the Top Margin will be shown; otherwise, the margin will not be displayed. */
    HasTopMargin?: Maybe<Scalars['Bool']['output']>;
    Headline?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    /** If the option is checked, the Bottom Angle will be removed; otherwise, the bottom angle will be displayed. */
    RemoveBottomAngle?: Maybe<Scalars['Bool']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Module used to add different Block Content Pod cards. */
export type BlockContentPodGroupBlockBlockContentPodIconsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Module used to add different Block Content Pod cards. */
export type BlockContentPodGroupBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Module used to add different Block Content Pod cards. */
export type BlockContentPodGroupBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Module used to add different Block Content Pod cards. */
export type BlockContentPodGroupBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Module used to add different Block Content Pod cards. */
export type BlockContentPodGroupBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type BlockContentPodGroupBlockAutocomplete = {
  __typename?: 'BlockContentPodGroupBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type BlockContentPodGroupBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodGroupBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodGroupBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodGroupBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodGroupBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodGroupBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodGroupBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodGroupBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodGroupBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodGroupBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodGroupBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodGroupBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodGroupBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodGroupBlockFacet = {
  __typename?: 'BlockContentPodGroupBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BlockContentPodIcons?: Maybe<ContentAreaItemModelSearchFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  GrayBackground?: Maybe<Array<Maybe<StringFacet>>>;
  HasTopMargin?: Maybe<Array<Maybe<StringFacet>>>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RemoveBottomAngle?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type BlockContentPodGroupBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodGroupBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockContentPodGroupBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodGroupBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockContentPodGroupBlockFacetGrayBackgroundArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodGroupBlockFacetHasTopMarginArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodGroupBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodGroupBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodGroupBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodGroupBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodGroupBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodGroupBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodGroupBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockContentPodGroupBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodGroupBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodGroupBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodGroupBlockFacetRemoveBottomAngleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodGroupBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodGroupBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockContentPodGroupBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodGroupBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodGroupBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodGroupBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockContentPodGroupBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodGroupBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockContentPodGroupBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodGroupBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodGroupBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type BlockContentPodGroupBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BlockContentPodIcons?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  GrayBackground?: InputMaybe<OrderBy>;
  HasTopMargin?: InputMaybe<OrderBy>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RemoveBottomAngle?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type BlockContentPodGroupBlockOutput = {
  __typename?: 'BlockContentPodGroupBlockOutput';
  autocomplete?: Maybe<BlockContentPodGroupBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<BlockContentPodGroupBlockFacet>;
  item?: Maybe<BlockContentPodGroupBlock>;
  items?: Maybe<Array<Maybe<BlockContentPodGroupBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type BlockContentPodGroupBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockContentPodGroupBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BlockContentPodIcons?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  GrayBackground?: InputMaybe<BoolFilterInput>;
  HasTopMargin?: InputMaybe<BoolFilterInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RemoveBottomAngle?: InputMaybe<BoolFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<BlockContentPodGroupBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<BlockContentPodGroupBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<BlockContentPodGroupBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Clickable card with an icon that can be added in Block Content Pod Group. */
export type BlockContentPodIconBlock = IContent &
  IData & {
    __typename?: 'BlockContentPodIconBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    IconReference?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    ShowOutline?: Maybe<Scalars['Bool']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Clickable card with an icon that can be added in Block Content Pod Group. */
export type BlockContentPodIconBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Clickable card with an icon that can be added in Block Content Pod Group. */
export type BlockContentPodIconBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Clickable card with an icon that can be added in Block Content Pod Group. */
export type BlockContentPodIconBlockIconReferenceArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Clickable card with an icon that can be added in Block Content Pod Group. */
export type BlockContentPodIconBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Clickable card with an icon that can be added in Block Content Pod Group. */
export type BlockContentPodIconBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Clickable card with an icon that can be added in Block Content Pod Group. */
export type BlockContentPodIconBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type BlockContentPodIconBlockAutocomplete = {
  __typename?: 'BlockContentPodIconBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type BlockContentPodIconBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodIconBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodIconBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodIconBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodIconBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodIconBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodIconBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodIconBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodIconBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodIconBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodIconBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodIconBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodIconBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodIconBlockFacet = {
  __typename?: 'BlockContentPodIconBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IconReference?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  ShowOutline?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type BlockContentPodIconBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodIconBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockContentPodIconBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodIconBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockContentPodIconBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodIconBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodIconBlockFacetIconReferenceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodIconBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodIconBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodIconBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodIconBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodIconBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodIconBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockContentPodIconBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodIconBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodIconBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodIconBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodIconBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockContentPodIconBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodIconBlockFacetShowOutlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodIconBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodIconBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodIconBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockContentPodIconBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodIconBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockContentPodIconBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodIconBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodIconBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type BlockContentPodIconBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  IconReference?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  ShowOutline?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type BlockContentPodIconBlockOutput = {
  __typename?: 'BlockContentPodIconBlockOutput';
  autocomplete?: Maybe<BlockContentPodIconBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<BlockContentPodIconBlockFacet>;
  item?: Maybe<BlockContentPodIconBlock>;
  items?: Maybe<Array<Maybe<BlockContentPodIconBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type BlockContentPodIconBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockContentPodIconBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IconReference?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  ShowOutline?: InputMaybe<BoolFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<BlockContentPodIconBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<BlockContentPodIconBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<BlockContentPodIconBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Card with an optional image and a link. */
export type BlockContentPodImageBlock = IContent &
  IData & {
    __typename?: 'BlockContentPodImageBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    HasImagePadding?: Maybe<Scalars['Bool']['output']>;
    Headline?: Maybe<Scalars['String']['output']>;
    Image?: Maybe<ContentModelReference>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    LinkColor?: Maybe<Scalars['String']['output']>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    ShowOutline?: Maybe<Scalars['Bool']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Card with an optional image and a link. */
export type BlockContentPodImageBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Card with an optional image and a link. */
export type BlockContentPodImageBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Card with an optional image and a link. */
export type BlockContentPodImageBlockLinkColorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Card with an optional image and a link. */
export type BlockContentPodImageBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Card with an optional image and a link. */
export type BlockContentPodImageBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Card with an optional image and a link. */
export type BlockContentPodImageBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type BlockContentPodImageBlockAutocomplete = {
  __typename?: 'BlockContentPodImageBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type BlockContentPodImageBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodImageBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodImageBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodImageBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodImageBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodImageBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodImageBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodImageBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodImageBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodImageBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodImageBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodImageBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodImageBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlockContentPodImageBlockFacet = {
  __typename?: 'BlockContentPodImageBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  HasImagePadding?: Maybe<Array<Maybe<StringFacet>>>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LinkColor?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  ShowOutline?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type BlockContentPodImageBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodImageBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockContentPodImageBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodImageBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockContentPodImageBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodImageBlockFacetHasImagePaddingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodImageBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodImageBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodImageBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodImageBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodImageBlockFacetLinkColorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodImageBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodImageBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodImageBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockContentPodImageBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodImageBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodImageBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodImageBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodImageBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockContentPodImageBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodImageBlockFacetShowOutlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodImageBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodImageBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodImageBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockContentPodImageBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodImageBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockContentPodImageBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodImageBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlockContentPodImageBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type BlockContentPodImageBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  HasImagePadding?: InputMaybe<OrderBy>;
  Headline?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LinkColor?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  ShowOutline?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type BlockContentPodImageBlockOutput = {
  __typename?: 'BlockContentPodImageBlockOutput';
  autocomplete?: Maybe<BlockContentPodImageBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<BlockContentPodImageBlockFacet>;
  item?: Maybe<BlockContentPodImageBlock>;
  items?: Maybe<Array<Maybe<BlockContentPodImageBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type BlockContentPodImageBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockContentPodImageBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  HasImagePadding?: InputMaybe<BoolFilterInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LinkColor?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  ShowOutline?: InputMaybe<BoolFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<BlockContentPodImageBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<BlockContentPodImageBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<BlockContentPodImageBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Component that displays most recent blogs. */
export type BlogFeaturedPodModuleBlock = IContent &
  IData & {
    __typename?: 'BlogFeaturedPodModuleBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Blogs?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    DisplayMostRecentBlogs?: Maybe<Scalars['Bool']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RemoveBottomAngle?: Maybe<Scalars['Bool']['output']>;
    RemoveTopAngle?: Maybe<Scalars['Bool']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    ShowBackground?: Maybe<Scalars['Bool']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Component that displays most recent blogs. */
export type BlogFeaturedPodModuleBlockBlogsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Component that displays most recent blogs. */
export type BlogFeaturedPodModuleBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Component that displays most recent blogs. */
export type BlogFeaturedPodModuleBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Component that displays most recent blogs. */
export type BlogFeaturedPodModuleBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Component that displays most recent blogs. */
export type BlogFeaturedPodModuleBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type BlogFeaturedPodModuleBlockAutocomplete = {
  __typename?: 'BlogFeaturedPodModuleBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type BlogFeaturedPodModuleBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogFeaturedPodModuleBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogFeaturedPodModuleBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogFeaturedPodModuleBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogFeaturedPodModuleBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogFeaturedPodModuleBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogFeaturedPodModuleBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogFeaturedPodModuleBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogFeaturedPodModuleBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogFeaturedPodModuleBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogFeaturedPodModuleBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogFeaturedPodModuleBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogFeaturedPodModuleBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogFeaturedPodModuleBlockFacet = {
  __typename?: 'BlogFeaturedPodModuleBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Blogs?: Maybe<ContentAreaItemModelSearchFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisplayMostRecentBlogs?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RemoveBottomAngle?: Maybe<Array<Maybe<StringFacet>>>;
  RemoveTopAngle?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  ShowBackground?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type BlogFeaturedPodModuleBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogFeaturedPodModuleBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlogFeaturedPodModuleBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogFeaturedPodModuleBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlogFeaturedPodModuleBlockFacetDisplayMostRecentBlogsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogFeaturedPodModuleBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogFeaturedPodModuleBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogFeaturedPodModuleBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogFeaturedPodModuleBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogFeaturedPodModuleBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogFeaturedPodModuleBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogFeaturedPodModuleBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlogFeaturedPodModuleBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogFeaturedPodModuleBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogFeaturedPodModuleBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogFeaturedPodModuleBlockFacetRemoveBottomAngleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogFeaturedPodModuleBlockFacetRemoveTopAngleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogFeaturedPodModuleBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogFeaturedPodModuleBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlogFeaturedPodModuleBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogFeaturedPodModuleBlockFacetShowBackgroundArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogFeaturedPodModuleBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogFeaturedPodModuleBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogFeaturedPodModuleBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlogFeaturedPodModuleBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogFeaturedPodModuleBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlogFeaturedPodModuleBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogFeaturedPodModuleBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogFeaturedPodModuleBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type BlogFeaturedPodModuleBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Blogs?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisplayMostRecentBlogs?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RemoveBottomAngle?: InputMaybe<OrderBy>;
  RemoveTopAngle?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  ShowBackground?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type BlogFeaturedPodModuleBlockOutput = {
  __typename?: 'BlogFeaturedPodModuleBlockOutput';
  autocomplete?: Maybe<BlogFeaturedPodModuleBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<BlogFeaturedPodModuleBlockFacet>;
  item?: Maybe<BlogFeaturedPodModuleBlock>;
  items?: Maybe<Array<Maybe<BlogFeaturedPodModuleBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type BlogFeaturedPodModuleBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlogFeaturedPodModuleBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Blogs?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisplayMostRecentBlogs?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RemoveBottomAngle?: InputMaybe<BoolFilterInput>;
  RemoveTopAngle?: InputMaybe<BoolFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  ShowBackground?: InputMaybe<BoolFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<BlogFeaturedPodModuleBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<BlogFeaturedPodModuleBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<BlogFeaturedPodModuleBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Listing the Blogs on the site */
export type BlogListing = IContent &
  IData & {
    __typename?: 'BlogListing';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /** How many items we have to show in the each page  */
    Count?: Maybe<Scalars['Int']['output']>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Listing the Blogs on the site */
export type BlogListingNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Blogs on the site */
export type BlogListing_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Blogs on the site */
export type BlogListing_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type BlogListingAutocomplete = {
  __typename?: 'BlogListingAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type BlogListingAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogListingAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogListingAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogListingAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogListingAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogListingAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogListingAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogListingAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogListingAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogListingAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogListingAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogListingAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogListingAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogListingFacet = {
  __typename?: 'BlogListingFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Count?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type BlogListingFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogListingFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlogListingFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogListingFacetCountArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type BlogListingFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlogListingFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogListingFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogListingFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogListingFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogListingFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogListingFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlogListingFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogListingFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogListingFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogListingFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogListingFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlogListingFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogListingFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogListingFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogListingFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlogListingFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogListingFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlogListingFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogListingFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogListingFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type BlogListingOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Count?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type BlogListingOutput = {
  __typename?: 'BlogListingOutput';
  autocomplete?: Maybe<BlogListingAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<BlogListingFacet>;
  item?: Maybe<BlogListing>;
  items?: Maybe<Array<Maybe<BlogListing>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type BlogListingOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlogListingWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Count?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<BlogListingWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<BlogListingWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<BlogListingWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Page with blog content and blog author information. */
export type BlogPage = IContent &
  IData & {
    __typename?: 'BlogPage';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    AuthorLink?: Maybe<LinkItemNode>;
    AuthorMetaData?: Maybe<Scalars['String']['output']>;
    Body?: Maybe<Scalars['String']['output']>;
    BreadcrumbsTitle?: Maybe<Scalars['String']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    DisableIndexing?: Maybe<Scalars['Bool']['output']>;
    /** This will determine whether or not to show on search. */
    ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
    /** This will determine whether or not to show on the Sitemap. */
    ExcludeFromSitemap?: Maybe<Scalars['Bool']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    FeaturedImage?: Maybe<ContentModelReference>;
    FooterOverride?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    HeaderOverride?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    /** This will determine whether or not to be dispalyed in breadcrumbs. */
    HideInBreadcrumbs?: Maybe<Scalars['Bool']['output']>;
    HideSiteFooter?: Maybe<Scalars['Bool']['output']>;
    HideSiteHeader?: Maybe<Scalars['Bool']['output']>;
    Highlight?: Maybe<Scalars['Bool']['output']>;
    Industry?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Keywords?: Maybe<Scalars['String']['output']>;
    /** Container for Schema Field */
    LDJsonContainer?: Maybe<Scalars['String']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    /** The Component placed below the Blog Content Block */
    LeftSideContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    MainContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    MetaContentType?: Maybe<Scalars['String']['output']>;
    MetaTitle?: Maybe<Scalars['String']['output']>;
    Name?: Maybe<Scalars['String']['output']>;
    NavigationTitle?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Description value that has been managed for the current page */
    OpenGraphDescription?: Maybe<Scalars['String']['output']>;
    /** Page template will always inherit the OpenGraph image from the parent page, recursively, until an image is managed for the current page */
    OpenGraphImage?: Maybe<ContentModelReference>;
    /** If managed, this field will overwrite the Image Height value that has been managed for the current page */
    OpenGraphImageHeight?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Image Type value that has been managed for the current page */
    OpenGraphImageType?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Image Width  value that has been managed for the current page */
    OpenGraphImageWidth?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Site value that has been managed for the current page */
    OpenGraphSite?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Title value that has been managed for the current page */
    OpenGraphTitle?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Url value that has been managed for the current page */
    OpenGraphUrl?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Type value that has been managed for the current page */
    OpenGraphtype?: Maybe<Scalars['String']['output']>;
    PageDescription?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    PageTitle?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    ParentLink?: Maybe<ContentModelReference>;
    PostingDate?: Maybe<Scalars['Date']['output']>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    /** Short Description is shown when the page appears in Search Results. */
    ShortDescription?: Maybe<Scalars['String']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SideContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    TeaserText?: Maybe<Scalars['String']['output']>;
    Topic?: Maybe<FilterCategoryModel>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Page with blog content and blog author information. */
export type BlogPageAuthorMetaDataArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with blog content and blog author information. */
export type BlogPageBodyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with blog content and blog author information. */
export type BlogPageFooterOverrideArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with blog content and blog author information. */
export type BlogPageHeaderOverrideArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with blog content and blog author information. */
export type BlogPageHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with blog content and blog author information. */
export type BlogPageIndustryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with blog content and blog author information. */
export type BlogPageKeywordsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with blog content and blog author information. */
export type BlogPageLdJsonContainerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with blog content and blog author information. */
export type BlogPageLeftSideContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with blog content and blog author information. */
export type BlogPageMainContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with blog content and blog author information. */
export type BlogPageMetaContentTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with blog content and blog author information. */
export type BlogPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with blog content and blog author information. */
export type BlogPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with blog content and blog author information. */
export type BlogPageNavigationTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with blog content and blog author information. */
export type BlogPageOpenGraphDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with blog content and blog author information. */
export type BlogPageOpenGraphImageHeightArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with blog content and blog author information. */
export type BlogPageOpenGraphImageTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with blog content and blog author information. */
export type BlogPageOpenGraphImageWidthArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with blog content and blog author information. */
export type BlogPageOpenGraphSiteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with blog content and blog author information. */
export type BlogPageOpenGraphTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with blog content and blog author information. */
export type BlogPageOpenGraphUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with blog content and blog author information. */
export type BlogPageOpenGraphtypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with blog content and blog author information. */
export type BlogPagePageDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with blog content and blog author information. */
export type BlogPagePageTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with blog content and blog author information. */
export type BlogPageShortDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with blog content and blog author information. */
export type BlogPageSideContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with blog content and blog author information. */
export type BlogPageTeaserTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with blog content and blog author information. */
export type BlogPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with blog content and blog author information. */
export type BlogPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type BlogPageAutocomplete = {
  __typename?: 'BlogPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AuthorLink?: Maybe<LinkItemNodeAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  FeaturedImage?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  OpenGraphImage?: Maybe<ContentModelReferenceAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Topic?: Maybe<FilterCategoryModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type BlogPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogPageAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogPageAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogPageAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogPageFacet = {
  __typename?: 'BlogPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AuthorLink?: Maybe<LinkItemNodeFacet>;
  AuthorMetaData?: Maybe<Array<Maybe<StringFacet>>>;
  Body?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSitemap?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FeaturedImage?: Maybe<ContentModelReferenceFacet>;
  FooterOverride?: Maybe<ContentAreaItemModelSearchFacet>;
  HeaderOverride?: Maybe<ContentAreaItemModelSearchFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  HideInBreadcrumbs?: Maybe<Array<Maybe<StringFacet>>>;
  HideSiteFooter?: Maybe<Array<Maybe<StringFacet>>>;
  HideSiteHeader?: Maybe<Array<Maybe<StringFacet>>>;
  Highlight?: Maybe<Array<Maybe<StringFacet>>>;
  Industry?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Keywords?: Maybe<Array<Maybe<StringFacet>>>;
  LDJsonContainer?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LeftSideContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  MainContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaContentType?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NavigationTitle?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphDescription?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphImage?: Maybe<ContentModelReferenceFacet>;
  OpenGraphImageHeight?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphImageType?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphImageWidth?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphSite?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphTitle?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphUrl?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphtype?: Maybe<Array<Maybe<StringFacet>>>;
  PageDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PageTitle?: Maybe<ContentAreaItemModelSearchFacet>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  ShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SideContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TeaserText?: Maybe<Array<Maybe<StringFacet>>>;
  Topic?: Maybe<FilterCategoryModelFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type BlogPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetAuthorMetaDataArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetBodyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlogPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlogPageFacetDisableIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetExcludeFromSitemapArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetHideInBreadcrumbsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetHideSiteFooterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetHideSiteHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetHighlightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetIndustryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetKeywordsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetLdJsonContainerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetMetaContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetNavigationTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetOpenGraphDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetOpenGraphImageHeightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetOpenGraphImageTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetOpenGraphImageWidthArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetOpenGraphSiteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetOpenGraphTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetOpenGraphUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetOpenGraphtypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetPageDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlogPageFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetPostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlogPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlogPageFacetShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlogPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlogPageFacetTeaserTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type BlogPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AuthorLink?: InputMaybe<LinkItemNodeOrderByInput>;
  AuthorMetaData?: InputMaybe<OrderBy>;
  Body?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExcludeFromSitemap?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FeaturedImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  FooterOverride?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  HeaderOverride?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  HideInBreadcrumbs?: InputMaybe<OrderBy>;
  HideSiteFooter?: InputMaybe<OrderBy>;
  HideSiteHeader?: InputMaybe<OrderBy>;
  Highlight?: InputMaybe<OrderBy>;
  Industry?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Keywords?: InputMaybe<OrderBy>;
  LDJsonContainer?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LeftSideContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaContentType?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NavigationTitle?: InputMaybe<OrderBy>;
  OpenGraphDescription?: InputMaybe<OrderBy>;
  OpenGraphImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  OpenGraphImageHeight?: InputMaybe<OrderBy>;
  OpenGraphImageType?: InputMaybe<OrderBy>;
  OpenGraphImageWidth?: InputMaybe<OrderBy>;
  OpenGraphSite?: InputMaybe<OrderBy>;
  OpenGraphTitle?: InputMaybe<OrderBy>;
  OpenGraphUrl?: InputMaybe<OrderBy>;
  OpenGraphtype?: InputMaybe<OrderBy>;
  PageDescription?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  PageTitle?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PostingDate?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  ShortDescription?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SideContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TeaserText?: InputMaybe<OrderBy>;
  Topic?: InputMaybe<FilterCategoryModelOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type BlogPageOutput = {
  __typename?: 'BlogPageOutput';
  autocomplete?: Maybe<BlogPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<BlogPageFacet>;
  item?: Maybe<BlogPage>;
  items?: Maybe<Array<Maybe<BlogPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type BlogPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlogPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AuthorLink?: InputMaybe<LinkItemNodeWhereInput>;
  AuthorMetaData?: InputMaybe<SearchableStringFilterInput>;
  Body?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExcludeFromSitemap?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FeaturedImage?: InputMaybe<ContentModelReferenceWhereInput>;
  FooterOverride?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  HeaderOverride?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  HideInBreadcrumbs?: InputMaybe<BoolFilterInput>;
  HideSiteFooter?: InputMaybe<BoolFilterInput>;
  HideSiteHeader?: InputMaybe<BoolFilterInput>;
  Highlight?: InputMaybe<BoolFilterInput>;
  Industry?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Keywords?: InputMaybe<SearchableStringFilterInput>;
  LDJsonContainer?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LeftSideContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaContentType?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NavigationTitle?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphDescription?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphImage?: InputMaybe<ContentModelReferenceWhereInput>;
  OpenGraphImageHeight?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphImageType?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphImageWidth?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphSite?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphTitle?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphUrl?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphtype?: InputMaybe<SearchableStringFilterInput>;
  PageDescription?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  PageTitle?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PostingDate?: InputMaybe<DateFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  ShortDescription?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SideContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TeaserText?: InputMaybe<SearchableStringFilterInput>;
  Topic?: InputMaybe<FilterCategoryModelWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<BlogPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<BlogPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<BlogPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Blog Sign-Up Form */
export type BlogSignUpFormBlock = IContent &
  IData & {
    __typename?: 'BlogSignUpFormBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    BlogPublicationTopics?: Maybe<Scalars['String']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    EmailAddressLabel?: Maybe<Scalars['String']['output']>;
    ErrorMessage?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    FirstNameLabel?: Maybe<Scalars['String']['output']>;
    Headline?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    LastNameLabel?: Maybe<Scalars['String']['output']>;
    LoadWithListing?: Maybe<Scalars['Bool']['output']>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    PublicationHeading?: Maybe<Scalars['String']['output']>;
    PublicationLabel?: Maybe<Scalars['String']['output']>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    SFMCListId?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    Source?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    SubmitButtonLabel?: Maybe<Scalars['String']['output']>;
    SuccessMessage?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Blog Sign-Up Form */
export type BlogSignUpFormBlockBlogPublicationTopicsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Blog Sign-Up Form */
export type BlogSignUpFormBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Blog Sign-Up Form */
export type BlogSignUpFormBlockEmailAddressLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Blog Sign-Up Form */
export type BlogSignUpFormBlockErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Blog Sign-Up Form */
export type BlogSignUpFormBlockFirstNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Blog Sign-Up Form */
export type BlogSignUpFormBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Blog Sign-Up Form */
export type BlogSignUpFormBlockLastNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Blog Sign-Up Form */
export type BlogSignUpFormBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Blog Sign-Up Form */
export type BlogSignUpFormBlockPublicationHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Blog Sign-Up Form */
export type BlogSignUpFormBlockPublicationLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Blog Sign-Up Form */
export type BlogSignUpFormBlockSfmcListIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Blog Sign-Up Form */
export type BlogSignUpFormBlockSourceArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Blog Sign-Up Form */
export type BlogSignUpFormBlockSubmitButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Blog Sign-Up Form */
export type BlogSignUpFormBlockSuccessMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Blog Sign-Up Form */
export type BlogSignUpFormBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Blog Sign-Up Form */
export type BlogSignUpFormBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type BlogSignUpFormBlockAutocomplete = {
  __typename?: 'BlogSignUpFormBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type BlogSignUpFormBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogSignUpFormBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogSignUpFormBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogSignUpFormBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogSignUpFormBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogSignUpFormBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogSignUpFormBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogSignUpFormBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogSignUpFormBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogSignUpFormBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogSignUpFormBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogSignUpFormBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogSignUpFormBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlogSignUpFormBlockFacet = {
  __typename?: 'BlogSignUpFormBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BlogPublicationTopics?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  EmailAddressLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FirstNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LastNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LoadWithListing?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PublicationHeading?: Maybe<Array<Maybe<StringFacet>>>;
  PublicationLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SFMCListId?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  Source?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SubmitButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SuccessMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type BlogSignUpFormBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogSignUpFormBlockFacetBlogPublicationTopicsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogSignUpFormBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlogSignUpFormBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogSignUpFormBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlogSignUpFormBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogSignUpFormBlockFacetEmailAddressLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogSignUpFormBlockFacetErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogSignUpFormBlockFacetFirstNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogSignUpFormBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogSignUpFormBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogSignUpFormBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogSignUpFormBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogSignUpFormBlockFacetLastNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogSignUpFormBlockFacetLoadWithListingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogSignUpFormBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogSignUpFormBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogSignUpFormBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlogSignUpFormBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogSignUpFormBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogSignUpFormBlockFacetPublicationHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogSignUpFormBlockFacetPublicationLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogSignUpFormBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogSignUpFormBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogSignUpFormBlockFacetSfmcListIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogSignUpFormBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlogSignUpFormBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogSignUpFormBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogSignUpFormBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogSignUpFormBlockFacetSourceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogSignUpFormBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlogSignUpFormBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogSignUpFormBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type BlogSignUpFormBlockFacetSubmitButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogSignUpFormBlockFacetSuccessMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogSignUpFormBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogSignUpFormBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlogSignUpFormBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type BlogSignUpFormBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BlogPublicationTopics?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  EmailAddressLabel?: InputMaybe<OrderBy>;
  ErrorMessage?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FirstNameLabel?: InputMaybe<OrderBy>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LastNameLabel?: InputMaybe<OrderBy>;
  LoadWithListing?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PublicationHeading?: InputMaybe<OrderBy>;
  PublicationLabel?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SFMCListId?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  Source?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SubmitButtonLabel?: InputMaybe<OrderBy>;
  SuccessMessage?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type BlogSignUpFormBlockOutput = {
  __typename?: 'BlogSignUpFormBlockOutput';
  autocomplete?: Maybe<BlogSignUpFormBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<BlogSignUpFormBlockFacet>;
  item?: Maybe<BlogSignUpFormBlock>;
  items?: Maybe<Array<Maybe<BlogSignUpFormBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type BlogSignUpFormBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlogSignUpFormBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BlogPublicationTopics?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  EmailAddressLabel?: InputMaybe<SearchableStringFilterInput>;
  ErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FirstNameLabel?: InputMaybe<SearchableStringFilterInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LastNameLabel?: InputMaybe<SearchableStringFilterInput>;
  LoadWithListing?: InputMaybe<BoolFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PublicationHeading?: InputMaybe<SearchableStringFilterInput>;
  PublicationLabel?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SFMCListId?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  Source?: InputMaybe<SearchableStringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SubmitButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  SuccessMessage?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<BlogSignUpFormBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<BlogSignUpFormBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<BlogSignUpFormBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type BoolFilterInput = {
  /** `boost` influences the weight of a field by boosting a match with a number (default: 1) — counts more towards the eventual relevance score which can be projected with `_score` — at query time. Note that `boost` cannot be a negative number. */
  boost?: InputMaybe<Scalars['Int']['input']>;
  /** `eq` matches on an exact value, but the value is case-insensitive. */
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  /** `exist` matches results that have this field. */
  exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** `not_eq` retrieves results not matching with an exact (but case-insensitive) value. */
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Button Block component that can be used on any page. */
export type ButtonBlock = IContent &
  IData & {
    __typename?: 'ButtonBlock';
    Alignment?: Maybe<Scalars['String']['output']>;
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCTAButton?: Maybe<Scalars['Bool']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Button Block component that can be used on any page. */
export type ButtonBlockAlignmentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Button Block component that can be used on any page. */
export type ButtonBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Button Block component that can be used on any page. */
export type ButtonBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Button Block component that can be used on any page. */
export type ButtonBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ButtonBlockAutocomplete = {
  __typename?: 'ButtonBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ButtonBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ButtonBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ButtonBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ButtonBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ButtonBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ButtonBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ButtonBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ButtonBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ButtonBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ButtonBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ButtonBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ButtonBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ButtonBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ButtonBlockFacet = {
  __typename?: 'ButtonBlockFacet';
  Alignment?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCTAButton?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type ButtonBlockFacetAlignmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ButtonBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ButtonBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ButtonBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ButtonBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ButtonBlockFacetIsCtaButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ButtonBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ButtonBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ButtonBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ButtonBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ButtonBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ButtonBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ButtonBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ButtonBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ButtonBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ButtonBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ButtonBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ButtonBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ButtonBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ButtonBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ButtonBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ButtonBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ButtonBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ButtonBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ButtonBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ButtonBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ButtonBlockOrderByInput = {
  Alignment?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCTAButton?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ButtonBlockOutput = {
  __typename?: 'ButtonBlockOutput';
  autocomplete?: Maybe<ButtonBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ButtonBlockFacet>;
  item?: Maybe<ButtonBlock>;
  items?: Maybe<Array<Maybe<ButtonBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ButtonBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ButtonBlockWhereInput = {
  Alignment?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCTAButton?: InputMaybe<BoolFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ButtonBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ButtonBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ButtonBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Calculator pages for holding a calculator component and content. */
export type CalculatorPage = IContent &
  IData & {
    __typename?: 'CalculatorPage';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    AuthorMetaData?: Maybe<Scalars['String']['output']>;
    BreadcrumbsTitle?: Maybe<Scalars['String']['output']>;
    Calculator?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    DisableIndexing?: Maybe<Scalars['Bool']['output']>;
    /** This will determine whether or not to show on search. */
    ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
    /** This will determine whether or not to show on the Sitemap. */
    ExcludeFromSitemap?: Maybe<Scalars['Bool']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    FooterOverride?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    HeaderOverride?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    HeroImage?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    /** This will determine whether or not to be dispalyed in breadcrumbs. */
    HideInBreadcrumbs?: Maybe<Scalars['Bool']['output']>;
    HideSiteFooter?: Maybe<Scalars['Bool']['output']>;
    HideSiteHeader?: Maybe<Scalars['Bool']['output']>;
    Highlight?: Maybe<Scalars['Bool']['output']>;
    Industry?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Keywords?: Maybe<Scalars['String']['output']>;
    /** Container for Schema Field */
    LDJsonContainer?: Maybe<Scalars['String']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MainContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    MetaContentType?: Maybe<Scalars['String']['output']>;
    MetaTitle?: Maybe<Scalars['String']['output']>;
    Name?: Maybe<Scalars['String']['output']>;
    NavigationTitle?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Description value that has been managed for the current page */
    OpenGraphDescription?: Maybe<Scalars['String']['output']>;
    /** Page template will always inherit the OpenGraph image from the parent page, recursively, until an image is managed for the current page */
    OpenGraphImage?: Maybe<ContentModelReference>;
    /** If managed, this field will overwrite the Image Height value that has been managed for the current page */
    OpenGraphImageHeight?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Image Type value that has been managed for the current page */
    OpenGraphImageType?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Image Width  value that has been managed for the current page */
    OpenGraphImageWidth?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Site value that has been managed for the current page */
    OpenGraphSite?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Title value that has been managed for the current page */
    OpenGraphTitle?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Url value that has been managed for the current page */
    OpenGraphUrl?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Type value that has been managed for the current page */
    OpenGraphtype?: Maybe<Scalars['String']['output']>;
    PageDescription?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    /** Short Description is shown when the page appears in Search Results. */
    ShortDescription?: Maybe<Scalars['String']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SiderailCtaPod?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SimpleMasthead?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    TeaserText?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Calculator pages for holding a calculator component and content. */
export type CalculatorPageAuthorMetaDataArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Calculator pages for holding a calculator component and content. */
export type CalculatorPageCalculatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Calculator pages for holding a calculator component and content. */
export type CalculatorPageFooterOverrideArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Calculator pages for holding a calculator component and content. */
export type CalculatorPageHeaderOverrideArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Calculator pages for holding a calculator component and content. */
export type CalculatorPageHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Calculator pages for holding a calculator component and content. */
export type CalculatorPageHeroImageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Calculator pages for holding a calculator component and content. */
export type CalculatorPageIndustryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Calculator pages for holding a calculator component and content. */
export type CalculatorPageKeywordsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Calculator pages for holding a calculator component and content. */
export type CalculatorPageLdJsonContainerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Calculator pages for holding a calculator component and content. */
export type CalculatorPageMainContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Calculator pages for holding a calculator component and content. */
export type CalculatorPageMetaContentTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Calculator pages for holding a calculator component and content. */
export type CalculatorPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Calculator pages for holding a calculator component and content. */
export type CalculatorPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Calculator pages for holding a calculator component and content. */
export type CalculatorPageNavigationTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Calculator pages for holding a calculator component and content. */
export type CalculatorPageOpenGraphDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Calculator pages for holding a calculator component and content. */
export type CalculatorPageOpenGraphImageHeightArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Calculator pages for holding a calculator component and content. */
export type CalculatorPageOpenGraphImageTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Calculator pages for holding a calculator component and content. */
export type CalculatorPageOpenGraphImageWidthArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Calculator pages for holding a calculator component and content. */
export type CalculatorPageOpenGraphSiteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Calculator pages for holding a calculator component and content. */
export type CalculatorPageOpenGraphTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Calculator pages for holding a calculator component and content. */
export type CalculatorPageOpenGraphUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Calculator pages for holding a calculator component and content. */
export type CalculatorPageOpenGraphtypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Calculator pages for holding a calculator component and content. */
export type CalculatorPagePageDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Calculator pages for holding a calculator component and content. */
export type CalculatorPageShortDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Calculator pages for holding a calculator component and content. */
export type CalculatorPageSiderailCtaPodArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Calculator pages for holding a calculator component and content. */
export type CalculatorPageSimpleMastheadArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Calculator pages for holding a calculator component and content. */
export type CalculatorPageTeaserTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Calculator pages for holding a calculator component and content. */
export type CalculatorPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Calculator pages for holding a calculator component and content. */
export type CalculatorPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CalculatorPageAutocomplete = {
  __typename?: 'CalculatorPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  OpenGraphImage?: Maybe<ContentModelReferenceAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CalculatorPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CalculatorPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CalculatorPageAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CalculatorPageAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CalculatorPageAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CalculatorPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CalculatorPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CalculatorPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CalculatorPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CalculatorPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CalculatorPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CalculatorPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CalculatorPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CalculatorPageFacet = {
  __typename?: 'CalculatorPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AuthorMetaData?: Maybe<Array<Maybe<StringFacet>>>;
  Calculator?: Maybe<ContentAreaItemModelSearchFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSitemap?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FooterOverride?: Maybe<ContentAreaItemModelSearchFacet>;
  HeaderOverride?: Maybe<ContentAreaItemModelSearchFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  HeroImage?: Maybe<ContentAreaItemModelSearchFacet>;
  HideInBreadcrumbs?: Maybe<Array<Maybe<StringFacet>>>;
  HideSiteFooter?: Maybe<Array<Maybe<StringFacet>>>;
  HideSiteHeader?: Maybe<Array<Maybe<StringFacet>>>;
  Highlight?: Maybe<Array<Maybe<StringFacet>>>;
  Industry?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Keywords?: Maybe<Array<Maybe<StringFacet>>>;
  LDJsonContainer?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaContentType?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NavigationTitle?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphDescription?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphImage?: Maybe<ContentModelReferenceFacet>;
  OpenGraphImageHeight?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphImageType?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphImageWidth?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphSite?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphTitle?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphUrl?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphtype?: Maybe<Array<Maybe<StringFacet>>>;
  PageDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  ShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiderailCtaPod?: Maybe<ContentAreaItemModelSearchFacet>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleMasthead?: Maybe<ContentAreaItemModelSearchFacet>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TeaserText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type CalculatorPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetAuthorMetaDataArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CalculatorPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CalculatorPageFacetDisableIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetExcludeFromSitemapArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetHideInBreadcrumbsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetHideSiteFooterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetHideSiteHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetHighlightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetIndustryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetKeywordsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetLdJsonContainerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetMetaContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetNavigationTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetOpenGraphDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetOpenGraphImageHeightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetOpenGraphImageTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetOpenGraphImageWidthArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetOpenGraphSiteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetOpenGraphTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetOpenGraphUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetOpenGraphtypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetPageDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CalculatorPageFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CalculatorPageFacetShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CalculatorPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CalculatorPageFacetTeaserTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CalculatorPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AuthorMetaData?: InputMaybe<OrderBy>;
  Calculator?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExcludeFromSitemap?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FooterOverride?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  HeaderOverride?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  HeroImage?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  HideInBreadcrumbs?: InputMaybe<OrderBy>;
  HideSiteFooter?: InputMaybe<OrderBy>;
  HideSiteHeader?: InputMaybe<OrderBy>;
  Highlight?: InputMaybe<OrderBy>;
  Industry?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Keywords?: InputMaybe<OrderBy>;
  LDJsonContainer?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaContentType?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NavigationTitle?: InputMaybe<OrderBy>;
  OpenGraphDescription?: InputMaybe<OrderBy>;
  OpenGraphImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  OpenGraphImageHeight?: InputMaybe<OrderBy>;
  OpenGraphImageType?: InputMaybe<OrderBy>;
  OpenGraphImageWidth?: InputMaybe<OrderBy>;
  OpenGraphSite?: InputMaybe<OrderBy>;
  OpenGraphTitle?: InputMaybe<OrderBy>;
  OpenGraphUrl?: InputMaybe<OrderBy>;
  OpenGraphtype?: InputMaybe<OrderBy>;
  PageDescription?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  ShortDescription?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiderailCtaPod?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SimpleMasthead?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TeaserText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CalculatorPageOutput = {
  __typename?: 'CalculatorPageOutput';
  autocomplete?: Maybe<CalculatorPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CalculatorPageFacet>;
  item?: Maybe<CalculatorPage>;
  items?: Maybe<Array<Maybe<CalculatorPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type CalculatorPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CalculatorPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AuthorMetaData?: InputMaybe<SearchableStringFilterInput>;
  Calculator?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExcludeFromSitemap?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FooterOverride?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  HeaderOverride?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  HeroImage?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  HideInBreadcrumbs?: InputMaybe<BoolFilterInput>;
  HideSiteFooter?: InputMaybe<BoolFilterInput>;
  HideSiteHeader?: InputMaybe<BoolFilterInput>;
  Highlight?: InputMaybe<BoolFilterInput>;
  Industry?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Keywords?: InputMaybe<SearchableStringFilterInput>;
  LDJsonContainer?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaContentType?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NavigationTitle?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphDescription?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphImage?: InputMaybe<ContentModelReferenceWhereInput>;
  OpenGraphImageHeight?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphImageType?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphImageWidth?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphSite?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphTitle?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphUrl?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphtype?: InputMaybe<SearchableStringFilterInput>;
  PageDescription?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  ShortDescription?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiderailCtaPod?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SimpleMasthead?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TeaserText?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CalculatorPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CalculatorPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CalculatorPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type CaptchaElementBlock = IContent &
  IData & {
    __typename?: 'CaptchaElementBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    ImageHeight?: Maybe<Scalars['Int']['output']>;
    ImageWidth?: Maybe<Scalars['Int']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Label?: Maybe<Scalars['String']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    TextLength?: Maybe<Scalars['Int']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    Validators?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

export type CaptchaElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CaptchaElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CaptchaElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CaptchaElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CaptchaElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CaptchaElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CaptchaElementBlockAutocomplete = {
  __typename?: 'CaptchaElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CaptchaElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CaptchaElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CaptchaElementBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CaptchaElementBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CaptchaElementBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CaptchaElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CaptchaElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CaptchaElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CaptchaElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CaptchaElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CaptchaElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CaptchaElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CaptchaElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CaptchaElementBlockFacet = {
  __typename?: 'CaptchaElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ImageHeight?: Maybe<Array<Maybe<NumberFacet>>>;
  ImageWidth?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TextLength?: Maybe<Array<Maybe<NumberFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type CaptchaElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CaptchaElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CaptchaElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CaptchaElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CaptchaElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CaptchaElementBlockFacetImageHeightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CaptchaElementBlockFacetImageWidthArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CaptchaElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CaptchaElementBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CaptchaElementBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CaptchaElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CaptchaElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CaptchaElementBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CaptchaElementBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CaptchaElementBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CaptchaElementBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CaptchaElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CaptchaElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CaptchaElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CaptchaElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CaptchaElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CaptchaElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CaptchaElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CaptchaElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CaptchaElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CaptchaElementBlockFacetTextLengthArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CaptchaElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CaptchaElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CaptchaElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CaptchaElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CaptchaElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ImageHeight?: InputMaybe<OrderBy>;
  ImageWidth?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TextLength?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CaptchaElementBlockOutput = {
  __typename?: 'CaptchaElementBlockOutput';
  autocomplete?: Maybe<CaptchaElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CaptchaElementBlockFacet>;
  item?: Maybe<CaptchaElementBlock>;
  items?: Maybe<Array<Maybe<CaptchaElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type CaptchaElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CaptchaElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ImageHeight?: InputMaybe<IntFilterInput>;
  ImageWidth?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TextLength?: InputMaybe<IntFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CaptchaElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CaptchaElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CaptchaElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type CategoryModel = {
  __typename?: 'CategoryModel';
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['Int']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
};

export type CategoryModelAutocomplete = {
  __typename?: 'CategoryModelAutocomplete';
  Description?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Name?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CategoryModelAutocompleteDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CategoryModelAutocompleteNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CategoryModelFacet = {
  __typename?: 'CategoryModelFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Id?: Maybe<Array<Maybe<NumberFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
};

export type CategoryModelFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CategoryModelFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CategoryModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CategoryModelOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Id?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
};

export type CategoryModelWhereInput = {
  Description?: InputMaybe<StringFilterInput>;
  Id?: InputMaybe<IntFilterInput>;
  Name?: InputMaybe<StringFilterInput>;
};

/** Certificate of deposit calculator. */
export type CertificateOfDepositCalculatorBlock = IContent &
  IData & {
    __typename?: 'CertificateOfDepositCalculatorBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Certificate of deposit calculator. */
export type CertificateOfDepositCalculatorBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Certificate of deposit calculator. */
export type CertificateOfDepositCalculatorBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Certificate of deposit calculator. */
export type CertificateOfDepositCalculatorBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Certificate of deposit calculator. */
export type CertificateOfDepositCalculatorBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Certificate of deposit calculator. */
export type CertificateOfDepositCalculatorBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CertificateOfDepositCalculatorBlockAutocomplete = {
  __typename?: 'CertificateOfDepositCalculatorBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CertificateOfDepositCalculatorBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CertificateOfDepositCalculatorBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CertificateOfDepositCalculatorBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CertificateOfDepositCalculatorBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CertificateOfDepositCalculatorBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CertificateOfDepositCalculatorBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CertificateOfDepositCalculatorBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CertificateOfDepositCalculatorBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CertificateOfDepositCalculatorBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CertificateOfDepositCalculatorBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CertificateOfDepositCalculatorBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CertificateOfDepositCalculatorBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CertificateOfDepositCalculatorBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CertificateOfDepositCalculatorBlockFacet = {
  __typename?: 'CertificateOfDepositCalculatorBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type CertificateOfDepositCalculatorBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CertificateOfDepositCalculatorBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CertificateOfDepositCalculatorBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CertificateOfDepositCalculatorBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CertificateOfDepositCalculatorBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CertificateOfDepositCalculatorBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CertificateOfDepositCalculatorBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CertificateOfDepositCalculatorBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CertificateOfDepositCalculatorBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CertificateOfDepositCalculatorBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CertificateOfDepositCalculatorBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CertificateOfDepositCalculatorBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CertificateOfDepositCalculatorBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CertificateOfDepositCalculatorBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CertificateOfDepositCalculatorBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CertificateOfDepositCalculatorBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CertificateOfDepositCalculatorBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CertificateOfDepositCalculatorBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CertificateOfDepositCalculatorBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CertificateOfDepositCalculatorBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CertificateOfDepositCalculatorBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CertificateOfDepositCalculatorBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CertificateOfDepositCalculatorBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CertificateOfDepositCalculatorBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CertificateOfDepositCalculatorBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CertificateOfDepositCalculatorBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CertificateOfDepositCalculatorBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CertificateOfDepositCalculatorBlockOutput = {
  __typename?: 'CertificateOfDepositCalculatorBlockOutput';
  autocomplete?: Maybe<CertificateOfDepositCalculatorBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CertificateOfDepositCalculatorBlockFacet>;
  item?: Maybe<CertificateOfDepositCalculatorBlock>;
  items?: Maybe<Array<Maybe<CertificateOfDepositCalculatorBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type CertificateOfDepositCalculatorBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CertificateOfDepositCalculatorBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CertificateOfDepositCalculatorBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CertificateOfDepositCalculatorBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CertificateOfDepositCalculatorBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ChoiceElementBlock = IContent &
  IData & {
    __typename?: 'ChoiceElementBlock';
    AllowMultiSelect?: Maybe<Scalars['Bool']['output']>;
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ConditionCombination?: Maybe<Scalars['Int']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Feed?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Label?: Maybe<Scalars['String']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    SatisfiedAction?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    Validators?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

export type ChoiceElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ChoiceElementBlockFeedArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ChoiceElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ChoiceElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ChoiceElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ChoiceElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ChoiceElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ChoiceElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ChoiceElementBlockAutocomplete = {
  __typename?: 'ChoiceElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ChoiceElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ChoiceElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ChoiceElementBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ChoiceElementBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ChoiceElementBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ChoiceElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ChoiceElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ChoiceElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ChoiceElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ChoiceElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ChoiceElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ChoiceElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ChoiceElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ChoiceElementBlockFacet = {
  __typename?: 'ChoiceElementBlockFacet';
  AllowMultiSelect?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Feed?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type ChoiceElementBlockFacetAllowMultiSelectArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ChoiceElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ChoiceElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ChoiceElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ChoiceElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ChoiceElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ChoiceElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ChoiceElementBlockFacetFeedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ChoiceElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ChoiceElementBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ChoiceElementBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ChoiceElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ChoiceElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ChoiceElementBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ChoiceElementBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ChoiceElementBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ChoiceElementBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ChoiceElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ChoiceElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ChoiceElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ChoiceElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ChoiceElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ChoiceElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ChoiceElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ChoiceElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ChoiceElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ChoiceElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ChoiceElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ChoiceElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ChoiceElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ChoiceElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ChoiceElementBlockOrderByInput = {
  AllowMultiSelect?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Feed?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ChoiceElementBlockOutput = {
  __typename?: 'ChoiceElementBlockOutput';
  autocomplete?: Maybe<ChoiceElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ChoiceElementBlockFacet>;
  item?: Maybe<ChoiceElementBlock>;
  items?: Maybe<Array<Maybe<ChoiceElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ChoiceElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChoiceElementBlockWhereInput = {
  AllowMultiSelect?: InputMaybe<BoolFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Feed?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ChoiceElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ChoiceElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ChoiceElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Used for coding file types such as Css, Javascript. */
export type CodingFile = IContent &
  IData & {
    __typename?: 'CodingFile';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    Content?: Maybe<Scalars['String']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    MimeType?: Maybe<Scalars['String']['output']>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Thumbnail?: Maybe<BlobModel>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Used for coding file types such as Css, Javascript. */
export type CodingFileContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for coding file types such as Css, Javascript. */
export type CodingFileDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for coding file types such as Css, Javascript. */
export type CodingFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for coding file types such as Css, Javascript. */
export type CodingFile_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for coding file types such as Css, Javascript. */
export type CodingFile_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CodingFileAutocomplete = {
  __typename?: 'CodingFileAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MimeType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Thumbnail?: Maybe<BlobModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CodingFileAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CodingFileAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CodingFileAutocompleteMimeTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CodingFileAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CodingFileAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CodingFileAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CodingFileAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CodingFileAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CodingFileAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CodingFileAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CodingFileAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CodingFileAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CodingFileAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CodingFileAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CodingFileFacet = {
  __typename?: 'CodingFileFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MimeType?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Thumbnail?: Maybe<BlobModelFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type CodingFileFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CodingFileFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CodingFileFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CodingFileFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CodingFileFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CodingFileFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CodingFileFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CodingFileFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CodingFileFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CodingFileFacetMimeTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CodingFileFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CodingFileFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CodingFileFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CodingFileFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CodingFileFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CodingFileFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CodingFileFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CodingFileFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CodingFileFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CodingFileFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CodingFileFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CodingFileFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CodingFileFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CodingFileFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CodingFileFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CodingFileFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CodingFileFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CodingFileOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MimeType?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Thumbnail?: InputMaybe<BlobModelOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CodingFileOutput = {
  __typename?: 'CodingFileOutput';
  autocomplete?: Maybe<CodingFileAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CodingFileFacet>;
  item?: Maybe<CodingFile>;
  items?: Maybe<Array<Maybe<CodingFile>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type CodingFileOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CodingFileWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MimeType?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Thumbnail?: InputMaybe<BlobModelWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CodingFileWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CodingFileWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CodingFileWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Complex Table component that can be used on any Page or Blocks */
export type ComplexTableBlock = IContent &
  IData & {
    __typename?: 'ComplexTableBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    HeaderRow?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Rows?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    TableCaption?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Complex Table component that can be used on any Page or Blocks */
export type ComplexTableBlockHeaderRowArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Complex Table component that can be used on any Page or Blocks */
export type ComplexTableBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Complex Table component that can be used on any Page or Blocks */
export type ComplexTableBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Complex Table component that can be used on any Page or Blocks */
export type ComplexTableBlockRowsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Complex Table component that can be used on any Page or Blocks */
export type ComplexTableBlockTableCaptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Complex Table component that can be used on any Page or Blocks */
export type ComplexTableBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Complex Table component that can be used on any Page or Blocks */
export type ComplexTableBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ComplexTableBlockAutocomplete = {
  __typename?: 'ComplexTableBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ComplexTableBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableBlockFacet = {
  __typename?: 'ComplexTableBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  HeaderRow?: Maybe<ContentAreaItemModelSearchFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Rows?: Maybe<ContentAreaItemModelSearchFacet>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TableCaption?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type ComplexTableBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ComplexTableBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ComplexTableBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ComplexTableBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ComplexTableBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ComplexTableBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ComplexTableBlockFacetTableCaptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ComplexTableBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  HeaderRow?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Rows?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TableCaption?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ComplexTableBlockOutput = {
  __typename?: 'ComplexTableBlockOutput';
  autocomplete?: Maybe<ComplexTableBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ComplexTableBlockFacet>;
  item?: Maybe<ComplexTableBlock>;
  items?: Maybe<Array<Maybe<ComplexTableBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ComplexTableBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComplexTableBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  HeaderRow?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Rows?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TableCaption?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ComplexTableBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ComplexTableBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ComplexTableBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Complex Table Column component that can be used on any Complex Table */
export type ComplexTableColumnBlock = IContent &
  IData & {
    __typename?: 'ComplexTableColumnBlock';
    Alignment?: Maybe<Scalars['String']['output']>;
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Bold?: Maybe<Scalars['Bool']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    Color?: Maybe<Scalars['String']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IconReference?: Maybe<Scalars['String']['output']>;
    IsCTAButton?: Maybe<Scalars['Bool']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    Size?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Text?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Complex Table Column component that can be used on any Complex Table */
export type ComplexTableColumnBlockAlignmentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Complex Table Column component that can be used on any Complex Table */
export type ComplexTableColumnBlockColorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Complex Table Column component that can be used on any Complex Table */
export type ComplexTableColumnBlockIconReferenceArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Complex Table Column component that can be used on any Complex Table */
export type ComplexTableColumnBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Complex Table Column component that can be used on any Complex Table */
export type ComplexTableColumnBlockSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Complex Table Column component that can be used on any Complex Table */
export type ComplexTableColumnBlockTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Complex Table Column component that can be used on any Complex Table */
export type ComplexTableColumnBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Complex Table Column component that can be used on any Complex Table */
export type ComplexTableColumnBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ComplexTableColumnBlockAutocomplete = {
  __typename?: 'ComplexTableColumnBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ComplexTableColumnBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableColumnBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableColumnBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableColumnBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableColumnBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableColumnBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableColumnBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableColumnBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableColumnBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableColumnBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableColumnBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableColumnBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableColumnBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableColumnBlockFacet = {
  __typename?: 'ComplexTableColumnBlockFacet';
  Alignment?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Bold?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Color?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IconReference?: Maybe<Array<Maybe<StringFacet>>>;
  IsCTAButton?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  Size?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Text?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type ComplexTableColumnBlockFacetAlignmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableColumnBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableColumnBlockFacetBoldArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableColumnBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ComplexTableColumnBlockFacetColorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableColumnBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableColumnBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ComplexTableColumnBlockFacetIconReferenceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableColumnBlockFacetIsCtaButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableColumnBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableColumnBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableColumnBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableColumnBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableColumnBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableColumnBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ComplexTableColumnBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableColumnBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableColumnBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableColumnBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableColumnBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ComplexTableColumnBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableColumnBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableColumnBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableColumnBlockFacetSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableColumnBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ComplexTableColumnBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableColumnBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ComplexTableColumnBlockFacetTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableColumnBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableColumnBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableColumnBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ComplexTableColumnBlockOrderByInput = {
  Alignment?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Bold?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Color?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IconReference?: InputMaybe<OrderBy>;
  IsCTAButton?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  Size?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Text?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ComplexTableColumnBlockOutput = {
  __typename?: 'ComplexTableColumnBlockOutput';
  autocomplete?: Maybe<ComplexTableColumnBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ComplexTableColumnBlockFacet>;
  item?: Maybe<ComplexTableColumnBlock>;
  items?: Maybe<Array<Maybe<ComplexTableColumnBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ComplexTableColumnBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComplexTableColumnBlockWhereInput = {
  Alignment?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Bold?: InputMaybe<BoolFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Color?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IconReference?: InputMaybe<SearchableStringFilterInput>;
  IsCTAButton?: InputMaybe<BoolFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  Size?: InputMaybe<SearchableStringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Text?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ComplexTableColumnBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ComplexTableColumnBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ComplexTableColumnBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Complex Table Header component that can be used on any Complex Table */
export type ComplexTableHeaderBlock = IContent &
  IData & {
    __typename?: 'ComplexTableHeaderBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    Columns?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Complex Table Header component that can be used on any Complex Table */
export type ComplexTableHeaderBlockColumnsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Complex Table Header component that can be used on any Complex Table */
export type ComplexTableHeaderBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Complex Table Header component that can be used on any Complex Table */
export type ComplexTableHeaderBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Complex Table Header component that can be used on any Complex Table */
export type ComplexTableHeaderBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ComplexTableHeaderBlockAutocomplete = {
  __typename?: 'ComplexTableHeaderBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ComplexTableHeaderBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableHeaderBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableHeaderBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableHeaderBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableHeaderBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableHeaderBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableHeaderBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableHeaderBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableHeaderBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableHeaderBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableHeaderBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableHeaderBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableHeaderBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableHeaderBlockFacet = {
  __typename?: 'ComplexTableHeaderBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Columns?: Maybe<ContentAreaItemModelSearchFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type ComplexTableHeaderBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableHeaderBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ComplexTableHeaderBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableHeaderBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ComplexTableHeaderBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableHeaderBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableHeaderBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableHeaderBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableHeaderBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableHeaderBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ComplexTableHeaderBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableHeaderBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableHeaderBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableHeaderBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableHeaderBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ComplexTableHeaderBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableHeaderBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableHeaderBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableHeaderBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ComplexTableHeaderBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableHeaderBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ComplexTableHeaderBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableHeaderBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableHeaderBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ComplexTableHeaderBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Columns?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ComplexTableHeaderBlockOutput = {
  __typename?: 'ComplexTableHeaderBlockOutput';
  autocomplete?: Maybe<ComplexTableHeaderBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ComplexTableHeaderBlockFacet>;
  item?: Maybe<ComplexTableHeaderBlock>;
  items?: Maybe<Array<Maybe<ComplexTableHeaderBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ComplexTableHeaderBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComplexTableHeaderBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Columns?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ComplexTableHeaderBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ComplexTableHeaderBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ComplexTableHeaderBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Complex Table Row component that can be used on any Complex Table */
export type ComplexTableRowBlock = IContent &
  IData & {
    __typename?: 'ComplexTableRowBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    Columns?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Complex Table Row component that can be used on any Complex Table */
export type ComplexTableRowBlockColumnsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Complex Table Row component that can be used on any Complex Table */
export type ComplexTableRowBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Complex Table Row component that can be used on any Complex Table */
export type ComplexTableRowBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Complex Table Row component that can be used on any Complex Table */
export type ComplexTableRowBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ComplexTableRowBlockAutocomplete = {
  __typename?: 'ComplexTableRowBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ComplexTableRowBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableRowBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableRowBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableRowBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableRowBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableRowBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableRowBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableRowBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableRowBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableRowBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableRowBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableRowBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableRowBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ComplexTableRowBlockFacet = {
  __typename?: 'ComplexTableRowBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Columns?: Maybe<ContentAreaItemModelSearchFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type ComplexTableRowBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableRowBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ComplexTableRowBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableRowBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ComplexTableRowBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableRowBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableRowBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableRowBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableRowBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableRowBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ComplexTableRowBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableRowBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableRowBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableRowBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableRowBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ComplexTableRowBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableRowBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableRowBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableRowBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ComplexTableRowBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableRowBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ComplexTableRowBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableRowBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ComplexTableRowBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ComplexTableRowBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Columns?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ComplexTableRowBlockOutput = {
  __typename?: 'ComplexTableRowBlockOutput';
  autocomplete?: Maybe<ComplexTableRowBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ComplexTableRowBlockFacet>;
  item?: Maybe<ComplexTableRowBlock>;
  items?: Maybe<Array<Maybe<ComplexTableRowBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ComplexTableRowBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComplexTableRowBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Columns?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ComplexTableRowBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ComplexTableRowBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ComplexTableRowBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Consent banner for accepting cookie consent */
export type ConsentBannerBlock = IContent &
  IData & {
    __typename?: 'ConsentBannerBlock';
    AcceptButton?: Maybe<Scalars['String']['output']>;
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Consent banner for accepting cookie consent */
export type ConsentBannerBlockAcceptButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Consent banner for accepting cookie consent */
export type ConsentBannerBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Consent banner for accepting cookie consent */
export type ConsentBannerBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Consent banner for accepting cookie consent */
export type ConsentBannerBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Consent banner for accepting cookie consent */
export type ConsentBannerBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ConsentBannerBlockAutocomplete = {
  __typename?: 'ConsentBannerBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ConsentBannerBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ConsentBannerBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ConsentBannerBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ConsentBannerBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ConsentBannerBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ConsentBannerBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ConsentBannerBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ConsentBannerBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ConsentBannerBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ConsentBannerBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ConsentBannerBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ConsentBannerBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ConsentBannerBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ConsentBannerBlockFacet = {
  __typename?: 'ConsentBannerBlockFacet';
  AcceptButton?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type ConsentBannerBlockFacetAcceptButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ConsentBannerBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ConsentBannerBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ConsentBannerBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ConsentBannerBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ConsentBannerBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ConsentBannerBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ConsentBannerBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ConsentBannerBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ConsentBannerBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ConsentBannerBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ConsentBannerBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ConsentBannerBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ConsentBannerBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ConsentBannerBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ConsentBannerBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ConsentBannerBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ConsentBannerBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ConsentBannerBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ConsentBannerBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ConsentBannerBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ConsentBannerBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ConsentBannerBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ConsentBannerBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ConsentBannerBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ConsentBannerBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ConsentBannerBlockOrderByInput = {
  AcceptButton?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ConsentBannerBlockOutput = {
  __typename?: 'ConsentBannerBlockOutput';
  autocomplete?: Maybe<ConsentBannerBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ConsentBannerBlockFacet>;
  item?: Maybe<ConsentBannerBlock>;
  items?: Maybe<Array<Maybe<ConsentBannerBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ConsentBannerBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConsentBannerBlockWhereInput = {
  AcceptButton?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ConsentBannerBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ConsentBannerBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ConsentBannerBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Allow users to add content in Single Component */
export type ContainerBlock = IContent &
  IData & {
    __typename?: 'ContainerBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MainContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Allow users to add content in Single Component */
export type ContainerBlockMainContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow users to add content in Single Component */
export type ContainerBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow users to add content in Single Component */
export type ContainerBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow users to add content in Single Component */
export type ContainerBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ContainerBlockAutocomplete = {
  __typename?: 'ContainerBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ContainerBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContainerBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContainerBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContainerBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContainerBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContainerBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContainerBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContainerBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContainerBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContainerBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContainerBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContainerBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContainerBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContainerBlockFacet = {
  __typename?: 'ContainerBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainContent?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type ContainerBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContainerBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContainerBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContainerBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContainerBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContainerBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContainerBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ContainerBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ContainerBlockOutput = {
  __typename?: 'ContainerBlockOutput';
  autocomplete?: Maybe<ContainerBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ContainerBlockFacet>;
  item?: Maybe<ContainerBlock>;
  items?: Maybe<Array<Maybe<ContainerBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ContainerBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContainerBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ContainerBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ContainerBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ContainerBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Allow users to add content in two columns */
export type ContainerWithSideRailBlock = IContent &
  IData & {
    __typename?: 'ContainerWithSideRailBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MainContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SideContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    SideContentAlignment?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Allow users to add content in two columns */
export type ContainerWithSideRailBlockMainContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow users to add content in two columns */
export type ContainerWithSideRailBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow users to add content in two columns */
export type ContainerWithSideRailBlockSideContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow users to add content in two columns */
export type ContainerWithSideRailBlockSideContentAlignmentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow users to add content in two columns */
export type ContainerWithSideRailBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow users to add content in two columns */
export type ContainerWithSideRailBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ContainerWithSideRailBlockAutocomplete = {
  __typename?: 'ContainerWithSideRailBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ContainerWithSideRailBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContainerWithSideRailBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContainerWithSideRailBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContainerWithSideRailBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContainerWithSideRailBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContainerWithSideRailBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContainerWithSideRailBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContainerWithSideRailBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContainerWithSideRailBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContainerWithSideRailBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContainerWithSideRailBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContainerWithSideRailBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContainerWithSideRailBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContainerWithSideRailBlockFacet = {
  __typename?: 'ContainerWithSideRailBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainContent?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SideContent?: Maybe<ContentAreaItemModelSearchFacet>;
  SideContentAlignment?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type ContainerWithSideRailBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerWithSideRailBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContainerWithSideRailBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerWithSideRailBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContainerWithSideRailBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerWithSideRailBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerWithSideRailBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerWithSideRailBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerWithSideRailBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerWithSideRailBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContainerWithSideRailBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerWithSideRailBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerWithSideRailBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerWithSideRailBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerWithSideRailBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContainerWithSideRailBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerWithSideRailBlockFacetSideContentAlignmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerWithSideRailBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerWithSideRailBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerWithSideRailBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContainerWithSideRailBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerWithSideRailBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContainerWithSideRailBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerWithSideRailBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContainerWithSideRailBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ContainerWithSideRailBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SideContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  SideContentAlignment?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ContainerWithSideRailBlockOutput = {
  __typename?: 'ContainerWithSideRailBlockOutput';
  autocomplete?: Maybe<ContainerWithSideRailBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ContainerWithSideRailBlockFacet>;
  item?: Maybe<ContainerWithSideRailBlock>;
  items?: Maybe<Array<Maybe<ContainerWithSideRailBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ContainerWithSideRailBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContainerWithSideRailBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SideContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  SideContentAlignment?: InputMaybe<SearchableStringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ContainerWithSideRailBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ContainerWithSideRailBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ContainerWithSideRailBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type Content = IContent &
  IData & {
    __typename?: 'Content';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

export type ContentNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type Content_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type Content_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ContentAreaItemModel = {
  __typename?: 'ContentAreaItemModel';
  ContentLink?: Maybe<ContentModelReference>;
  DisplayOption?: Maybe<Scalars['String']['output']>;
  InlineBlock?: Maybe<InlineBlockPropertyModel>;
  Tag?: Maybe<Scalars['String']['output']>;
};

export type ContentAreaItemModelAutocomplete = {
  __typename?: 'ContentAreaItemModelAutocomplete';
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  DisplayOption?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  InlineBlock?: Maybe<InlineBlockPropertyModelAutocomplete>;
  Tag?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ContentAreaItemModelAutocompleteDisplayOptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentAreaItemModelAutocompleteTagArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentAreaItemModelFacet = {
  __typename?: 'ContentAreaItemModelFacet';
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  DisplayOption?: Maybe<Array<Maybe<StringFacet>>>;
  InlineBlock?: Maybe<InlineBlockPropertyModelFacet>;
  Tag?: Maybe<Array<Maybe<StringFacet>>>;
};

export type ContentAreaItemModelFacetDisplayOptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentAreaItemModelFacetTagArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentAreaItemModelOrderByInput = {
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  DisplayOption?: InputMaybe<OrderBy>;
  InlineBlock?: InputMaybe<InlineBlockPropertyModelOrderByInput>;
  Tag?: InputMaybe<OrderBy>;
};

export type ContentAreaItemModelSearch = {
  __typename?: 'ContentAreaItemModelSearch';
  ContentLink?: Maybe<ContentModelReferenceSearch>;
  DisplayOption?: Maybe<Scalars['String']['output']>;
  InlineBlock?: Maybe<InlineBlockPropertyModelSearch>;
  Tag?: Maybe<Scalars['String']['output']>;
};

export type ContentAreaItemModelSearchContentLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ContentAreaItemModelSearchDisplayOptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ContentAreaItemModelSearchInlineBlockArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ContentAreaItemModelSearchTagArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ContentAreaItemModelSearchFacet = {
  __typename?: 'ContentAreaItemModelSearchFacet';
  ContentLink?: Maybe<ContentModelReferenceSearchFacet>;
  DisplayOption?: Maybe<Array<Maybe<StringFacet>>>;
  InlineBlock?: Maybe<InlineBlockPropertyModelSearchFacet>;
  Tag?: Maybe<Array<Maybe<StringFacet>>>;
};

export type ContentAreaItemModelSearchFacetDisplayOptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentAreaItemModelSearchFacetTagArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentAreaItemModelSearchOrderByInput = {
  ContentLink?: InputMaybe<ContentModelReferenceSearchOrderByInput>;
  DisplayOption?: InputMaybe<OrderBy>;
  InlineBlock?: InputMaybe<InlineBlockPropertyModelSearchOrderByInput>;
  Tag?: InputMaybe<OrderBy>;
};

export type ContentAreaItemModelSearchWhereInput = {
  ContentLink?: InputMaybe<ContentModelReferenceSearchWhereInput>;
  DisplayOption?: InputMaybe<SearchableStringFilterInput>;
  InlineBlock?: InputMaybe<InlineBlockPropertyModelSearchWhereInput>;
  Tag?: InputMaybe<SearchableStringFilterInput>;
};

export type ContentAreaItemModelWhereInput = {
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  DisplayOption?: InputMaybe<StringFilterInput>;
  InlineBlock?: InputMaybe<InlineBlockPropertyModelWhereInput>;
  Tag?: InputMaybe<StringFilterInput>;
};

export type ContentAutocomplete = {
  __typename?: 'ContentAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ContentAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

/** Allow content authors to add a module with rich text to pages */
export type ContentBlock = IContent &
  IData & {
    __typename?: 'ContentBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Text?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Allow content authors to add a module with rich text to pages */
export type ContentBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add a module with rich text to pages */
export type ContentBlockTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add a module with rich text to pages */
export type ContentBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add a module with rich text to pages */
export type ContentBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ContentBlockAutocomplete = {
  __typename?: 'ContentBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ContentBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentBlockFacet = {
  __typename?: 'ContentBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Text?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type ContentBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentBlockFacetTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ContentBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Text?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ContentBlockOutput = {
  __typename?: 'ContentBlockOutput';
  autocomplete?: Maybe<ContentBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ContentBlockFacet>;
  item?: Maybe<ContentBlock>;
  items?: Maybe<Array<Maybe<ContentBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ContentBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Text?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ContentBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ContentBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ContentBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ContentFacet = {
  __typename?: 'ContentFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type ContentFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ContentLanguageModel = {
  __typename?: 'ContentLanguageModel';
  DisplayName?: Maybe<Scalars['String']['output']>;
  Link?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
};

export type ContentLanguageModelAutocomplete = {
  __typename?: 'ContentLanguageModelAutocomplete';
  DisplayName?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Link?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Name?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ContentLanguageModelAutocompleteDisplayNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentLanguageModelAutocompleteLinkArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentLanguageModelAutocompleteNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentLanguageModelFacet = {
  __typename?: 'ContentLanguageModelFacet';
  DisplayName?: Maybe<Array<Maybe<StringFacet>>>;
  Link?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
};

export type ContentLanguageModelFacetDisplayNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentLanguageModelFacetLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentLanguageModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentLanguageModelOrderByInput = {
  DisplayName?: InputMaybe<OrderBy>;
  Link?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
};

export type ContentLanguageModelSearch = {
  __typename?: 'ContentLanguageModelSearch';
  DisplayName?: Maybe<Scalars['String']['output']>;
  Link?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
};

export type ContentLanguageModelSearchDisplayNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ContentLanguageModelSearchLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ContentLanguageModelSearchNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ContentLanguageModelSearchFacet = {
  __typename?: 'ContentLanguageModelSearchFacet';
  DisplayName?: Maybe<Array<Maybe<StringFacet>>>;
  Link?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
};

export type ContentLanguageModelSearchFacetDisplayNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentLanguageModelSearchFacetLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentLanguageModelSearchFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentLanguageModelSearchOrderByInput = {
  DisplayName?: InputMaybe<OrderBy>;
  Link?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
};

export type ContentLanguageModelSearchWhereInput = {
  DisplayName?: InputMaybe<SearchableStringFilterInput>;
  Link?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
};

export type ContentLanguageModelWhereInput = {
  DisplayName?: InputMaybe<StringFilterInput>;
  Link?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<StringFilterInput>;
};

export type ContentModelReference = {
  __typename?: 'ContentModelReference';
  Expanded?: Maybe<IContent>;
  GuidValue?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['Int']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  ProviderName?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  WorkId?: Maybe<Scalars['Int']['output']>;
};

export type ContentModelReferenceAutocomplete = {
  __typename?: 'ContentModelReferenceAutocomplete';
  GuidValue?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  ProviderName?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ContentModelReferenceAutocompleteGuidValueArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentModelReferenceAutocompleteProviderNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentModelReferenceAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentModelReferenceFacet = {
  __typename?: 'ContentModelReferenceFacet';
  GuidValue?: Maybe<Array<Maybe<StringFacet>>>;
  Id?: Maybe<Array<Maybe<NumberFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  ProviderName?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  WorkId?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type ContentModelReferenceFacetGuidValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentModelReferenceFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ContentModelReferenceFacetProviderNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentModelReferenceFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentModelReferenceFacetWorkIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ContentModelReferenceOrderByInput = {
  GuidValue?: InputMaybe<OrderBy>;
  Id?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  ProviderName?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  WorkId?: InputMaybe<OrderBy>;
};

export type ContentModelReferenceSearch = {
  __typename?: 'ContentModelReferenceSearch';
  Expanded?: Maybe<IContent>;
  GuidValue?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['Int']['output']>;
  Language?: Maybe<ContentLanguageModelSearch>;
  ProviderName?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  WorkId?: Maybe<Scalars['Int']['output']>;
};

export type ContentModelReferenceSearchExpandedArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ContentModelReferenceSearchLanguageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ContentModelReferenceSearchProviderNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ContentModelReferenceSearchUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ContentModelReferenceSearchFacet = {
  __typename?: 'ContentModelReferenceSearchFacet';
  GuidValue?: Maybe<Array<Maybe<StringFacet>>>;
  Id?: Maybe<Array<Maybe<NumberFacet>>>;
  Language?: Maybe<ContentLanguageModelSearchFacet>;
  ProviderName?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  WorkId?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type ContentModelReferenceSearchFacetGuidValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentModelReferenceSearchFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ContentModelReferenceSearchFacetProviderNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentModelReferenceSearchFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentModelReferenceSearchFacetWorkIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ContentModelReferenceSearchOrderByInput = {
  GuidValue?: InputMaybe<OrderBy>;
  Id?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelSearchOrderByInput>;
  ProviderName?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  WorkId?: InputMaybe<OrderBy>;
};

export type ContentModelReferenceSearchWhereInput = {
  GuidValue?: InputMaybe<StringFilterInput>;
  Id?: InputMaybe<IntFilterInput>;
  Language?: InputMaybe<ContentLanguageModelSearchWhereInput>;
  ProviderName?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<SearchableStringFilterInput>;
  WorkId?: InputMaybe<IntFilterInput>;
};

export type ContentModelReferenceWhereInput = {
  GuidValue?: InputMaybe<StringFilterInput>;
  Id?: InputMaybe<IntFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  ProviderName?: InputMaybe<StringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  WorkId?: InputMaybe<IntFilterInput>;
};

export type ContentOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ContentOutput = {
  __typename?: 'ContentOutput';
  autocomplete?: Maybe<ContentAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ContentFacet>;
  item?: Maybe<IContent>;
  items?: Maybe<Array<Maybe<IContent>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ContentOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Module with an image, description and button. On desktop, the image can be shown at the left or right of the module. */
export type ContentPanelBlock = IContent &
  IData & {
    __typename?: 'ContentPanelBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    BodyText?: Maybe<Scalars['String']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    HasDarkHeading?: Maybe<Scalars['Bool']['output']>;
    Heading?: Maybe<Scalars['String']['output']>;
    Image?: Maybe<ContentModelReference>;
    ImageAlignment?: Maybe<Scalars['String']['output']>;
    IsCTAButton?: Maybe<Scalars['Bool']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    LinkColor?: Maybe<Scalars['String']['output']>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Module with an image, description and button. On desktop, the image can be shown at the left or right of the module. */
export type ContentPanelBlockBodyTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Module with an image, description and button. On desktop, the image can be shown at the left or right of the module. */
export type ContentPanelBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Module with an image, description and button. On desktop, the image can be shown at the left or right of the module. */
export type ContentPanelBlockImageAlignmentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Module with an image, description and button. On desktop, the image can be shown at the left or right of the module. */
export type ContentPanelBlockLinkColorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Module with an image, description and button. On desktop, the image can be shown at the left or right of the module. */
export type ContentPanelBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Module with an image, description and button. On desktop, the image can be shown at the left or right of the module. */
export type ContentPanelBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Module with an image, description and button. On desktop, the image can be shown at the left or right of the module. */
export type ContentPanelBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ContentPanelBlockAutocomplete = {
  __typename?: 'ContentPanelBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ContentPanelBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPanelBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPanelBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPanelBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPanelBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPanelBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPanelBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPanelBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPanelBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPanelBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPanelBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPanelBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPanelBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPanelBlockFacet = {
  __typename?: 'ContentPanelBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BodyText?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  HasDarkHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  ImageAlignment?: Maybe<Array<Maybe<StringFacet>>>;
  IsCTAButton?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LinkColor?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type ContentPanelBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPanelBlockFacetBodyTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPanelBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentPanelBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPanelBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentPanelBlockFacetHasDarkHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPanelBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPanelBlockFacetImageAlignmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPanelBlockFacetIsCtaButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPanelBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPanelBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPanelBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPanelBlockFacetLinkColorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPanelBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPanelBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPanelBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentPanelBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPanelBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPanelBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPanelBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPanelBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentPanelBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPanelBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPanelBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPanelBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentPanelBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPanelBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentPanelBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPanelBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPanelBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ContentPanelBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BodyText?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  HasDarkHeading?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageAlignment?: InputMaybe<OrderBy>;
  IsCTAButton?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LinkColor?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ContentPanelBlockOutput = {
  __typename?: 'ContentPanelBlockOutput';
  autocomplete?: Maybe<ContentPanelBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ContentPanelBlockFacet>;
  item?: Maybe<ContentPanelBlock>;
  items?: Maybe<Array<Maybe<ContentPanelBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ContentPanelBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentPanelBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BodyText?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  HasDarkHeading?: InputMaybe<BoolFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageAlignment?: InputMaybe<SearchableStringFilterInput>;
  IsCTAButton?: InputMaybe<BoolFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LinkColor?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ContentPanelBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ContentPanelBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ContentPanelBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Cards with an Image, Description and an optional button. */
export type ContentPodBlock = IContent &
  IData & {
    __typename?: 'ContentPodBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    Image?: Maybe<ContentModelReference>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    ShowOutline?: Maybe<Scalars['Bool']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Cards with an Image, Description and an optional button. */
export type ContentPodBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Cards with an Image, Description and an optional button. */
export type ContentPodBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Cards with an Image, Description and an optional button. */
export type ContentPodBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Cards with an Image, Description and an optional button. */
export type ContentPodBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Cards with an Image, Description and an optional button. */
export type ContentPodBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ContentPodBlockAutocomplete = {
  __typename?: 'ContentPodBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ContentPodBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodBlockFacet = {
  __typename?: 'ContentPodBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  ShowOutline?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type ContentPodBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentPodBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentPodBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentPodBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentPodBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodBlockFacetShowOutlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentPodBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentPodBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ContentPodBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  ShowOutline?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ContentPodBlockOutput = {
  __typename?: 'ContentPodBlockOutput';
  autocomplete?: Maybe<ContentPodBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ContentPodBlockFacet>;
  item?: Maybe<ContentPodBlock>;
  items?: Maybe<Array<Maybe<ContentPodBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ContentPodBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentPodBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  ShowOutline?: InputMaybe<BoolFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ContentPodBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ContentPodBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ContentPodBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Allow content authors to add Content Pod cards. */
export type ContentPodGroupBlock = IContent &
  IData & {
    __typename?: 'ContentPodGroupBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentPodItems?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Allow content authors to add Content Pod cards. */
export type ContentPodGroupBlockContentPodItemsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add Content Pod cards. */
export type ContentPodGroupBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add Content Pod cards. */
export type ContentPodGroupBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add Content Pod cards. */
export type ContentPodGroupBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add Content Pod cards. */
export type ContentPodGroupBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ContentPodGroupBlockAutocomplete = {
  __typename?: 'ContentPodGroupBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ContentPodGroupBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodGroupBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodGroupBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodGroupBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodGroupBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodGroupBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodGroupBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodGroupBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodGroupBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodGroupBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodGroupBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodGroupBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodGroupBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodGroupBlockFacet = {
  __typename?: 'ContentPodGroupBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentPodItems?: Maybe<ContentAreaItemModelSearchFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type ContentPodGroupBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodGroupBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentPodGroupBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodGroupBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentPodGroupBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodGroupBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodGroupBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodGroupBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodGroupBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodGroupBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodGroupBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentPodGroupBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodGroupBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodGroupBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodGroupBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodGroupBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentPodGroupBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodGroupBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodGroupBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodGroupBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentPodGroupBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodGroupBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentPodGroupBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodGroupBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodGroupBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ContentPodGroupBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentPodItems?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ContentPodGroupBlockOutput = {
  __typename?: 'ContentPodGroupBlockOutput';
  autocomplete?: Maybe<ContentPodGroupBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ContentPodGroupBlockFacet>;
  item?: Maybe<ContentPodGroupBlock>;
  items?: Maybe<Array<Maybe<ContentPodGroupBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ContentPodGroupBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentPodGroupBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentPodItems?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ContentPodGroupBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ContentPodGroupBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ContentPodGroupBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Allow content authors to add content pod multi rate card */
export type ContentPodMultiRateCardBlock = IContent &
  IData & {
    __typename?: 'ContentPodMultiRateCardBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    IconReference?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RateCondition?: Maybe<Scalars['String']['output']>;
    /** Rate selection from list */
    RateId?: Maybe<Scalars['String']['output']>;
    RateTerm?: Maybe<Scalars['String']['output']>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Allow content authors to add content pod multi rate card */
export type ContentPodMultiRateCardBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add content pod multi rate card */
export type ContentPodMultiRateCardBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add content pod multi rate card */
export type ContentPodMultiRateCardBlockIconReferenceArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add content pod multi rate card */
export type ContentPodMultiRateCardBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add content pod multi rate card */
export type ContentPodMultiRateCardBlockRateConditionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add content pod multi rate card */
export type ContentPodMultiRateCardBlockRateIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add content pod multi rate card */
export type ContentPodMultiRateCardBlockRateTermArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add content pod multi rate card */
export type ContentPodMultiRateCardBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add content pod multi rate card */
export type ContentPodMultiRateCardBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ContentPodMultiRateCardBlockAutocomplete = {
  __typename?: 'ContentPodMultiRateCardBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ContentPodMultiRateCardBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodMultiRateCardBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodMultiRateCardBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodMultiRateCardBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodMultiRateCardBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodMultiRateCardBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodMultiRateCardBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodMultiRateCardBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodMultiRateCardBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodMultiRateCardBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodMultiRateCardBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodMultiRateCardBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodMultiRateCardBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodMultiRateCardBlockFacet = {
  __typename?: 'ContentPodMultiRateCardBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IconReference?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RateCondition?: Maybe<Array<Maybe<StringFacet>>>;
  RateId?: Maybe<Array<Maybe<StringFacet>>>;
  RateTerm?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type ContentPodMultiRateCardBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateCardBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentPodMultiRateCardBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateCardBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentPodMultiRateCardBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateCardBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateCardBlockFacetIconReferenceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateCardBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateCardBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateCardBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateCardBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateCardBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateCardBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentPodMultiRateCardBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateCardBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateCardBlockFacetRateConditionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateCardBlockFacetRateIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateCardBlockFacetRateTermArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateCardBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateCardBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateCardBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentPodMultiRateCardBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateCardBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateCardBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateCardBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentPodMultiRateCardBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateCardBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentPodMultiRateCardBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateCardBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateCardBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ContentPodMultiRateCardBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  IconReference?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RateCondition?: InputMaybe<OrderBy>;
  RateId?: InputMaybe<OrderBy>;
  RateTerm?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ContentPodMultiRateCardBlockOutput = {
  __typename?: 'ContentPodMultiRateCardBlockOutput';
  autocomplete?: Maybe<ContentPodMultiRateCardBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ContentPodMultiRateCardBlockFacet>;
  item?: Maybe<ContentPodMultiRateCardBlock>;
  items?: Maybe<Array<Maybe<ContentPodMultiRateCardBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ContentPodMultiRateCardBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentPodMultiRateCardBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IconReference?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RateCondition?: InputMaybe<SearchableStringFilterInput>;
  RateId?: InputMaybe<SearchableStringFilterInput>;
  RateTerm?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ContentPodMultiRateCardBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ContentPodMultiRateCardBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ContentPodMultiRateCardBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Allow content authors to add content pod multi rate card */
export type ContentPodMultiRateGroupBlock = IContent &
  IData & {
    __typename?: 'ContentPodMultiRateGroupBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentPodMultiRateCards?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Allow content authors to add content pod multi rate card */
export type ContentPodMultiRateGroupBlockContentPodMultiRateCardsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add content pod multi rate card */
export type ContentPodMultiRateGroupBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add content pod multi rate card */
export type ContentPodMultiRateGroupBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add content pod multi rate card */
export type ContentPodMultiRateGroupBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add content pod multi rate card */
export type ContentPodMultiRateGroupBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ContentPodMultiRateGroupBlockAutocomplete = {
  __typename?: 'ContentPodMultiRateGroupBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ContentPodMultiRateGroupBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodMultiRateGroupBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodMultiRateGroupBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodMultiRateGroupBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodMultiRateGroupBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodMultiRateGroupBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodMultiRateGroupBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodMultiRateGroupBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodMultiRateGroupBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodMultiRateGroupBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodMultiRateGroupBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodMultiRateGroupBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodMultiRateGroupBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentPodMultiRateGroupBlockFacet = {
  __typename?: 'ContentPodMultiRateGroupBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentPodMultiRateCards?: Maybe<ContentAreaItemModelSearchFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type ContentPodMultiRateGroupBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateGroupBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentPodMultiRateGroupBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateGroupBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentPodMultiRateGroupBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateGroupBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateGroupBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateGroupBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateGroupBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateGroupBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateGroupBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentPodMultiRateGroupBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateGroupBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateGroupBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateGroupBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateGroupBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentPodMultiRateGroupBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateGroupBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateGroupBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateGroupBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentPodMultiRateGroupBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateGroupBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentPodMultiRateGroupBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateGroupBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentPodMultiRateGroupBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ContentPodMultiRateGroupBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentPodMultiRateCards?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ContentPodMultiRateGroupBlockOutput = {
  __typename?: 'ContentPodMultiRateGroupBlockOutput';
  autocomplete?: Maybe<ContentPodMultiRateGroupBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ContentPodMultiRateGroupBlockFacet>;
  item?: Maybe<ContentPodMultiRateGroupBlock>;
  items?: Maybe<Array<Maybe<ContentPodMultiRateGroupBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ContentPodMultiRateGroupBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentPodMultiRateGroupBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentPodMultiRateCards?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ContentPodMultiRateGroupBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ContentPodMultiRateGroupBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ContentPodMultiRateGroupBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ContentRootsModel = {
  __typename?: 'ContentRootsModel';
  ContentAssetsRoot?: Maybe<ContentModelReference>;
  GlobalAssetsRoot?: Maybe<ContentModelReference>;
  RootPage?: Maybe<ContentModelReference>;
  SiteAssetsRoot?: Maybe<ContentModelReference>;
  StartPage?: Maybe<ContentModelReference>;
  WasteBasket?: Maybe<ContentModelReference>;
};

export type ContentRootsModelAutocomplete = {
  __typename?: 'ContentRootsModelAutocomplete';
  ContentAssetsRoot?: Maybe<ContentModelReferenceAutocomplete>;
  GlobalAssetsRoot?: Maybe<ContentModelReferenceAutocomplete>;
  RootPage?: Maybe<ContentModelReferenceAutocomplete>;
  SiteAssetsRoot?: Maybe<ContentModelReferenceAutocomplete>;
  StartPage?: Maybe<ContentModelReferenceAutocomplete>;
  WasteBasket?: Maybe<ContentModelReferenceAutocomplete>;
};

export type ContentRootsModelFacet = {
  __typename?: 'ContentRootsModelFacet';
  ContentAssetsRoot?: Maybe<ContentModelReferenceFacet>;
  GlobalAssetsRoot?: Maybe<ContentModelReferenceFacet>;
  RootPage?: Maybe<ContentModelReferenceFacet>;
  SiteAssetsRoot?: Maybe<ContentModelReferenceFacet>;
  StartPage?: Maybe<ContentModelReferenceFacet>;
  WasteBasket?: Maybe<ContentModelReferenceFacet>;
};

export type ContentRootsModelOrderByInput = {
  ContentAssetsRoot?: InputMaybe<ContentModelReferenceOrderByInput>;
  GlobalAssetsRoot?: InputMaybe<ContentModelReferenceOrderByInput>;
  RootPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  SiteAssetsRoot?: InputMaybe<ContentModelReferenceOrderByInput>;
  StartPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  WasteBasket?: InputMaybe<ContentModelReferenceOrderByInput>;
};

export type ContentRootsModelWhereInput = {
  ContentAssetsRoot?: InputMaybe<ContentModelReferenceWhereInput>;
  GlobalAssetsRoot?: InputMaybe<ContentModelReferenceWhereInput>;
  RootPage?: InputMaybe<ContentModelReferenceWhereInput>;
  SiteAssetsRoot?: InputMaybe<ContentModelReferenceWhereInput>;
  StartPage?: InputMaybe<ContentModelReferenceWhereInput>;
  WasteBasket?: InputMaybe<ContentModelReferenceWhereInput>;
};

export type ContentWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ContentWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ContentWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ContentWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Will pull data from a cookie if available. If not it will also look in the query string. */
export type CookieHiddenElementBlock = IContent &
  IData & {
    __typename?: 'CookieHiddenElementBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    PredefinedValue?: Maybe<Scalars['String']['output']>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Will pull data from a cookie if available. If not it will also look in the query string. */
export type CookieHiddenElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Will pull data from a cookie if available. If not it will also look in the query string. */
export type CookieHiddenElementBlockPredefinedValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Will pull data from a cookie if available. If not it will also look in the query string. */
export type CookieHiddenElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Will pull data from a cookie if available. If not it will also look in the query string. */
export type CookieHiddenElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CookieHiddenElementBlockAutocomplete = {
  __typename?: 'CookieHiddenElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CookieHiddenElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CookieHiddenElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CookieHiddenElementBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CookieHiddenElementBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CookieHiddenElementBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CookieHiddenElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CookieHiddenElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CookieHiddenElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CookieHiddenElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CookieHiddenElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CookieHiddenElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CookieHiddenElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CookieHiddenElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CookieHiddenElementBlockFacet = {
  __typename?: 'CookieHiddenElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PredefinedValue?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type CookieHiddenElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CookieHiddenElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CookieHiddenElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CookieHiddenElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CookieHiddenElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CookieHiddenElementBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CookieHiddenElementBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CookieHiddenElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CookieHiddenElementBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CookieHiddenElementBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CookieHiddenElementBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CookieHiddenElementBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CookieHiddenElementBlockFacetPredefinedValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CookieHiddenElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CookieHiddenElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CookieHiddenElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CookieHiddenElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CookieHiddenElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CookieHiddenElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CookieHiddenElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CookieHiddenElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CookieHiddenElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CookieHiddenElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CookieHiddenElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CookieHiddenElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CookieHiddenElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PredefinedValue?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CookieHiddenElementBlockOutput = {
  __typename?: 'CookieHiddenElementBlockOutput';
  autocomplete?: Maybe<CookieHiddenElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CookieHiddenElementBlockFacet>;
  item?: Maybe<CookieHiddenElementBlock>;
  items?: Maybe<Array<Maybe<CookieHiddenElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type CookieHiddenElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CookieHiddenElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PredefinedValue?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CookieHiddenElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CookieHiddenElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CookieHiddenElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type CountrySelectionElementBlock = IContent &
  IData & {
    __typename?: 'CountrySelectionElementBlock';
    AllowMultiSelect?: Maybe<Scalars['Bool']['output']>;
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ConditionCombination?: Maybe<Scalars['Int']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Feed?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Label?: Maybe<Scalars['String']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    PlaceHolder?: Maybe<Scalars['String']['output']>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    SatisfiedAction?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    Validators?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

export type CountrySelectionElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CountrySelectionElementBlockFeedArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CountrySelectionElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CountrySelectionElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CountrySelectionElementBlockPlaceHolderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CountrySelectionElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CountrySelectionElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CountrySelectionElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CountrySelectionElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CountrySelectionElementBlockAutocomplete = {
  __typename?: 'CountrySelectionElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CountrySelectionElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CountrySelectionElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CountrySelectionElementBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CountrySelectionElementBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CountrySelectionElementBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CountrySelectionElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CountrySelectionElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CountrySelectionElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CountrySelectionElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CountrySelectionElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CountrySelectionElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CountrySelectionElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CountrySelectionElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CountrySelectionElementBlockFacet = {
  __typename?: 'CountrySelectionElementBlockFacet';
  AllowMultiSelect?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Feed?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PlaceHolder?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type CountrySelectionElementBlockFacetAllowMultiSelectArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CountrySelectionElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CountrySelectionElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CountrySelectionElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CountrySelectionElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CountrySelectionElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CountrySelectionElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CountrySelectionElementBlockFacetFeedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CountrySelectionElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CountrySelectionElementBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CountrySelectionElementBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CountrySelectionElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CountrySelectionElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CountrySelectionElementBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CountrySelectionElementBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CountrySelectionElementBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CountrySelectionElementBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CountrySelectionElementBlockFacetPlaceHolderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CountrySelectionElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CountrySelectionElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CountrySelectionElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CountrySelectionElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CountrySelectionElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CountrySelectionElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CountrySelectionElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CountrySelectionElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CountrySelectionElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CountrySelectionElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CountrySelectionElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CountrySelectionElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CountrySelectionElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CountrySelectionElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CountrySelectionElementBlockOrderByInput = {
  AllowMultiSelect?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Feed?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PlaceHolder?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CountrySelectionElementBlockOutput = {
  __typename?: 'CountrySelectionElementBlockOutput';
  autocomplete?: Maybe<CountrySelectionElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CountrySelectionElementBlockFacet>;
  item?: Maybe<CountrySelectionElementBlock>;
  items?: Maybe<Array<Maybe<CountrySelectionElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type CountrySelectionElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CountrySelectionElementBlockWhereInput = {
  AllowMultiSelect?: InputMaybe<BoolFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Feed?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PlaceHolder?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CountrySelectionElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CountrySelectionElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CountrySelectionElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Allow content authors to add currency converter */
export type CurrencyConverterBlock = IContent &
  IData & {
    __typename?: 'CurrencyConverterBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Disclaimer?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Allow content authors to add currency converter */
export type CurrencyConverterBlockDisclaimerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add currency converter */
export type CurrencyConverterBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add currency converter */
export type CurrencyConverterBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add currency converter */
export type CurrencyConverterBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add currency converter */
export type CurrencyConverterBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CurrencyConverterBlockAutocomplete = {
  __typename?: 'CurrencyConverterBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CurrencyConverterBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CurrencyConverterBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CurrencyConverterBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CurrencyConverterBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CurrencyConverterBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CurrencyConverterBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CurrencyConverterBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CurrencyConverterBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CurrencyConverterBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CurrencyConverterBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CurrencyConverterBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CurrencyConverterBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CurrencyConverterBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CurrencyConverterBlockFacet = {
  __typename?: 'CurrencyConverterBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Disclaimer?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type CurrencyConverterBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CurrencyConverterBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CurrencyConverterBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CurrencyConverterBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CurrencyConverterBlockFacetDisclaimerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CurrencyConverterBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CurrencyConverterBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CurrencyConverterBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CurrencyConverterBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CurrencyConverterBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CurrencyConverterBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CurrencyConverterBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CurrencyConverterBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CurrencyConverterBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CurrencyConverterBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CurrencyConverterBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CurrencyConverterBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CurrencyConverterBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CurrencyConverterBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CurrencyConverterBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CurrencyConverterBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CurrencyConverterBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CurrencyConverterBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CurrencyConverterBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CurrencyConverterBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CurrencyConverterBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CurrencyConverterBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Disclaimer?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CurrencyConverterBlockOutput = {
  __typename?: 'CurrencyConverterBlockOutput';
  autocomplete?: Maybe<CurrencyConverterBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CurrencyConverterBlockFacet>;
  item?: Maybe<CurrencyConverterBlock>;
  items?: Maybe<Array<Maybe<CurrencyConverterBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type CurrencyConverterBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CurrencyConverterBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Disclaimer?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CurrencyConverterBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CurrencyConverterBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CurrencyConverterBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Module to allow to add Optimizely forms using the current website styles. */
export type CustomFormContainerBlock = IContent &
  IData & {
    __typename?: 'CustomFormContainerBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    OptiForm?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Title?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Module to allow to add Optimizely forms using the current website styles. */
export type CustomFormContainerBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Module to allow to add Optimizely forms using the current website styles. */
export type CustomFormContainerBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Module to allow to add Optimizely forms using the current website styles. */
export type CustomFormContainerBlockOptiFormArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Module to allow to add Optimizely forms using the current website styles. */
export type CustomFormContainerBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Module to allow to add Optimizely forms using the current website styles. */
export type CustomFormContainerBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Module to allow to add Optimizely forms using the current website styles. */
export type CustomFormContainerBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CustomFormContainerBlockAutocomplete = {
  __typename?: 'CustomFormContainerBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CustomFormContainerBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CustomFormContainerBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CustomFormContainerBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CustomFormContainerBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CustomFormContainerBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CustomFormContainerBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CustomFormContainerBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CustomFormContainerBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CustomFormContainerBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CustomFormContainerBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CustomFormContainerBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CustomFormContainerBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CustomFormContainerBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CustomFormContainerBlockFacet = {
  __typename?: 'CustomFormContainerBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  OptiForm?: Maybe<ContentAreaItemModelSearchFacet>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type CustomFormContainerBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CustomFormContainerBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomFormContainerBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CustomFormContainerBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomFormContainerBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CustomFormContainerBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CustomFormContainerBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CustomFormContainerBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CustomFormContainerBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CustomFormContainerBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CustomFormContainerBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomFormContainerBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CustomFormContainerBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CustomFormContainerBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CustomFormContainerBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CustomFormContainerBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomFormContainerBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CustomFormContainerBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CustomFormContainerBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CustomFormContainerBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomFormContainerBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CustomFormContainerBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomFormContainerBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CustomFormContainerBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CustomFormContainerBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CustomFormContainerBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CustomFormContainerBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  OptiForm?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CustomFormContainerBlockOutput = {
  __typename?: 'CustomFormContainerBlockOutput';
  autocomplete?: Maybe<CustomFormContainerBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CustomFormContainerBlockFacet>;
  item?: Maybe<CustomFormContainerBlock>;
  items?: Maybe<Array<Maybe<CustomFormContainerBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type CustomFormContainerBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomFormContainerBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  OptiForm?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CustomFormContainerBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CustomFormContainerBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CustomFormContainerBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type Data = IData & {
  __typename?: 'Data';
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
};

export type Data_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type Data_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DataOrderByInput = {
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type DataOutput = {
  __typename?: 'DataOutput';
  cursor?: Maybe<Scalars['String']['output']>;
  item?: Maybe<IData>;
  items?: Maybe<Array<Maybe<IData>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type DataOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DataWhereInput = {
  _and?: InputMaybe<Array<InputMaybe<DataWhereInput>>>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DataWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DataWhereInput>>>;
};

export type DateFacet = {
  __typename?: 'DateFacet';
  count?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum DateFacetUnit {
  /** Defined as 24 hours (86,400,000 milliseconds). All days begin at the earliest possible time, which is usually 00:00:00 (midnight). */
  Day = 'DAY',
  /** Defined as 60 minutes each (3,600,000 milliseconds). All hours begin at 00 minutes and 00 seconds. */
  Hour = 'HOUR',
  /** Defined as 1000 milliseconds each. */
  Minute = 'MINUTE'
}

export type DateFilterInput = {
  /** `boost` influences the weight of a field by boosting a match with a number (default: 1) — counts more towards the eventual relevance score which can be projected with `_score` — at query time. Note that `boost` cannot be a negative number. */
  boost?: InputMaybe<Scalars['Int']['input']>;
  /** `decay` influences the weight of the score with a decay function. For example, results that have a more recent datetime will be ranked higher. The `origin` will be `now()` in case not specified. The `scale` is by default 10. The `rate` must be in the range `[0..1]`. */
  decay?: InputMaybe<Decay>;
  /** `eq` matches on an exact value, but the value is case-insensitive. */
  eq?: InputMaybe<Scalars['Date']['input']>;
  /** `exist` matches results that have this field. */
  exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** `gt` retrieves results with matches that have a value which is `greater than` it. */
  gt?: InputMaybe<Scalars['Date']['input']>;
  /** `gte` retrieves results with matches that have a value which is `greater than or equal to` it. */
  gte?: InputMaybe<Scalars['Date']['input']>;
  /** `lt` retrieves results with matches that have a value which is `lower than` it. */
  lt?: InputMaybe<Scalars['Date']['input']>;
  /** `lte` retrieves results with matches that have a value which is `lower than or equal to` it. */
  lte?: InputMaybe<Scalars['Date']['input']>;
  /** `not_eq` retrieves results not matching with an exact (but case-insensitive) value. */
  notEq?: InputMaybe<Scalars['Date']['input']>;
};

/** Decay influences the weight of the score based on field values with a decay function */
export type Decay = {
  origin?: InputMaybe<Scalars['Date']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  scale?: InputMaybe<Scalars['Int']['input']>;
};

/** Used for document file types such as PDF, Word, Excel */
export type DocumentMediaData = IContent &
  IData & {
    __typename?: 'DocumentMediaData';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    Content?: Maybe<Scalars['String']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    /** Description of the document */
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    MimeType?: Maybe<Scalars['String']['output']>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Thumbnail?: Maybe<BlobModel>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Used for document file types such as PDF, Word, Excel */
export type DocumentMediaDataContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for document file types such as PDF, Word, Excel */
export type DocumentMediaDataDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for document file types such as PDF, Word, Excel */
export type DocumentMediaDataNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for document file types such as PDF, Word, Excel */
export type DocumentMediaData_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for document file types such as PDF, Word, Excel */
export type DocumentMediaData_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DocumentMediaDataAutocomplete = {
  __typename?: 'DocumentMediaDataAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MimeType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Thumbnail?: Maybe<BlobModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type DocumentMediaDataAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DocumentMediaDataAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DocumentMediaDataAutocompleteMimeTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DocumentMediaDataAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DocumentMediaDataAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DocumentMediaDataAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DocumentMediaDataAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DocumentMediaDataAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DocumentMediaDataAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DocumentMediaDataAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DocumentMediaDataAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DocumentMediaDataAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DocumentMediaDataAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DocumentMediaDataAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DocumentMediaDataFacet = {
  __typename?: 'DocumentMediaDataFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MimeType?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Thumbnail?: Maybe<BlobModelFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type DocumentMediaDataFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DocumentMediaDataFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentMediaDataFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DocumentMediaDataFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DocumentMediaDataFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentMediaDataFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DocumentMediaDataFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DocumentMediaDataFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DocumentMediaDataFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DocumentMediaDataFacetMimeTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DocumentMediaDataFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DocumentMediaDataFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DocumentMediaDataFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentMediaDataFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DocumentMediaDataFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DocumentMediaDataFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DocumentMediaDataFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DocumentMediaDataFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentMediaDataFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DocumentMediaDataFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DocumentMediaDataFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DocumentMediaDataFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentMediaDataFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DocumentMediaDataFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentMediaDataFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DocumentMediaDataFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DocumentMediaDataFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type DocumentMediaDataOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MimeType?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Thumbnail?: InputMaybe<BlobModelOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type DocumentMediaDataOutput = {
  __typename?: 'DocumentMediaDataOutput';
  autocomplete?: Maybe<DocumentMediaDataAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<DocumentMediaDataFacet>;
  item?: Maybe<DocumentMediaData>;
  items?: Maybe<Array<Maybe<DocumentMediaData>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type DocumentMediaDataOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentMediaDataWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MimeType?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Thumbnail?: InputMaybe<BlobModelWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<DocumentMediaDataWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DocumentMediaDataWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DocumentMediaDataWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ErrorPage = IContent &
  IData & {
    __typename?: 'ErrorPage';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    AuthorMetaData?: Maybe<Scalars['String']['output']>;
    BreadcrumbsTitle?: Maybe<Scalars['String']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    DisableIndexing?: Maybe<Scalars['Bool']['output']>;
    /** This will determine whether or not to show on search. */
    ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
    /** This will determine whether or not to show on the Sitemap. */
    ExcludeFromSitemap?: Maybe<Scalars['Bool']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    FooterOverride?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    HeaderOverride?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    /** This will determine whether or not to be dispalyed in breadcrumbs. */
    HideInBreadcrumbs?: Maybe<Scalars['Bool']['output']>;
    HideSiteFooter?: Maybe<Scalars['Bool']['output']>;
    HideSiteHeader?: Maybe<Scalars['Bool']['output']>;
    Highlight?: Maybe<Scalars['Bool']['output']>;
    Industry?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Keywords?: Maybe<Scalars['String']['output']>;
    /** Container for Schema Field */
    LDJsonContainer?: Maybe<Scalars['String']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MainContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    MetaContentType?: Maybe<Scalars['String']['output']>;
    MetaTitle?: Maybe<Scalars['String']['output']>;
    Name?: Maybe<Scalars['String']['output']>;
    NavigationTitle?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Description value that has been managed for the current page */
    OpenGraphDescription?: Maybe<Scalars['String']['output']>;
    /** Page template will always inherit the OpenGraph image from the parent page, recursively, until an image is managed for the current page */
    OpenGraphImage?: Maybe<ContentModelReference>;
    /** If managed, this field will overwrite the Image Height value that has been managed for the current page */
    OpenGraphImageHeight?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Image Type value that has been managed for the current page */
    OpenGraphImageType?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Image Width  value that has been managed for the current page */
    OpenGraphImageWidth?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Site value that has been managed for the current page */
    OpenGraphSite?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Title value that has been managed for the current page */
    OpenGraphTitle?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Url value that has been managed for the current page */
    OpenGraphUrl?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Type value that has been managed for the current page */
    OpenGraphtype?: Maybe<Scalars['String']['output']>;
    PageDescription?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    TeaserText?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

export type ErrorPageAuthorMetaDataArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ErrorPageFooterOverrideArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ErrorPageHeaderOverrideArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ErrorPageIndustryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ErrorPageKeywordsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ErrorPageLdJsonContainerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ErrorPageMainContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ErrorPageMetaContentTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ErrorPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ErrorPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ErrorPageNavigationTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ErrorPageOpenGraphDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ErrorPageOpenGraphImageHeightArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ErrorPageOpenGraphImageTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ErrorPageOpenGraphImageWidthArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ErrorPageOpenGraphSiteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ErrorPageOpenGraphTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ErrorPageOpenGraphUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ErrorPageOpenGraphtypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ErrorPagePageDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ErrorPageTeaserTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ErrorPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ErrorPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ErrorPageAutocomplete = {
  __typename?: 'ErrorPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  OpenGraphImage?: Maybe<ContentModelReferenceAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ErrorPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ErrorPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ErrorPageAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ErrorPageAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ErrorPageAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ErrorPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ErrorPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ErrorPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ErrorPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ErrorPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ErrorPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ErrorPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ErrorPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ErrorPageFacet = {
  __typename?: 'ErrorPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AuthorMetaData?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSitemap?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FooterOverride?: Maybe<ContentAreaItemModelSearchFacet>;
  HeaderOverride?: Maybe<ContentAreaItemModelSearchFacet>;
  HideInBreadcrumbs?: Maybe<Array<Maybe<StringFacet>>>;
  HideSiteFooter?: Maybe<Array<Maybe<StringFacet>>>;
  HideSiteHeader?: Maybe<Array<Maybe<StringFacet>>>;
  Highlight?: Maybe<Array<Maybe<StringFacet>>>;
  Industry?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Keywords?: Maybe<Array<Maybe<StringFacet>>>;
  LDJsonContainer?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaContentType?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NavigationTitle?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphDescription?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphImage?: Maybe<ContentModelReferenceFacet>;
  OpenGraphImageHeight?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphImageType?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphImageWidth?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphSite?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphTitle?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphUrl?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphtype?: Maybe<Array<Maybe<StringFacet>>>;
  PageDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TeaserText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type ErrorPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetAuthorMetaDataArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ErrorPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ErrorPageFacetDisableIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetExcludeFromSitemapArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetHideInBreadcrumbsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetHideSiteFooterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetHideSiteHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetHighlightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetIndustryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetKeywordsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetLdJsonContainerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetMetaContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetNavigationTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetOpenGraphDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetOpenGraphImageHeightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetOpenGraphImageTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetOpenGraphImageWidthArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetOpenGraphSiteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetOpenGraphTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetOpenGraphUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetOpenGraphtypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetPageDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ErrorPageFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ErrorPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ErrorPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ErrorPageFacetTeaserTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ErrorPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AuthorMetaData?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExcludeFromSitemap?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FooterOverride?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  HeaderOverride?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  HideInBreadcrumbs?: InputMaybe<OrderBy>;
  HideSiteFooter?: InputMaybe<OrderBy>;
  HideSiteHeader?: InputMaybe<OrderBy>;
  Highlight?: InputMaybe<OrderBy>;
  Industry?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Keywords?: InputMaybe<OrderBy>;
  LDJsonContainer?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaContentType?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NavigationTitle?: InputMaybe<OrderBy>;
  OpenGraphDescription?: InputMaybe<OrderBy>;
  OpenGraphImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  OpenGraphImageHeight?: InputMaybe<OrderBy>;
  OpenGraphImageType?: InputMaybe<OrderBy>;
  OpenGraphImageWidth?: InputMaybe<OrderBy>;
  OpenGraphSite?: InputMaybe<OrderBy>;
  OpenGraphTitle?: InputMaybe<OrderBy>;
  OpenGraphUrl?: InputMaybe<OrderBy>;
  OpenGraphtype?: InputMaybe<OrderBy>;
  PageDescription?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TeaserText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ErrorPageOutput = {
  __typename?: 'ErrorPageOutput';
  autocomplete?: Maybe<ErrorPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ErrorPageFacet>;
  item?: Maybe<ErrorPage>;
  items?: Maybe<Array<Maybe<ErrorPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ErrorPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ErrorPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AuthorMetaData?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExcludeFromSitemap?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FooterOverride?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  HeaderOverride?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  HideInBreadcrumbs?: InputMaybe<BoolFilterInput>;
  HideSiteFooter?: InputMaybe<BoolFilterInput>;
  HideSiteHeader?: InputMaybe<BoolFilterInput>;
  Highlight?: InputMaybe<BoolFilterInput>;
  Industry?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Keywords?: InputMaybe<SearchableStringFilterInput>;
  LDJsonContainer?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaContentType?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NavigationTitle?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphDescription?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphImage?: InputMaybe<ContentModelReferenceWhereInput>;
  OpenGraphImageHeight?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphImageType?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphImageWidth?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphSite?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphTitle?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphUrl?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphtype?: InputMaybe<SearchableStringFilterInput>;
  PageDescription?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TeaserText?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ErrorPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ErrorPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ErrorPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Used for executable file types such as EXE. */
export type ExecutableMediaData = IContent &
  IData & {
    __typename?: 'ExecutableMediaData';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    Content?: Maybe<Scalars['String']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    FileSize?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    MimeType?: Maybe<Scalars['String']['output']>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Thumbnail?: Maybe<BlobModel>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Used for executable file types such as EXE. */
export type ExecutableMediaDataContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for executable file types such as EXE. */
export type ExecutableMediaDataFileSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for executable file types such as EXE. */
export type ExecutableMediaDataNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for executable file types such as EXE. */
export type ExecutableMediaData_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for executable file types such as EXE. */
export type ExecutableMediaData_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ExecutableMediaDataAutocomplete = {
  __typename?: 'ExecutableMediaDataAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MimeType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Thumbnail?: Maybe<BlobModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ExecutableMediaDataAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExecutableMediaDataAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExecutableMediaDataAutocompleteMimeTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExecutableMediaDataAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExecutableMediaDataAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExecutableMediaDataAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExecutableMediaDataAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExecutableMediaDataAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExecutableMediaDataAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExecutableMediaDataAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExecutableMediaDataAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExecutableMediaDataAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExecutableMediaDataAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExecutableMediaDataAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExecutableMediaDataFacet = {
  __typename?: 'ExecutableMediaDataFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileSize?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MimeType?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Thumbnail?: Maybe<BlobModelFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type ExecutableMediaDataFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExecutableMediaDataFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ExecutableMediaDataFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExecutableMediaDataFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExecutableMediaDataFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ExecutableMediaDataFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExecutableMediaDataFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExecutableMediaDataFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExecutableMediaDataFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExecutableMediaDataFacetMimeTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExecutableMediaDataFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExecutableMediaDataFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExecutableMediaDataFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ExecutableMediaDataFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExecutableMediaDataFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExecutableMediaDataFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExecutableMediaDataFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExecutableMediaDataFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ExecutableMediaDataFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExecutableMediaDataFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExecutableMediaDataFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExecutableMediaDataFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ExecutableMediaDataFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExecutableMediaDataFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ExecutableMediaDataFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExecutableMediaDataFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExecutableMediaDataFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ExecutableMediaDataOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileSize?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MimeType?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Thumbnail?: InputMaybe<BlobModelOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ExecutableMediaDataOutput = {
  __typename?: 'ExecutableMediaDataOutput';
  autocomplete?: Maybe<ExecutableMediaDataAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ExecutableMediaDataFacet>;
  item?: Maybe<ExecutableMediaData>;
  items?: Maybe<Array<Maybe<ExecutableMediaData>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ExecutableMediaDataOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExecutableMediaDataWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileSize?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MimeType?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Thumbnail?: InputMaybe<BlobModelWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ExecutableMediaDataWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ExecutableMediaDataWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ExecutableMediaDataWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Dialog that show when leaving from the website */
export type ExitIntentModal = IContent &
  IData & {
    __typename?: 'ExitIntentModal';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  CTA button label */
    ButtonText?: Maybe<Scalars['String']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    /**  Add $url where we have to replace website name */
    Description?: Maybe<Scalars['String']['output']>;
    /** Add websites list with comma separator example: www.abc.com,www.xyz.com */
    ExcludeWebsitesUrlList?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Dialog that show when leaving from the website */
export type ExitIntentModalButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Dialog that show when leaving from the website */
export type ExitIntentModalDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Dialog that show when leaving from the website */
export type ExitIntentModalExcludeWebsitesUrlListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Dialog that show when leaving from the website */
export type ExitIntentModalHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Dialog that show when leaving from the website */
export type ExitIntentModalNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Dialog that show when leaving from the website */
export type ExitIntentModal_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Dialog that show when leaving from the website */
export type ExitIntentModal_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ExitIntentModalAutocomplete = {
  __typename?: 'ExitIntentModalAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ExitIntentModalAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExitIntentModalAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExitIntentModalAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExitIntentModalAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExitIntentModalAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExitIntentModalAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExitIntentModalAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExitIntentModalAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExitIntentModalAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExitIntentModalAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExitIntentModalAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExitIntentModalAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExitIntentModalAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExitIntentModalFacet = {
  __typename?: 'ExitIntentModalFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  ButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeWebsitesUrlList?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type ExitIntentModalFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExitIntentModalFacetButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExitIntentModalFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ExitIntentModalFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExitIntentModalFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ExitIntentModalFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExitIntentModalFacetExcludeWebsitesUrlListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExitIntentModalFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExitIntentModalFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExitIntentModalFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExitIntentModalFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExitIntentModalFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExitIntentModalFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExitIntentModalFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ExitIntentModalFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExitIntentModalFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExitIntentModalFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExitIntentModalFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExitIntentModalFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ExitIntentModalFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExitIntentModalFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExitIntentModalFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExitIntentModalFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ExitIntentModalFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExitIntentModalFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ExitIntentModalFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExitIntentModalFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExitIntentModalFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ExitIntentModalOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  ButtonText?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExcludeWebsitesUrlList?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ExitIntentModalOutput = {
  __typename?: 'ExitIntentModalOutput';
  autocomplete?: Maybe<ExitIntentModalAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ExitIntentModalFacet>;
  item?: Maybe<ExitIntentModal>;
  items?: Maybe<Array<Maybe<ExitIntentModal>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ExitIntentModalOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExitIntentModalWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  ButtonText?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExcludeWebsitesUrlList?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ExitIntentModalWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ExitIntentModalWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ExitIntentModalWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export enum FactorModifier {
  /** Add 1 to the field value and take the natural logarithm */
  Log = 'LOG',
  /** Do not apply any multiplier to the field value */
  None = 'NONE',
  /** Reciprocate the field value, same as 1/x where x is the field's value */
  Reciprocal = 'RECIPROCAL',
  /** Take the square root of the field value */
  Sqrt = 'SQRT',
  /** Square the field value (multiply it by itself) */
  Square = 'SQUARE'
}

/** FAQ item for search card. */
export type FaqItem = IContent &
  IData & {
    __typename?: 'FaqItem';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Answer?: Maybe<Scalars['String']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    /** This will determine whether or not to show on search. */
    ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    Question?: Maybe<Scalars['String']['output']>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Synonyms?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** FAQ item for search card. */
export type FaqItemAnswerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** FAQ item for search card. */
export type FaqItemNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** FAQ item for search card. */
export type FaqItemQuestionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** FAQ item for search card. */
export type FaqItemSynonymsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** FAQ item for search card. */
export type FaqItem_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** FAQ item for search card. */
export type FaqItem_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type FaqItemAutocomplete = {
  __typename?: 'FaqItemAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FaqItemAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FaqItemAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FaqItemAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FaqItemAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FaqItemAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FaqItemAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FaqItemAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FaqItemAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FaqItemAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FaqItemAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FaqItemAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FaqItemAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FaqItemAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FaqItemFacet = {
  __typename?: 'FaqItemFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Answer?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  Question?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Synonyms?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type FaqItemFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqItemFacetAnswerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqItemFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FaqItemFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqItemFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FaqItemFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqItemFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqItemFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqItemFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqItemFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqItemFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqItemFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FaqItemFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqItemFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqItemFacetQuestionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqItemFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqItemFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqItemFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FaqItemFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqItemFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqItemFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqItemFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FaqItemFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqItemFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FaqItemFacetSynonymsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqItemFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqItemFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqItemFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type FaqItemOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Answer?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Question?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Synonyms?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type FaqItemOutput = {
  __typename?: 'FaqItemOutput';
  autocomplete?: Maybe<FaqItemAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<FaqItemFacet>;
  item?: Maybe<FaqItem>;
  items?: Maybe<Array<Maybe<FaqItem>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type FaqItemOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FaqItemWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Answer?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Question?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Synonyms?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<FaqItemWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<FaqItemWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<FaqItemWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** FAQ schema */
export type FaqSchemaBlock = IContent &
  IData & {
    __typename?: 'FaqSchemaBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    /** Select all the Schema you have to add into the schema */
    FaqContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** FAQ schema */
export type FaqSchemaBlockFaqContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** FAQ schema */
export type FaqSchemaBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** FAQ schema */
export type FaqSchemaBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** FAQ schema */
export type FaqSchemaBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type FaqSchemaBlockAutocomplete = {
  __typename?: 'FaqSchemaBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FaqSchemaBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FaqSchemaBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FaqSchemaBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FaqSchemaBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FaqSchemaBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FaqSchemaBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FaqSchemaBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FaqSchemaBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FaqSchemaBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FaqSchemaBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FaqSchemaBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FaqSchemaBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FaqSchemaBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FaqSchemaBlockFacet = {
  __typename?: 'FaqSchemaBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FaqContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type FaqSchemaBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqSchemaBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FaqSchemaBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqSchemaBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FaqSchemaBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqSchemaBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqSchemaBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqSchemaBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqSchemaBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqSchemaBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FaqSchemaBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqSchemaBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqSchemaBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqSchemaBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqSchemaBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FaqSchemaBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqSchemaBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqSchemaBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqSchemaBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FaqSchemaBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqSchemaBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FaqSchemaBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqSchemaBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqSchemaBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type FaqSchemaBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FaqContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type FaqSchemaBlockOutput = {
  __typename?: 'FaqSchemaBlockOutput';
  autocomplete?: Maybe<FaqSchemaBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<FaqSchemaBlockFacet>;
  item?: Maybe<FaqSchemaBlock>;
  items?: Maybe<Array<Maybe<FaqSchemaBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type FaqSchemaBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FaqSchemaBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FaqContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<FaqSchemaBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<FaqSchemaBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<FaqSchemaBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Enable users to input a keyword and perform a search on the site. */
export type FeaturedSearchIconBlock = IContent &
  IData & {
    __typename?: 'FeaturedSearchIconBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Icon?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Enable users to input a keyword and perform a search on the site. */
export type FeaturedSearchIconBlockIconArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Enable users to input a keyword and perform a search on the site. */
export type FeaturedSearchIconBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Enable users to input a keyword and perform a search on the site. */
export type FeaturedSearchIconBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Enable users to input a keyword and perform a search on the site. */
export type FeaturedSearchIconBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type FeaturedSearchIconBlockAutocomplete = {
  __typename?: 'FeaturedSearchIconBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FeaturedSearchIconBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FeaturedSearchIconBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FeaturedSearchIconBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FeaturedSearchIconBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FeaturedSearchIconBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FeaturedSearchIconBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FeaturedSearchIconBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FeaturedSearchIconBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FeaturedSearchIconBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FeaturedSearchIconBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FeaturedSearchIconBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FeaturedSearchIconBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FeaturedSearchIconBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FeaturedSearchIconBlockFacet = {
  __typename?: 'FeaturedSearchIconBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Icon?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type FeaturedSearchIconBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FeaturedSearchIconBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FeaturedSearchIconBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FeaturedSearchIconBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FeaturedSearchIconBlockFacetIconArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FeaturedSearchIconBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FeaturedSearchIconBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FeaturedSearchIconBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FeaturedSearchIconBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FeaturedSearchIconBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FeaturedSearchIconBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FeaturedSearchIconBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FeaturedSearchIconBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FeaturedSearchIconBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FeaturedSearchIconBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FeaturedSearchIconBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FeaturedSearchIconBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FeaturedSearchIconBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FeaturedSearchIconBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FeaturedSearchIconBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FeaturedSearchIconBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FeaturedSearchIconBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FeaturedSearchIconBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FeaturedSearchIconBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FeaturedSearchIconBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type FeaturedSearchIconBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Icon?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type FeaturedSearchIconBlockOutput = {
  __typename?: 'FeaturedSearchIconBlockOutput';
  autocomplete?: Maybe<FeaturedSearchIconBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<FeaturedSearchIconBlockFacet>;
  item?: Maybe<FeaturedSearchIconBlock>;
  items?: Maybe<Array<Maybe<FeaturedSearchIconBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type FeaturedSearchIconBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FeaturedSearchIconBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Icon?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<FeaturedSearchIconBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<FeaturedSearchIconBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<FeaturedSearchIconBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** 50/30/20 Calculator. */
export type FiftyThirtyTwentyCalculatorBlock = IContent &
  IData & {
    __typename?: 'FiftyThirtyTwentyCalculatorBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** 50/30/20 Calculator. */
export type FiftyThirtyTwentyCalculatorBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** 50/30/20 Calculator. */
export type FiftyThirtyTwentyCalculatorBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** 50/30/20 Calculator. */
export type FiftyThirtyTwentyCalculatorBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** 50/30/20 Calculator. */
export type FiftyThirtyTwentyCalculatorBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** 50/30/20 Calculator. */
export type FiftyThirtyTwentyCalculatorBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type FiftyThirtyTwentyCalculatorBlockAutocomplete = {
  __typename?: 'FiftyThirtyTwentyCalculatorBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FiftyThirtyTwentyCalculatorBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FiftyThirtyTwentyCalculatorBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FiftyThirtyTwentyCalculatorBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FiftyThirtyTwentyCalculatorBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FiftyThirtyTwentyCalculatorBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FiftyThirtyTwentyCalculatorBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FiftyThirtyTwentyCalculatorBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FiftyThirtyTwentyCalculatorBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FiftyThirtyTwentyCalculatorBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FiftyThirtyTwentyCalculatorBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FiftyThirtyTwentyCalculatorBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FiftyThirtyTwentyCalculatorBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FiftyThirtyTwentyCalculatorBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FiftyThirtyTwentyCalculatorBlockFacet = {
  __typename?: 'FiftyThirtyTwentyCalculatorBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type FiftyThirtyTwentyCalculatorBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FiftyThirtyTwentyCalculatorBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FiftyThirtyTwentyCalculatorBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FiftyThirtyTwentyCalculatorBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FiftyThirtyTwentyCalculatorBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FiftyThirtyTwentyCalculatorBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FiftyThirtyTwentyCalculatorBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FiftyThirtyTwentyCalculatorBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FiftyThirtyTwentyCalculatorBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FiftyThirtyTwentyCalculatorBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FiftyThirtyTwentyCalculatorBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FiftyThirtyTwentyCalculatorBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FiftyThirtyTwentyCalculatorBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FiftyThirtyTwentyCalculatorBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FiftyThirtyTwentyCalculatorBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FiftyThirtyTwentyCalculatorBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FiftyThirtyTwentyCalculatorBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FiftyThirtyTwentyCalculatorBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FiftyThirtyTwentyCalculatorBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FiftyThirtyTwentyCalculatorBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FiftyThirtyTwentyCalculatorBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FiftyThirtyTwentyCalculatorBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FiftyThirtyTwentyCalculatorBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FiftyThirtyTwentyCalculatorBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FiftyThirtyTwentyCalculatorBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FiftyThirtyTwentyCalculatorBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type FiftyThirtyTwentyCalculatorBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type FiftyThirtyTwentyCalculatorBlockOutput = {
  __typename?: 'FiftyThirtyTwentyCalculatorBlockOutput';
  autocomplete?: Maybe<FiftyThirtyTwentyCalculatorBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<FiftyThirtyTwentyCalculatorBlockFacet>;
  item?: Maybe<FiftyThirtyTwentyCalculatorBlock>;
  items?: Maybe<Array<Maybe<FiftyThirtyTwentyCalculatorBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type FiftyThirtyTwentyCalculatorBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FiftyThirtyTwentyCalculatorBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<FiftyThirtyTwentyCalculatorBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<FiftyThirtyTwentyCalculatorBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<FiftyThirtyTwentyCalculatorBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type FileUploadElementBlock = IContent &
  IData & {
    __typename?: 'FileUploadElementBlock';
    AllowMultiple?: Maybe<Scalars['Bool']['output']>;
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ConditionCombination?: Maybe<Scalars['Int']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    FileSize?: Maybe<Scalars['Int']['output']>;
    FileTypes?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Label?: Maybe<Scalars['String']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    SatisfiedAction?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    Validators?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

export type FileUploadElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FileUploadElementBlockFileTypesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FileUploadElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FileUploadElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FileUploadElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FileUploadElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FileUploadElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FileUploadElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type FileUploadElementBlockAutocomplete = {
  __typename?: 'FileUploadElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FileUploadElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FileUploadElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FileUploadElementBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FileUploadElementBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FileUploadElementBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FileUploadElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FileUploadElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FileUploadElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FileUploadElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FileUploadElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FileUploadElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FileUploadElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FileUploadElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FileUploadElementBlockFacet = {
  __typename?: 'FileUploadElementBlockFacet';
  AllowMultiple?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileSize?: Maybe<Array<Maybe<NumberFacet>>>;
  FileTypes?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type FileUploadElementBlockFacetAllowMultipleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FileUploadElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FileUploadElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FileUploadElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type FileUploadElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FileUploadElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FileUploadElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FileUploadElementBlockFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type FileUploadElementBlockFacetFileTypesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FileUploadElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FileUploadElementBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FileUploadElementBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FileUploadElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FileUploadElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FileUploadElementBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FileUploadElementBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FileUploadElementBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FileUploadElementBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FileUploadElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FileUploadElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FileUploadElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FileUploadElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FileUploadElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FileUploadElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FileUploadElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FileUploadElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FileUploadElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FileUploadElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FileUploadElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FileUploadElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FileUploadElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FileUploadElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type FileUploadElementBlockOrderByInput = {
  AllowMultiple?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileSize?: InputMaybe<OrderBy>;
  FileTypes?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type FileUploadElementBlockOutput = {
  __typename?: 'FileUploadElementBlockOutput';
  autocomplete?: Maybe<FileUploadElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<FileUploadElementBlockFacet>;
  item?: Maybe<FileUploadElementBlock>;
  items?: Maybe<Array<Maybe<FileUploadElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type FileUploadElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileUploadElementBlockWhereInput = {
  AllowMultiple?: InputMaybe<BoolFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileSize?: InputMaybe<IntFilterInput>;
  FileTypes?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<FileUploadElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<FileUploadElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<FileUploadElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type FilterCategoryItemModel = {
  __typename?: 'FilterCategoryItemModel';
  Id?: Maybe<Scalars['String']['output']>;
  IdTitle?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

export type FilterCategoryItemModelAutocomplete = {
  __typename?: 'FilterCategoryItemModelAutocomplete';
  Id?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  IdTitle?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Title?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FilterCategoryItemModelAutocompleteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FilterCategoryItemModelAutocompleteIdTitleArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FilterCategoryItemModelAutocompleteTitleArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FilterCategoryItemModelFacet = {
  __typename?: 'FilterCategoryItemModelFacet';
  Id?: Maybe<Array<Maybe<StringFacet>>>;
  IdTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};

export type FilterCategoryItemModelFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FilterCategoryItemModelFacetIdTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FilterCategoryItemModelFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FilterCategoryItemModelOrderByInput = {
  Id?: InputMaybe<OrderBy>;
  IdTitle?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type FilterCategoryItemModelWhereInput = {
  Id?: InputMaybe<StringFilterInput>;
  IdTitle?: InputMaybe<StringFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
};

export type FilterCategoryModel = {
  __typename?: 'FilterCategoryModel';
  AllCategoriesIds?: Maybe<Scalars['String']['output']>;
  Categories?: Maybe<Array<Maybe<FilterCategoryItemModel>>>;
};

export type FilterCategoryModelAutocomplete = {
  __typename?: 'FilterCategoryModelAutocomplete';
  AllCategoriesIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Categories?: Maybe<FilterCategoryItemModelAutocomplete>;
};

export type FilterCategoryModelAutocompleteAllCategoriesIdsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FilterCategoryModelFacet = {
  __typename?: 'FilterCategoryModelFacet';
  AllCategoriesIds?: Maybe<Array<Maybe<StringFacet>>>;
  Categories?: Maybe<FilterCategoryItemModelFacet>;
};

export type FilterCategoryModelFacetAllCategoriesIdsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FilterCategoryModelOrderByInput = {
  AllCategoriesIds?: InputMaybe<OrderBy>;
  Categories?: InputMaybe<FilterCategoryItemModelOrderByInput>;
};

export type FilterCategoryModelWhereInput = {
  AllCategoriesIds?: InputMaybe<StringFilterInput>;
  Categories?: InputMaybe<FilterCategoryItemModelWhereInput>;
};

/** A page which allows you to structure pages. */
export type FolderPage = IContent &
  IData & {
    __typename?: 'FolderPage';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    BreadcrumbsTitle?: Maybe<Scalars['String']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    /** This will determine whether or not to be dispalyed in breadcrumbs. */
    HideInBreadcrumbs?: Maybe<Scalars['Bool']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** A page which allows you to structure pages. */
export type FolderPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** A page which allows you to structure pages. */
export type FolderPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** A page which allows you to structure pages. */
export type FolderPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type FolderPageAutocomplete = {
  __typename?: 'FolderPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FolderPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FolderPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FolderPageAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FolderPageAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FolderPageAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FolderPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FolderPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FolderPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FolderPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FolderPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FolderPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FolderPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FolderPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FolderPageFacet = {
  __typename?: 'FolderPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  HideInBreadcrumbs?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type FolderPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FolderPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FolderPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FolderPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FolderPageFacetHideInBreadcrumbsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FolderPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FolderPageFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FolderPageFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FolderPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FolderPageFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FolderPageFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FolderPageFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FolderPageFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FolderPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FolderPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FolderPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FolderPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FolderPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FolderPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FolderPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FolderPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FolderPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FolderPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FolderPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FolderPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type FolderPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  HideInBreadcrumbs?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type FolderPageOutput = {
  __typename?: 'FolderPageOutput';
  autocomplete?: Maybe<FolderPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<FolderPageFacet>;
  item?: Maybe<FolderPage>;
  items?: Maybe<Array<Maybe<FolderPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type FolderPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FolderPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  HideInBreadcrumbs?: InputMaybe<BoolFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<FolderPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<FolderPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<FolderPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type FooterBlock = IContent &
  IData & {
    __typename?: 'FooterBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    BottomFooterLogo?: Maybe<ContentModelReference>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /** The token '%year%' will be replaced with current year. */
    CopyrightText?: Maybe<Scalars['String']['output']>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    LeftColumnLinks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    MiddleColumnLinks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    PhoneLabel?: Maybe<Scalars['String']['output']>;
    PhoneNumber?: Maybe<Scalars['String']['output']>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RightColumnLinks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    RoutingNumber?: Maybe<Scalars['String']['output']>;
    RoutingNumberLabel?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    SocialMediaIcons?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

export type FooterBlockCopyrightTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FooterBlockLeftColumnLinksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FooterBlockMiddleColumnLinksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FooterBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FooterBlockPhoneLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FooterBlockPhoneNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FooterBlockRightColumnLinksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FooterBlockRoutingNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FooterBlockRoutingNumberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FooterBlockSocialMediaIconsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FooterBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FooterBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type FooterBlockAutocomplete = {
  __typename?: 'FooterBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BottomFooterLogo?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FooterBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FooterBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FooterBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FooterBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FooterBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FooterBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FooterBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FooterBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FooterBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FooterBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FooterBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FooterBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FooterBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FooterBlockFacet = {
  __typename?: 'FooterBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BottomFooterLogo?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  CopyrightText?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LeftColumnLinks?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MiddleColumnLinks?: Maybe<ContentAreaItemModelSearchFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PhoneLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneNumber?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RightColumnLinks?: Maybe<ContentAreaItemModelSearchFacet>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  RoutingNumber?: Maybe<Array<Maybe<StringFacet>>>;
  RoutingNumberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SocialMediaIcons?: Maybe<ContentAreaItemModelSearchFacet>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type FooterBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FooterBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterBlockFacetCopyrightTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FooterBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FooterBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterBlockFacetPhoneLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterBlockFacetPhoneNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterBlockFacetRoutingNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterBlockFacetRoutingNumberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FooterBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FooterBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FooterBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type FooterBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BottomFooterLogo?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  CopyrightText?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LeftColumnLinks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MiddleColumnLinks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PhoneLabel?: InputMaybe<OrderBy>;
  PhoneNumber?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RightColumnLinks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  RouteSegment?: InputMaybe<OrderBy>;
  RoutingNumber?: InputMaybe<OrderBy>;
  RoutingNumberLabel?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SocialMediaIcons?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type FooterBlockOutput = {
  __typename?: 'FooterBlockOutput';
  autocomplete?: Maybe<FooterBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<FooterBlockFacet>;
  item?: Maybe<FooterBlock>;
  items?: Maybe<Array<Maybe<FooterBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type FooterBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FooterBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BottomFooterLogo?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  CopyrightText?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LeftColumnLinks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MiddleColumnLinks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PhoneLabel?: InputMaybe<SearchableStringFilterInput>;
  PhoneNumber?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RightColumnLinks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  RoutingNumber?: InputMaybe<SearchableStringFilterInput>;
  RoutingNumberLabel?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SocialMediaIcons?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<FooterBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<FooterBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<FooterBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type FooterMenuLinksBlock = IContent &
  IData & {
    __typename?: 'FooterMenuLinksBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    MenuLabel?: Maybe<Scalars['String']['output']>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

export type FooterMenuLinksBlockMenuLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FooterMenuLinksBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FooterMenuLinksBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FooterMenuLinksBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type FooterMenuLinksBlockAutocomplete = {
  __typename?: 'FooterMenuLinksBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FooterMenuLinksBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FooterMenuLinksBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FooterMenuLinksBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FooterMenuLinksBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FooterMenuLinksBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FooterMenuLinksBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FooterMenuLinksBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FooterMenuLinksBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FooterMenuLinksBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FooterMenuLinksBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FooterMenuLinksBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FooterMenuLinksBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FooterMenuLinksBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FooterMenuLinksBlockFacet = {
  __typename?: 'FooterMenuLinksBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MenuLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type FooterMenuLinksBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterMenuLinksBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FooterMenuLinksBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterMenuLinksBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FooterMenuLinksBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterMenuLinksBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterMenuLinksBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterMenuLinksBlockFacetMenuLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterMenuLinksBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterMenuLinksBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterMenuLinksBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FooterMenuLinksBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterMenuLinksBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterMenuLinksBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterMenuLinksBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterMenuLinksBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FooterMenuLinksBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterMenuLinksBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterMenuLinksBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterMenuLinksBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FooterMenuLinksBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterMenuLinksBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FooterMenuLinksBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterMenuLinksBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterMenuLinksBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type FooterMenuLinksBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MenuLabel?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type FooterMenuLinksBlockOutput = {
  __typename?: 'FooterMenuLinksBlockOutput';
  autocomplete?: Maybe<FooterMenuLinksBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<FooterMenuLinksBlockFacet>;
  item?: Maybe<FooterMenuLinksBlock>;
  items?: Maybe<Array<Maybe<FooterMenuLinksBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type FooterMenuLinksBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FooterMenuLinksBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MenuLabel?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<FooterMenuLinksBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<FooterMenuLinksBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<FooterMenuLinksBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Used to add footnote section in the page */
export type FootnoteSectionBlock = IContent &
  IData & {
    __typename?: 'FootnoteSectionBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Heading?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Used to add footnote section in the page */
export type FootnoteSectionBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used to add footnote section in the page */
export type FootnoteSectionBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used to add footnote section in the page */
export type FootnoteSectionBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used to add footnote section in the page */
export type FootnoteSectionBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used to add footnote section in the page */
export type FootnoteSectionBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type FootnoteSectionBlockAutocomplete = {
  __typename?: 'FootnoteSectionBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FootnoteSectionBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FootnoteSectionBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FootnoteSectionBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FootnoteSectionBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FootnoteSectionBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FootnoteSectionBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FootnoteSectionBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FootnoteSectionBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FootnoteSectionBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FootnoteSectionBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FootnoteSectionBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FootnoteSectionBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FootnoteSectionBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FootnoteSectionBlockFacet = {
  __typename?: 'FootnoteSectionBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type FootnoteSectionBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FootnoteSectionBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FootnoteSectionBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FootnoteSectionBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FootnoteSectionBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FootnoteSectionBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FootnoteSectionBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FootnoteSectionBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FootnoteSectionBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FootnoteSectionBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FootnoteSectionBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FootnoteSectionBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FootnoteSectionBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FootnoteSectionBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FootnoteSectionBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FootnoteSectionBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FootnoteSectionBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FootnoteSectionBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FootnoteSectionBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FootnoteSectionBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FootnoteSectionBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FootnoteSectionBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FootnoteSectionBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FootnoteSectionBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FootnoteSectionBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FootnoteSectionBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type FootnoteSectionBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type FootnoteSectionBlockOutput = {
  __typename?: 'FootnoteSectionBlockOutput';
  autocomplete?: Maybe<FootnoteSectionBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<FootnoteSectionBlockFacet>;
  item?: Maybe<FootnoteSectionBlock>;
  items?: Maybe<Array<Maybe<FootnoteSectionBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type FootnoteSectionBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FootnoteSectionBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<FootnoteSectionBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<FootnoteSectionBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<FootnoteSectionBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Allow content authors to display FormAssembly forms */
export type FormAssemblyBlock = IContent &
  IData & {
    __typename?: 'FormAssemblyBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    /** Form Assembly ID */
    FormAssemblyId?: Maybe<Scalars['String']['output']>;
    /** Height of the Iframe */
    Height?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    /** For the accessibility */
    Title?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** Width of the Iframe */
    Width?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Allow content authors to display FormAssembly forms */
export type FormAssemblyBlockFormAssemblyIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to display FormAssembly forms */
export type FormAssemblyBlockHeightArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to display FormAssembly forms */
export type FormAssemblyBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to display FormAssembly forms */
export type FormAssemblyBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to display FormAssembly forms */
export type FormAssemblyBlockWidthArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to display FormAssembly forms */
export type FormAssemblyBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to display FormAssembly forms */
export type FormAssemblyBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type FormAssemblyBlockAutocomplete = {
  __typename?: 'FormAssemblyBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FormAssemblyBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormAssemblyBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormAssemblyBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormAssemblyBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormAssemblyBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormAssemblyBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormAssemblyBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormAssemblyBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormAssemblyBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormAssemblyBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormAssemblyBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormAssemblyBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormAssemblyBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormAssemblyBlockFacet = {
  __typename?: 'FormAssemblyBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FormAssemblyId?: Maybe<Array<Maybe<StringFacet>>>;
  Height?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Width?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type FormAssemblyBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormAssemblyBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FormAssemblyBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormAssemblyBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FormAssemblyBlockFacetFormAssemblyIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormAssemblyBlockFacetHeightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormAssemblyBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormAssemblyBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormAssemblyBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormAssemblyBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormAssemblyBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormAssemblyBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FormAssemblyBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormAssemblyBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormAssemblyBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormAssemblyBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormAssemblyBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FormAssemblyBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormAssemblyBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormAssemblyBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormAssemblyBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FormAssemblyBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormAssemblyBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FormAssemblyBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormAssemblyBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormAssemblyBlockFacetWidthArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormAssemblyBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormAssemblyBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type FormAssemblyBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FormAssemblyId?: InputMaybe<OrderBy>;
  Height?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Width?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type FormAssemblyBlockOutput = {
  __typename?: 'FormAssemblyBlockOutput';
  autocomplete?: Maybe<FormAssemblyBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<FormAssemblyBlockFacet>;
  item?: Maybe<FormAssemblyBlock>;
  items?: Maybe<Array<Maybe<FormAssemblyBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type FormAssemblyBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormAssemblyBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FormAssemblyId?: InputMaybe<SearchableStringFilterInput>;
  Height?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Width?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<FormAssemblyBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<FormAssemblyBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<FormAssemblyBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type FormContainerBlock = IContent &
  IData & {
    __typename?: 'FormContainerBlock';
    AllowAnonymousSubmission?: Maybe<Scalars['Bool']['output']>;
    AllowExposingDataFeeds?: Maybe<Scalars['Bool']['output']>;
    AllowMultipleSubmission?: Maybe<Scalars['Bool']['output']>;
    AllowToStoreSubmissionData?: Maybe<Scalars['Bool']['output']>;
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ConfirmationMessage?: Maybe<Scalars['String']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ElementsArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    FinalizedSubmissionRetentionPeriod?: Maybe<Scalars['String']['output']>;
    FocusOnForm?: Maybe<Scalars['Bool']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    MetadataAttribute?: Maybe<Scalars['String']['output']>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    PartialSubmissionRetentionPeriod?: Maybe<Scalars['String']['output']>;
    RedirectToPage?: Maybe<Scalars['String']['output']>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    ResetConfirmationMessage?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    ShowNavigationBar?: Maybe<Scalars['Bool']['output']>;
    ShowSummarizedData?: Maybe<Scalars['Bool']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    SubmitSuccessMessage?: Maybe<Scalars['String']['output']>;
    Title?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

export type FormContainerBlockConfirmationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FormContainerBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FormContainerBlockElementsAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FormContainerBlockFinalizedSubmissionRetentionPeriodArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FormContainerBlockMetadataAttributeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FormContainerBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FormContainerBlockPartialSubmissionRetentionPeriodArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FormContainerBlockResetConfirmationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FormContainerBlockSubmitSuccessMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FormContainerBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FormContainerBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FormContainerBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type FormContainerBlockAutocomplete = {
  __typename?: 'FormContainerBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RedirectToPage?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FormContainerBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormContainerBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormContainerBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormContainerBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormContainerBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormContainerBlockAutocompleteRedirectToPageArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormContainerBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormContainerBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormContainerBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormContainerBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormContainerBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormContainerBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormContainerBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormContainerBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormContainerBlockFacet = {
  __typename?: 'FormContainerBlockFacet';
  AllowAnonymousSubmission?: Maybe<Array<Maybe<StringFacet>>>;
  AllowExposingDataFeeds?: Maybe<Array<Maybe<StringFacet>>>;
  AllowMultipleSubmission?: Maybe<Array<Maybe<StringFacet>>>;
  AllowToStoreSubmissionData?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConfirmationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ElementsArea?: Maybe<ContentAreaItemModelSearchFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FinalizedSubmissionRetentionPeriod?: Maybe<Array<Maybe<StringFacet>>>;
  FocusOnForm?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetadataAttribute?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PartialSubmissionRetentionPeriod?: Maybe<Array<Maybe<StringFacet>>>;
  RedirectToPage?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  ResetConfirmationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  ShowNavigationBar?: Maybe<Array<Maybe<StringFacet>>>;
  ShowSummarizedData?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SubmitSuccessMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type FormContainerBlockFacetAllowAnonymousSubmissionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacetAllowExposingDataFeedsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacetAllowMultipleSubmissionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacetAllowToStoreSubmissionDataArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FormContainerBlockFacetConfirmationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FormContainerBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacetFinalizedSubmissionRetentionPeriodArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacetFocusOnFormArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacetMetadataAttributeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FormContainerBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacetPartialSubmissionRetentionPeriodArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacetRedirectToPageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacetResetConfirmationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FormContainerBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacetShowNavigationBarArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacetShowSummarizedDataArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FormContainerBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FormContainerBlockFacetSubmitSuccessMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type FormContainerBlockOrderByInput = {
  AllowAnonymousSubmission?: InputMaybe<OrderBy>;
  AllowExposingDataFeeds?: InputMaybe<OrderBy>;
  AllowMultipleSubmission?: InputMaybe<OrderBy>;
  AllowToStoreSubmissionData?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConfirmationMessage?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ElementsArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FinalizedSubmissionRetentionPeriod?: InputMaybe<OrderBy>;
  FocusOnForm?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetadataAttribute?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PartialSubmissionRetentionPeriod?: InputMaybe<OrderBy>;
  RedirectToPage?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  ResetConfirmationMessage?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  ShowNavigationBar?: InputMaybe<OrderBy>;
  ShowSummarizedData?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SubmitSuccessMessage?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type FormContainerBlockOutput = {
  __typename?: 'FormContainerBlockOutput';
  autocomplete?: Maybe<FormContainerBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<FormContainerBlockFacet>;
  item?: Maybe<FormContainerBlock>;
  items?: Maybe<Array<Maybe<FormContainerBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type FormContainerBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormContainerBlockWhereInput = {
  AllowAnonymousSubmission?: InputMaybe<BoolFilterInput>;
  AllowExposingDataFeeds?: InputMaybe<BoolFilterInput>;
  AllowMultipleSubmission?: InputMaybe<BoolFilterInput>;
  AllowToStoreSubmissionData?: InputMaybe<BoolFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConfirmationMessage?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ElementsArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FinalizedSubmissionRetentionPeriod?: InputMaybe<SearchableStringFilterInput>;
  FocusOnForm?: InputMaybe<BoolFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetadataAttribute?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PartialSubmissionRetentionPeriod?: InputMaybe<SearchableStringFilterInput>;
  RedirectToPage?: InputMaybe<StringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  ResetConfirmationMessage?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  ShowNavigationBar?: InputMaybe<BoolFilterInput>;
  ShowSummarizedData?: InputMaybe<BoolFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SubmitSuccessMessage?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<FormContainerBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<FormContainerBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<FormContainerBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type FormStepBlock = IContent &
  IData & {
    __typename?: 'FormStepBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    AttachedContentLink?: Maybe<Scalars['String']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    DependCondition?: Maybe<Scalars['Int']['output']>;
    DependField?: Maybe<ContentModelReference>;
    DependValue?: Maybe<Scalars['String']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Label?: Maybe<Scalars['String']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

export type FormStepBlockDependValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FormStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FormStepBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FormStepBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FormStepBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FormStepBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type FormStepBlockAutocomplete = {
  __typename?: 'FormStepBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AttachedContentLink?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  DependField?: Maybe<ContentModelReferenceAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FormStepBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormStepBlockAutocompleteAttachedContentLinkArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormStepBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormStepBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormStepBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormStepBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormStepBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormStepBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormStepBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormStepBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormStepBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormStepBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormStepBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormStepBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormStepBlockFacet = {
  __typename?: 'FormStepBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AttachedContentLink?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DependCondition?: Maybe<Array<Maybe<NumberFacet>>>;
  DependField?: Maybe<ContentModelReferenceFacet>;
  DependValue?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type FormStepBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormStepBlockFacetAttachedContentLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormStepBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FormStepBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormStepBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FormStepBlockFacetDependConditionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type FormStepBlockFacetDependValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormStepBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormStepBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormStepBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormStepBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormStepBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormStepBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormStepBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FormStepBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormStepBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormStepBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormStepBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormStepBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FormStepBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormStepBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormStepBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormStepBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FormStepBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormStepBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FormStepBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormStepBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormStepBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type FormStepBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AttachedContentLink?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DependCondition?: InputMaybe<OrderBy>;
  DependField?: InputMaybe<ContentModelReferenceOrderByInput>;
  DependValue?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type FormStepBlockOutput = {
  __typename?: 'FormStepBlockOutput';
  autocomplete?: Maybe<FormStepBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<FormStepBlockFacet>;
  item?: Maybe<FormStepBlock>;
  items?: Maybe<Array<Maybe<FormStepBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type FormStepBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormStepBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AttachedContentLink?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DependCondition?: InputMaybe<IntFilterInput>;
  DependField?: InputMaybe<ContentModelReferenceWhereInput>;
  DependValue?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<FormStepBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<FormStepBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<FormStepBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Allow content authors to add full width video */
export type FullWidthVideoBlock = IContent &
  IData & {
    __typename?: 'FullWidthVideoBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    EmbeddedCode?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Allow content authors to add full width video */
export type FullWidthVideoBlockEmbeddedCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add full width video */
export type FullWidthVideoBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add full width video */
export type FullWidthVideoBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add full width video */
export type FullWidthVideoBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type FullWidthVideoBlockAutocomplete = {
  __typename?: 'FullWidthVideoBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FullWidthVideoBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FullWidthVideoBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FullWidthVideoBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FullWidthVideoBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FullWidthVideoBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FullWidthVideoBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FullWidthVideoBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FullWidthVideoBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FullWidthVideoBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FullWidthVideoBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FullWidthVideoBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FullWidthVideoBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FullWidthVideoBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FullWidthVideoBlockFacet = {
  __typename?: 'FullWidthVideoBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  EmbeddedCode?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type FullWidthVideoBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FullWidthVideoBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FullWidthVideoBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FullWidthVideoBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FullWidthVideoBlockFacetEmbeddedCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FullWidthVideoBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FullWidthVideoBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FullWidthVideoBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FullWidthVideoBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FullWidthVideoBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FullWidthVideoBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FullWidthVideoBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FullWidthVideoBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FullWidthVideoBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FullWidthVideoBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FullWidthVideoBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FullWidthVideoBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FullWidthVideoBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FullWidthVideoBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FullWidthVideoBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FullWidthVideoBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FullWidthVideoBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FullWidthVideoBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FullWidthVideoBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FullWidthVideoBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type FullWidthVideoBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  EmbeddedCode?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type FullWidthVideoBlockOutput = {
  __typename?: 'FullWidthVideoBlockOutput';
  autocomplete?: Maybe<FullWidthVideoBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<FullWidthVideoBlockFacet>;
  item?: Maybe<FullWidthVideoBlock>;
  items?: Maybe<Array<Maybe<FullWidthVideoBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type FullWidthVideoBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FullWidthVideoBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  EmbeddedCode?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<FullWidthVideoBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<FullWidthVideoBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<FullWidthVideoBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type GlobalLabelsBlock = IContent &
  IData & {
    __typename?: 'GlobalLabelsBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    BackToLabel?: Maybe<Scalars['String']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    TopLabel?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

export type GlobalLabelsBlockBackToLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GlobalLabelsBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GlobalLabelsBlockTopLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GlobalLabelsBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GlobalLabelsBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type GlobalLabelsBlockAutocomplete = {
  __typename?: 'GlobalLabelsBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GlobalLabelsBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GlobalLabelsBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GlobalLabelsBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GlobalLabelsBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GlobalLabelsBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GlobalLabelsBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GlobalLabelsBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GlobalLabelsBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GlobalLabelsBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GlobalLabelsBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GlobalLabelsBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GlobalLabelsBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GlobalLabelsBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GlobalLabelsBlockFacet = {
  __typename?: 'GlobalLabelsBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BackToLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TopLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type GlobalLabelsBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GlobalLabelsBlockFacetBackToLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GlobalLabelsBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type GlobalLabelsBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GlobalLabelsBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type GlobalLabelsBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GlobalLabelsBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GlobalLabelsBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GlobalLabelsBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GlobalLabelsBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GlobalLabelsBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type GlobalLabelsBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GlobalLabelsBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GlobalLabelsBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GlobalLabelsBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GlobalLabelsBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type GlobalLabelsBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GlobalLabelsBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GlobalLabelsBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GlobalLabelsBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type GlobalLabelsBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GlobalLabelsBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type GlobalLabelsBlockFacetTopLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GlobalLabelsBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GlobalLabelsBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GlobalLabelsBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type GlobalLabelsBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BackToLabel?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TopLabel?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type GlobalLabelsBlockOutput = {
  __typename?: 'GlobalLabelsBlockOutput';
  autocomplete?: Maybe<GlobalLabelsBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<GlobalLabelsBlockFacet>;
  item?: Maybe<GlobalLabelsBlock>;
  items?: Maybe<Array<Maybe<GlobalLabelsBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type GlobalLabelsBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GlobalLabelsBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BackToLabel?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TopLabel?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<GlobalLabelsBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<GlobalLabelsBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<GlobalLabelsBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type HeaderBlock = IContent &
  IData & {
    __typename?: 'HeaderBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    LoginLabel?: Maybe<Scalars['String']['output']>;
    LoginModal?: Maybe<Array<Maybe<ContentAreaItemModel>>>;
    Logo?: Maybe<ContentModelReference>;
    LogoUrl?: Maybe<LinkItemNode>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    NavigationMenu?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    SearchLabelMobile?: Maybe<Scalars['String']['output']>;
    SearchMenu?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

export type HeaderBlockLoginLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type HeaderBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type HeaderBlockNavigationMenuArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type HeaderBlockSearchLabelMobileArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type HeaderBlockSearchMenuArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type HeaderBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type HeaderBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type HeaderBlockAutocomplete = {
  __typename?: 'HeaderBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  LoginModal?: Maybe<ContentAreaItemModelAutocomplete>;
  Logo?: Maybe<ContentModelReferenceAutocomplete>;
  LogoUrl?: Maybe<LinkItemNodeAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type HeaderBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeaderBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeaderBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeaderBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeaderBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeaderBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeaderBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeaderBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeaderBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeaderBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeaderBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeaderBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeaderBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeaderBlockFacet = {
  __typename?: 'HeaderBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LoginLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LoginModal?: Maybe<ContentAreaItemModelFacet>;
  Logo?: Maybe<ContentModelReferenceFacet>;
  LogoUrl?: Maybe<LinkItemNodeFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NavigationMenu?: Maybe<ContentAreaItemModelSearchFacet>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchLabelMobile?: Maybe<Array<Maybe<StringFacet>>>;
  SearchMenu?: Maybe<ContentAreaItemModelSearchFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type HeaderBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeaderBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type HeaderBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeaderBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type HeaderBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeaderBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeaderBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeaderBlockFacetLoginLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeaderBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeaderBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeaderBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type HeaderBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeaderBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeaderBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeaderBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeaderBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type HeaderBlockFacetSearchLabelMobileArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeaderBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeaderBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeaderBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeaderBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type HeaderBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeaderBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type HeaderBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeaderBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeaderBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type HeaderBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LoginLabel?: InputMaybe<OrderBy>;
  LoginModal?: InputMaybe<ContentAreaItemModelOrderByInput>;
  Logo?: InputMaybe<ContentModelReferenceOrderByInput>;
  LogoUrl?: InputMaybe<LinkItemNodeOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NavigationMenu?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchLabelMobile?: InputMaybe<OrderBy>;
  SearchMenu?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type HeaderBlockOutput = {
  __typename?: 'HeaderBlockOutput';
  autocomplete?: Maybe<HeaderBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<HeaderBlockFacet>;
  item?: Maybe<HeaderBlock>;
  items?: Maybe<Array<Maybe<HeaderBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type HeaderBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeaderBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LoginLabel?: InputMaybe<SearchableStringFilterInput>;
  LoginModal?: InputMaybe<ContentAreaItemModelWhereInput>;
  Logo?: InputMaybe<ContentModelReferenceWhereInput>;
  LogoUrl?: InputMaybe<LinkItemNodeWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NavigationMenu?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchLabelMobile?: InputMaybe<SearchableStringFilterInput>;
  SearchMenu?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<HeaderBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<HeaderBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<HeaderBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Allow content authors to add a hero component to pages. */
export type HeroBlock = IContent &
  IData & {
    __typename?: 'HeroBlock';
    Alignment?: Maybe<Scalars['String']['output']>;
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    ForegroundImage?: Maybe<ContentModelReference>;
    HeadLine?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    OverlayColor?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Allow content authors to add a hero component to pages. */
export type HeroBlockAlignmentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add a hero component to pages. */
export type HeroBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add a hero component to pages. */
export type HeroBlockHeadLineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add a hero component to pages. */
export type HeroBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add a hero component to pages. */
export type HeroBlockOverlayColorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add a hero component to pages. */
export type HeroBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add a hero component to pages. */
export type HeroBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type HeroBlockAutocomplete = {
  __typename?: 'HeroBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ForegroundImage?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type HeroBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeroBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeroBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeroBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeroBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeroBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeroBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeroBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeroBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeroBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeroBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeroBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeroBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeroBlockFacet = {
  __typename?: 'HeroBlockFacet';
  Alignment?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ForegroundImage?: Maybe<ContentModelReferenceFacet>;
  HeadLine?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  OverlayColor?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type HeroBlockFacetAlignmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type HeroBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type HeroBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroBlockFacetHeadLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroBlockFacetOverlayColorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type HeroBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type HeroBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type HeroBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type HeroBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type HeroBlockOrderByInput = {
  Alignment?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ForegroundImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  HeadLine?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  OverlayColor?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type HeroBlockOutput = {
  __typename?: 'HeroBlockOutput';
  autocomplete?: Maybe<HeroBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<HeroBlockFacet>;
  item?: Maybe<HeroBlock>;
  items?: Maybe<Array<Maybe<HeroBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type HeroBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeroBlockWhereInput = {
  Alignment?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ForegroundImage?: InputMaybe<ContentModelReferenceWhereInput>;
  HeadLine?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  OverlayColor?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<HeroBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<HeroBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<HeroBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Hero component that can be used on any page. */
export type HeroImageBlock = IContent &
  IData & {
    __typename?: 'HeroImageBlock';
    Alignment?: Maybe<Scalars['String']['output']>;
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    HeroImage?: Maybe<ContentModelReference>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    OverlayColor?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    ShortDescription?: Maybe<Scalars['String']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Hero component that can be used on any page. */
export type HeroImageBlockAlignmentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Hero component that can be used on any page. */
export type HeroImageBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Hero component that can be used on any page. */
export type HeroImageBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Hero component that can be used on any page. */
export type HeroImageBlockOverlayColorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Hero component that can be used on any page. */
export type HeroImageBlockShortDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Hero component that can be used on any page. */
export type HeroImageBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Hero component that can be used on any page. */
export type HeroImageBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type HeroImageBlockAutocomplete = {
  __typename?: 'HeroImageBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  HeroImage?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type HeroImageBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeroImageBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeroImageBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeroImageBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeroImageBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeroImageBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeroImageBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeroImageBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeroImageBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeroImageBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeroImageBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeroImageBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeroImageBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeroImageBlockFacet = {
  __typename?: 'HeroImageBlockFacet';
  Alignment?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  HeroImage?: Maybe<ContentModelReferenceFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  OverlayColor?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  ShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type HeroImageBlockFacetAlignmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroImageBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroImageBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type HeroImageBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroImageBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type HeroImageBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroImageBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroImageBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroImageBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroImageBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroImageBlockFacetOverlayColorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroImageBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroImageBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type HeroImageBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroImageBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroImageBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroImageBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroImageBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type HeroImageBlockFacetShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroImageBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroImageBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroImageBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroImageBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type HeroImageBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroImageBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type HeroImageBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroImageBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroImageBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type HeroImageBlockOrderByInput = {
  Alignment?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  HeroImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  OverlayColor?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  ShortDescription?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type HeroImageBlockOutput = {
  __typename?: 'HeroImageBlockOutput';
  autocomplete?: Maybe<HeroImageBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<HeroImageBlockFacet>;
  item?: Maybe<HeroImageBlock>;
  items?: Maybe<Array<Maybe<HeroImageBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type HeroImageBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeroImageBlockWhereInput = {
  Alignment?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  HeroImage?: InputMaybe<ContentModelReferenceWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  OverlayColor?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  ShortDescription?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<HeroImageBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<HeroImageBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<HeroImageBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Options for highlighting */
export type HighlightOptions = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endToken?: InputMaybe<Scalars['String']['input']>;
  startToken?: InputMaybe<Scalars['String']['input']>;
};

/** Home Affordability Calculator. */
export type HomeAffordabilityCalculatorBlock = IContent &
  IData & {
    __typename?: 'HomeAffordabilityCalculatorBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Term?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Home Affordability Calculator. */
export type HomeAffordabilityCalculatorBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Home Affordability Calculator. */
export type HomeAffordabilityCalculatorBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Home Affordability Calculator. */
export type HomeAffordabilityCalculatorBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Home Affordability Calculator. */
export type HomeAffordabilityCalculatorBlockTermArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Home Affordability Calculator. */
export type HomeAffordabilityCalculatorBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Home Affordability Calculator. */
export type HomeAffordabilityCalculatorBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type HomeAffordabilityCalculatorBlockAutocomplete = {
  __typename?: 'HomeAffordabilityCalculatorBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type HomeAffordabilityCalculatorBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HomeAffordabilityCalculatorBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HomeAffordabilityCalculatorBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HomeAffordabilityCalculatorBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HomeAffordabilityCalculatorBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HomeAffordabilityCalculatorBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HomeAffordabilityCalculatorBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HomeAffordabilityCalculatorBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HomeAffordabilityCalculatorBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HomeAffordabilityCalculatorBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HomeAffordabilityCalculatorBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HomeAffordabilityCalculatorBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HomeAffordabilityCalculatorBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HomeAffordabilityCalculatorBlockFacet = {
  __typename?: 'HomeAffordabilityCalculatorBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Term?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type HomeAffordabilityCalculatorBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeAffordabilityCalculatorBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type HomeAffordabilityCalculatorBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeAffordabilityCalculatorBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type HomeAffordabilityCalculatorBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeAffordabilityCalculatorBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeAffordabilityCalculatorBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeAffordabilityCalculatorBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeAffordabilityCalculatorBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeAffordabilityCalculatorBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeAffordabilityCalculatorBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeAffordabilityCalculatorBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type HomeAffordabilityCalculatorBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeAffordabilityCalculatorBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeAffordabilityCalculatorBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeAffordabilityCalculatorBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeAffordabilityCalculatorBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type HomeAffordabilityCalculatorBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeAffordabilityCalculatorBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeAffordabilityCalculatorBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeAffordabilityCalculatorBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type HomeAffordabilityCalculatorBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeAffordabilityCalculatorBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type HomeAffordabilityCalculatorBlockFacetTermArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeAffordabilityCalculatorBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeAffordabilityCalculatorBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeAffordabilityCalculatorBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type HomeAffordabilityCalculatorBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Term?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type HomeAffordabilityCalculatorBlockOutput = {
  __typename?: 'HomeAffordabilityCalculatorBlockOutput';
  autocomplete?: Maybe<HomeAffordabilityCalculatorBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<HomeAffordabilityCalculatorBlockFacet>;
  item?: Maybe<HomeAffordabilityCalculatorBlock>;
  items?: Maybe<Array<Maybe<HomeAffordabilityCalculatorBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type HomeAffordabilityCalculatorBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomeAffordabilityCalculatorBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Term?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<HomeAffordabilityCalculatorBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<HomeAffordabilityCalculatorBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<HomeAffordabilityCalculatorBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Home Equity Calculator. */
export type HomeEquityCalculatorBlock = IContent &
  IData & {
    __typename?: 'HomeEquityCalculatorBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Home Equity Calculator. */
export type HomeEquityCalculatorBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Home Equity Calculator. */
export type HomeEquityCalculatorBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Home Equity Calculator. */
export type HomeEquityCalculatorBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Home Equity Calculator. */
export type HomeEquityCalculatorBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Home Equity Calculator. */
export type HomeEquityCalculatorBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type HomeEquityCalculatorBlockAutocomplete = {
  __typename?: 'HomeEquityCalculatorBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type HomeEquityCalculatorBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HomeEquityCalculatorBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HomeEquityCalculatorBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HomeEquityCalculatorBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HomeEquityCalculatorBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HomeEquityCalculatorBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HomeEquityCalculatorBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HomeEquityCalculatorBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HomeEquityCalculatorBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HomeEquityCalculatorBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HomeEquityCalculatorBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HomeEquityCalculatorBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HomeEquityCalculatorBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HomeEquityCalculatorBlockFacet = {
  __typename?: 'HomeEquityCalculatorBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type HomeEquityCalculatorBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeEquityCalculatorBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type HomeEquityCalculatorBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeEquityCalculatorBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type HomeEquityCalculatorBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeEquityCalculatorBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeEquityCalculatorBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeEquityCalculatorBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeEquityCalculatorBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeEquityCalculatorBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeEquityCalculatorBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeEquityCalculatorBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type HomeEquityCalculatorBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeEquityCalculatorBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeEquityCalculatorBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeEquityCalculatorBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeEquityCalculatorBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type HomeEquityCalculatorBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeEquityCalculatorBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeEquityCalculatorBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeEquityCalculatorBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type HomeEquityCalculatorBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeEquityCalculatorBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type HomeEquityCalculatorBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeEquityCalculatorBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomeEquityCalculatorBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type HomeEquityCalculatorBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type HomeEquityCalculatorBlockOutput = {
  __typename?: 'HomeEquityCalculatorBlockOutput';
  autocomplete?: Maybe<HomeEquityCalculatorBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<HomeEquityCalculatorBlockFacet>;
  item?: Maybe<HomeEquityCalculatorBlock>;
  items?: Maybe<Array<Maybe<HomeEquityCalculatorBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type HomeEquityCalculatorBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomeEquityCalculatorBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<HomeEquityCalculatorBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<HomeEquityCalculatorBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<HomeEquityCalculatorBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type HostDefinitionModel = {
  __typename?: 'HostDefinitionModel';
  Language?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
};

export type HostDefinitionModelAutocomplete = {
  __typename?: 'HostDefinitionModelAutocomplete';
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  Name?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Type?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type HostDefinitionModelAutocompleteNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HostDefinitionModelAutocompleteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HostDefinitionModelFacet = {
  __typename?: 'HostDefinitionModelFacet';
  Language?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  Type?: Maybe<Array<Maybe<StringFacet>>>;
};

export type HostDefinitionModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HostDefinitionModelFacetTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HostDefinitionModelOrderByInput = {
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  Type?: InputMaybe<OrderBy>;
};

export type HostDefinitionModelWhereInput = {
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<StringFilterInput>;
  Type?: InputMaybe<StringFilterInput>;
};

export type IContent = {
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
  IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  PageImageUrl?: Maybe<Scalars['String']['output']>;
  PagePostingDate?: Maybe<Scalars['Date']['output']>;
  PageSearchHeadline?: Maybe<Scalars['String']['output']>;
  PageShortDescription?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};

export type IContentNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type IContent_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type IContent_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type IData = {
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
};

export type IData_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type IData_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

/** Allow Content author to add iframe content */
export type IFrameContainerBlock = IContent &
  IData & {
    __typename?: 'IFrameContainerBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    /** Iframe Container data */
    FormCode?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Allow Content author to add iframe content */
export type IFrameContainerBlockFormCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow Content author to add iframe content */
export type IFrameContainerBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow Content author to add iframe content */
export type IFrameContainerBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow Content author to add iframe content */
export type IFrameContainerBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type IFrameContainerBlockAutocomplete = {
  __typename?: 'IFrameContainerBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type IFrameContainerBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IFrameContainerBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IFrameContainerBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IFrameContainerBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IFrameContainerBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IFrameContainerBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IFrameContainerBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IFrameContainerBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IFrameContainerBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IFrameContainerBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IFrameContainerBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IFrameContainerBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IFrameContainerBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IFrameContainerBlockFacet = {
  __typename?: 'IFrameContainerBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FormCode?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type IFrameContainerBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IFrameContainerBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type IFrameContainerBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IFrameContainerBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type IFrameContainerBlockFacetFormCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IFrameContainerBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IFrameContainerBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IFrameContainerBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IFrameContainerBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IFrameContainerBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IFrameContainerBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type IFrameContainerBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IFrameContainerBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IFrameContainerBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IFrameContainerBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IFrameContainerBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type IFrameContainerBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IFrameContainerBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IFrameContainerBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IFrameContainerBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type IFrameContainerBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IFrameContainerBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type IFrameContainerBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IFrameContainerBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IFrameContainerBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type IFrameContainerBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FormCode?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type IFrameContainerBlockOutput = {
  __typename?: 'IFrameContainerBlockOutput';
  autocomplete?: Maybe<IFrameContainerBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<IFrameContainerBlockFacet>;
  item?: Maybe<IFrameContainerBlock>;
  items?: Maybe<Array<Maybe<IFrameContainerBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type IFrameContainerBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IFrameContainerBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FormCode?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<IFrameContainerBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<IFrameContainerBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<IFrameContainerBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Allow content authors to display FormAssembly forms */
export type IframeCalculatorBlock = IContent &
  IData & {
    __typename?: 'IframeCalculatorBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    /** Description for the form */
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    /** Iframe calculator data */
    FormCode?: Maybe<Scalars['String']['output']>;
    /** Heading for the form */
    Heading?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Allow content authors to display FormAssembly forms */
export type IframeCalculatorBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to display FormAssembly forms */
export type IframeCalculatorBlockFormCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to display FormAssembly forms */
export type IframeCalculatorBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to display FormAssembly forms */
export type IframeCalculatorBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to display FormAssembly forms */
export type IframeCalculatorBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to display FormAssembly forms */
export type IframeCalculatorBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type IframeCalculatorBlockAutocomplete = {
  __typename?: 'IframeCalculatorBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type IframeCalculatorBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IframeCalculatorBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IframeCalculatorBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IframeCalculatorBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IframeCalculatorBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IframeCalculatorBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IframeCalculatorBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IframeCalculatorBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IframeCalculatorBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IframeCalculatorBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IframeCalculatorBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IframeCalculatorBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IframeCalculatorBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IframeCalculatorBlockFacet = {
  __typename?: 'IframeCalculatorBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FormCode?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type IframeCalculatorBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IframeCalculatorBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type IframeCalculatorBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IframeCalculatorBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type IframeCalculatorBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IframeCalculatorBlockFacetFormCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IframeCalculatorBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IframeCalculatorBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IframeCalculatorBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IframeCalculatorBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IframeCalculatorBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IframeCalculatorBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IframeCalculatorBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type IframeCalculatorBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IframeCalculatorBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IframeCalculatorBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IframeCalculatorBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IframeCalculatorBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type IframeCalculatorBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IframeCalculatorBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IframeCalculatorBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IframeCalculatorBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type IframeCalculatorBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IframeCalculatorBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type IframeCalculatorBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IframeCalculatorBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IframeCalculatorBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type IframeCalculatorBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FormCode?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type IframeCalculatorBlockOutput = {
  __typename?: 'IframeCalculatorBlockOutput';
  autocomplete?: Maybe<IframeCalculatorBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<IframeCalculatorBlockFacet>;
  item?: Maybe<IframeCalculatorBlock>;
  items?: Maybe<Array<Maybe<IframeCalculatorBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type IframeCalculatorBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IframeCalculatorBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FormCode?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<IframeCalculatorBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<IframeCalculatorBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<IframeCalculatorBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ImageChoiceElementBlock = IContent &
  IData & {
    __typename?: 'ImageChoiceElementBlock';
    AllowMultiSelect?: Maybe<Scalars['Bool']['output']>;
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ConditionCombination?: Maybe<Scalars['Int']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Items?: Maybe<Array<Maybe<LinkItemNode>>>;
    Label?: Maybe<Scalars['String']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    SatisfiedAction?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    ShowSelectionInputControl?: Maybe<Scalars['Bool']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    Validators?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

export type ImageChoiceElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ImageChoiceElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ImageChoiceElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ImageChoiceElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ImageChoiceElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ImageChoiceElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ImageChoiceElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ImageChoiceElementBlockAutocomplete = {
  __typename?: 'ImageChoiceElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Items?: Maybe<LinkItemNodeAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ImageChoiceElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageChoiceElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageChoiceElementBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageChoiceElementBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageChoiceElementBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageChoiceElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageChoiceElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageChoiceElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageChoiceElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageChoiceElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageChoiceElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageChoiceElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageChoiceElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageChoiceElementBlockFacet = {
  __typename?: 'ImageChoiceElementBlockFacet';
  AllowMultiSelect?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Items?: Maybe<LinkItemNodeFacet>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  ShowSelectionInputControl?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type ImageChoiceElementBlockFacetAllowMultiSelectArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageChoiceElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageChoiceElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageChoiceElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ImageChoiceElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageChoiceElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageChoiceElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageChoiceElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageChoiceElementBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageChoiceElementBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageChoiceElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageChoiceElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageChoiceElementBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageChoiceElementBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageChoiceElementBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageChoiceElementBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageChoiceElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageChoiceElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageChoiceElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageChoiceElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageChoiceElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageChoiceElementBlockFacetShowSelectionInputControlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageChoiceElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageChoiceElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageChoiceElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageChoiceElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageChoiceElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageChoiceElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageChoiceElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageChoiceElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageChoiceElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ImageChoiceElementBlockOrderByInput = {
  AllowMultiSelect?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Items?: InputMaybe<LinkItemNodeOrderByInput>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  ShowSelectionInputControl?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ImageChoiceElementBlockOutput = {
  __typename?: 'ImageChoiceElementBlockOutput';
  autocomplete?: Maybe<ImageChoiceElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ImageChoiceElementBlockFacet>;
  item?: Maybe<ImageChoiceElementBlock>;
  items?: Maybe<Array<Maybe<ImageChoiceElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ImageChoiceElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageChoiceElementBlockWhereInput = {
  AllowMultiSelect?: InputMaybe<BoolFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Items?: InputMaybe<LinkItemNodeWhereInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  ShowSelectionInputControl?: InputMaybe<BoolFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ImageChoiceElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ImageChoiceElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ImageChoiceElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Used for image file types such as jpg, jpeg, jpe, ico, gif, bmp, png */
export type ImageMediaData = IContent &
  IData & {
    __typename?: 'ImageMediaData';
    AltText?: Maybe<Scalars['String']['output']>;
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    Content?: Maybe<Scalars['String']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    /** Description of the image */
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    MimeType?: Maybe<Scalars['String']['output']>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Thumbnail?: Maybe<BlobModel>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Used for image file types such as jpg, jpeg, jpe, ico, gif, bmp, png */
export type ImageMediaDataAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for image file types such as jpg, jpeg, jpe, ico, gif, bmp, png */
export type ImageMediaDataContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for image file types such as jpg, jpeg, jpe, ico, gif, bmp, png */
export type ImageMediaDataDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for image file types such as jpg, jpeg, jpe, ico, gif, bmp, png */
export type ImageMediaDataNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for image file types such as jpg, jpeg, jpe, ico, gif, bmp, png */
export type ImageMediaData_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for image file types such as jpg, jpeg, jpe, ico, gif, bmp, png */
export type ImageMediaData_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ImageMediaDataAutocomplete = {
  __typename?: 'ImageMediaDataAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MimeType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Thumbnail?: Maybe<BlobModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ImageMediaDataAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageMediaDataAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageMediaDataAutocompleteMimeTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageMediaDataAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageMediaDataAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageMediaDataAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageMediaDataAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageMediaDataAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageMediaDataAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageMediaDataAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageMediaDataAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageMediaDataAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageMediaDataAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageMediaDataAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageMediaDataFacet = {
  __typename?: 'ImageMediaDataFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MimeType?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Thumbnail?: Maybe<BlobModelFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type ImageMediaDataFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageMediaDataFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageMediaDataFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageMediaDataFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageMediaDataFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageMediaDataFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageMediaDataFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageMediaDataFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageMediaDataFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageMediaDataFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageMediaDataFacetMimeTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageMediaDataFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageMediaDataFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageMediaDataFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageMediaDataFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageMediaDataFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageMediaDataFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageMediaDataFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageMediaDataFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageMediaDataFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageMediaDataFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageMediaDataFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageMediaDataFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageMediaDataFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageMediaDataFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageMediaDataFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageMediaDataFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageMediaDataFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ImageMediaDataOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MimeType?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Thumbnail?: InputMaybe<BlobModelOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ImageMediaDataOutput = {
  __typename?: 'ImageMediaDataOutput';
  autocomplete?: Maybe<ImageMediaDataAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ImageMediaDataFacet>;
  item?: Maybe<ImageMediaData>;
  items?: Maybe<Array<Maybe<ImageMediaData>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ImageMediaDataOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageMediaDataWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MimeType?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Thumbnail?: InputMaybe<BlobModelWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ImageMediaDataWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ImageMediaDataWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ImageMediaDataWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type InlineBlockPropertyModel = {
  __typename?: 'InlineBlockPropertyModel';
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type InlineBlockPropertyModelAutocomplete = {
  __typename?: 'InlineBlockPropertyModelAutocomplete';
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type InlineBlockPropertyModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type InlineBlockPropertyModelFacet = {
  __typename?: 'InlineBlockPropertyModelFacet';
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
};

export type InlineBlockPropertyModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InlineBlockPropertyModelOrderByInput = {
  ContentType?: InputMaybe<OrderBy>;
};

export type InlineBlockPropertyModelSearch = {
  __typename?: 'InlineBlockPropertyModelSearch';
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type InlineBlockPropertyModelSearchContentTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type InlineBlockPropertyModelSearchFacet = {
  __typename?: 'InlineBlockPropertyModelSearchFacet';
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
};

export type InlineBlockPropertyModelSearchFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InlineBlockPropertyModelSearchOrderByInput = {
  ContentType?: InputMaybe<OrderBy>;
};

export type InlineBlockPropertyModelSearchWhereInput = {
  ContentType?: InputMaybe<SearchableStringFilterInput>;
};

export type InlineBlockPropertyModelWhereInput = {
  ContentType?: InputMaybe<StringFilterInput>;
};

export type IntFilterInput = {
  /** `boost` influences the weight of a field by boosting a match with a number (default: 1) — counts more towards the eventual relevance score which can be projected with `_score` — at query time. Note that `boost` cannot be a negative number. */
  boost?: InputMaybe<Scalars['Int']['input']>;
  /** `eq` matches on an exact value, but the value is case-insensitive. */
  eq?: InputMaybe<Scalars['Int']['input']>;
  /** `exist` matches results that have this field. */
  exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** `Factor` allows you to use a number value in a field to influence the `_score` directly. If used on a multi-valued field, then only the lowest value of the field is used in calculations. Default for `value` is `1`. Default for `modifier` is `NONE`. */
  factor?: InputMaybe<NumberFactor>;
  /** `gt` retrieves results with matches that have a value which is `greater than` it. */
  gt?: InputMaybe<Scalars['Int']['input']>;
  /** `gte` retrieves results with matches that have a value which is `greater than or equal to` it. */
  gte?: InputMaybe<Scalars['Int']['input']>;
  /** `in` matches with 1 or more exact values in a list. Example: `in: ["word1", "word2", "this is a phrase"]` */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** `lt` retrieves results with matches that have a value which is `lower than` it. */
  lt?: InputMaybe<Scalars['Int']['input']>;
  /** `lte` retrieves results with matches that have a value which is `lower than or equal to` it. */
  lte?: InputMaybe<Scalars['Int']['input']>;
  /** `not_eq` retrieves results not matching with an exact (but case-insensitive) value. */
  notEq?: InputMaybe<Scalars['Int']['input']>;
  /** `not_in` returns results that do not match with 1 or more exact values in a list. Example: `not_in: ["word1", "word2", "this is a phrase"]` */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/** Used for all landing pages across CACU */
export type InteriorContentPage = IContent &
  IData & {
    __typename?: 'InteriorContentPage';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    AuthorMetaData?: Maybe<Scalars['String']['output']>;
    BreadcrumbsTitle?: Maybe<Scalars['String']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    DisableIndexing?: Maybe<Scalars['Bool']['output']>;
    /** This will determine whether or not to show on search. */
    ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
    /** This will determine whether or not to show on the Sitemap. */
    ExcludeFromSitemap?: Maybe<Scalars['Bool']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    FooterOverride?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    HeaderOverride?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    /** Headline is shown when the page appears in Search Results. */
    Headline?: Maybe<Scalars['String']['output']>;
    /** This will determine whether or not to be dispalyed in breadcrumbs. */
    HideInBreadcrumbs?: Maybe<Scalars['Bool']['output']>;
    HideSiteFooter?: Maybe<Scalars['Bool']['output']>;
    HideSiteHeader?: Maybe<Scalars['Bool']['output']>;
    Highlight?: Maybe<Scalars['Bool']['output']>;
    Industry?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Keywords?: Maybe<Scalars['String']['output']>;
    /** Container for Schema Field */
    LDJsonContainer?: Maybe<Scalars['String']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MainContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    MetaContentType?: Maybe<Scalars['String']['output']>;
    MetaTitle?: Maybe<Scalars['String']['output']>;
    Name?: Maybe<Scalars['String']['output']>;
    NavigationTitle?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Description value that has been managed for the current page */
    OpenGraphDescription?: Maybe<Scalars['String']['output']>;
    /** Page template will always inherit the OpenGraph image from the parent page, recursively, until an image is managed for the current page */
    OpenGraphImage?: Maybe<ContentModelReference>;
    /** If managed, this field will overwrite the Image Height value that has been managed for the current page */
    OpenGraphImageHeight?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Image Type value that has been managed for the current page */
    OpenGraphImageType?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Image Width  value that has been managed for the current page */
    OpenGraphImageWidth?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Site value that has been managed for the current page */
    OpenGraphSite?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Title value that has been managed for the current page */
    OpenGraphTitle?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Url value that has been managed for the current page */
    OpenGraphUrl?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Type value that has been managed for the current page */
    OpenGraphtype?: Maybe<Scalars['String']['output']>;
    PageDescription?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    /** Short Description is shown when the page appears in Search Results. */
    ShortDescription?: Maybe<Scalars['String']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    TeaserText?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Used for all landing pages across CACU */
export type InteriorContentPageAuthorMetaDataArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for all landing pages across CACU */
export type InteriorContentPageFooterOverrideArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for all landing pages across CACU */
export type InteriorContentPageHeaderOverrideArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for all landing pages across CACU */
export type InteriorContentPageHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for all landing pages across CACU */
export type InteriorContentPageIndustryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for all landing pages across CACU */
export type InteriorContentPageKeywordsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for all landing pages across CACU */
export type InteriorContentPageLdJsonContainerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for all landing pages across CACU */
export type InteriorContentPageMainContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for all landing pages across CACU */
export type InteriorContentPageMetaContentTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for all landing pages across CACU */
export type InteriorContentPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for all landing pages across CACU */
export type InteriorContentPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for all landing pages across CACU */
export type InteriorContentPageNavigationTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for all landing pages across CACU */
export type InteriorContentPageOpenGraphDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for all landing pages across CACU */
export type InteriorContentPageOpenGraphImageHeightArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for all landing pages across CACU */
export type InteriorContentPageOpenGraphImageTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for all landing pages across CACU */
export type InteriorContentPageOpenGraphImageWidthArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for all landing pages across CACU */
export type InteriorContentPageOpenGraphSiteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for all landing pages across CACU */
export type InteriorContentPageOpenGraphTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for all landing pages across CACU */
export type InteriorContentPageOpenGraphUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for all landing pages across CACU */
export type InteriorContentPageOpenGraphtypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for all landing pages across CACU */
export type InteriorContentPagePageDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for all landing pages across CACU */
export type InteriorContentPageShortDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for all landing pages across CACU */
export type InteriorContentPageTeaserTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for all landing pages across CACU */
export type InteriorContentPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for all landing pages across CACU */
export type InteriorContentPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type InteriorContentPageAutocomplete = {
  __typename?: 'InteriorContentPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  OpenGraphImage?: Maybe<ContentModelReferenceAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type InteriorContentPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type InteriorContentPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type InteriorContentPageAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type InteriorContentPageAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type InteriorContentPageAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type InteriorContentPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type InteriorContentPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type InteriorContentPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type InteriorContentPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type InteriorContentPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type InteriorContentPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type InteriorContentPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type InteriorContentPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type InteriorContentPageFacet = {
  __typename?: 'InteriorContentPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AuthorMetaData?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSitemap?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FooterOverride?: Maybe<ContentAreaItemModelSearchFacet>;
  HeaderOverride?: Maybe<ContentAreaItemModelSearchFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  HideInBreadcrumbs?: Maybe<Array<Maybe<StringFacet>>>;
  HideSiteFooter?: Maybe<Array<Maybe<StringFacet>>>;
  HideSiteHeader?: Maybe<Array<Maybe<StringFacet>>>;
  Highlight?: Maybe<Array<Maybe<StringFacet>>>;
  Industry?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Keywords?: Maybe<Array<Maybe<StringFacet>>>;
  LDJsonContainer?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaContentType?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NavigationTitle?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphDescription?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphImage?: Maybe<ContentModelReferenceFacet>;
  OpenGraphImageHeight?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphImageType?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphImageWidth?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphSite?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphTitle?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphUrl?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphtype?: Maybe<Array<Maybe<StringFacet>>>;
  PageDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  ShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TeaserText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type InteriorContentPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetAuthorMetaDataArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type InteriorContentPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type InteriorContentPageFacetDisableIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetExcludeFromSitemapArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetHideInBreadcrumbsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetHideSiteFooterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetHideSiteHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetHighlightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetIndustryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetKeywordsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetLdJsonContainerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetMetaContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetNavigationTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetOpenGraphDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetOpenGraphImageHeightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetOpenGraphImageTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetOpenGraphImageWidthArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetOpenGraphSiteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetOpenGraphTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetOpenGraphUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetOpenGraphtypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetPageDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type InteriorContentPageFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type InteriorContentPageFacetShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type InteriorContentPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type InteriorContentPageFacetTeaserTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InteriorContentPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type InteriorContentPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AuthorMetaData?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExcludeFromSitemap?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FooterOverride?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  HeaderOverride?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  HideInBreadcrumbs?: InputMaybe<OrderBy>;
  HideSiteFooter?: InputMaybe<OrderBy>;
  HideSiteHeader?: InputMaybe<OrderBy>;
  Highlight?: InputMaybe<OrderBy>;
  Industry?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Keywords?: InputMaybe<OrderBy>;
  LDJsonContainer?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaContentType?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NavigationTitle?: InputMaybe<OrderBy>;
  OpenGraphDescription?: InputMaybe<OrderBy>;
  OpenGraphImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  OpenGraphImageHeight?: InputMaybe<OrderBy>;
  OpenGraphImageType?: InputMaybe<OrderBy>;
  OpenGraphImageWidth?: InputMaybe<OrderBy>;
  OpenGraphSite?: InputMaybe<OrderBy>;
  OpenGraphTitle?: InputMaybe<OrderBy>;
  OpenGraphUrl?: InputMaybe<OrderBy>;
  OpenGraphtype?: InputMaybe<OrderBy>;
  PageDescription?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  ShortDescription?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TeaserText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type InteriorContentPageOutput = {
  __typename?: 'InteriorContentPageOutput';
  autocomplete?: Maybe<InteriorContentPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<InteriorContentPageFacet>;
  item?: Maybe<InteriorContentPage>;
  items?: Maybe<Array<Maybe<InteriorContentPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type InteriorContentPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InteriorContentPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AuthorMetaData?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExcludeFromSitemap?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FooterOverride?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  HeaderOverride?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  HideInBreadcrumbs?: InputMaybe<BoolFilterInput>;
  HideSiteFooter?: InputMaybe<BoolFilterInput>;
  HideSiteHeader?: InputMaybe<BoolFilterInput>;
  Highlight?: InputMaybe<BoolFilterInput>;
  Industry?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Keywords?: InputMaybe<SearchableStringFilterInput>;
  LDJsonContainer?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaContentType?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NavigationTitle?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphDescription?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphImage?: InputMaybe<ContentModelReferenceWhereInput>;
  OpenGraphImageHeight?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphImageType?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphImageWidth?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphSite?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphTitle?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphUrl?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphtype?: InputMaybe<SearchableStringFilterInput>;
  PageDescription?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  ShortDescription?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TeaserText?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<InteriorContentPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<InteriorContentPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<InteriorContentPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type LinkConfig = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type LinkItemNode = {
  __typename?: 'LinkItemNode';
  ContentLink?: Maybe<ContentModelReference>;
  Href?: Maybe<Scalars['String']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
  Text?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

export type LinkItemNodeAutocomplete = {
  __typename?: 'LinkItemNodeAutocomplete';
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  Href?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Target?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Text?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Title?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type LinkItemNodeAutocompleteHrefArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LinkItemNodeAutocompleteTargetArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LinkItemNodeAutocompleteTextArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LinkItemNodeAutocompleteTitleArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LinkItemNodeFacet = {
  __typename?: 'LinkItemNodeFacet';
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  Href?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
  Text?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};

export type LinkItemNodeFacetHrefArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LinkItemNodeFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LinkItemNodeFacetTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LinkItemNodeFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LinkItemNodeOrderByInput = {
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Href?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
  Text?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type LinkItemNodeWhereInput = {
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Href?: InputMaybe<StringFilterInput>;
  Target?: InputMaybe<StringFilterInput>;
  Text?: InputMaybe<StringFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
};

export enum LinkTypes {
  /**
   *
   * | *Direction* | &nbsp; | *Field*     |
   * | ----------: | ------ | :---------- |
   * | *from*      |        | `Ancestors` |
   * | *to*        |        | `ContentLink.GuidValue`   |
   */
  Ancestors = 'ANCESTORS',
  /**
   *
   * | *Direction* | &nbsp; | *Field*     |
   * | ----------: | ------ | :---------- |
   * | *from*      |        | `ContentLink.GuidValue` |
   * | *to*        |        | `ParentLink.GuidValue`   |
   */
  Children = 'CHILDREN',
  /**
   *
   * | *Direction* | &nbsp; | *Field*     |
   * | ----------: | ------ | :---------- |
   * | *from*      |        | `ContentLink.GuidValue` |
   * | *to*        |        | `ParentLink.GuidValue`   |
   */
  Default = 'DEFAULT'
}

export enum Locales {
  All = 'ALL',
  Neutral = 'NEUTRAL',
  En = 'en'
}

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPage = IContent &
  IData & {
    __typename?: 'LocationPage';
    ATMHoursFriday?: Maybe<Scalars['String']['output']>;
    ATMHoursHeading?: Maybe<Scalars['String']['output']>;
    ATMHoursMonday?: Maybe<Scalars['String']['output']>;
    ATMHoursSaturday?: Maybe<Scalars['String']['output']>;
    ATMHoursSunday?: Maybe<Scalars['String']['output']>;
    ATMHoursThursday?: Maybe<Scalars['String']['output']>;
    ATMHoursTuesday?: Maybe<Scalars['String']['output']>;
    ATMHoursWednesday?: Maybe<Scalars['String']['output']>;
    AboutThisBranchHeading?: Maybe<Scalars['String']['output']>;
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    AuthorMetaData?: Maybe<Scalars['String']['output']>;
    BreadcrumbsTitle?: Maybe<Scalars['String']['output']>;
    CallUsLabel?: Maybe<Scalars['String']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    City?: Maybe<Scalars['String']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    DisableIndexing?: Maybe<Scalars['Bool']['output']>;
    DriveThruHoursFriday?: Maybe<Scalars['String']['output']>;
    DriveThruHoursHeading?: Maybe<Scalars['String']['output']>;
    DriveThruHoursMonday?: Maybe<Scalars['String']['output']>;
    DriveThruHoursSaturday?: Maybe<Scalars['String']['output']>;
    DriveThruHoursSunday?: Maybe<Scalars['String']['output']>;
    DriveThruHoursThursday?: Maybe<Scalars['String']['output']>;
    DriveThruHoursTuesday?: Maybe<Scalars['String']['output']>;
    DriveThruHoursWednesday?: Maybe<Scalars['String']['output']>;
    DriveThruVideoTellerHoursFriday?: Maybe<Scalars['String']['output']>;
    DriveThruVideoTellerHoursHeading?: Maybe<Scalars['String']['output']>;
    DriveThruVideoTellerHoursMonday?: Maybe<Scalars['String']['output']>;
    DriveThruVideoTellerHoursSaturday?: Maybe<Scalars['String']['output']>;
    DriveThruVideoTellerHoursSunday?: Maybe<Scalars['String']['output']>;
    DriveThruVideoTellerHoursThursday?: Maybe<Scalars['String']['output']>;
    DriveThruVideoTellerHoursTuesday?: Maybe<Scalars['String']['output']>;
    DriveThruVideoTellerHoursWednesday?: Maybe<Scalars['String']['output']>;
    /** This will determine whether or not to show on search. */
    ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
    /** This will determine whether or not to show on the Sitemap. */
    ExcludeFromSitemap?: Maybe<Scalars['Bool']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    FAQSchema?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    FeaturedProducts?: Maybe<Scalars['String']['output']>;
    FeaturesAndServicesHeading?: Maybe<Scalars['String']['output']>;
    FinancialSchema?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    FooterOverride?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    GetDirectionsLabel?: Maybe<Scalars['String']['output']>;
    HeaderOverride?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    Hero?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    /** This will determine whether or not to be dispalyed in breadcrumbs. */
    HideInBreadcrumbs?: Maybe<Scalars['Bool']['output']>;
    HideSiteFooter?: Maybe<Scalars['Bool']['output']>;
    HideSiteHeader?: Maybe<Scalars['Bool']['output']>;
    Highlight?: Maybe<Scalars['Bool']['output']>;
    HoursHeading?: Maybe<Scalars['String']['output']>;
    Industry?: Maybe<Scalars['String']['output']>;
    IsBranch?: Maybe<Scalars['Bool']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    ItemProductName?: Maybe<Scalars['String']['output']>;
    Keywords?: Maybe<Scalars['String']['output']>;
    /** Container for Schema Field */
    LDJsonContainer?: Maybe<Scalars['String']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    Latitude?: Maybe<Scalars['String']['output']>;
    LobbyHoursFriday?: Maybe<Scalars['String']['output']>;
    LobbyHoursHeading?: Maybe<Scalars['String']['output']>;
    LobbyHoursMonday?: Maybe<Scalars['String']['output']>;
    LobbyHoursSaturday?: Maybe<Scalars['String']['output']>;
    LobbyHoursSunday?: Maybe<Scalars['String']['output']>;
    LobbyHoursThursday?: Maybe<Scalars['String']['output']>;
    LobbyHoursTuesday?: Maybe<Scalars['String']['output']>;
    LobbyHoursWednesday?: Maybe<Scalars['String']['output']>;
    LocationDescription?: Maybe<Scalars['String']['output']>;
    LocationImage?: Maybe<ContentModelReference>;
    LocationImageUrl?: Maybe<ContentModelReference>;
    LocationLogoUrl?: Maybe<ContentModelReference>;
    LocationMapUrl?: Maybe<Scalars['String']['output']>;
    LocationName?: Maybe<Scalars['String']['output']>;
    LocationSchema?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    LocationSectionId?: Maybe<Scalars['String']['output']>;
    LocationSiderCTA?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    Longitude?: Maybe<Scalars['String']['output']>;
    MainContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    MetaContentType?: Maybe<Scalars['String']['output']>;
    MetaTitle?: Maybe<Scalars['String']['output']>;
    Name?: Maybe<Scalars['String']['output']>;
    NavigationTitle?: Maybe<Scalars['String']['output']>;
    OfferServiceName?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Description value that has been managed for the current page */
    OpenGraphDescription?: Maybe<Scalars['String']['output']>;
    /** Page template will always inherit the OpenGraph image from the parent page, recursively, until an image is managed for the current page */
    OpenGraphImage?: Maybe<ContentModelReference>;
    /** If managed, this field will overwrite the Image Height value that has been managed for the current page */
    OpenGraphImageHeight?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Image Type value that has been managed for the current page */
    OpenGraphImageType?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Image Width  value that has been managed for the current page */
    OpenGraphImageWidth?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Site value that has been managed for the current page */
    OpenGraphSite?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Title value that has been managed for the current page */
    OpenGraphTitle?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Url value that has been managed for the current page */
    OpenGraphUrl?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Type value that has been managed for the current page */
    OpenGraphtype?: Maybe<Scalars['String']['output']>;
    OrganizationSchema?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    PageDescription?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    PersonSchema?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    Phone?: Maybe<Scalars['String']['output']>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    SItemProductName?: Maybe<Scalars['String']['output']>;
    SOfferServiceName?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    ServicesAvailable?: Maybe<Scalars['String']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    /** Show the location schema of the current location */
    ShowSchema?: Maybe<Scalars['Bool']['output']>;
    SignUpToNewsletterForm?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SimpleMasthead?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    State?: Maybe<Scalars['String']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Street?: Maybe<Scalars['String']['output']>;
    Street2?: Maybe<Scalars['String']['output']>;
    TItemProductName?: Maybe<Scalars['String']['output']>;
    TOfferServiceName?: Maybe<Scalars['String']['output']>;
    TeaserText?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    VideoTellerHoursFriday?: Maybe<Scalars['String']['output']>;
    VideoTellerHoursHeading?: Maybe<Scalars['String']['output']>;
    VideoTellerHoursMonday?: Maybe<Scalars['String']['output']>;
    VideoTellerHoursSaturday?: Maybe<Scalars['String']['output']>;
    VideoTellerHoursSunday?: Maybe<Scalars['String']['output']>;
    VideoTellerHoursThursday?: Maybe<Scalars['String']['output']>;
    VideoTellerHoursTuesday?: Maybe<Scalars['String']['output']>;
    VideoTellerHoursWednesday?: Maybe<Scalars['String']['output']>;
    Zip?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageAtmHoursFridayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageAtmHoursHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageAtmHoursMondayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageAtmHoursSaturdayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageAtmHoursSundayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageAtmHoursThursdayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageAtmHoursTuesdayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageAtmHoursWednesdayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageAboutThisBranchHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageAuthorMetaDataArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageCallUsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageCityArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageDriveThruHoursFridayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageDriveThruHoursHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageDriveThruHoursMondayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageDriveThruHoursSaturdayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageDriveThruHoursSundayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageDriveThruHoursThursdayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageDriveThruHoursTuesdayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageDriveThruHoursWednesdayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageDriveThruVideoTellerHoursFridayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageDriveThruVideoTellerHoursHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageDriveThruVideoTellerHoursMondayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageDriveThruVideoTellerHoursSaturdayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageDriveThruVideoTellerHoursSundayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageDriveThruVideoTellerHoursThursdayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageDriveThruVideoTellerHoursTuesdayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageDriveThruVideoTellerHoursWednesdayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageFaqSchemaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageFeaturedProductsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageFeaturesAndServicesHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageFinancialSchemaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageFooterOverrideArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageGetDirectionsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageHeaderOverrideArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageHeroArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageHoursHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageIndustryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageItemProductNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageKeywordsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageLdJsonContainerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageLatitudeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageLobbyHoursFridayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageLobbyHoursHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageLobbyHoursMondayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageLobbyHoursSaturdayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageLobbyHoursSundayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageLobbyHoursThursdayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageLobbyHoursTuesdayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageLobbyHoursWednesdayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageLocationDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageLocationMapUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageLocationNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageLocationSchemaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageLocationSectionIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageLocationSiderCtaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageLongitudeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageMainContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageMetaContentTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageNavigationTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageOfferServiceNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageOpenGraphDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageOpenGraphImageHeightArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageOpenGraphImageTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageOpenGraphImageWidthArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageOpenGraphSiteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageOpenGraphTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageOpenGraphUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageOpenGraphtypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageOrganizationSchemaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPagePageDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPagePersonSchemaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPagePhoneArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageSItemProductNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageSOfferServiceNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageServicesAvailableArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageSignUpToNewsletterFormArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageSimpleMastheadArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageStateArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageStreetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageStreet2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageTItemProductNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageTOfferServiceNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageTeaserTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageVideoTellerHoursFridayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageVideoTellerHoursHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageVideoTellerHoursMondayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageVideoTellerHoursSaturdayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageVideoTellerHoursSundayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageVideoTellerHoursThursdayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageVideoTellerHoursTuesdayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageVideoTellerHoursWednesdayArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPageZipArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Pages with a specific CACU Location information such as name, description, address, phone, lobby hours, features and services, location map and a CTA to get directions */
export type LocationPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type LocationPageAutocomplete = {
  __typename?: 'LocationPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  LocationImage?: Maybe<ContentModelReferenceAutocomplete>;
  LocationImageUrl?: Maybe<ContentModelReferenceAutocomplete>;
  LocationLogoUrl?: Maybe<ContentModelReferenceAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  OpenGraphImage?: Maybe<ContentModelReferenceAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type LocationPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LocationPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LocationPageAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LocationPageAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LocationPageAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LocationPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LocationPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LocationPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LocationPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LocationPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LocationPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LocationPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LocationPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LocationPageFacet = {
  __typename?: 'LocationPageFacet';
  ATMHoursFriday?: Maybe<Array<Maybe<StringFacet>>>;
  ATMHoursHeading?: Maybe<Array<Maybe<StringFacet>>>;
  ATMHoursMonday?: Maybe<Array<Maybe<StringFacet>>>;
  ATMHoursSaturday?: Maybe<Array<Maybe<StringFacet>>>;
  ATMHoursSunday?: Maybe<Array<Maybe<StringFacet>>>;
  ATMHoursThursday?: Maybe<Array<Maybe<StringFacet>>>;
  ATMHoursTuesday?: Maybe<Array<Maybe<StringFacet>>>;
  ATMHoursWednesday?: Maybe<Array<Maybe<StringFacet>>>;
  AboutThisBranchHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AuthorMetaData?: Maybe<Array<Maybe<StringFacet>>>;
  CallUsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  City?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DisableIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  DriveThruHoursFriday?: Maybe<Array<Maybe<StringFacet>>>;
  DriveThruHoursHeading?: Maybe<Array<Maybe<StringFacet>>>;
  DriveThruHoursMonday?: Maybe<Array<Maybe<StringFacet>>>;
  DriveThruHoursSaturday?: Maybe<Array<Maybe<StringFacet>>>;
  DriveThruHoursSunday?: Maybe<Array<Maybe<StringFacet>>>;
  DriveThruHoursThursday?: Maybe<Array<Maybe<StringFacet>>>;
  DriveThruHoursTuesday?: Maybe<Array<Maybe<StringFacet>>>;
  DriveThruHoursWednesday?: Maybe<Array<Maybe<StringFacet>>>;
  DriveThruVideoTellerHoursFriday?: Maybe<Array<Maybe<StringFacet>>>;
  DriveThruVideoTellerHoursHeading?: Maybe<Array<Maybe<StringFacet>>>;
  DriveThruVideoTellerHoursMonday?: Maybe<Array<Maybe<StringFacet>>>;
  DriveThruVideoTellerHoursSaturday?: Maybe<Array<Maybe<StringFacet>>>;
  DriveThruVideoTellerHoursSunday?: Maybe<Array<Maybe<StringFacet>>>;
  DriveThruVideoTellerHoursThursday?: Maybe<Array<Maybe<StringFacet>>>;
  DriveThruVideoTellerHoursTuesday?: Maybe<Array<Maybe<StringFacet>>>;
  DriveThruVideoTellerHoursWednesday?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSitemap?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FAQSchema?: Maybe<ContentAreaItemModelSearchFacet>;
  FeaturedProducts?: Maybe<Array<Maybe<StringFacet>>>;
  FeaturesAndServicesHeading?: Maybe<Array<Maybe<StringFacet>>>;
  FinancialSchema?: Maybe<ContentAreaItemModelSearchFacet>;
  FooterOverride?: Maybe<ContentAreaItemModelSearchFacet>;
  GetDirectionsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  HeaderOverride?: Maybe<ContentAreaItemModelSearchFacet>;
  Hero?: Maybe<ContentAreaItemModelSearchFacet>;
  HideInBreadcrumbs?: Maybe<Array<Maybe<StringFacet>>>;
  HideSiteFooter?: Maybe<Array<Maybe<StringFacet>>>;
  HideSiteHeader?: Maybe<Array<Maybe<StringFacet>>>;
  Highlight?: Maybe<Array<Maybe<StringFacet>>>;
  HoursHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Industry?: Maybe<Array<Maybe<StringFacet>>>;
  IsBranch?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  ItemProductName?: Maybe<Array<Maybe<StringFacet>>>;
  Keywords?: Maybe<Array<Maybe<StringFacet>>>;
  LDJsonContainer?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  Latitude?: Maybe<Array<Maybe<StringFacet>>>;
  LobbyHoursFriday?: Maybe<Array<Maybe<StringFacet>>>;
  LobbyHoursHeading?: Maybe<Array<Maybe<StringFacet>>>;
  LobbyHoursMonday?: Maybe<Array<Maybe<StringFacet>>>;
  LobbyHoursSaturday?: Maybe<Array<Maybe<StringFacet>>>;
  LobbyHoursSunday?: Maybe<Array<Maybe<StringFacet>>>;
  LobbyHoursThursday?: Maybe<Array<Maybe<StringFacet>>>;
  LobbyHoursTuesday?: Maybe<Array<Maybe<StringFacet>>>;
  LobbyHoursWednesday?: Maybe<Array<Maybe<StringFacet>>>;
  LocationDescription?: Maybe<Array<Maybe<StringFacet>>>;
  LocationImage?: Maybe<ContentModelReferenceFacet>;
  LocationImageUrl?: Maybe<ContentModelReferenceFacet>;
  LocationLogoUrl?: Maybe<ContentModelReferenceFacet>;
  LocationMapUrl?: Maybe<Array<Maybe<StringFacet>>>;
  LocationName?: Maybe<Array<Maybe<StringFacet>>>;
  LocationSchema?: Maybe<ContentAreaItemModelSearchFacet>;
  LocationSectionId?: Maybe<Array<Maybe<StringFacet>>>;
  LocationSiderCTA?: Maybe<ContentAreaItemModelSearchFacet>;
  Longitude?: Maybe<Array<Maybe<StringFacet>>>;
  MainContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaContentType?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NavigationTitle?: Maybe<Array<Maybe<StringFacet>>>;
  OfferServiceName?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphDescription?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphImage?: Maybe<ContentModelReferenceFacet>;
  OpenGraphImageHeight?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphImageType?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphImageWidth?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphSite?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphTitle?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphUrl?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphtype?: Maybe<Array<Maybe<StringFacet>>>;
  OrganizationSchema?: Maybe<ContentAreaItemModelSearchFacet>;
  PageDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PersonSchema?: Maybe<ContentAreaItemModelSearchFacet>;
  Phone?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SItemProductName?: Maybe<Array<Maybe<StringFacet>>>;
  SOfferServiceName?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  ServicesAvailable?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  ShowSchema?: Maybe<Array<Maybe<StringFacet>>>;
  SignUpToNewsletterForm?: Maybe<ContentAreaItemModelSearchFacet>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleMasthead?: Maybe<ContentAreaItemModelSearchFacet>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  State?: Maybe<Array<Maybe<StringFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Street?: Maybe<Array<Maybe<StringFacet>>>;
  Street2?: Maybe<Array<Maybe<StringFacet>>>;
  TItemProductName?: Maybe<Array<Maybe<StringFacet>>>;
  TOfferServiceName?: Maybe<Array<Maybe<StringFacet>>>;
  TeaserText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VideoTellerHoursFriday?: Maybe<Array<Maybe<StringFacet>>>;
  VideoTellerHoursHeading?: Maybe<Array<Maybe<StringFacet>>>;
  VideoTellerHoursMonday?: Maybe<Array<Maybe<StringFacet>>>;
  VideoTellerHoursSaturday?: Maybe<Array<Maybe<StringFacet>>>;
  VideoTellerHoursSunday?: Maybe<Array<Maybe<StringFacet>>>;
  VideoTellerHoursThursday?: Maybe<Array<Maybe<StringFacet>>>;
  VideoTellerHoursTuesday?: Maybe<Array<Maybe<StringFacet>>>;
  VideoTellerHoursWednesday?: Maybe<Array<Maybe<StringFacet>>>;
  Zip?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type LocationPageFacetAtmHoursFridayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetAtmHoursHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetAtmHoursMondayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetAtmHoursSaturdayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetAtmHoursSundayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetAtmHoursThursdayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetAtmHoursTuesdayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetAtmHoursWednesdayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetAboutThisBranchHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetAuthorMetaDataArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetCallUsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationPageFacetCityArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationPageFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetDisableIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetDriveThruHoursFridayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetDriveThruHoursHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetDriveThruHoursMondayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetDriveThruHoursSaturdayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetDriveThruHoursSundayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetDriveThruHoursThursdayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetDriveThruHoursTuesdayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetDriveThruHoursWednesdayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetDriveThruVideoTellerHoursFridayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetDriveThruVideoTellerHoursHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetDriveThruVideoTellerHoursMondayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetDriveThruVideoTellerHoursSaturdayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetDriveThruVideoTellerHoursSundayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetDriveThruVideoTellerHoursThursdayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetDriveThruVideoTellerHoursTuesdayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetDriveThruVideoTellerHoursWednesdayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetExcludeFromSitemapArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetFeaturedProductsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetFeaturesAndServicesHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetGetDirectionsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetHideInBreadcrumbsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetHideSiteFooterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetHideSiteHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetHighlightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetHoursHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetIndustryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetIsBranchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetItemProductNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetKeywordsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetLdJsonContainerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetLatitudeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetLobbyHoursFridayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetLobbyHoursHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetLobbyHoursMondayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetLobbyHoursSaturdayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetLobbyHoursSundayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetLobbyHoursThursdayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetLobbyHoursTuesdayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetLobbyHoursWednesdayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetLocationDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetLocationMapUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetLocationNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetLocationSectionIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetLongitudeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetMetaContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetNavigationTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetOfferServiceNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetOpenGraphDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetOpenGraphImageHeightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetOpenGraphImageTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetOpenGraphImageWidthArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetOpenGraphSiteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetOpenGraphTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetOpenGraphUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetOpenGraphtypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetPageDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationPageFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetPhoneArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetSItemProductNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetSOfferServiceNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationPageFacetServicesAvailableArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetShowSchemaArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationPageFacetStateArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationPageFacetStreetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetStreet2Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetTItemProductNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetTOfferServiceNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetTeaserTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetVideoTellerHoursFridayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetVideoTellerHoursHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetVideoTellerHoursMondayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetVideoTellerHoursSaturdayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetVideoTellerHoursSundayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetVideoTellerHoursThursdayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetVideoTellerHoursTuesdayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetVideoTellerHoursWednesdayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacetZipArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type LocationPageOrderByInput = {
  ATMHoursFriday?: InputMaybe<OrderBy>;
  ATMHoursHeading?: InputMaybe<OrderBy>;
  ATMHoursMonday?: InputMaybe<OrderBy>;
  ATMHoursSaturday?: InputMaybe<OrderBy>;
  ATMHoursSunday?: InputMaybe<OrderBy>;
  ATMHoursThursday?: InputMaybe<OrderBy>;
  ATMHoursTuesday?: InputMaybe<OrderBy>;
  ATMHoursWednesday?: InputMaybe<OrderBy>;
  AboutThisBranchHeading?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AuthorMetaData?: InputMaybe<OrderBy>;
  CallUsLabel?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  City?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DisableIndexing?: InputMaybe<OrderBy>;
  DriveThruHoursFriday?: InputMaybe<OrderBy>;
  DriveThruHoursHeading?: InputMaybe<OrderBy>;
  DriveThruHoursMonday?: InputMaybe<OrderBy>;
  DriveThruHoursSaturday?: InputMaybe<OrderBy>;
  DriveThruHoursSunday?: InputMaybe<OrderBy>;
  DriveThruHoursThursday?: InputMaybe<OrderBy>;
  DriveThruHoursTuesday?: InputMaybe<OrderBy>;
  DriveThruHoursWednesday?: InputMaybe<OrderBy>;
  DriveThruVideoTellerHoursFriday?: InputMaybe<OrderBy>;
  DriveThruVideoTellerHoursHeading?: InputMaybe<OrderBy>;
  DriveThruVideoTellerHoursMonday?: InputMaybe<OrderBy>;
  DriveThruVideoTellerHoursSaturday?: InputMaybe<OrderBy>;
  DriveThruVideoTellerHoursSunday?: InputMaybe<OrderBy>;
  DriveThruVideoTellerHoursThursday?: InputMaybe<OrderBy>;
  DriveThruVideoTellerHoursTuesday?: InputMaybe<OrderBy>;
  DriveThruVideoTellerHoursWednesday?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExcludeFromSitemap?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FAQSchema?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  FeaturedProducts?: InputMaybe<OrderBy>;
  FeaturesAndServicesHeading?: InputMaybe<OrderBy>;
  FinancialSchema?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  FooterOverride?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  GetDirectionsLabel?: InputMaybe<OrderBy>;
  HeaderOverride?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Hero?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  HideInBreadcrumbs?: InputMaybe<OrderBy>;
  HideSiteFooter?: InputMaybe<OrderBy>;
  HideSiteHeader?: InputMaybe<OrderBy>;
  Highlight?: InputMaybe<OrderBy>;
  HoursHeading?: InputMaybe<OrderBy>;
  Industry?: InputMaybe<OrderBy>;
  IsBranch?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  ItemProductName?: InputMaybe<OrderBy>;
  Keywords?: InputMaybe<OrderBy>;
  LDJsonContainer?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  Latitude?: InputMaybe<OrderBy>;
  LobbyHoursFriday?: InputMaybe<OrderBy>;
  LobbyHoursHeading?: InputMaybe<OrderBy>;
  LobbyHoursMonday?: InputMaybe<OrderBy>;
  LobbyHoursSaturday?: InputMaybe<OrderBy>;
  LobbyHoursSunday?: InputMaybe<OrderBy>;
  LobbyHoursThursday?: InputMaybe<OrderBy>;
  LobbyHoursTuesday?: InputMaybe<OrderBy>;
  LobbyHoursWednesday?: InputMaybe<OrderBy>;
  LocationDescription?: InputMaybe<OrderBy>;
  LocationImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  LocationImageUrl?: InputMaybe<ContentModelReferenceOrderByInput>;
  LocationLogoUrl?: InputMaybe<ContentModelReferenceOrderByInput>;
  LocationMapUrl?: InputMaybe<OrderBy>;
  LocationName?: InputMaybe<OrderBy>;
  LocationSchema?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  LocationSectionId?: InputMaybe<OrderBy>;
  LocationSiderCTA?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Longitude?: InputMaybe<OrderBy>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaContentType?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NavigationTitle?: InputMaybe<OrderBy>;
  OfferServiceName?: InputMaybe<OrderBy>;
  OpenGraphDescription?: InputMaybe<OrderBy>;
  OpenGraphImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  OpenGraphImageHeight?: InputMaybe<OrderBy>;
  OpenGraphImageType?: InputMaybe<OrderBy>;
  OpenGraphImageWidth?: InputMaybe<OrderBy>;
  OpenGraphSite?: InputMaybe<OrderBy>;
  OpenGraphTitle?: InputMaybe<OrderBy>;
  OpenGraphUrl?: InputMaybe<OrderBy>;
  OpenGraphtype?: InputMaybe<OrderBy>;
  OrganizationSchema?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  PageDescription?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PersonSchema?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Phone?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SItemProductName?: InputMaybe<OrderBy>;
  SOfferServiceName?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  ServicesAvailable?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  ShowSchema?: InputMaybe<OrderBy>;
  SignUpToNewsletterForm?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SimpleMasthead?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  State?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Street?: InputMaybe<OrderBy>;
  Street2?: InputMaybe<OrderBy>;
  TItemProductName?: InputMaybe<OrderBy>;
  TOfferServiceName?: InputMaybe<OrderBy>;
  TeaserText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VideoTellerHoursFriday?: InputMaybe<OrderBy>;
  VideoTellerHoursHeading?: InputMaybe<OrderBy>;
  VideoTellerHoursMonday?: InputMaybe<OrderBy>;
  VideoTellerHoursSaturday?: InputMaybe<OrderBy>;
  VideoTellerHoursSunday?: InputMaybe<OrderBy>;
  VideoTellerHoursThursday?: InputMaybe<OrderBy>;
  VideoTellerHoursTuesday?: InputMaybe<OrderBy>;
  VideoTellerHoursWednesday?: InputMaybe<OrderBy>;
  Zip?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type LocationPageOutput = {
  __typename?: 'LocationPageOutput';
  autocomplete?: Maybe<LocationPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<LocationPageFacet>;
  item?: Maybe<LocationPage>;
  items?: Maybe<Array<Maybe<LocationPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type LocationPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationPageWhereInput = {
  ATMHoursFriday?: InputMaybe<SearchableStringFilterInput>;
  ATMHoursHeading?: InputMaybe<SearchableStringFilterInput>;
  ATMHoursMonday?: InputMaybe<SearchableStringFilterInput>;
  ATMHoursSaturday?: InputMaybe<SearchableStringFilterInput>;
  ATMHoursSunday?: InputMaybe<SearchableStringFilterInput>;
  ATMHoursThursday?: InputMaybe<SearchableStringFilterInput>;
  ATMHoursTuesday?: InputMaybe<SearchableStringFilterInput>;
  ATMHoursWednesday?: InputMaybe<SearchableStringFilterInput>;
  AboutThisBranchHeading?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AuthorMetaData?: InputMaybe<SearchableStringFilterInput>;
  CallUsLabel?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  City?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DisableIndexing?: InputMaybe<BoolFilterInput>;
  DriveThruHoursFriday?: InputMaybe<SearchableStringFilterInput>;
  DriveThruHoursHeading?: InputMaybe<SearchableStringFilterInput>;
  DriveThruHoursMonday?: InputMaybe<SearchableStringFilterInput>;
  DriveThruHoursSaturday?: InputMaybe<SearchableStringFilterInput>;
  DriveThruHoursSunday?: InputMaybe<SearchableStringFilterInput>;
  DriveThruHoursThursday?: InputMaybe<SearchableStringFilterInput>;
  DriveThruHoursTuesday?: InputMaybe<SearchableStringFilterInput>;
  DriveThruHoursWednesday?: InputMaybe<SearchableStringFilterInput>;
  DriveThruVideoTellerHoursFriday?: InputMaybe<SearchableStringFilterInput>;
  DriveThruVideoTellerHoursHeading?: InputMaybe<SearchableStringFilterInput>;
  DriveThruVideoTellerHoursMonday?: InputMaybe<SearchableStringFilterInput>;
  DriveThruVideoTellerHoursSaturday?: InputMaybe<SearchableStringFilterInput>;
  DriveThruVideoTellerHoursSunday?: InputMaybe<SearchableStringFilterInput>;
  DriveThruVideoTellerHoursThursday?: InputMaybe<SearchableStringFilterInput>;
  DriveThruVideoTellerHoursTuesday?: InputMaybe<SearchableStringFilterInput>;
  DriveThruVideoTellerHoursWednesday?: InputMaybe<SearchableStringFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExcludeFromSitemap?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FAQSchema?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  FeaturedProducts?: InputMaybe<SearchableStringFilterInput>;
  FeaturesAndServicesHeading?: InputMaybe<SearchableStringFilterInput>;
  FinancialSchema?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  FooterOverride?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  GetDirectionsLabel?: InputMaybe<SearchableStringFilterInput>;
  HeaderOverride?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Hero?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  HideInBreadcrumbs?: InputMaybe<BoolFilterInput>;
  HideSiteFooter?: InputMaybe<BoolFilterInput>;
  HideSiteHeader?: InputMaybe<BoolFilterInput>;
  Highlight?: InputMaybe<BoolFilterInput>;
  HoursHeading?: InputMaybe<SearchableStringFilterInput>;
  Industry?: InputMaybe<SearchableStringFilterInput>;
  IsBranch?: InputMaybe<BoolFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  ItemProductName?: InputMaybe<SearchableStringFilterInput>;
  Keywords?: InputMaybe<SearchableStringFilterInput>;
  LDJsonContainer?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  Latitude?: InputMaybe<SearchableStringFilterInput>;
  LobbyHoursFriday?: InputMaybe<SearchableStringFilterInput>;
  LobbyHoursHeading?: InputMaybe<SearchableStringFilterInput>;
  LobbyHoursMonday?: InputMaybe<SearchableStringFilterInput>;
  LobbyHoursSaturday?: InputMaybe<SearchableStringFilterInput>;
  LobbyHoursSunday?: InputMaybe<SearchableStringFilterInput>;
  LobbyHoursThursday?: InputMaybe<SearchableStringFilterInput>;
  LobbyHoursTuesday?: InputMaybe<SearchableStringFilterInput>;
  LobbyHoursWednesday?: InputMaybe<SearchableStringFilterInput>;
  LocationDescription?: InputMaybe<SearchableStringFilterInput>;
  LocationImage?: InputMaybe<ContentModelReferenceWhereInput>;
  LocationImageUrl?: InputMaybe<ContentModelReferenceWhereInput>;
  LocationLogoUrl?: InputMaybe<ContentModelReferenceWhereInput>;
  LocationMapUrl?: InputMaybe<SearchableStringFilterInput>;
  LocationName?: InputMaybe<SearchableStringFilterInput>;
  LocationSchema?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  LocationSectionId?: InputMaybe<SearchableStringFilterInput>;
  LocationSiderCTA?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Longitude?: InputMaybe<SearchableStringFilterInput>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaContentType?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NavigationTitle?: InputMaybe<SearchableStringFilterInput>;
  OfferServiceName?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphDescription?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphImage?: InputMaybe<ContentModelReferenceWhereInput>;
  OpenGraphImageHeight?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphImageType?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphImageWidth?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphSite?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphTitle?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphUrl?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphtype?: InputMaybe<SearchableStringFilterInput>;
  OrganizationSchema?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  PageDescription?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PersonSchema?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Phone?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SItemProductName?: InputMaybe<SearchableStringFilterInput>;
  SOfferServiceName?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  ServicesAvailable?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  ShowSchema?: InputMaybe<BoolFilterInput>;
  SignUpToNewsletterForm?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SimpleMasthead?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  State?: InputMaybe<SearchableStringFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Street?: InputMaybe<SearchableStringFilterInput>;
  Street2?: InputMaybe<SearchableStringFilterInput>;
  TItemProductName?: InputMaybe<SearchableStringFilterInput>;
  TOfferServiceName?: InputMaybe<SearchableStringFilterInput>;
  TeaserText?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VideoTellerHoursFriday?: InputMaybe<SearchableStringFilterInput>;
  VideoTellerHoursHeading?: InputMaybe<SearchableStringFilterInput>;
  VideoTellerHoursMonday?: InputMaybe<SearchableStringFilterInput>;
  VideoTellerHoursSaturday?: InputMaybe<SearchableStringFilterInput>;
  VideoTellerHoursSunday?: InputMaybe<SearchableStringFilterInput>;
  VideoTellerHoursThursday?: InputMaybe<SearchableStringFilterInput>;
  VideoTellerHoursTuesday?: InputMaybe<SearchableStringFilterInput>;
  VideoTellerHoursWednesday?: InputMaybe<SearchableStringFilterInput>;
  Zip?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<LocationPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<LocationPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<LocationPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Listing the Locations on the site */
export type LocationsListingBlock = IContent &
  IData & {
    __typename?: 'LocationsListingBlock';
    ATMCheckboxLabel?: Maybe<Scalars['String']['output']>;
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    BackToTopButtonLabel?: Maybe<Scalars['String']['output']>;
    BranchCheckboxLabel?: Maybe<Scalars['String']['output']>;
    CallUsButtonLabel?: Maybe<Scalars['String']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    CloseButtonAriaLabel?: Maybe<Scalars['String']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    CoopCheckboxLabel?: Maybe<Scalars['String']['output']>;
    Created?: Maybe<Scalars['Date']['output']>;
    DefaultLocation?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    FilterApplyLabel?: Maybe<Scalars['String']['output']>;
    FilterPlaceholder?: Maybe<Scalars['String']['output']>;
    FilterResetLabel?: Maybe<Scalars['String']['output']>;
    GetDirectionsButtonLabel?: Maybe<Scalars['String']['output']>;
    GetDirectionsModalMessage?: Maybe<Scalars['String']['output']>;
    GetDirectionsModalProceedButtonLabel?: Maybe<Scalars['String']['output']>;
    GetDirectionsModalTitle?: Maybe<Scalars['String']['output']>;
    IframeTitle?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    LearnMoreButtonLabel?: Maybe<Scalars['String']['output']>;
    ListViewButtonLabel?: Maybe<Scalars['String']['output']>;
    LocateButtonLabel?: Maybe<Scalars['String']['output']>;
    MapViewButtonLabel?: Maybe<Scalars['String']['output']>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    MilesAwayLabel?: Maybe<Scalars['String']['output']>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    SearchButtonLabel?: Maybe<Scalars['String']['output']>;
    SearchInputLabel?: Maybe<Scalars['String']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Listing the Locations on the site */
export type LocationsListingBlockAtmCheckboxLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Locations on the site */
export type LocationsListingBlockBackToTopButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Locations on the site */
export type LocationsListingBlockBranchCheckboxLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Locations on the site */
export type LocationsListingBlockCallUsButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Locations on the site */
export type LocationsListingBlockCloseButtonAriaLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Locations on the site */
export type LocationsListingBlockCoopCheckboxLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Locations on the site */
export type LocationsListingBlockDefaultLocationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Locations on the site */
export type LocationsListingBlockFilterApplyLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Locations on the site */
export type LocationsListingBlockFilterPlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Locations on the site */
export type LocationsListingBlockFilterResetLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Locations on the site */
export type LocationsListingBlockGetDirectionsButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Locations on the site */
export type LocationsListingBlockGetDirectionsModalMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Locations on the site */
export type LocationsListingBlockGetDirectionsModalProceedButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Locations on the site */
export type LocationsListingBlockGetDirectionsModalTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Locations on the site */
export type LocationsListingBlockIframeTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Locations on the site */
export type LocationsListingBlockLearnMoreButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Locations on the site */
export type LocationsListingBlockListViewButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Locations on the site */
export type LocationsListingBlockLocateButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Locations on the site */
export type LocationsListingBlockMapViewButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Locations on the site */
export type LocationsListingBlockMilesAwayLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Locations on the site */
export type LocationsListingBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Locations on the site */
export type LocationsListingBlockSearchButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Locations on the site */
export type LocationsListingBlockSearchInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Locations on the site */
export type LocationsListingBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the Locations on the site */
export type LocationsListingBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type LocationsListingBlockAutocomplete = {
  __typename?: 'LocationsListingBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type LocationsListingBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LocationsListingBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LocationsListingBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LocationsListingBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LocationsListingBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LocationsListingBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LocationsListingBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LocationsListingBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LocationsListingBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LocationsListingBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LocationsListingBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LocationsListingBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LocationsListingBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LocationsListingBlockFacet = {
  __typename?: 'LocationsListingBlockFacet';
  ATMCheckboxLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BackToTopButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BranchCheckboxLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CallUsButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CloseButtonAriaLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  CoopCheckboxLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DefaultLocation?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FilterApplyLabel?: Maybe<Array<Maybe<StringFacet>>>;
  FilterPlaceholder?: Maybe<Array<Maybe<StringFacet>>>;
  FilterResetLabel?: Maybe<Array<Maybe<StringFacet>>>;
  GetDirectionsButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  GetDirectionsModalMessage?: Maybe<Array<Maybe<StringFacet>>>;
  GetDirectionsModalProceedButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  GetDirectionsModalTitle?: Maybe<Array<Maybe<StringFacet>>>;
  IframeTitle?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LearnMoreButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ListViewButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LocateButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MapViewButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MilesAwayLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SearchInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type LocationsListingBlockFacetAtmCheckboxLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetBackToTopButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetBranchCheckboxLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetCallUsButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationsListingBlockFacetCloseButtonAriaLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetCoopCheckboxLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationsListingBlockFacetDefaultLocationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetFilterApplyLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetFilterPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetFilterResetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetGetDirectionsButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetGetDirectionsModalMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetGetDirectionsModalProceedButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetGetDirectionsModalTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetIframeTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetLearnMoreButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetListViewButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetLocateButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetMapViewButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetMilesAwayLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationsListingBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationsListingBlockFacetSearchButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetSearchInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationsListingBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationsListingBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationsListingBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type LocationsListingBlockOrderByInput = {
  ATMCheckboxLabel?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  BackToTopButtonLabel?: InputMaybe<OrderBy>;
  BranchCheckboxLabel?: InputMaybe<OrderBy>;
  CallUsButtonLabel?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CloseButtonAriaLabel?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  CoopCheckboxLabel?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DefaultLocation?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FilterApplyLabel?: InputMaybe<OrderBy>;
  FilterPlaceholder?: InputMaybe<OrderBy>;
  FilterResetLabel?: InputMaybe<OrderBy>;
  GetDirectionsButtonLabel?: InputMaybe<OrderBy>;
  GetDirectionsModalMessage?: InputMaybe<OrderBy>;
  GetDirectionsModalProceedButtonLabel?: InputMaybe<OrderBy>;
  GetDirectionsModalTitle?: InputMaybe<OrderBy>;
  IframeTitle?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LearnMoreButtonLabel?: InputMaybe<OrderBy>;
  ListViewButtonLabel?: InputMaybe<OrderBy>;
  LocateButtonLabel?: InputMaybe<OrderBy>;
  MapViewButtonLabel?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MilesAwayLabel?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchButtonLabel?: InputMaybe<OrderBy>;
  SearchInputLabel?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type LocationsListingBlockOutput = {
  __typename?: 'LocationsListingBlockOutput';
  autocomplete?: Maybe<LocationsListingBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<LocationsListingBlockFacet>;
  item?: Maybe<LocationsListingBlock>;
  items?: Maybe<Array<Maybe<LocationsListingBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type LocationsListingBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationsListingBlockWhereInput = {
  ATMCheckboxLabel?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  BackToTopButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  BranchCheckboxLabel?: InputMaybe<SearchableStringFilterInput>;
  CallUsButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CloseButtonAriaLabel?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  CoopCheckboxLabel?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DefaultLocation?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FilterApplyLabel?: InputMaybe<SearchableStringFilterInput>;
  FilterPlaceholder?: InputMaybe<SearchableStringFilterInput>;
  FilterResetLabel?: InputMaybe<SearchableStringFilterInput>;
  GetDirectionsButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  GetDirectionsModalMessage?: InputMaybe<SearchableStringFilterInput>;
  GetDirectionsModalProceedButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  GetDirectionsModalTitle?: InputMaybe<SearchableStringFilterInput>;
  IframeTitle?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LearnMoreButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ListViewButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  LocateButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  MapViewButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MilesAwayLabel?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  SearchInputLabel?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<LocationsListingBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<LocationsListingBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<LocationsListingBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Used to create a login modal. */
export type LoginModalBlock = IContent &
  IData & {
    __typename?: 'LoginModalBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    AppStoreImage?: Maybe<ContentModelReference>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    /** Please use ','(Comma) Symbol to separate the URLs */
    PageURLs?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    Password?: Maybe<Scalars['String']['output']>;
    PlayStoreImage?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Title?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    Username?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Used to create a login modal. */
export type LoginModalBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used to create a login modal. */
export type LoginModalBlockPageUrLsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used to create a login modal. */
export type LoginModalBlockPasswordArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used to create a login modal. */
export type LoginModalBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used to create a login modal. */
export type LoginModalBlockUsernameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used to create a login modal. */
export type LoginModalBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used to create a login modal. */
export type LoginModalBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type LoginModalBlockAutocomplete = {
  __typename?: 'LoginModalBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AppStoreImage?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PlayStoreImage?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type LoginModalBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LoginModalBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LoginModalBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LoginModalBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LoginModalBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LoginModalBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LoginModalBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LoginModalBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LoginModalBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LoginModalBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LoginModalBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LoginModalBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LoginModalBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LoginModalBlockFacet = {
  __typename?: 'LoginModalBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AppStoreImage?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PageURLs?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  Password?: Maybe<Array<Maybe<StringFacet>>>;
  PlayStoreImage?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Username?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type LoginModalBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LoginModalBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type LoginModalBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LoginModalBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type LoginModalBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LoginModalBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LoginModalBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LoginModalBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LoginModalBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LoginModalBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type LoginModalBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LoginModalBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LoginModalBlockFacetPageUrLsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LoginModalBlockFacetPasswordArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LoginModalBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LoginModalBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LoginModalBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type LoginModalBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LoginModalBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LoginModalBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LoginModalBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type LoginModalBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LoginModalBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type LoginModalBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LoginModalBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LoginModalBlockFacetUsernameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LoginModalBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LoginModalBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type LoginModalBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AppStoreImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  PageURLs?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Password?: InputMaybe<OrderBy>;
  PlayStoreImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Username?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type LoginModalBlockOutput = {
  __typename?: 'LoginModalBlockOutput';
  autocomplete?: Maybe<LoginModalBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<LoginModalBlockFacet>;
  item?: Maybe<LoginModalBlock>;
  items?: Maybe<Array<Maybe<LoginModalBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type LoginModalBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LoginModalBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AppStoreImage?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  PageURLs?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Password?: InputMaybe<SearchableStringFilterInput>;
  PlayStoreImage?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Username?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<LoginModalBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<LoginModalBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<LoginModalBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Allow content authors to add logos */
export type LogoImageBlock = IContent &
  IData & {
    __typename?: 'LogoImageBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    LogoImage?: Maybe<ContentModelReference>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Allow content authors to add logos */
export type LogoImageBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add logos */
export type LogoImageBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add logos */
export type LogoImageBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type LogoImageBlockAutocomplete = {
  __typename?: 'LogoImageBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  LogoImage?: Maybe<ContentModelReferenceAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type LogoImageBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LogoImageBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LogoImageBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LogoImageBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LogoImageBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LogoImageBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LogoImageBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LogoImageBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LogoImageBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LogoImageBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LogoImageBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LogoImageBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LogoImageBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LogoImageBlockFacet = {
  __typename?: 'LogoImageBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LogoImage?: Maybe<ContentModelReferenceFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type LogoImageBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LogoImageBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type LogoImageBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LogoImageBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type LogoImageBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LogoImageBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LogoImageBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LogoImageBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LogoImageBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LogoImageBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type LogoImageBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LogoImageBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LogoImageBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LogoImageBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LogoImageBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type LogoImageBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LogoImageBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LogoImageBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LogoImageBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type LogoImageBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LogoImageBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type LogoImageBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LogoImageBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LogoImageBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type LogoImageBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LogoImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type LogoImageBlockOutput = {
  __typename?: 'LogoImageBlockOutput';
  autocomplete?: Maybe<LogoImageBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<LogoImageBlockFacet>;
  item?: Maybe<LogoImageBlock>;
  items?: Maybe<Array<Maybe<LogoImageBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type LogoImageBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LogoImageBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LogoImage?: InputMaybe<ContentModelReferenceWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<LogoImageBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<LogoImageBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<LogoImageBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Used to create a menu item */
export type MenuItemBlock = IContent &
  IData & {
    __typename?: 'MenuItemBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    ButtonText?: Maybe<Scalars['String']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    MenuImage?: Maybe<ContentModelReference>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    TeaserText?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Used to create a menu item */
export type MenuItemBlockButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used to create a menu item */
export type MenuItemBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used to create a menu item */
export type MenuItemBlockTeaserTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used to create a menu item */
export type MenuItemBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used to create a menu item */
export type MenuItemBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MenuItemBlockAutocomplete = {
  __typename?: 'MenuItemBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MenuImage?: Maybe<ContentModelReferenceAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type MenuItemBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MenuItemBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MenuItemBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MenuItemBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MenuItemBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MenuItemBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MenuItemBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MenuItemBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MenuItemBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MenuItemBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MenuItemBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MenuItemBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MenuItemBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MenuItemBlockFacet = {
  __typename?: 'MenuItemBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  ButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MenuImage?: Maybe<ContentModelReferenceFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TeaserText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type MenuItemBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MenuItemBlockFacetButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MenuItemBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuItemBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MenuItemBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuItemBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MenuItemBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MenuItemBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MenuItemBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MenuItemBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MenuItemBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuItemBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MenuItemBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MenuItemBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MenuItemBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MenuItemBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuItemBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MenuItemBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MenuItemBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MenuItemBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuItemBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MenuItemBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuItemBlockFacetTeaserTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MenuItemBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MenuItemBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MenuItemBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type MenuItemBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  ButtonText?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MenuImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TeaserText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type MenuItemBlockOutput = {
  __typename?: 'MenuItemBlockOutput';
  autocomplete?: Maybe<MenuItemBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MenuItemBlockFacet>;
  item?: Maybe<MenuItemBlock>;
  items?: Maybe<Array<Maybe<MenuItemBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type MenuItemBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MenuItemBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  ButtonText?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MenuImage?: InputMaybe<ContentModelReferenceWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TeaserText?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MenuItemBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MenuItemBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MenuItemBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Mortgage payment calculator. */
export type MortgagePaymentCalculatorBlock = IContent &
  IData & {
    __typename?: 'MortgagePaymentCalculatorBlock';
    Amortization?: Maybe<Scalars['Int']['output']>;
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    EstimatePropertyTax?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Term?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Mortgage payment calculator. */
export type MortgagePaymentCalculatorBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Mortgage payment calculator. */
export type MortgagePaymentCalculatorBlockEstimatePropertyTaxArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Mortgage payment calculator. */
export type MortgagePaymentCalculatorBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Mortgage payment calculator. */
export type MortgagePaymentCalculatorBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Mortgage payment calculator. */
export type MortgagePaymentCalculatorBlockTermArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Mortgage payment calculator. */
export type MortgagePaymentCalculatorBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Mortgage payment calculator. */
export type MortgagePaymentCalculatorBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MortgagePaymentCalculatorBlockAutocomplete = {
  __typename?: 'MortgagePaymentCalculatorBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type MortgagePaymentCalculatorBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgagePaymentCalculatorBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgagePaymentCalculatorBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgagePaymentCalculatorBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgagePaymentCalculatorBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgagePaymentCalculatorBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgagePaymentCalculatorBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgagePaymentCalculatorBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgagePaymentCalculatorBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgagePaymentCalculatorBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgagePaymentCalculatorBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgagePaymentCalculatorBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgagePaymentCalculatorBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgagePaymentCalculatorBlockFacet = {
  __typename?: 'MortgagePaymentCalculatorBlockFacet';
  Amortization?: Maybe<Array<Maybe<NumberFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  EstimatePropertyTax?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Term?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type MortgagePaymentCalculatorBlockFacetAmortizationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type MortgagePaymentCalculatorBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgagePaymentCalculatorBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type MortgagePaymentCalculatorBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgagePaymentCalculatorBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type MortgagePaymentCalculatorBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgagePaymentCalculatorBlockFacetEstimatePropertyTaxArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgagePaymentCalculatorBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgagePaymentCalculatorBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgagePaymentCalculatorBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgagePaymentCalculatorBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgagePaymentCalculatorBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgagePaymentCalculatorBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgagePaymentCalculatorBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type MortgagePaymentCalculatorBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgagePaymentCalculatorBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgagePaymentCalculatorBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgagePaymentCalculatorBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgagePaymentCalculatorBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type MortgagePaymentCalculatorBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgagePaymentCalculatorBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgagePaymentCalculatorBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgagePaymentCalculatorBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type MortgagePaymentCalculatorBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgagePaymentCalculatorBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type MortgagePaymentCalculatorBlockFacetTermArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgagePaymentCalculatorBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgagePaymentCalculatorBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgagePaymentCalculatorBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type MortgagePaymentCalculatorBlockOrderByInput = {
  Amortization?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  EstimatePropertyTax?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Term?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type MortgagePaymentCalculatorBlockOutput = {
  __typename?: 'MortgagePaymentCalculatorBlockOutput';
  autocomplete?: Maybe<MortgagePaymentCalculatorBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MortgagePaymentCalculatorBlockFacet>;
  item?: Maybe<MortgagePaymentCalculatorBlock>;
  items?: Maybe<Array<Maybe<MortgagePaymentCalculatorBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type MortgagePaymentCalculatorBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MortgagePaymentCalculatorBlockWhereInput = {
  Amortization?: InputMaybe<IntFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  EstimatePropertyTax?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Term?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MortgagePaymentCalculatorBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MortgagePaymentCalculatorBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MortgagePaymentCalculatorBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Mortgage Rates Quick Quote Block calculator. */
export type MortgageRatesQuickQuoteBlock = IContent &
  IData & {
    __typename?: 'MortgageRatesQuickQuoteBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Mortgage Rates Quick Quote Block calculator. */
export type MortgageRatesQuickQuoteBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Mortgage Rates Quick Quote Block calculator. */
export type MortgageRatesQuickQuoteBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Mortgage Rates Quick Quote Block calculator. */
export type MortgageRatesQuickQuoteBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Mortgage Rates Quick Quote Block calculator. */
export type MortgageRatesQuickQuoteBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Mortgage Rates Quick Quote Block calculator. */
export type MortgageRatesQuickQuoteBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MortgageRatesQuickQuoteBlockAutocomplete = {
  __typename?: 'MortgageRatesQuickQuoteBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type MortgageRatesQuickQuoteBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgageRatesQuickQuoteBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgageRatesQuickQuoteBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgageRatesQuickQuoteBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgageRatesQuickQuoteBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgageRatesQuickQuoteBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgageRatesQuickQuoteBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgageRatesQuickQuoteBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgageRatesQuickQuoteBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgageRatesQuickQuoteBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgageRatesQuickQuoteBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgageRatesQuickQuoteBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgageRatesQuickQuoteBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgageRatesQuickQuoteBlockFacet = {
  __typename?: 'MortgageRatesQuickQuoteBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type MortgageRatesQuickQuoteBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRatesQuickQuoteBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type MortgageRatesQuickQuoteBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRatesQuickQuoteBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type MortgageRatesQuickQuoteBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRatesQuickQuoteBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRatesQuickQuoteBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRatesQuickQuoteBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRatesQuickQuoteBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRatesQuickQuoteBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRatesQuickQuoteBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRatesQuickQuoteBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type MortgageRatesQuickQuoteBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRatesQuickQuoteBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRatesQuickQuoteBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRatesQuickQuoteBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRatesQuickQuoteBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type MortgageRatesQuickQuoteBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRatesQuickQuoteBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRatesQuickQuoteBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRatesQuickQuoteBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type MortgageRatesQuickQuoteBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRatesQuickQuoteBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type MortgageRatesQuickQuoteBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRatesQuickQuoteBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRatesQuickQuoteBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type MortgageRatesQuickQuoteBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type MortgageRatesQuickQuoteBlockOutput = {
  __typename?: 'MortgageRatesQuickQuoteBlockOutput';
  autocomplete?: Maybe<MortgageRatesQuickQuoteBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MortgageRatesQuickQuoteBlockFacet>;
  item?: Maybe<MortgageRatesQuickQuoteBlock>;
  items?: Maybe<Array<Maybe<MortgageRatesQuickQuoteBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type MortgageRatesQuickQuoteBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MortgageRatesQuickQuoteBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MortgageRatesQuickQuoteBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MortgageRatesQuickQuoteBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MortgageRatesQuickQuoteBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Mortgage Refinance Calculator. */
export type MortgageRefinanceCalculatorBlock = IContent &
  IData & {
    __typename?: 'MortgageRefinanceCalculatorBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Mortgage Refinance Calculator. */
export type MortgageRefinanceCalculatorBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Mortgage Refinance Calculator. */
export type MortgageRefinanceCalculatorBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Mortgage Refinance Calculator. */
export type MortgageRefinanceCalculatorBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Mortgage Refinance Calculator. */
export type MortgageRefinanceCalculatorBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Mortgage Refinance Calculator. */
export type MortgageRefinanceCalculatorBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MortgageRefinanceCalculatorBlockAutocomplete = {
  __typename?: 'MortgageRefinanceCalculatorBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type MortgageRefinanceCalculatorBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgageRefinanceCalculatorBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgageRefinanceCalculatorBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgageRefinanceCalculatorBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgageRefinanceCalculatorBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgageRefinanceCalculatorBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgageRefinanceCalculatorBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgageRefinanceCalculatorBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgageRefinanceCalculatorBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgageRefinanceCalculatorBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgageRefinanceCalculatorBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgageRefinanceCalculatorBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgageRefinanceCalculatorBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MortgageRefinanceCalculatorBlockFacet = {
  __typename?: 'MortgageRefinanceCalculatorBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type MortgageRefinanceCalculatorBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRefinanceCalculatorBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type MortgageRefinanceCalculatorBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRefinanceCalculatorBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type MortgageRefinanceCalculatorBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRefinanceCalculatorBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRefinanceCalculatorBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRefinanceCalculatorBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRefinanceCalculatorBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRefinanceCalculatorBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRefinanceCalculatorBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRefinanceCalculatorBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type MortgageRefinanceCalculatorBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRefinanceCalculatorBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRefinanceCalculatorBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRefinanceCalculatorBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRefinanceCalculatorBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type MortgageRefinanceCalculatorBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRefinanceCalculatorBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRefinanceCalculatorBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRefinanceCalculatorBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type MortgageRefinanceCalculatorBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRefinanceCalculatorBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type MortgageRefinanceCalculatorBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRefinanceCalculatorBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MortgageRefinanceCalculatorBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type MortgageRefinanceCalculatorBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type MortgageRefinanceCalculatorBlockOutput = {
  __typename?: 'MortgageRefinanceCalculatorBlockOutput';
  autocomplete?: Maybe<MortgageRefinanceCalculatorBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MortgageRefinanceCalculatorBlockFacet>;
  item?: Maybe<MortgageRefinanceCalculatorBlock>;
  items?: Maybe<Array<Maybe<MortgageRefinanceCalculatorBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type MortgageRefinanceCalculatorBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MortgageRefinanceCalculatorBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MortgageRefinanceCalculatorBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MortgageRefinanceCalculatorBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MortgageRefinanceCalculatorBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Allow content authors to add multiple logo image blocks */
export type MultiLogoImageBlock = IContent &
  IData & {
    __typename?: 'MultiLogoImageBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    HasTopMargin?: Maybe<Scalars['Bool']['output']>;
    Headline?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    LogoImages?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RemoveBottomAngle?: Maybe<Scalars['Bool']['output']>;
    RemoveTopAngle?: Maybe<Scalars['Bool']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Allow content authors to add multiple logo image blocks */
export type MultiLogoImageBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add multiple logo image blocks */
export type MultiLogoImageBlockLogoImagesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add multiple logo image blocks */
export type MultiLogoImageBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add multiple logo image blocks */
export type MultiLogoImageBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add multiple logo image blocks */
export type MultiLogoImageBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MultiLogoImageBlockAutocomplete = {
  __typename?: 'MultiLogoImageBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type MultiLogoImageBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MultiLogoImageBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MultiLogoImageBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MultiLogoImageBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MultiLogoImageBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MultiLogoImageBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MultiLogoImageBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MultiLogoImageBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MultiLogoImageBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MultiLogoImageBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MultiLogoImageBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MultiLogoImageBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MultiLogoImageBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MultiLogoImageBlockFacet = {
  __typename?: 'MultiLogoImageBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  HasTopMargin?: Maybe<Array<Maybe<StringFacet>>>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LogoImages?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RemoveBottomAngle?: Maybe<Array<Maybe<StringFacet>>>;
  RemoveTopAngle?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type MultiLogoImageBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MultiLogoImageBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type MultiLogoImageBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MultiLogoImageBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type MultiLogoImageBlockFacetHasTopMarginArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MultiLogoImageBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MultiLogoImageBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MultiLogoImageBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MultiLogoImageBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MultiLogoImageBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MultiLogoImageBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MultiLogoImageBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type MultiLogoImageBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MultiLogoImageBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MultiLogoImageBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MultiLogoImageBlockFacetRemoveBottomAngleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MultiLogoImageBlockFacetRemoveTopAngleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MultiLogoImageBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MultiLogoImageBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type MultiLogoImageBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MultiLogoImageBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MultiLogoImageBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MultiLogoImageBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type MultiLogoImageBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MultiLogoImageBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type MultiLogoImageBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MultiLogoImageBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MultiLogoImageBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type MultiLogoImageBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  HasTopMargin?: InputMaybe<OrderBy>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LogoImages?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RemoveBottomAngle?: InputMaybe<OrderBy>;
  RemoveTopAngle?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type MultiLogoImageBlockOutput = {
  __typename?: 'MultiLogoImageBlockOutput';
  autocomplete?: Maybe<MultiLogoImageBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MultiLogoImageBlockFacet>;
  item?: Maybe<MultiLogoImageBlock>;
  items?: Maybe<Array<Maybe<MultiLogoImageBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type MultiLogoImageBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MultiLogoImageBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  HasTopMargin?: InputMaybe<BoolFilterInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LogoImages?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RemoveBottomAngle?: InputMaybe<BoolFilterInput>;
  RemoveTopAngle?: InputMaybe<BoolFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MultiLogoImageBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MultiLogoImageBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MultiLogoImageBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Consists of the submenu items that appear beneath each Level 1 or 2 navigation item. */
export type NavigationColumnBlock = IContent &
  IData & {
    __typename?: 'NavigationColumnBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    /** Using to add navigation items at level 3 */
    ColumnName?: Maybe<Scalars['String']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    /** Add navigation items at level 3 */
    NavigationItems?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Consists of the submenu items that appear beneath each Level 1 or 2 navigation item. */
export type NavigationColumnBlockColumnNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Consists of the submenu items that appear beneath each Level 1 or 2 navigation item. */
export type NavigationColumnBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Consists of the submenu items that appear beneath each Level 1 or 2 navigation item. */
export type NavigationColumnBlockNavigationItemsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Consists of the submenu items that appear beneath each Level 1 or 2 navigation item. */
export type NavigationColumnBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Consists of the submenu items that appear beneath each Level 1 or 2 navigation item. */
export type NavigationColumnBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type NavigationColumnBlockAutocomplete = {
  __typename?: 'NavigationColumnBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type NavigationColumnBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationColumnBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationColumnBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationColumnBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationColumnBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationColumnBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationColumnBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationColumnBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationColumnBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationColumnBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationColumnBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationColumnBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationColumnBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationColumnBlockFacet = {
  __typename?: 'NavigationColumnBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ColumnName?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NavigationItems?: Maybe<ContentAreaItemModelSearchFacet>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type NavigationColumnBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationColumnBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationColumnBlockFacetColumnNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationColumnBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationColumnBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationColumnBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationColumnBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationColumnBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationColumnBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationColumnBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationColumnBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationColumnBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationColumnBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationColumnBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationColumnBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationColumnBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationColumnBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationColumnBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationColumnBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationColumnBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationColumnBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationColumnBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationColumnBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationColumnBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationColumnBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type NavigationColumnBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ColumnName?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NavigationItems?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type NavigationColumnBlockOutput = {
  __typename?: 'NavigationColumnBlockOutput';
  autocomplete?: Maybe<NavigationColumnBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<NavigationColumnBlockFacet>;
  item?: Maybe<NavigationColumnBlock>;
  items?: Maybe<Array<Maybe<NavigationColumnBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type NavigationColumnBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NavigationColumnBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ColumnName?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NavigationItems?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<NavigationColumnBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<NavigationColumnBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<NavigationColumnBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Consists of the submenu items that appear beneath each Level 1 or 2 navigation item. */
export type NavigationItemLevel1Block = IContent &
  IData & {
    __typename?: 'NavigationItemLevel1Block';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    /** Only available at level 1 */
    IsSelected?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    /** Only available at level 1 and 2 */
    NavigationItems?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    NavigationTitle?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Consists of the submenu items that appear beneath each Level 1 or 2 navigation item. */
export type NavigationItemLevel1BlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Consists of the submenu items that appear beneath each Level 1 or 2 navigation item. */
export type NavigationItemLevel1BlockNavigationItemsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Consists of the submenu items that appear beneath each Level 1 or 2 navigation item. */
export type NavigationItemLevel1BlockNavigationTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Consists of the submenu items that appear beneath each Level 1 or 2 navigation item. */
export type NavigationItemLevel1Block_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Consists of the submenu items that appear beneath each Level 1 or 2 navigation item. */
export type NavigationItemLevel1Block_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type NavigationItemLevel1BlockAutocomplete = {
  __typename?: 'NavigationItemLevel1BlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type NavigationItemLevel1BlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel1BlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel1BlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel1BlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel1BlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel1BlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel1BlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel1BlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel1BlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel1BlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel1BlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel1BlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel1BlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel1BlockFacet = {
  __typename?: 'NavigationItemLevel1BlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  IsSelected?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NavigationItems?: Maybe<ContentAreaItemModelSearchFacet>;
  NavigationTitle?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type NavigationItemLevel1BlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel1BlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationItemLevel1BlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel1BlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationItemLevel1BlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel1BlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel1BlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel1BlockFacetIsSelectedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel1BlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel1BlockFacetNavigationTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel1BlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel1BlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationItemLevel1BlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel1BlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel1BlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel1BlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel1BlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationItemLevel1BlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel1BlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel1BlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel1BlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationItemLevel1BlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel1BlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationItemLevel1BlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel1BlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel1BlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type NavigationItemLevel1BlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  IsSelected?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NavigationItems?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  NavigationTitle?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type NavigationItemLevel1BlockOutput = {
  __typename?: 'NavigationItemLevel1BlockOutput';
  autocomplete?: Maybe<NavigationItemLevel1BlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<NavigationItemLevel1BlockFacet>;
  item?: Maybe<NavigationItemLevel1Block>;
  items?: Maybe<Array<Maybe<NavigationItemLevel1Block>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type NavigationItemLevel1BlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NavigationItemLevel1BlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  IsSelected?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NavigationItems?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  NavigationTitle?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<NavigationItemLevel1BlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<NavigationItemLevel1BlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<NavigationItemLevel1BlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Consists of the submenu items that appear beneath each Level 1 or 2 navigation item. */
export type NavigationItemLevel2Block = IContent &
  IData & {
    __typename?: 'NavigationItemLevel2Block';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /** It is used for the mobile navigation menu */
    BackLabel?: Maybe<Scalars['String']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    /** Only available at level 2 */
    FeaturedBannerImage?: Maybe<ContentModelReference>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    /** Only available at level 2 */
    NavigationColumns?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    NavigationTitle?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Consists of the submenu items that appear beneath each Level 1 or 2 navigation item. */
export type NavigationItemLevel2BlockBackLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Consists of the submenu items that appear beneath each Level 1 or 2 navigation item. */
export type NavigationItemLevel2BlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Consists of the submenu items that appear beneath each Level 1 or 2 navigation item. */
export type NavigationItemLevel2BlockNavigationColumnsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Consists of the submenu items that appear beneath each Level 1 or 2 navigation item. */
export type NavigationItemLevel2BlockNavigationTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Consists of the submenu items that appear beneath each Level 1 or 2 navigation item. */
export type NavigationItemLevel2Block_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Consists of the submenu items that appear beneath each Level 1 or 2 navigation item. */
export type NavigationItemLevel2Block_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type NavigationItemLevel2BlockAutocomplete = {
  __typename?: 'NavigationItemLevel2BlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  FeaturedBannerImage?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type NavigationItemLevel2BlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel2BlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel2BlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel2BlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel2BlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel2BlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel2BlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel2BlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel2BlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel2BlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel2BlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel2BlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel2BlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel2BlockFacet = {
  __typename?: 'NavigationItemLevel2BlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BackLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FeaturedBannerImage?: Maybe<ContentModelReferenceFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NavigationColumns?: Maybe<ContentAreaItemModelSearchFacet>;
  NavigationTitle?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type NavigationItemLevel2BlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel2BlockFacetBackLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel2BlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationItemLevel2BlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel2BlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationItemLevel2BlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel2BlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel2BlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel2BlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel2BlockFacetNavigationTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel2BlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel2BlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationItemLevel2BlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel2BlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel2BlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel2BlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel2BlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationItemLevel2BlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel2BlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel2BlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel2BlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationItemLevel2BlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel2BlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationItemLevel2BlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel2BlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel2BlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type NavigationItemLevel2BlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BackLabel?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FeaturedBannerImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NavigationColumns?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  NavigationTitle?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type NavigationItemLevel2BlockOutput = {
  __typename?: 'NavigationItemLevel2BlockOutput';
  autocomplete?: Maybe<NavigationItemLevel2BlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<NavigationItemLevel2BlockFacet>;
  item?: Maybe<NavigationItemLevel2Block>;
  items?: Maybe<Array<Maybe<NavigationItemLevel2Block>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type NavigationItemLevel2BlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NavigationItemLevel2BlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BackLabel?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FeaturedBannerImage?: InputMaybe<ContentModelReferenceWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NavigationColumns?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  NavigationTitle?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<NavigationItemLevel2BlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<NavigationItemLevel2BlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<NavigationItemLevel2BlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Consists of the submenu items that appear beneath each Level 1 or 2 navigation item. */
export type NavigationItemLevel3Block = IContent &
  IData & {
    __typename?: 'NavigationItemLevel3Block';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    NavigationTitle?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Consists of the submenu items that appear beneath each Level 1 or 2 navigation item. */
export type NavigationItemLevel3BlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Consists of the submenu items that appear beneath each Level 1 or 2 navigation item. */
export type NavigationItemLevel3BlockNavigationTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Consists of the submenu items that appear beneath each Level 1 or 2 navigation item. */
export type NavigationItemLevel3Block_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Consists of the submenu items that appear beneath each Level 1 or 2 navigation item. */
export type NavigationItemLevel3Block_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type NavigationItemLevel3BlockAutocomplete = {
  __typename?: 'NavigationItemLevel3BlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type NavigationItemLevel3BlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel3BlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel3BlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel3BlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel3BlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel3BlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel3BlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel3BlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel3BlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel3BlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel3BlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel3BlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel3BlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationItemLevel3BlockFacet = {
  __typename?: 'NavigationItemLevel3BlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NavigationTitle?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type NavigationItemLevel3BlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel3BlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationItemLevel3BlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel3BlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationItemLevel3BlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel3BlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel3BlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel3BlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel3BlockFacetNavigationTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel3BlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel3BlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationItemLevel3BlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel3BlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel3BlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel3BlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel3BlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationItemLevel3BlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel3BlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel3BlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel3BlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationItemLevel3BlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel3BlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationItemLevel3BlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel3BlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationItemLevel3BlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type NavigationItemLevel3BlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NavigationTitle?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type NavigationItemLevel3BlockOutput = {
  __typename?: 'NavigationItemLevel3BlockOutput';
  autocomplete?: Maybe<NavigationItemLevel3BlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<NavigationItemLevel3BlockFacet>;
  item?: Maybe<NavigationItemLevel3Block>;
  items?: Maybe<Array<Maybe<NavigationItemLevel3Block>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type NavigationItemLevel3BlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NavigationItemLevel3BlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NavigationTitle?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<NavigationItemLevel3BlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<NavigationItemLevel3BlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<NavigationItemLevel3BlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Allow content authors to edit  CACU site navigation menu. */
export type NavigationMenuBlock = IContent &
  IData & {
    __typename?: 'NavigationMenuBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Allow content authors to edit  CACU site navigation menu. */
export type NavigationMenuBlockContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to edit  CACU site navigation menu. */
export type NavigationMenuBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to edit  CACU site navigation menu. */
export type NavigationMenuBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to edit  CACU site navigation menu. */
export type NavigationMenuBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type NavigationMenuBlockAutocomplete = {
  __typename?: 'NavigationMenuBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type NavigationMenuBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationMenuBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationMenuBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationMenuBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationMenuBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationMenuBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationMenuBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationMenuBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationMenuBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationMenuBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationMenuBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationMenuBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationMenuBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NavigationMenuBlockFacet = {
  __typename?: 'NavigationMenuBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type NavigationMenuBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationMenuBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationMenuBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationMenuBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationMenuBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationMenuBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationMenuBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationMenuBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationMenuBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationMenuBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationMenuBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationMenuBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationMenuBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationMenuBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationMenuBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationMenuBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationMenuBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationMenuBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationMenuBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationMenuBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationMenuBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationMenuBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationMenuBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NavigationMenuBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type NavigationMenuBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type NavigationMenuBlockOutput = {
  __typename?: 'NavigationMenuBlockOutput';
  autocomplete?: Maybe<NavigationMenuBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<NavigationMenuBlockFacet>;
  item?: Maybe<NavigationMenuBlock>;
  items?: Maybe<Array<Maybe<NavigationMenuBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type NavigationMenuBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NavigationMenuBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<NavigationMenuBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<NavigationMenuBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<NavigationMenuBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Listing the news content on the site */
export type NewsListing = IContent &
  IData & {
    __typename?: 'NewsListing';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /** How many items we have to show in the each page  */
    Count?: Maybe<Scalars['Int']['output']>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Listing the news content on the site */
export type NewsListingNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the news content on the site */
export type NewsListing_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Listing the news content on the site */
export type NewsListing_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type NewsListingAutocomplete = {
  __typename?: 'NewsListingAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type NewsListingAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NewsListingAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NewsListingAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NewsListingAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NewsListingAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NewsListingAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NewsListingAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NewsListingAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NewsListingAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NewsListingAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NewsListingAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NewsListingAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NewsListingAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NewsListingFacet = {
  __typename?: 'NewsListingFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Count?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type NewsListingFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsListingFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NewsListingFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsListingFacetCountArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type NewsListingFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NewsListingFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsListingFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsListingFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsListingFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsListingFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsListingFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NewsListingFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsListingFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsListingFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsListingFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsListingFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NewsListingFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsListingFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsListingFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsListingFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NewsListingFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsListingFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NewsListingFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsListingFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsListingFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type NewsListingOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Count?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type NewsListingOutput = {
  __typename?: 'NewsListingOutput';
  autocomplete?: Maybe<NewsListingAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<NewsListingFacet>;
  item?: Maybe<NewsListing>;
  items?: Maybe<Array<Maybe<NewsListing>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type NewsListingOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NewsListingWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Count?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<NewsListingWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<NewsListingWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<NewsListingWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Page with CACU News which include text and images. */
export type NewsPage = IContent &
  IData & {
    __typename?: 'NewsPage';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    AuthorMetaData?: Maybe<Scalars['String']['output']>;
    Body?: Maybe<Scalars['String']['output']>;
    BreadcrumbsTitle?: Maybe<Scalars['String']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentBlock?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    DisableIndexing?: Maybe<Scalars['Bool']['output']>;
    /** This will determine whether or not to show on search. */
    ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
    /** This will determine whether or not to show on the Sitemap. */
    ExcludeFromSitemap?: Maybe<Scalars['Bool']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    FeaturedImage?: Maybe<ContentModelReference>;
    FooterOverride?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    HeaderOverride?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    HeadlineColor?: Maybe<Scalars['String']['output']>;
    Hero?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    /** This will determine whether or not to be dispalyed in breadcrumbs. */
    HideInBreadcrumbs?: Maybe<Scalars['Bool']['output']>;
    HideSiteFooter?: Maybe<Scalars['Bool']['output']>;
    HideSiteHeader?: Maybe<Scalars['Bool']['output']>;
    Highlight?: Maybe<Scalars['Bool']['output']>;
    Industry?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Keywords?: Maybe<Scalars['String']['output']>;
    /** Container for Schema Field */
    LDJsonContainer?: Maybe<Scalars['String']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MainContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    MetaContentType?: Maybe<Scalars['String']['output']>;
    MetaTitle?: Maybe<Scalars['String']['output']>;
    Name?: Maybe<Scalars['String']['output']>;
    NavigationTitle?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Description value that has been managed for the current page */
    OpenGraphDescription?: Maybe<Scalars['String']['output']>;
    /** Page template will always inherit the OpenGraph image from the parent page, recursively, until an image is managed for the current page */
    OpenGraphImage?: Maybe<ContentModelReference>;
    /** If managed, this field will overwrite the Image Height value that has been managed for the current page */
    OpenGraphImageHeight?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Image Type value that has been managed for the current page */
    OpenGraphImageType?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Image Width  value that has been managed for the current page */
    OpenGraphImageWidth?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Site value that has been managed for the current page */
    OpenGraphSite?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Title value that has been managed for the current page */
    OpenGraphTitle?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Url value that has been managed for the current page */
    OpenGraphUrl?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Type value that has been managed for the current page */
    OpenGraphtype?: Maybe<Scalars['String']['output']>;
    PageDescription?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    PostingDate?: Maybe<Scalars['Date']['output']>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RightRailComponents?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    /** Short Description is shown when the page appears in Search Results. */
    ShortDescription?: Maybe<Scalars['String']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SignUpToNewsletterForm?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SimpleMasthead?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    TeaserText?: Maybe<Scalars['String']['output']>;
    Topic?: Maybe<FilterCategoryModel>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Page with CACU News which include text and images. */
export type NewsPageAuthorMetaDataArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU News which include text and images. */
export type NewsPageBodyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU News which include text and images. */
export type NewsPageContentBlockArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU News which include text and images. */
export type NewsPageFooterOverrideArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU News which include text and images. */
export type NewsPageHeaderOverrideArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU News which include text and images. */
export type NewsPageHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU News which include text and images. */
export type NewsPageHeadlineColorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU News which include text and images. */
export type NewsPageHeroArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU News which include text and images. */
export type NewsPageIndustryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU News which include text and images. */
export type NewsPageKeywordsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU News which include text and images. */
export type NewsPageLdJsonContainerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU News which include text and images. */
export type NewsPageMainContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU News which include text and images. */
export type NewsPageMetaContentTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU News which include text and images. */
export type NewsPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU News which include text and images. */
export type NewsPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU News which include text and images. */
export type NewsPageNavigationTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU News which include text and images. */
export type NewsPageOpenGraphDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU News which include text and images. */
export type NewsPageOpenGraphImageHeightArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU News which include text and images. */
export type NewsPageOpenGraphImageTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU News which include text and images. */
export type NewsPageOpenGraphImageWidthArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU News which include text and images. */
export type NewsPageOpenGraphSiteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU News which include text and images. */
export type NewsPageOpenGraphTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU News which include text and images. */
export type NewsPageOpenGraphUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU News which include text and images. */
export type NewsPageOpenGraphtypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU News which include text and images. */
export type NewsPagePageDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU News which include text and images. */
export type NewsPageRightRailComponentsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU News which include text and images. */
export type NewsPageShortDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU News which include text and images. */
export type NewsPageSignUpToNewsletterFormArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU News which include text and images. */
export type NewsPageSimpleMastheadArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU News which include text and images. */
export type NewsPageTeaserTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU News which include text and images. */
export type NewsPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU News which include text and images. */
export type NewsPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type NewsPageAutocomplete = {
  __typename?: 'NewsPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  FeaturedImage?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  OpenGraphImage?: Maybe<ContentModelReferenceAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Topic?: Maybe<FilterCategoryModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type NewsPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NewsPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NewsPageAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NewsPageAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NewsPageAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NewsPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NewsPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NewsPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NewsPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NewsPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NewsPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NewsPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NewsPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NewsPageFacet = {
  __typename?: 'NewsPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AuthorMetaData?: Maybe<Array<Maybe<StringFacet>>>;
  Body?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentBlock?: Maybe<ContentAreaItemModelSearchFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSitemap?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FeaturedImage?: Maybe<ContentModelReferenceFacet>;
  FooterOverride?: Maybe<ContentAreaItemModelSearchFacet>;
  HeaderOverride?: Maybe<ContentAreaItemModelSearchFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  HeadlineColor?: Maybe<Array<Maybe<StringFacet>>>;
  Hero?: Maybe<ContentAreaItemModelSearchFacet>;
  HideInBreadcrumbs?: Maybe<Array<Maybe<StringFacet>>>;
  HideSiteFooter?: Maybe<Array<Maybe<StringFacet>>>;
  HideSiteHeader?: Maybe<Array<Maybe<StringFacet>>>;
  Highlight?: Maybe<Array<Maybe<StringFacet>>>;
  Industry?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Keywords?: Maybe<Array<Maybe<StringFacet>>>;
  LDJsonContainer?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaContentType?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NavigationTitle?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphDescription?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphImage?: Maybe<ContentModelReferenceFacet>;
  OpenGraphImageHeight?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphImageType?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphImageWidth?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphSite?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphTitle?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphUrl?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphtype?: Maybe<Array<Maybe<StringFacet>>>;
  PageDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RightRailComponents?: Maybe<ContentAreaItemModelSearchFacet>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  ShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SignUpToNewsletterForm?: Maybe<ContentAreaItemModelSearchFacet>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleMasthead?: Maybe<ContentAreaItemModelSearchFacet>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TeaserText?: Maybe<Array<Maybe<StringFacet>>>;
  Topic?: Maybe<FilterCategoryModelFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type NewsPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetAuthorMetaDataArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetBodyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NewsPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NewsPageFacetDisableIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetExcludeFromSitemapArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetHeadlineColorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetHideInBreadcrumbsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetHideSiteFooterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetHideSiteHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetHighlightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetIndustryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetKeywordsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetLdJsonContainerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetMetaContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetNavigationTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetOpenGraphDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetOpenGraphImageHeightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetOpenGraphImageTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetOpenGraphImageWidthArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetOpenGraphSiteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetOpenGraphTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetOpenGraphUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetOpenGraphtypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetPageDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NewsPageFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetPostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NewsPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NewsPageFacetShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NewsPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NewsPageFacetTeaserTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type NewsPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AuthorMetaData?: InputMaybe<OrderBy>;
  Body?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentBlock?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExcludeFromSitemap?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FeaturedImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  FooterOverride?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  HeaderOverride?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  HeadlineColor?: InputMaybe<OrderBy>;
  Hero?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  HideInBreadcrumbs?: InputMaybe<OrderBy>;
  HideSiteFooter?: InputMaybe<OrderBy>;
  HideSiteHeader?: InputMaybe<OrderBy>;
  Highlight?: InputMaybe<OrderBy>;
  Industry?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Keywords?: InputMaybe<OrderBy>;
  LDJsonContainer?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaContentType?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NavigationTitle?: InputMaybe<OrderBy>;
  OpenGraphDescription?: InputMaybe<OrderBy>;
  OpenGraphImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  OpenGraphImageHeight?: InputMaybe<OrderBy>;
  OpenGraphImageType?: InputMaybe<OrderBy>;
  OpenGraphImageWidth?: InputMaybe<OrderBy>;
  OpenGraphSite?: InputMaybe<OrderBy>;
  OpenGraphTitle?: InputMaybe<OrderBy>;
  OpenGraphUrl?: InputMaybe<OrderBy>;
  OpenGraphtype?: InputMaybe<OrderBy>;
  PageDescription?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PostingDate?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RightRailComponents?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  ShortDescription?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SignUpToNewsletterForm?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SimpleMasthead?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TeaserText?: InputMaybe<OrderBy>;
  Topic?: InputMaybe<FilterCategoryModelOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type NewsPageOutput = {
  __typename?: 'NewsPageOutput';
  autocomplete?: Maybe<NewsPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<NewsPageFacet>;
  item?: Maybe<NewsPage>;
  items?: Maybe<Array<Maybe<NewsPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type NewsPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NewsPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AuthorMetaData?: InputMaybe<SearchableStringFilterInput>;
  Body?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentBlock?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExcludeFromSitemap?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FeaturedImage?: InputMaybe<ContentModelReferenceWhereInput>;
  FooterOverride?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  HeaderOverride?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  HeadlineColor?: InputMaybe<SearchableStringFilterInput>;
  Hero?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  HideInBreadcrumbs?: InputMaybe<BoolFilterInput>;
  HideSiteFooter?: InputMaybe<BoolFilterInput>;
  HideSiteHeader?: InputMaybe<BoolFilterInput>;
  Highlight?: InputMaybe<BoolFilterInput>;
  Industry?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Keywords?: InputMaybe<SearchableStringFilterInput>;
  LDJsonContainer?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaContentType?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NavigationTitle?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphDescription?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphImage?: InputMaybe<ContentModelReferenceWhereInput>;
  OpenGraphImageHeight?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphImageType?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphImageWidth?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphSite?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphTitle?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphUrl?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphtype?: InputMaybe<SearchableStringFilterInput>;
  PageDescription?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PostingDate?: InputMaybe<DateFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RightRailComponents?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  ShortDescription?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SignUpToNewsletterForm?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SimpleMasthead?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TeaserText?: InputMaybe<SearchableStringFilterInput>;
  Topic?: InputMaybe<FilterCategoryModelWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<NewsPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<NewsPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<NewsPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type NumberElementBlock = IContent &
  IData & {
    __typename?: 'NumberElementBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    AutoComplete?: Maybe<Scalars['Int']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ConditionCombination?: Maybe<Scalars['Int']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Label?: Maybe<Scalars['String']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    PlaceHolder?: Maybe<Scalars['String']['output']>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    SatisfiedAction?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    Validators?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

export type NumberElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type NumberElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type NumberElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type NumberElementBlockPlaceHolderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type NumberElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type NumberElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type NumberElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type NumberElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type NumberElementBlockAutocomplete = {
  __typename?: 'NumberElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type NumberElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NumberElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NumberElementBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NumberElementBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NumberElementBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NumberElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NumberElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NumberElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NumberElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NumberElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NumberElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NumberElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NumberElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NumberElementBlockFacet = {
  __typename?: 'NumberElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AutoComplete?: Maybe<Array<Maybe<NumberFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PlaceHolder?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type NumberElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NumberElementBlockFacetAutoCompleteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type NumberElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NumberElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type NumberElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NumberElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NumberElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NumberElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NumberElementBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NumberElementBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NumberElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NumberElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NumberElementBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NumberElementBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NumberElementBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NumberElementBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NumberElementBlockFacetPlaceHolderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NumberElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NumberElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NumberElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NumberElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NumberElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NumberElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NumberElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NumberElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NumberElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NumberElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NumberElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NumberElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NumberElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NumberElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type NumberElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AutoComplete?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PlaceHolder?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type NumberElementBlockOutput = {
  __typename?: 'NumberElementBlockOutput';
  autocomplete?: Maybe<NumberElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<NumberElementBlockFacet>;
  item?: Maybe<NumberElementBlock>;
  items?: Maybe<Array<Maybe<NumberElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type NumberElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NumberElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AutoComplete?: InputMaybe<IntFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PlaceHolder?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<NumberElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<NumberElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<NumberElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type NumberFacet = {
  __typename?: 'NumberFacet';
  count?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Factor influences the score based of number values with a factor function */
export type NumberFactor = {
  modifier?: InputMaybe<FactorModifier>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export enum OrderBy {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum OrderByFacetType {
  Count = 'COUNT',
  Value = 'VALUE'
}

/** Organization Schema */
export type OrgSchemaBlock = IContent &
  IData & {
    __typename?: 'OrgSchemaBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Image?: Maybe<ContentModelReference>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    Logo?: Maybe<ContentModelReference>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    OrganizationDescription?: Maybe<Scalars['String']['output']>;
    OrganizationEmail?: Maybe<Scalars['String']['output']>;
    OrganizationName?: Maybe<Scalars['String']['output']>;
    OrganizationTelephone?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    /** Social links */
    SocialLinks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Organization Schema */
export type OrgSchemaBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Organization Schema */
export type OrgSchemaBlockOrganizationDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Organization Schema */
export type OrgSchemaBlockOrganizationEmailArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Organization Schema */
export type OrgSchemaBlockOrganizationNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Organization Schema */
export type OrgSchemaBlockOrganizationTelephoneArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Organization Schema */
export type OrgSchemaBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Organization Schema */
export type OrgSchemaBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type OrgSchemaBlockAutocomplete = {
  __typename?: 'OrgSchemaBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  Logo?: Maybe<ContentModelReferenceAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SocialLinks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type OrgSchemaBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type OrgSchemaBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type OrgSchemaBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type OrgSchemaBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type OrgSchemaBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type OrgSchemaBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type OrgSchemaBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type OrgSchemaBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type OrgSchemaBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type OrgSchemaBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type OrgSchemaBlockAutocompleteSocialLinksArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type OrgSchemaBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type OrgSchemaBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type OrgSchemaBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type OrgSchemaBlockFacet = {
  __typename?: 'OrgSchemaBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Image?: Maybe<ContentModelReferenceFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  Logo?: Maybe<ContentModelReferenceFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  OrganizationDescription?: Maybe<Array<Maybe<StringFacet>>>;
  OrganizationEmail?: Maybe<Array<Maybe<StringFacet>>>;
  OrganizationName?: Maybe<Array<Maybe<StringFacet>>>;
  OrganizationTelephone?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SocialLinks?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type OrgSchemaBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type OrgSchemaBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type OrgSchemaBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type OrgSchemaBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type OrgSchemaBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type OrgSchemaBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type OrgSchemaBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type OrgSchemaBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type OrgSchemaBlockFacetOrganizationDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type OrgSchemaBlockFacetOrganizationEmailArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type OrgSchemaBlockFacetOrganizationNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type OrgSchemaBlockFacetOrganizationTelephoneArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type OrgSchemaBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type OrgSchemaBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type OrgSchemaBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type OrgSchemaBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type OrgSchemaBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type OrgSchemaBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type OrgSchemaBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type OrgSchemaBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type OrgSchemaBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type OrgSchemaBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type OrgSchemaBlockFacetSocialLinksArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type OrgSchemaBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type OrgSchemaBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type OrgSchemaBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type OrgSchemaBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type OrgSchemaBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type OrgSchemaBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type OrgSchemaBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  Logo?: InputMaybe<ContentModelReferenceOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  OrganizationDescription?: InputMaybe<OrderBy>;
  OrganizationEmail?: InputMaybe<OrderBy>;
  OrganizationName?: InputMaybe<OrderBy>;
  OrganizationTelephone?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SocialLinks?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type OrgSchemaBlockOutput = {
  __typename?: 'OrgSchemaBlockOutput';
  autocomplete?: Maybe<OrgSchemaBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<OrgSchemaBlockFacet>;
  item?: Maybe<OrgSchemaBlock>;
  items?: Maybe<Array<Maybe<OrgSchemaBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type OrgSchemaBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrgSchemaBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  Logo?: InputMaybe<ContentModelReferenceWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  OrganizationDescription?: InputMaybe<SearchableStringFilterInput>;
  OrganizationEmail?: InputMaybe<SearchableStringFilterInput>;
  OrganizationName?: InputMaybe<SearchableStringFilterInput>;
  OrganizationTelephone?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SocialLinks?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<OrgSchemaBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<OrgSchemaBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<OrgSchemaBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ParagraphTextElementBlock = IContent &
  IData & {
    __typename?: 'ParagraphTextElementBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ConditionCombination?: Maybe<Scalars['Int']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    DisablePlaceholdersReplacement?: Maybe<Scalars['Bool']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    FormSubmissionId?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParagraphText?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    SatisfiedAction?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

export type ParagraphTextElementBlockFormSubmissionIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ParagraphTextElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ParagraphTextElementBlockParagraphTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ParagraphTextElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ParagraphTextElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ParagraphTextElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ParagraphTextElementBlockAutocomplete = {
  __typename?: 'ParagraphTextElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ParagraphTextElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ParagraphTextElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ParagraphTextElementBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ParagraphTextElementBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ParagraphTextElementBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ParagraphTextElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ParagraphTextElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ParagraphTextElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ParagraphTextElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ParagraphTextElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ParagraphTextElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ParagraphTextElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ParagraphTextElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ParagraphTextElementBlockFacet = {
  __typename?: 'ParagraphTextElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisablePlaceholdersReplacement?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FormSubmissionId?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParagraphText?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type ParagraphTextElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ParagraphTextElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ParagraphTextElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ParagraphTextElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ParagraphTextElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ParagraphTextElementBlockFacetDisablePlaceholdersReplacementArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ParagraphTextElementBlockFacetFormSubmissionIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ParagraphTextElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ParagraphTextElementBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ParagraphTextElementBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ParagraphTextElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ParagraphTextElementBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ParagraphTextElementBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ParagraphTextElementBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ParagraphTextElementBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ParagraphTextElementBlockFacetParagraphTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ParagraphTextElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ParagraphTextElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ParagraphTextElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ParagraphTextElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ParagraphTextElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ParagraphTextElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ParagraphTextElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ParagraphTextElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ParagraphTextElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ParagraphTextElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ParagraphTextElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ParagraphTextElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ParagraphTextElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ParagraphTextElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisablePlaceholdersReplacement?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FormSubmissionId?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParagraphText?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ParagraphTextElementBlockOutput = {
  __typename?: 'ParagraphTextElementBlockOutput';
  autocomplete?: Maybe<ParagraphTextElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ParagraphTextElementBlockFacet>;
  item?: Maybe<ParagraphTextElementBlock>;
  items?: Maybe<Array<Maybe<ParagraphTextElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ParagraphTextElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ParagraphTextElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisablePlaceholdersReplacement?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FormSubmissionId?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParagraphText?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ParagraphTextElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ParagraphTextElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ParagraphTextElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Person Schema */
export type PersonSchemaBlock = IContent &
  IData & {
    __typename?: 'PersonSchemaBlock';
    Affiliation?: Maybe<Scalars['String']['output']>;
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Email?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Image?: Maybe<ContentModelReference>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    JobTitle?: Maybe<Scalars['String']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    LocationPage?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    /** SameAs */
    SameAs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Telephone?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Person Schema */
export type PersonSchemaBlockAffiliationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Person Schema */
export type PersonSchemaBlockEmailArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Person Schema */
export type PersonSchemaBlockJobTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Person Schema */
export type PersonSchemaBlockLocationPageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Person Schema */
export type PersonSchemaBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Person Schema */
export type PersonSchemaBlockTelephoneArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Person Schema */
export type PersonSchemaBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Person Schema */
export type PersonSchemaBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PersonSchemaBlockAutocomplete = {
  __typename?: 'PersonSchemaBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SameAs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PersonSchemaBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PersonSchemaBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PersonSchemaBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PersonSchemaBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PersonSchemaBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PersonSchemaBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PersonSchemaBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PersonSchemaBlockAutocompleteSameAsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PersonSchemaBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PersonSchemaBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PersonSchemaBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PersonSchemaBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PersonSchemaBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PersonSchemaBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PersonSchemaBlockFacet = {
  __typename?: 'PersonSchemaBlockFacet';
  Affiliation?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Email?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Image?: Maybe<ContentModelReferenceFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  JobTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LocationPage?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SameAs?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Telephone?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type PersonSchemaBlockFacetAffiliationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonSchemaBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonSchemaBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonSchemaBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonSchemaBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonSchemaBlockFacetEmailArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonSchemaBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonSchemaBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonSchemaBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonSchemaBlockFacetJobTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonSchemaBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonSchemaBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonSchemaBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonSchemaBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonSchemaBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonSchemaBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonSchemaBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonSchemaBlockFacetSameAsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonSchemaBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonSchemaBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonSchemaBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonSchemaBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonSchemaBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonSchemaBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonSchemaBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonSchemaBlockFacetTelephoneArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonSchemaBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonSchemaBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonSchemaBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PersonSchemaBlockOrderByInput = {
  Affiliation?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Email?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  JobTitle?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LocationPage?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SameAs?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Telephone?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PersonSchemaBlockOutput = {
  __typename?: 'PersonSchemaBlockOutput';
  autocomplete?: Maybe<PersonSchemaBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PersonSchemaBlockFacet>;
  item?: Maybe<PersonSchemaBlock>;
  items?: Maybe<Array<Maybe<PersonSchemaBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PersonSchemaBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonSchemaBlockWhereInput = {
  Affiliation?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Email?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  JobTitle?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LocationPage?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SameAs?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Telephone?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PersonSchemaBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PersonSchemaBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PersonSchemaBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type PredefinedHiddenElementBlock = IContent &
  IData & {
    __typename?: 'PredefinedHiddenElementBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    PredefinedValue?: Maybe<Scalars['String']['output']>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

export type PredefinedHiddenElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PredefinedHiddenElementBlockPredefinedValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PredefinedHiddenElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PredefinedHiddenElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PredefinedHiddenElementBlockAutocomplete = {
  __typename?: 'PredefinedHiddenElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PredefinedHiddenElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PredefinedHiddenElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PredefinedHiddenElementBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PredefinedHiddenElementBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PredefinedHiddenElementBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PredefinedHiddenElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PredefinedHiddenElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PredefinedHiddenElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PredefinedHiddenElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PredefinedHiddenElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PredefinedHiddenElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PredefinedHiddenElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PredefinedHiddenElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PredefinedHiddenElementBlockFacet = {
  __typename?: 'PredefinedHiddenElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PredefinedValue?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type PredefinedHiddenElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PredefinedHiddenElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PredefinedHiddenElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PredefinedHiddenElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PredefinedHiddenElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PredefinedHiddenElementBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PredefinedHiddenElementBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PredefinedHiddenElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PredefinedHiddenElementBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PredefinedHiddenElementBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PredefinedHiddenElementBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PredefinedHiddenElementBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PredefinedHiddenElementBlockFacetPredefinedValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PredefinedHiddenElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PredefinedHiddenElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PredefinedHiddenElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PredefinedHiddenElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PredefinedHiddenElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PredefinedHiddenElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PredefinedHiddenElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PredefinedHiddenElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PredefinedHiddenElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PredefinedHiddenElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PredefinedHiddenElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PredefinedHiddenElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PredefinedHiddenElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PredefinedValue?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PredefinedHiddenElementBlockOutput = {
  __typename?: 'PredefinedHiddenElementBlockOutput';
  autocomplete?: Maybe<PredefinedHiddenElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PredefinedHiddenElementBlockFacet>;
  item?: Maybe<PredefinedHiddenElementBlock>;
  items?: Maybe<Array<Maybe<PredefinedHiddenElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PredefinedHiddenElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PredefinedHiddenElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PredefinedValue?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PredefinedHiddenElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PredefinedHiddenElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PredefinedHiddenElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Page with CACU’s Product information including description, featured image, and modules that allow users to request a quote and explore detailed product features. */
export type ProductPage = IContent &
  IData & {
    __typename?: 'ProductPage';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    AuthorMetaData?: Maybe<Scalars['String']['output']>;
    BreadcrumbsTitle?: Maybe<Scalars['String']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    DisableIndexing?: Maybe<Scalars['Bool']['output']>;
    /** This will determine whether or not to show on search. */
    ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
    /** This will determine whether or not to show on the Sitemap. */
    ExcludeFromSitemap?: Maybe<Scalars['Bool']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    FinancialSchema?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    FooterOverride?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    HeaderOverride?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    /** Headline is shown when the page appears in Search Results. */
    Headline?: Maybe<Scalars['String']['output']>;
    /** This will determine whether or not to be dispalyed in breadcrumbs. */
    HideInBreadcrumbs?: Maybe<Scalars['Bool']['output']>;
    HideSiteFooter?: Maybe<Scalars['Bool']['output']>;
    HideSiteHeader?: Maybe<Scalars['Bool']['output']>;
    Highlight?: Maybe<Scalars['Bool']['output']>;
    Industry?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Keywords?: Maybe<Scalars['String']['output']>;
    /** Container for Schema Field */
    LDJsonContainer?: Maybe<Scalars['String']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    LocationSchema?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    MainContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    MetaContentType?: Maybe<Scalars['String']['output']>;
    MetaTitle?: Maybe<Scalars['String']['output']>;
    Name?: Maybe<Scalars['String']['output']>;
    NavigationTitle?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Description value that has been managed for the current page */
    OpenGraphDescription?: Maybe<Scalars['String']['output']>;
    /** Page template will always inherit the OpenGraph image from the parent page, recursively, until an image is managed for the current page */
    OpenGraphImage?: Maybe<ContentModelReference>;
    /** If managed, this field will overwrite the Image Height value that has been managed for the current page */
    OpenGraphImageHeight?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Image Type value that has been managed for the current page */
    OpenGraphImageType?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Image Width  value that has been managed for the current page */
    OpenGraphImageWidth?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Site value that has been managed for the current page */
    OpenGraphSite?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Title value that has been managed for the current page */
    OpenGraphTitle?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Url value that has been managed for the current page */
    OpenGraphUrl?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Type value that has been managed for the current page */
    OpenGraphtype?: Maybe<Scalars['String']['output']>;
    PageDescription?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    /** Short Description is shown when the page appears in Search Results. */
    ShortDescription?: Maybe<Scalars['String']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    /** Show the FinancialProduct schema of the current product */
    ShowSchema?: Maybe<Scalars['Bool']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SimpleMasthead?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    TeaserText?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Page with CACU’s Product information including description, featured image, and modules that allow users to request a quote and explore detailed product features. */
export type ProductPageAuthorMetaDataArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU’s Product information including description, featured image, and modules that allow users to request a quote and explore detailed product features. */
export type ProductPageFinancialSchemaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU’s Product information including description, featured image, and modules that allow users to request a quote and explore detailed product features. */
export type ProductPageFooterOverrideArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU’s Product information including description, featured image, and modules that allow users to request a quote and explore detailed product features. */
export type ProductPageHeaderOverrideArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU’s Product information including description, featured image, and modules that allow users to request a quote and explore detailed product features. */
export type ProductPageHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU’s Product information including description, featured image, and modules that allow users to request a quote and explore detailed product features. */
export type ProductPageIndustryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU’s Product information including description, featured image, and modules that allow users to request a quote and explore detailed product features. */
export type ProductPageKeywordsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU’s Product information including description, featured image, and modules that allow users to request a quote and explore detailed product features. */
export type ProductPageLdJsonContainerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU’s Product information including description, featured image, and modules that allow users to request a quote and explore detailed product features. */
export type ProductPageLocationSchemaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU’s Product information including description, featured image, and modules that allow users to request a quote and explore detailed product features. */
export type ProductPageMainContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU’s Product information including description, featured image, and modules that allow users to request a quote and explore detailed product features. */
export type ProductPageMetaContentTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU’s Product information including description, featured image, and modules that allow users to request a quote and explore detailed product features. */
export type ProductPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU’s Product information including description, featured image, and modules that allow users to request a quote and explore detailed product features. */
export type ProductPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU’s Product information including description, featured image, and modules that allow users to request a quote and explore detailed product features. */
export type ProductPageNavigationTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU’s Product information including description, featured image, and modules that allow users to request a quote and explore detailed product features. */
export type ProductPageOpenGraphDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU’s Product information including description, featured image, and modules that allow users to request a quote and explore detailed product features. */
export type ProductPageOpenGraphImageHeightArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU’s Product information including description, featured image, and modules that allow users to request a quote and explore detailed product features. */
export type ProductPageOpenGraphImageTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU’s Product information including description, featured image, and modules that allow users to request a quote and explore detailed product features. */
export type ProductPageOpenGraphImageWidthArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU’s Product information including description, featured image, and modules that allow users to request a quote and explore detailed product features. */
export type ProductPageOpenGraphSiteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU’s Product information including description, featured image, and modules that allow users to request a quote and explore detailed product features. */
export type ProductPageOpenGraphTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU’s Product information including description, featured image, and modules that allow users to request a quote and explore detailed product features. */
export type ProductPageOpenGraphUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU’s Product information including description, featured image, and modules that allow users to request a quote and explore detailed product features. */
export type ProductPageOpenGraphtypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU’s Product information including description, featured image, and modules that allow users to request a quote and explore detailed product features. */
export type ProductPagePageDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU’s Product information including description, featured image, and modules that allow users to request a quote and explore detailed product features. */
export type ProductPageShortDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU’s Product information including description, featured image, and modules that allow users to request a quote and explore detailed product features. */
export type ProductPageSimpleMastheadArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU’s Product information including description, featured image, and modules that allow users to request a quote and explore detailed product features. */
export type ProductPageTeaserTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU’s Product information including description, featured image, and modules that allow users to request a quote and explore detailed product features. */
export type ProductPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Page with CACU’s Product information including description, featured image, and modules that allow users to request a quote and explore detailed product features. */
export type ProductPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ProductPageAutocomplete = {
  __typename?: 'ProductPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  OpenGraphImage?: Maybe<ContentModelReferenceAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ProductPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProductPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProductPageAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProductPageAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProductPageAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProductPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProductPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProductPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProductPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProductPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProductPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProductPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProductPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProductPageFacet = {
  __typename?: 'ProductPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AuthorMetaData?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSitemap?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FinancialSchema?: Maybe<ContentAreaItemModelSearchFacet>;
  FooterOverride?: Maybe<ContentAreaItemModelSearchFacet>;
  HeaderOverride?: Maybe<ContentAreaItemModelSearchFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  HideInBreadcrumbs?: Maybe<Array<Maybe<StringFacet>>>;
  HideSiteFooter?: Maybe<Array<Maybe<StringFacet>>>;
  HideSiteHeader?: Maybe<Array<Maybe<StringFacet>>>;
  Highlight?: Maybe<Array<Maybe<StringFacet>>>;
  Industry?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Keywords?: Maybe<Array<Maybe<StringFacet>>>;
  LDJsonContainer?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LocationSchema?: Maybe<ContentAreaItemModelSearchFacet>;
  MainContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaContentType?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NavigationTitle?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphDescription?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphImage?: Maybe<ContentModelReferenceFacet>;
  OpenGraphImageHeight?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphImageType?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphImageWidth?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphSite?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphTitle?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphUrl?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphtype?: Maybe<Array<Maybe<StringFacet>>>;
  PageDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  ShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  ShowSchema?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleMasthead?: Maybe<ContentAreaItemModelSearchFacet>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TeaserText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type ProductPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetAuthorMetaDataArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductPageFacetDisableIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetExcludeFromSitemapArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetHideInBreadcrumbsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetHideSiteFooterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetHideSiteHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetHighlightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetIndustryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetKeywordsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetLdJsonContainerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetMetaContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetNavigationTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetOpenGraphDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetOpenGraphImageHeightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetOpenGraphImageTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetOpenGraphImageWidthArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetOpenGraphSiteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetOpenGraphTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetOpenGraphUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetOpenGraphtypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetPageDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductPageFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductPageFacetShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetShowSchemaArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductPageFacetTeaserTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ProductPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AuthorMetaData?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExcludeFromSitemap?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FinancialSchema?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  FooterOverride?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  HeaderOverride?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  HideInBreadcrumbs?: InputMaybe<OrderBy>;
  HideSiteFooter?: InputMaybe<OrderBy>;
  HideSiteHeader?: InputMaybe<OrderBy>;
  Highlight?: InputMaybe<OrderBy>;
  Industry?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Keywords?: InputMaybe<OrderBy>;
  LDJsonContainer?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LocationSchema?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaContentType?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NavigationTitle?: InputMaybe<OrderBy>;
  OpenGraphDescription?: InputMaybe<OrderBy>;
  OpenGraphImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  OpenGraphImageHeight?: InputMaybe<OrderBy>;
  OpenGraphImageType?: InputMaybe<OrderBy>;
  OpenGraphImageWidth?: InputMaybe<OrderBy>;
  OpenGraphSite?: InputMaybe<OrderBy>;
  OpenGraphTitle?: InputMaybe<OrderBy>;
  OpenGraphUrl?: InputMaybe<OrderBy>;
  OpenGraphtype?: InputMaybe<OrderBy>;
  PageDescription?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  ShortDescription?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  ShowSchema?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SimpleMasthead?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TeaserText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ProductPageOutput = {
  __typename?: 'ProductPageOutput';
  autocomplete?: Maybe<ProductPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ProductPageFacet>;
  item?: Maybe<ProductPage>;
  items?: Maybe<Array<Maybe<ProductPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ProductPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AuthorMetaData?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExcludeFromSitemap?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FinancialSchema?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  FooterOverride?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  HeaderOverride?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  HideInBreadcrumbs?: InputMaybe<BoolFilterInput>;
  HideSiteFooter?: InputMaybe<BoolFilterInput>;
  HideSiteHeader?: InputMaybe<BoolFilterInput>;
  Highlight?: InputMaybe<BoolFilterInput>;
  Industry?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Keywords?: InputMaybe<SearchableStringFilterInput>;
  LDJsonContainer?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LocationSchema?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaContentType?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NavigationTitle?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphDescription?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphImage?: InputMaybe<ContentModelReferenceWhereInput>;
  OpenGraphImageHeight?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphImageType?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphImageWidth?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphSite?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphTitle?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphUrl?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphtype?: InputMaybe<SearchableStringFilterInput>;
  PageDescription?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  ShortDescription?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  ShowSchema?: InputMaybe<BoolFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SimpleMasthead?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TeaserText?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ProductPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ProductPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ProductPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Profit Payout calculator. */
export type ProfitPayoutCalculatorBlock = IContent &
  IData & {
    __typename?: 'ProfitPayoutCalculatorBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Profit Payout calculator. */
export type ProfitPayoutCalculatorBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Profit Payout calculator. */
export type ProfitPayoutCalculatorBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Profit Payout calculator. */
export type ProfitPayoutCalculatorBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Profit Payout calculator. */
export type ProfitPayoutCalculatorBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Profit Payout calculator. */
export type ProfitPayoutCalculatorBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ProfitPayoutCalculatorBlockAutocomplete = {
  __typename?: 'ProfitPayoutCalculatorBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ProfitPayoutCalculatorBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProfitPayoutCalculatorBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProfitPayoutCalculatorBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProfitPayoutCalculatorBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProfitPayoutCalculatorBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProfitPayoutCalculatorBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProfitPayoutCalculatorBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProfitPayoutCalculatorBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProfitPayoutCalculatorBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProfitPayoutCalculatorBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProfitPayoutCalculatorBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProfitPayoutCalculatorBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProfitPayoutCalculatorBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProfitPayoutCalculatorBlockFacet = {
  __typename?: 'ProfitPayoutCalculatorBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type ProfitPayoutCalculatorBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProfitPayoutCalculatorBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ProfitPayoutCalculatorBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProfitPayoutCalculatorBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ProfitPayoutCalculatorBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProfitPayoutCalculatorBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProfitPayoutCalculatorBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProfitPayoutCalculatorBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProfitPayoutCalculatorBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProfitPayoutCalculatorBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProfitPayoutCalculatorBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProfitPayoutCalculatorBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ProfitPayoutCalculatorBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProfitPayoutCalculatorBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProfitPayoutCalculatorBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProfitPayoutCalculatorBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProfitPayoutCalculatorBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ProfitPayoutCalculatorBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProfitPayoutCalculatorBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProfitPayoutCalculatorBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProfitPayoutCalculatorBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ProfitPayoutCalculatorBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProfitPayoutCalculatorBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ProfitPayoutCalculatorBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProfitPayoutCalculatorBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProfitPayoutCalculatorBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ProfitPayoutCalculatorBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ProfitPayoutCalculatorBlockOutput = {
  __typename?: 'ProfitPayoutCalculatorBlockOutput';
  autocomplete?: Maybe<ProfitPayoutCalculatorBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ProfitPayoutCalculatorBlockFacet>;
  item?: Maybe<ProfitPayoutCalculatorBlock>;
  items?: Maybe<Array<Maybe<ProfitPayoutCalculatorBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ProfitPayoutCalculatorBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfitPayoutCalculatorBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ProfitPayoutCalculatorBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ProfitPayoutCalculatorBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ProfitPayoutCalculatorBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Enable promotion banner component. */
export type PromoBannerBlock = IContent &
  IData & {
    __typename?: 'PromoBannerBlock';
    Alignment?: Maybe<Scalars['String']['output']>;
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    DescriptionColor?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    HeadlineColor?: Maybe<Scalars['String']['output']>;
    Image?: Maybe<ContentModelReference>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    VisitDays?: Maybe<Scalars['Int']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Enable promotion banner component. */
export type PromoBannerBlockAlignmentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Enable promotion banner component. */
export type PromoBannerBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Enable promotion banner component. */
export type PromoBannerBlockDescriptionColorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Enable promotion banner component. */
export type PromoBannerBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Enable promotion banner component. */
export type PromoBannerBlockHeadlineColorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Enable promotion banner component. */
export type PromoBannerBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Enable promotion banner component. */
export type PromoBannerBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Enable promotion banner component. */
export type PromoBannerBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PromoBannerBlockAutocomplete = {
  __typename?: 'PromoBannerBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PromoBannerBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoBannerBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoBannerBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoBannerBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoBannerBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoBannerBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoBannerBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoBannerBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoBannerBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoBannerBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoBannerBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoBannerBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoBannerBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoBannerBlockFacet = {
  __typename?: 'PromoBannerBlockFacet';
  Alignment?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DescriptionColor?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  HeadlineColor?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VisitDays?: Maybe<Array<Maybe<NumberFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type PromoBannerBlockFacetAlignmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoBannerBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoBannerBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoBannerBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoBannerBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoBannerBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoBannerBlockFacetDescriptionColorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoBannerBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoBannerBlockFacetHeadlineColorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoBannerBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoBannerBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoBannerBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoBannerBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoBannerBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoBannerBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoBannerBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoBannerBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoBannerBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoBannerBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoBannerBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoBannerBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoBannerBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoBannerBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoBannerBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoBannerBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoBannerBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoBannerBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoBannerBlockFacetVisitDaysArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PromoBannerBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoBannerBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PromoBannerBlockOrderByInput = {
  Alignment?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DescriptionColor?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  HeadlineColor?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VisitDays?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PromoBannerBlockOutput = {
  __typename?: 'PromoBannerBlockOutput';
  autocomplete?: Maybe<PromoBannerBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PromoBannerBlockFacet>;
  item?: Maybe<PromoBannerBlock>;
  items?: Maybe<Array<Maybe<PromoBannerBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PromoBannerBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PromoBannerBlockWhereInput = {
  Alignment?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DescriptionColor?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  HeadlineColor?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VisitDays?: InputMaybe<IntFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PromoBannerBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PromoBannerBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PromoBannerBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Promo Callout component that can be used on any promo page. */
export type PromoCalloutBlock = IContent &
  IData & {
    __typename?: 'PromoCalloutBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    ShortDescription?: Maybe<Scalars['String']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Promo Callout component that can be used on any promo page. */
export type PromoCalloutBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Promo Callout component that can be used on any promo page. */
export type PromoCalloutBlockShortDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Promo Callout component that can be used on any promo page. */
export type PromoCalloutBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Promo Callout component that can be used on any promo page. */
export type PromoCalloutBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PromoCalloutBlockAutocomplete = {
  __typename?: 'PromoCalloutBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PromoCalloutBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoCalloutBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoCalloutBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoCalloutBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoCalloutBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoCalloutBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoCalloutBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoCalloutBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoCalloutBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoCalloutBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoCalloutBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoCalloutBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoCalloutBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoCalloutBlockFacet = {
  __typename?: 'PromoCalloutBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  ShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type PromoCalloutBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoCalloutBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoCalloutBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoCalloutBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoCalloutBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoCalloutBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoCalloutBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoCalloutBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoCalloutBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoCalloutBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoCalloutBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoCalloutBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoCalloutBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoCalloutBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoCalloutBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoCalloutBlockFacetShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoCalloutBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoCalloutBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoCalloutBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoCalloutBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoCalloutBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoCalloutBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoCalloutBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoCalloutBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoCalloutBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PromoCalloutBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  ShortDescription?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PromoCalloutBlockOutput = {
  __typename?: 'PromoCalloutBlockOutput';
  autocomplete?: Maybe<PromoCalloutBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PromoCalloutBlockFacet>;
  item?: Maybe<PromoCalloutBlock>;
  items?: Maybe<Array<Maybe<PromoCalloutBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PromoCalloutBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PromoCalloutBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  ShortDescription?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PromoCalloutBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PromoCalloutBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PromoCalloutBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Promo Footer component that can be used on any page. */
export type PromoFooterBlock = IContent &
  IData & {
    __typename?: 'PromoFooterBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    CACULogo?: Maybe<ContentModelReference>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /** The token '%year%' will be replaced with current year. */
    Copyright?: Maybe<Scalars['String']['output']>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    PhoneNumber?: Maybe<Scalars['String']['output']>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Promo Footer component that can be used on any page. */
export type PromoFooterBlockCopyrightArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Promo Footer component that can be used on any page. */
export type PromoFooterBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Promo Footer component that can be used on any page. */
export type PromoFooterBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Promo Footer component that can be used on any page. */
export type PromoFooterBlockPhoneNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Promo Footer component that can be used on any page. */
export type PromoFooterBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Promo Footer component that can be used on any page. */
export type PromoFooterBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PromoFooterBlockAutocomplete = {
  __typename?: 'PromoFooterBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CACULogo?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PromoFooterBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoFooterBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoFooterBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoFooterBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoFooterBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoFooterBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoFooterBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoFooterBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoFooterBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoFooterBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoFooterBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoFooterBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoFooterBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoFooterBlockFacet = {
  __typename?: 'PromoFooterBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  CACULogo?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Copyright?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PhoneNumber?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type PromoFooterBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoFooterBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoFooterBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoFooterBlockFacetCopyrightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoFooterBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoFooterBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoFooterBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoFooterBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoFooterBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoFooterBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoFooterBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoFooterBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoFooterBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoFooterBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoFooterBlockFacetPhoneNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoFooterBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoFooterBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoFooterBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoFooterBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoFooterBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoFooterBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoFooterBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoFooterBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoFooterBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoFooterBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoFooterBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoFooterBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PromoFooterBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  CACULogo?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Copyright?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PhoneNumber?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PromoFooterBlockOutput = {
  __typename?: 'PromoFooterBlockOutput';
  autocomplete?: Maybe<PromoFooterBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PromoFooterBlockFacet>;
  item?: Maybe<PromoFooterBlock>;
  items?: Maybe<Array<Maybe<PromoFooterBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PromoFooterBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PromoFooterBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  CACULogo?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Copyright?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PhoneNumber?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PromoFooterBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PromoFooterBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PromoFooterBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Promo header that be used for promotional purposes. */
export type PromoHeaderBlock = IContent &
  IData & {
    __typename?: 'PromoHeaderBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    Logo?: Maybe<ContentModelReference>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Promo header that be used for promotional purposes. */
export type PromoHeaderBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Promo header that be used for promotional purposes. */
export type PromoHeaderBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Promo header that be used for promotional purposes. */
export type PromoHeaderBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PromoHeaderBlockAutocomplete = {
  __typename?: 'PromoHeaderBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  Logo?: Maybe<ContentModelReferenceAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PromoHeaderBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoHeaderBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoHeaderBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoHeaderBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoHeaderBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoHeaderBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoHeaderBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoHeaderBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoHeaderBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoHeaderBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoHeaderBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoHeaderBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoHeaderBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoHeaderBlockFacet = {
  __typename?: 'PromoHeaderBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  Logo?: Maybe<ContentModelReferenceFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type PromoHeaderBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeaderBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoHeaderBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeaderBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoHeaderBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeaderBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeaderBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeaderBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeaderBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeaderBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoHeaderBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeaderBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeaderBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeaderBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeaderBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoHeaderBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeaderBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeaderBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeaderBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoHeaderBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeaderBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoHeaderBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeaderBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeaderBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PromoHeaderBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  Logo?: InputMaybe<ContentModelReferenceOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PromoHeaderBlockOutput = {
  __typename?: 'PromoHeaderBlockOutput';
  autocomplete?: Maybe<PromoHeaderBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PromoHeaderBlockFacet>;
  item?: Maybe<PromoHeaderBlock>;
  items?: Maybe<Array<Maybe<PromoHeaderBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PromoHeaderBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PromoHeaderBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  Logo?: InputMaybe<ContentModelReferenceWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PromoHeaderBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PromoHeaderBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PromoHeaderBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Allow content authors to promo hero block */
export type PromoHeroBlock = IContent &
  IData & {
    __typename?: 'PromoHeroBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    BackgroundImage?: Maybe<ContentModelReference>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    HeadLine?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    ShortDescription?: Maybe<Scalars['String']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Allow content authors to promo hero block */
export type PromoHeroBlockHeadLineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to promo hero block */
export type PromoHeroBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to promo hero block */
export type PromoHeroBlockShortDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to promo hero block */
export type PromoHeroBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to promo hero block */
export type PromoHeroBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PromoHeroBlockAutocomplete = {
  __typename?: 'PromoHeroBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BackgroundImage?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PromoHeroBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoHeroBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoHeroBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoHeroBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoHeroBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoHeroBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoHeroBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoHeroBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoHeroBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoHeroBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoHeroBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoHeroBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoHeroBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoHeroBlockFacet = {
  __typename?: 'PromoHeroBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BackgroundImage?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  HeadLine?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  ShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type PromoHeroBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeroBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoHeroBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeroBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoHeroBlockFacetHeadLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeroBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeroBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeroBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeroBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeroBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeroBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoHeroBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeroBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeroBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeroBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeroBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoHeroBlockFacetShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeroBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeroBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeroBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeroBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoHeroBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeroBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoHeroBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeroBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PromoHeroBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PromoHeroBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BackgroundImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  HeadLine?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  ShortDescription?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PromoHeroBlockOutput = {
  __typename?: 'PromoHeroBlockOutput';
  autocomplete?: Maybe<PromoHeroBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PromoHeroBlockFacet>;
  item?: Maybe<PromoHeroBlock>;
  items?: Maybe<Array<Maybe<PromoHeroBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PromoHeroBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PromoHeroBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BackgroundImage?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  HeadLine?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  ShortDescription?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PromoHeroBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PromoHeroBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PromoHeroBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type Query = {
  __typename?: 'Query';
  AboutAuthor?: Maybe<AboutAuthorOutput>;
  AccordionBlock?: Maybe<AccordionBlockOutput>;
  AccordionSectionBlock?: Maybe<AccordionSectionBlockOutput>;
  AdvisorListingBlock?: Maybe<AdvisorListingBlockOutput>;
  AdvisorPage?: Maybe<AdvisorPageOutput>;
  AlertBannerBlock?: Maybe<AlertBannerBlockOutput>;
  AnchorBlock?: Maybe<AnchorBlockOutput>;
  AreYouMemberModal?: Maybe<AreYouMemberModalOutput>;
  AuthorPage?: Maybe<AuthorPageOutput>;
  AutoAffordabilityCalculatorBlock?: Maybe<AutoAffordabilityCalculatorBlockOutput>;
  AutoPaymentCalculatorBlock?: Maybe<AutoPaymentCalculatorBlockOutput>;
  AutoRefinanceCalculatorBlock?: Maybe<AutoRefinanceCalculatorBlockOutput>;
  BlockContentPodExpandCardBlock?: Maybe<BlockContentPodExpandCardBlockOutput>;
  BlockContentPodGroupBlock?: Maybe<BlockContentPodGroupBlockOutput>;
  BlockContentPodIconBlock?: Maybe<BlockContentPodIconBlockOutput>;
  BlockContentPodImageBlock?: Maybe<BlockContentPodImageBlockOutput>;
  BlogFeaturedPodModuleBlock?: Maybe<BlogFeaturedPodModuleBlockOutput>;
  BlogListing?: Maybe<BlogListingOutput>;
  BlogPage?: Maybe<BlogPageOutput>;
  BlogSignUpFormBlock?: Maybe<BlogSignUpFormBlockOutput>;
  ButtonBlock?: Maybe<ButtonBlockOutput>;
  CalculatorPage?: Maybe<CalculatorPageOutput>;
  CaptchaElementBlock?: Maybe<CaptchaElementBlockOutput>;
  CertificateOfDepositCalculatorBlock?: Maybe<CertificateOfDepositCalculatorBlockOutput>;
  ChoiceElementBlock?: Maybe<ChoiceElementBlockOutput>;
  CodingFile?: Maybe<CodingFileOutput>;
  ComplexTableBlock?: Maybe<ComplexTableBlockOutput>;
  ComplexTableColumnBlock?: Maybe<ComplexTableColumnBlockOutput>;
  ComplexTableHeaderBlock?: Maybe<ComplexTableHeaderBlockOutput>;
  ComplexTableRowBlock?: Maybe<ComplexTableRowBlockOutput>;
  ConsentBannerBlock?: Maybe<ConsentBannerBlockOutput>;
  ContainerBlock?: Maybe<ContainerBlockOutput>;
  ContainerWithSideRailBlock?: Maybe<ContainerWithSideRailBlockOutput>;
  Content?: Maybe<ContentOutput>;
  ContentBlock?: Maybe<ContentBlockOutput>;
  ContentPanelBlock?: Maybe<ContentPanelBlockOutput>;
  ContentPodBlock?: Maybe<ContentPodBlockOutput>;
  ContentPodGroupBlock?: Maybe<ContentPodGroupBlockOutput>;
  ContentPodMultiRateCardBlock?: Maybe<ContentPodMultiRateCardBlockOutput>;
  ContentPodMultiRateGroupBlock?: Maybe<ContentPodMultiRateGroupBlockOutput>;
  CookieHiddenElementBlock?: Maybe<CookieHiddenElementBlockOutput>;
  CountrySelectionElementBlock?: Maybe<CountrySelectionElementBlockOutput>;
  CurrencyConverterBlock?: Maybe<CurrencyConverterBlockOutput>;
  CustomFormContainerBlock?: Maybe<CustomFormContainerBlockOutput>;
  Data?: Maybe<DataOutput>;
  DocumentMediaData?: Maybe<DocumentMediaDataOutput>;
  ErrorPage?: Maybe<ErrorPageOutput>;
  ExecutableMediaData?: Maybe<ExecutableMediaDataOutput>;
  ExitIntentModal?: Maybe<ExitIntentModalOutput>;
  FaqItem?: Maybe<FaqItemOutput>;
  FaqSchemaBlock?: Maybe<FaqSchemaBlockOutput>;
  FeaturedSearchIconBlock?: Maybe<FeaturedSearchIconBlockOutput>;
  FiftyThirtyTwentyCalculatorBlock?: Maybe<FiftyThirtyTwentyCalculatorBlockOutput>;
  FileUploadElementBlock?: Maybe<FileUploadElementBlockOutput>;
  FolderPage?: Maybe<FolderPageOutput>;
  FooterBlock?: Maybe<FooterBlockOutput>;
  FooterMenuLinksBlock?: Maybe<FooterMenuLinksBlockOutput>;
  FootnoteSectionBlock?: Maybe<FootnoteSectionBlockOutput>;
  FormAssemblyBlock?: Maybe<FormAssemblyBlockOutput>;
  FormContainerBlock?: Maybe<FormContainerBlockOutput>;
  FormStepBlock?: Maybe<FormStepBlockOutput>;
  FullWidthVideoBlock?: Maybe<FullWidthVideoBlockOutput>;
  GlobalLabelsBlock?: Maybe<GlobalLabelsBlockOutput>;
  HeaderBlock?: Maybe<HeaderBlockOutput>;
  HeroBlock?: Maybe<HeroBlockOutput>;
  HeroImageBlock?: Maybe<HeroImageBlockOutput>;
  HomeAffordabilityCalculatorBlock?: Maybe<HomeAffordabilityCalculatorBlockOutput>;
  HomeEquityCalculatorBlock?: Maybe<HomeEquityCalculatorBlockOutput>;
  IFrameContainerBlock?: Maybe<IFrameContainerBlockOutput>;
  IframeCalculatorBlock?: Maybe<IframeCalculatorBlockOutput>;
  ImageChoiceElementBlock?: Maybe<ImageChoiceElementBlockOutput>;
  ImageMediaData?: Maybe<ImageMediaDataOutput>;
  InteriorContentPage?: Maybe<InteriorContentPageOutput>;
  LocationPage?: Maybe<LocationPageOutput>;
  LocationsListingBlock?: Maybe<LocationsListingBlockOutput>;
  LoginModalBlock?: Maybe<LoginModalBlockOutput>;
  LogoImageBlock?: Maybe<LogoImageBlockOutput>;
  MenuItemBlock?: Maybe<MenuItemBlockOutput>;
  MortgagePaymentCalculatorBlock?: Maybe<MortgagePaymentCalculatorBlockOutput>;
  MortgageRatesQuickQuoteBlock?: Maybe<MortgageRatesQuickQuoteBlockOutput>;
  MortgageRefinanceCalculatorBlock?: Maybe<MortgageRefinanceCalculatorBlockOutput>;
  MultiLogoImageBlock?: Maybe<MultiLogoImageBlockOutput>;
  NavigationColumnBlock?: Maybe<NavigationColumnBlockOutput>;
  NavigationItemLevel1Block?: Maybe<NavigationItemLevel1BlockOutput>;
  NavigationItemLevel2Block?: Maybe<NavigationItemLevel2BlockOutput>;
  NavigationItemLevel3Block?: Maybe<NavigationItemLevel3BlockOutput>;
  NavigationMenuBlock?: Maybe<NavigationMenuBlockOutput>;
  NewsListing?: Maybe<NewsListingOutput>;
  NewsPage?: Maybe<NewsPageOutput>;
  NumberElementBlock?: Maybe<NumberElementBlockOutput>;
  OrgSchemaBlock?: Maybe<OrgSchemaBlockOutput>;
  ParagraphTextElementBlock?: Maybe<ParagraphTextElementBlockOutput>;
  PersonSchemaBlock?: Maybe<PersonSchemaBlockOutput>;
  PredefinedHiddenElementBlock?: Maybe<PredefinedHiddenElementBlockOutput>;
  ProductPage?: Maybe<ProductPageOutput>;
  ProfitPayoutCalculatorBlock?: Maybe<ProfitPayoutCalculatorBlockOutput>;
  PromoBannerBlock?: Maybe<PromoBannerBlockOutput>;
  PromoCalloutBlock?: Maybe<PromoCalloutBlockOutput>;
  PromoFooterBlock?: Maybe<PromoFooterBlockOutput>;
  PromoHeaderBlock?: Maybe<PromoHeaderBlockOutput>;
  PromoHeroBlock?: Maybe<PromoHeroBlockOutput>;
  QuerystringHiddenElementBlock?: Maybe<QuerystringHiddenElementBlockOutput>;
  RangeElementBlock?: Maybe<RangeElementBlockOutput>;
  ReCaptchaServiceElementBlock?: Maybe<ReCaptchaServiceElementBlockOutput>;
  RequestAppointmentWithAdvisorBlock?: Maybe<RequestAppointmentWithAdvisorBlockOutput>;
  ResetButtonElementBlock?: Maybe<ResetButtonElementBlockOutput>;
  SearchListingBlock?: Maybe<SearchListingBlockOutput>;
  SearchMenuBlock?: Maybe<SearchMenuBlockOutput>;
  SelectionElementBlock?: Maybe<SelectionElementBlockOutput>;
  SendMyResultsFormBlock?: Maybe<SendMyResultsFormBlockOutput>;
  SideBySideVideoBlock?: Maybe<SideBySideVideoBlockOutput>;
  SiderailCtaPodBlock?: Maybe<SiderailCtaPodBlockOutput>;
  SignUpToNewsletterFormBlock?: Maybe<SignUpToNewsletterFormBlockOutput>;
  SimpleMastheadBlock?: Maybe<SimpleMastheadBlockOutput>;
  SimpleTableBlock?: Maybe<SimpleTableBlockOutput>;
  SiteDefinition?: Maybe<SiteDefinitionOutput>;
  SiteUrlPredefinedHiddenElementBlock?: Maybe<SiteUrlPredefinedHiddenElementBlockOutput>;
  SocialMediaIconBlock?: Maybe<SocialMediaIconBlockOutput>;
  SocialSharingBlock?: Maybe<SocialSharingBlockOutput>;
  SpacerBlock?: Maybe<SpacerBlockOutput>;
  StandardFile?: Maybe<StandardFileOutput>;
  StartPage?: Maybe<StartPageOutput>;
  SubmitButtonElementBlock?: Maybe<SubmitButtonElementBlockOutput>;
  TabContainerBlock?: Maybe<TabContainerBlockOutput>;
  TabItemBlock?: Maybe<TabItemBlockOutput>;
  TestimonialCardBlock?: Maybe<TestimonialCardBlockOutput>;
  TestimonialCarouselBlock?: Maybe<TestimonialCarouselBlockOutput>;
  TextPanelCtaBlock?: Maybe<TextPanelCtaBlockOutput>;
  TextareaElementBlock?: Maybe<TextareaElementBlockOutput>;
  TextboxElementBlock?: Maybe<TextboxElementBlockOutput>;
  ThirdPartyIFrameBlock?: Maybe<ThirdPartyIFrameBlockOutput>;
  UrlElementBlock?: Maybe<UrlElementBlockOutput>;
  VectorImageMediaData?: Maybe<VectorImageMediaDataOutput>;
  VideoContentPanelBlock?: Maybe<VideoContentPanelBlockOutput>;
  VideoFile?: Maybe<VideoFileOutput>;
  VisitorDataHiddenElementBlock?: Maybe<VisitorDataHiddenElementBlockOutput>;
  WasThisHelpfulBlock?: Maybe<WasThisHelpfulBlockOutput>;
  WebImageMediaData?: Maybe<WebImageMediaDataOutput>;
};

export type QueryAboutAuthorArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AboutAuthorOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AboutAuthorWhereInput>;
};

export type QueryAccordionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AccordionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AccordionBlockWhereInput>;
};

export type QueryAccordionSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AccordionSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AccordionSectionBlockWhereInput>;
};

export type QueryAdvisorListingBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AdvisorListingBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AdvisorListingBlockWhereInput>;
};

export type QueryAdvisorPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AdvisorPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AdvisorPageWhereInput>;
};

export type QueryAlertBannerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AlertBannerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AlertBannerBlockWhereInput>;
};

export type QueryAnchorBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AnchorBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AnchorBlockWhereInput>;
};

export type QueryAreYouMemberModalArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AreYouMemberModalOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AreYouMemberModalWhereInput>;
};

export type QueryAuthorPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AuthorPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AuthorPageWhereInput>;
};

export type QueryAutoAffordabilityCalculatorBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AutoAffordabilityCalculatorBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AutoAffordabilityCalculatorBlockWhereInput>;
};

export type QueryAutoPaymentCalculatorBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AutoPaymentCalculatorBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AutoPaymentCalculatorBlockWhereInput>;
};

export type QueryAutoRefinanceCalculatorBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AutoRefinanceCalculatorBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AutoRefinanceCalculatorBlockWhereInput>;
};

export type QueryBlockContentPodExpandCardBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BlockContentPodExpandCardBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<BlockContentPodExpandCardBlockWhereInput>;
};

export type QueryBlockContentPodGroupBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BlockContentPodGroupBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<BlockContentPodGroupBlockWhereInput>;
};

export type QueryBlockContentPodIconBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BlockContentPodIconBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<BlockContentPodIconBlockWhereInput>;
};

export type QueryBlockContentPodImageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BlockContentPodImageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<BlockContentPodImageBlockWhereInput>;
};

export type QueryBlogFeaturedPodModuleBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BlogFeaturedPodModuleBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<BlogFeaturedPodModuleBlockWhereInput>;
};

export type QueryBlogListingArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BlogListingOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<BlogListingWhereInput>;
};

export type QueryBlogPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BlogPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<BlogPageWhereInput>;
};

export type QueryBlogSignUpFormBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BlogSignUpFormBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<BlogSignUpFormBlockWhereInput>;
};

export type QueryButtonBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ButtonBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ButtonBlockWhereInput>;
};

export type QueryCalculatorPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CalculatorPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CalculatorPageWhereInput>;
};

export type QueryCaptchaElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CaptchaElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CaptchaElementBlockWhereInput>;
};

export type QueryCertificateOfDepositCalculatorBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CertificateOfDepositCalculatorBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CertificateOfDepositCalculatorBlockWhereInput>;
};

export type QueryChoiceElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ChoiceElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ChoiceElementBlockWhereInput>;
};

export type QueryCodingFileArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CodingFileOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CodingFileWhereInput>;
};

export type QueryComplexTableBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ComplexTableBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ComplexTableBlockWhereInput>;
};

export type QueryComplexTableColumnBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ComplexTableColumnBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ComplexTableColumnBlockWhereInput>;
};

export type QueryComplexTableHeaderBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ComplexTableHeaderBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ComplexTableHeaderBlockWhereInput>;
};

export type QueryComplexTableRowBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ComplexTableRowBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ComplexTableRowBlockWhereInput>;
};

export type QueryConsentBannerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ConsentBannerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ConsentBannerBlockWhereInput>;
};

export type QueryContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ContainerBlockWhereInput>;
};

export type QueryContainerWithSideRailBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContainerWithSideRailBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ContainerWithSideRailBlockWhereInput>;
};

export type QueryContentArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContentOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ContentWhereInput>;
};

export type QueryContentBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContentBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ContentBlockWhereInput>;
};

export type QueryContentPanelBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContentPanelBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ContentPanelBlockWhereInput>;
};

export type QueryContentPodBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContentPodBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ContentPodBlockWhereInput>;
};

export type QueryContentPodGroupBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContentPodGroupBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ContentPodGroupBlockWhereInput>;
};

export type QueryContentPodMultiRateCardBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContentPodMultiRateCardBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ContentPodMultiRateCardBlockWhereInput>;
};

export type QueryContentPodMultiRateGroupBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContentPodMultiRateGroupBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ContentPodMultiRateGroupBlockWhereInput>;
};

export type QueryCookieHiddenElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CookieHiddenElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CookieHiddenElementBlockWhereInput>;
};

export type QueryCountrySelectionElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CountrySelectionElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CountrySelectionElementBlockWhereInput>;
};

export type QueryCurrencyConverterBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CurrencyConverterBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CurrencyConverterBlockWhereInput>;
};

export type QueryCustomFormContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CustomFormContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CustomFormContainerBlockWhereInput>;
};

export type QueryDataArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<System_Locales>>>;
  orderBy?: InputMaybe<DataOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DataWhereInput>;
};

export type QueryDocumentMediaDataArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DocumentMediaDataOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DocumentMediaDataWhereInput>;
};

export type QueryErrorPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ErrorPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ErrorPageWhereInput>;
};

export type QueryExecutableMediaDataArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ExecutableMediaDataOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ExecutableMediaDataWhereInput>;
};

export type QueryExitIntentModalArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ExitIntentModalOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ExitIntentModalWhereInput>;
};

export type QueryFaqItemArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FaqItemOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FaqItemWhereInput>;
};

export type QueryFaqSchemaBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FaqSchemaBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FaqSchemaBlockWhereInput>;
};

export type QueryFeaturedSearchIconBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FeaturedSearchIconBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FeaturedSearchIconBlockWhereInput>;
};

export type QueryFiftyThirtyTwentyCalculatorBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FiftyThirtyTwentyCalculatorBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FiftyThirtyTwentyCalculatorBlockWhereInput>;
};

export type QueryFileUploadElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FileUploadElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FileUploadElementBlockWhereInput>;
};

export type QueryFolderPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FolderPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FolderPageWhereInput>;
};

export type QueryFooterBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FooterBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FooterBlockWhereInput>;
};

export type QueryFooterMenuLinksBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FooterMenuLinksBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FooterMenuLinksBlockWhereInput>;
};

export type QueryFootnoteSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FootnoteSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FootnoteSectionBlockWhereInput>;
};

export type QueryFormAssemblyBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FormAssemblyBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FormAssemblyBlockWhereInput>;
};

export type QueryFormContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FormContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FormContainerBlockWhereInput>;
};

export type QueryFormStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FormStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FormStepBlockWhereInput>;
};

export type QueryFullWidthVideoBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FullWidthVideoBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FullWidthVideoBlockWhereInput>;
};

export type QueryGlobalLabelsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GlobalLabelsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GlobalLabelsBlockWhereInput>;
};

export type QueryHeaderBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HeaderBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<HeaderBlockWhereInput>;
};

export type QueryHeroBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HeroBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<HeroBlockWhereInput>;
};

export type QueryHeroImageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HeroImageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<HeroImageBlockWhereInput>;
};

export type QueryHomeAffordabilityCalculatorBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HomeAffordabilityCalculatorBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<HomeAffordabilityCalculatorBlockWhereInput>;
};

export type QueryHomeEquityCalculatorBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HomeEquityCalculatorBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<HomeEquityCalculatorBlockWhereInput>;
};

export type QueryIFrameContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IFrameContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<IFrameContainerBlockWhereInput>;
};

export type QueryIframeCalculatorBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IframeCalculatorBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<IframeCalculatorBlockWhereInput>;
};

export type QueryImageChoiceElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageChoiceElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ImageChoiceElementBlockWhereInput>;
};

export type QueryImageMediaDataArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageMediaDataOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ImageMediaDataWhereInput>;
};

export type QueryInteriorContentPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<InteriorContentPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<InteriorContentPageWhereInput>;
};

export type QueryLocationPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LocationPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LocationPageWhereInput>;
};

export type QueryLocationsListingBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LocationsListingBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LocationsListingBlockWhereInput>;
};

export type QueryLoginModalBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LoginModalBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LoginModalBlockWhereInput>;
};

export type QueryLogoImageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LogoImageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LogoImageBlockWhereInput>;
};

export type QueryMenuItemBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MenuItemBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MenuItemBlockWhereInput>;
};

export type QueryMortgagePaymentCalculatorBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MortgagePaymentCalculatorBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MortgagePaymentCalculatorBlockWhereInput>;
};

export type QueryMortgageRatesQuickQuoteBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MortgageRatesQuickQuoteBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MortgageRatesQuickQuoteBlockWhereInput>;
};

export type QueryMortgageRefinanceCalculatorBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MortgageRefinanceCalculatorBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MortgageRefinanceCalculatorBlockWhereInput>;
};

export type QueryMultiLogoImageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MultiLogoImageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MultiLogoImageBlockWhereInput>;
};

export type QueryNavigationColumnBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NavigationColumnBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NavigationColumnBlockWhereInput>;
};

export type QueryNavigationItemLevel1BlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NavigationItemLevel1BlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NavigationItemLevel1BlockWhereInput>;
};

export type QueryNavigationItemLevel2BlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NavigationItemLevel2BlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NavigationItemLevel2BlockWhereInput>;
};

export type QueryNavigationItemLevel3BlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NavigationItemLevel3BlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NavigationItemLevel3BlockWhereInput>;
};

export type QueryNavigationMenuBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NavigationMenuBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NavigationMenuBlockWhereInput>;
};

export type QueryNewsListingArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NewsListingOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NewsListingWhereInput>;
};

export type QueryNewsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NewsPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NewsPageWhereInput>;
};

export type QueryNumberElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NumberElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NumberElementBlockWhereInput>;
};

export type QueryOrgSchemaBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<OrgSchemaBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<OrgSchemaBlockWhereInput>;
};

export type QueryParagraphTextElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ParagraphTextElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ParagraphTextElementBlockWhereInput>;
};

export type QueryPersonSchemaBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PersonSchemaBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PersonSchemaBlockWhereInput>;
};

export type QueryPredefinedHiddenElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PredefinedHiddenElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PredefinedHiddenElementBlockWhereInput>;
};

export type QueryProductPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ProductPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ProductPageWhereInput>;
};

export type QueryProfitPayoutCalculatorBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ProfitPayoutCalculatorBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ProfitPayoutCalculatorBlockWhereInput>;
};

export type QueryPromoBannerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PromoBannerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PromoBannerBlockWhereInput>;
};

export type QueryPromoCalloutBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PromoCalloutBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PromoCalloutBlockWhereInput>;
};

export type QueryPromoFooterBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PromoFooterBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PromoFooterBlockWhereInput>;
};

export type QueryPromoHeaderBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PromoHeaderBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PromoHeaderBlockWhereInput>;
};

export type QueryPromoHeroBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PromoHeroBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PromoHeroBlockWhereInput>;
};

export type QueryQuerystringHiddenElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<QuerystringHiddenElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<QuerystringHiddenElementBlockWhereInput>;
};

export type QueryRangeElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<RangeElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<RangeElementBlockWhereInput>;
};

export type QueryReCaptchaServiceElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ReCaptchaServiceElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ReCaptchaServiceElementBlockWhereInput>;
};

export type QueryRequestAppointmentWithAdvisorBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<RequestAppointmentWithAdvisorBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<RequestAppointmentWithAdvisorBlockWhereInput>;
};

export type QueryResetButtonElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ResetButtonElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ResetButtonElementBlockWhereInput>;
};

export type QuerySearchListingBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SearchListingBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SearchListingBlockWhereInput>;
};

export type QuerySearchMenuBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SearchMenuBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SearchMenuBlockWhereInput>;
};

export type QuerySelectionElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SelectionElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SelectionElementBlockWhereInput>;
};

export type QuerySendMyResultsFormBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SendMyResultsFormBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SendMyResultsFormBlockWhereInput>;
};

export type QuerySideBySideVideoBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SideBySideVideoBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SideBySideVideoBlockWhereInput>;
};

export type QuerySiderailCtaPodBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SiderailCtaPodBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SiderailCtaPodBlockWhereInput>;
};

export type QuerySignUpToNewsletterFormBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SignUpToNewsletterFormBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SignUpToNewsletterFormBlockWhereInput>;
};

export type QuerySimpleMastheadBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SimpleMastheadBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SimpleMastheadBlockWhereInput>;
};

export type QuerySimpleTableBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SimpleTableBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SimpleTableBlockWhereInput>;
};

export type QuerySiteDefinitionArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SiteDefinitionOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SiteDefinitionWhereInput>;
};

export type QuerySiteUrlPredefinedHiddenElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SiteUrlPredefinedHiddenElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SiteUrlPredefinedHiddenElementBlockWhereInput>;
};

export type QuerySocialMediaIconBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SocialMediaIconBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SocialMediaIconBlockWhereInput>;
};

export type QuerySocialSharingBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SocialSharingBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SocialSharingBlockWhereInput>;
};

export type QuerySpacerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SpacerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SpacerBlockWhereInput>;
};

export type QueryStandardFileArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<StandardFileOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<StandardFileWhereInput>;
};

export type QueryStartPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<StartPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<StartPageWhereInput>;
};

export type QuerySubmitButtonElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SubmitButtonElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SubmitButtonElementBlockWhereInput>;
};

export type QueryTabContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TabContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TabContainerBlockWhereInput>;
};

export type QueryTabItemBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TabItemBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TabItemBlockWhereInput>;
};

export type QueryTestimonialCardBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TestimonialCardBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TestimonialCardBlockWhereInput>;
};

export type QueryTestimonialCarouselBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TestimonialCarouselBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TestimonialCarouselBlockWhereInput>;
};

export type QueryTextPanelCtaBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TextPanelCtaBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TextPanelCtaBlockWhereInput>;
};

export type QueryTextareaElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TextareaElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TextareaElementBlockWhereInput>;
};

export type QueryTextboxElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TextboxElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TextboxElementBlockWhereInput>;
};

export type QueryThirdPartyIFrameBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ThirdPartyIFrameBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ThirdPartyIFrameBlockWhereInput>;
};

export type QueryUrlElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<UrlElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<UrlElementBlockWhereInput>;
};

export type QueryVectorImageMediaDataArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<VectorImageMediaDataOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<VectorImageMediaDataWhereInput>;
};

export type QueryVideoContentPanelBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<VideoContentPanelBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<VideoContentPanelBlockWhereInput>;
};

export type QueryVideoFileArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<VideoFileOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<VideoFileWhereInput>;
};

export type QueryVisitorDataHiddenElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<VisitorDataHiddenElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<VisitorDataHiddenElementBlockWhereInput>;
};

export type QueryWasThisHelpfulBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<WasThisHelpfulBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<WasThisHelpfulBlockWhereInput>;
};

export type QueryWebImageMediaDataArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<WebImageMediaDataOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<WebImageMediaDataWhereInput>;
};

export type QueryRef = {
  __typename?: 'QueryRef';
  AboutAuthor?: Maybe<AboutAuthorOutput>;
  AccordionBlock?: Maybe<AccordionBlockOutput>;
  AccordionSectionBlock?: Maybe<AccordionSectionBlockOutput>;
  AdvisorListingBlock?: Maybe<AdvisorListingBlockOutput>;
  AdvisorPage?: Maybe<AdvisorPageOutput>;
  AlertBannerBlock?: Maybe<AlertBannerBlockOutput>;
  AnchorBlock?: Maybe<AnchorBlockOutput>;
  AreYouMemberModal?: Maybe<AreYouMemberModalOutput>;
  AuthorPage?: Maybe<AuthorPageOutput>;
  AutoAffordabilityCalculatorBlock?: Maybe<AutoAffordabilityCalculatorBlockOutput>;
  AutoPaymentCalculatorBlock?: Maybe<AutoPaymentCalculatorBlockOutput>;
  AutoRefinanceCalculatorBlock?: Maybe<AutoRefinanceCalculatorBlockOutput>;
  BlockContentPodExpandCardBlock?: Maybe<BlockContentPodExpandCardBlockOutput>;
  BlockContentPodGroupBlock?: Maybe<BlockContentPodGroupBlockOutput>;
  BlockContentPodIconBlock?: Maybe<BlockContentPodIconBlockOutput>;
  BlockContentPodImageBlock?: Maybe<BlockContentPodImageBlockOutput>;
  BlogFeaturedPodModuleBlock?: Maybe<BlogFeaturedPodModuleBlockOutput>;
  BlogListing?: Maybe<BlogListingOutput>;
  BlogPage?: Maybe<BlogPageOutput>;
  BlogSignUpFormBlock?: Maybe<BlogSignUpFormBlockOutput>;
  ButtonBlock?: Maybe<ButtonBlockOutput>;
  CalculatorPage?: Maybe<CalculatorPageOutput>;
  CaptchaElementBlock?: Maybe<CaptchaElementBlockOutput>;
  CertificateOfDepositCalculatorBlock?: Maybe<CertificateOfDepositCalculatorBlockOutput>;
  ChoiceElementBlock?: Maybe<ChoiceElementBlockOutput>;
  CodingFile?: Maybe<CodingFileOutput>;
  ComplexTableBlock?: Maybe<ComplexTableBlockOutput>;
  ComplexTableColumnBlock?: Maybe<ComplexTableColumnBlockOutput>;
  ComplexTableHeaderBlock?: Maybe<ComplexTableHeaderBlockOutput>;
  ComplexTableRowBlock?: Maybe<ComplexTableRowBlockOutput>;
  ConsentBannerBlock?: Maybe<ConsentBannerBlockOutput>;
  ContainerBlock?: Maybe<ContainerBlockOutput>;
  ContainerWithSideRailBlock?: Maybe<ContainerWithSideRailBlockOutput>;
  Content?: Maybe<ContentOutput>;
  ContentBlock?: Maybe<ContentBlockOutput>;
  ContentPanelBlock?: Maybe<ContentPanelBlockOutput>;
  ContentPodBlock?: Maybe<ContentPodBlockOutput>;
  ContentPodGroupBlock?: Maybe<ContentPodGroupBlockOutput>;
  ContentPodMultiRateCardBlock?: Maybe<ContentPodMultiRateCardBlockOutput>;
  ContentPodMultiRateGroupBlock?: Maybe<ContentPodMultiRateGroupBlockOutput>;
  CookieHiddenElementBlock?: Maybe<CookieHiddenElementBlockOutput>;
  CountrySelectionElementBlock?: Maybe<CountrySelectionElementBlockOutput>;
  CurrencyConverterBlock?: Maybe<CurrencyConverterBlockOutput>;
  CustomFormContainerBlock?: Maybe<CustomFormContainerBlockOutput>;
  Data?: Maybe<DataOutput>;
  DocumentMediaData?: Maybe<DocumentMediaDataOutput>;
  ErrorPage?: Maybe<ErrorPageOutput>;
  ExecutableMediaData?: Maybe<ExecutableMediaDataOutput>;
  ExitIntentModal?: Maybe<ExitIntentModalOutput>;
  FaqItem?: Maybe<FaqItemOutput>;
  FaqSchemaBlock?: Maybe<FaqSchemaBlockOutput>;
  FeaturedSearchIconBlock?: Maybe<FeaturedSearchIconBlockOutput>;
  FiftyThirtyTwentyCalculatorBlock?: Maybe<FiftyThirtyTwentyCalculatorBlockOutput>;
  FileUploadElementBlock?: Maybe<FileUploadElementBlockOutput>;
  FolderPage?: Maybe<FolderPageOutput>;
  FooterBlock?: Maybe<FooterBlockOutput>;
  FooterMenuLinksBlock?: Maybe<FooterMenuLinksBlockOutput>;
  FootnoteSectionBlock?: Maybe<FootnoteSectionBlockOutput>;
  FormAssemblyBlock?: Maybe<FormAssemblyBlockOutput>;
  FormContainerBlock?: Maybe<FormContainerBlockOutput>;
  FormStepBlock?: Maybe<FormStepBlockOutput>;
  FullWidthVideoBlock?: Maybe<FullWidthVideoBlockOutput>;
  GlobalLabelsBlock?: Maybe<GlobalLabelsBlockOutput>;
  HeaderBlock?: Maybe<HeaderBlockOutput>;
  HeroBlock?: Maybe<HeroBlockOutput>;
  HeroImageBlock?: Maybe<HeroImageBlockOutput>;
  HomeAffordabilityCalculatorBlock?: Maybe<HomeAffordabilityCalculatorBlockOutput>;
  HomeEquityCalculatorBlock?: Maybe<HomeEquityCalculatorBlockOutput>;
  IFrameContainerBlock?: Maybe<IFrameContainerBlockOutput>;
  IframeCalculatorBlock?: Maybe<IframeCalculatorBlockOutput>;
  ImageChoiceElementBlock?: Maybe<ImageChoiceElementBlockOutput>;
  ImageMediaData?: Maybe<ImageMediaDataOutput>;
  InteriorContentPage?: Maybe<InteriorContentPageOutput>;
  LocationPage?: Maybe<LocationPageOutput>;
  LocationsListingBlock?: Maybe<LocationsListingBlockOutput>;
  LoginModalBlock?: Maybe<LoginModalBlockOutput>;
  LogoImageBlock?: Maybe<LogoImageBlockOutput>;
  MenuItemBlock?: Maybe<MenuItemBlockOutput>;
  MortgagePaymentCalculatorBlock?: Maybe<MortgagePaymentCalculatorBlockOutput>;
  MortgageRatesQuickQuoteBlock?: Maybe<MortgageRatesQuickQuoteBlockOutput>;
  MortgageRefinanceCalculatorBlock?: Maybe<MortgageRefinanceCalculatorBlockOutput>;
  MultiLogoImageBlock?: Maybe<MultiLogoImageBlockOutput>;
  NavigationColumnBlock?: Maybe<NavigationColumnBlockOutput>;
  NavigationItemLevel1Block?: Maybe<NavigationItemLevel1BlockOutput>;
  NavigationItemLevel2Block?: Maybe<NavigationItemLevel2BlockOutput>;
  NavigationItemLevel3Block?: Maybe<NavigationItemLevel3BlockOutput>;
  NavigationMenuBlock?: Maybe<NavigationMenuBlockOutput>;
  NewsListing?: Maybe<NewsListingOutput>;
  NewsPage?: Maybe<NewsPageOutput>;
  NumberElementBlock?: Maybe<NumberElementBlockOutput>;
  OrgSchemaBlock?: Maybe<OrgSchemaBlockOutput>;
  ParagraphTextElementBlock?: Maybe<ParagraphTextElementBlockOutput>;
  PersonSchemaBlock?: Maybe<PersonSchemaBlockOutput>;
  PredefinedHiddenElementBlock?: Maybe<PredefinedHiddenElementBlockOutput>;
  ProductPage?: Maybe<ProductPageOutput>;
  ProfitPayoutCalculatorBlock?: Maybe<ProfitPayoutCalculatorBlockOutput>;
  PromoBannerBlock?: Maybe<PromoBannerBlockOutput>;
  PromoCalloutBlock?: Maybe<PromoCalloutBlockOutput>;
  PromoFooterBlock?: Maybe<PromoFooterBlockOutput>;
  PromoHeaderBlock?: Maybe<PromoHeaderBlockOutput>;
  PromoHeroBlock?: Maybe<PromoHeroBlockOutput>;
  QuerystringHiddenElementBlock?: Maybe<QuerystringHiddenElementBlockOutput>;
  RangeElementBlock?: Maybe<RangeElementBlockOutput>;
  ReCaptchaServiceElementBlock?: Maybe<ReCaptchaServiceElementBlockOutput>;
  RequestAppointmentWithAdvisorBlock?: Maybe<RequestAppointmentWithAdvisorBlockOutput>;
  ResetButtonElementBlock?: Maybe<ResetButtonElementBlockOutput>;
  SearchListingBlock?: Maybe<SearchListingBlockOutput>;
  SearchMenuBlock?: Maybe<SearchMenuBlockOutput>;
  SelectionElementBlock?: Maybe<SelectionElementBlockOutput>;
  SendMyResultsFormBlock?: Maybe<SendMyResultsFormBlockOutput>;
  SideBySideVideoBlock?: Maybe<SideBySideVideoBlockOutput>;
  SiderailCtaPodBlock?: Maybe<SiderailCtaPodBlockOutput>;
  SignUpToNewsletterFormBlock?: Maybe<SignUpToNewsletterFormBlockOutput>;
  SimpleMastheadBlock?: Maybe<SimpleMastheadBlockOutput>;
  SimpleTableBlock?: Maybe<SimpleTableBlockOutput>;
  SiteDefinition?: Maybe<SiteDefinitionOutput>;
  SiteUrlPredefinedHiddenElementBlock?: Maybe<SiteUrlPredefinedHiddenElementBlockOutput>;
  SocialMediaIconBlock?: Maybe<SocialMediaIconBlockOutput>;
  SocialSharingBlock?: Maybe<SocialSharingBlockOutput>;
  SpacerBlock?: Maybe<SpacerBlockOutput>;
  StandardFile?: Maybe<StandardFileOutput>;
  StartPage?: Maybe<StartPageOutput>;
  SubmitButtonElementBlock?: Maybe<SubmitButtonElementBlockOutput>;
  TabContainerBlock?: Maybe<TabContainerBlockOutput>;
  TabItemBlock?: Maybe<TabItemBlockOutput>;
  TestimonialCardBlock?: Maybe<TestimonialCardBlockOutput>;
  TestimonialCarouselBlock?: Maybe<TestimonialCarouselBlockOutput>;
  TextPanelCtaBlock?: Maybe<TextPanelCtaBlockOutput>;
  TextareaElementBlock?: Maybe<TextareaElementBlockOutput>;
  TextboxElementBlock?: Maybe<TextboxElementBlockOutput>;
  ThirdPartyIFrameBlock?: Maybe<ThirdPartyIFrameBlockOutput>;
  UrlElementBlock?: Maybe<UrlElementBlockOutput>;
  VectorImageMediaData?: Maybe<VectorImageMediaDataOutput>;
  VideoContentPanelBlock?: Maybe<VideoContentPanelBlockOutput>;
  VideoFile?: Maybe<VideoFileOutput>;
  VisitorDataHiddenElementBlock?: Maybe<VisitorDataHiddenElementBlockOutput>;
  WasThisHelpfulBlock?: Maybe<WasThisHelpfulBlockOutput>;
  WebImageMediaData?: Maybe<WebImageMediaDataOutput>;
};

export type QueryRefAboutAuthorArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AboutAuthorOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AboutAuthorWhereInput>;
};

export type QueryRefAccordionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AccordionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AccordionBlockWhereInput>;
};

export type QueryRefAccordionSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AccordionSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AccordionSectionBlockWhereInput>;
};

export type QueryRefAdvisorListingBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AdvisorListingBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AdvisorListingBlockWhereInput>;
};

export type QueryRefAdvisorPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AdvisorPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AdvisorPageWhereInput>;
};

export type QueryRefAlertBannerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AlertBannerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AlertBannerBlockWhereInput>;
};

export type QueryRefAnchorBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AnchorBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AnchorBlockWhereInput>;
};

export type QueryRefAreYouMemberModalArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AreYouMemberModalOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AreYouMemberModalWhereInput>;
};

export type QueryRefAuthorPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AuthorPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AuthorPageWhereInput>;
};

export type QueryRefAutoAffordabilityCalculatorBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AutoAffordabilityCalculatorBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AutoAffordabilityCalculatorBlockWhereInput>;
};

export type QueryRefAutoPaymentCalculatorBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AutoPaymentCalculatorBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AutoPaymentCalculatorBlockWhereInput>;
};

export type QueryRefAutoRefinanceCalculatorBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AutoRefinanceCalculatorBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AutoRefinanceCalculatorBlockWhereInput>;
};

export type QueryRefBlockContentPodExpandCardBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BlockContentPodExpandCardBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<BlockContentPodExpandCardBlockWhereInput>;
};

export type QueryRefBlockContentPodGroupBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BlockContentPodGroupBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<BlockContentPodGroupBlockWhereInput>;
};

export type QueryRefBlockContentPodIconBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BlockContentPodIconBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<BlockContentPodIconBlockWhereInput>;
};

export type QueryRefBlockContentPodImageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BlockContentPodImageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<BlockContentPodImageBlockWhereInput>;
};

export type QueryRefBlogFeaturedPodModuleBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BlogFeaturedPodModuleBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<BlogFeaturedPodModuleBlockWhereInput>;
};

export type QueryRefBlogListingArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BlogListingOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<BlogListingWhereInput>;
};

export type QueryRefBlogPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BlogPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<BlogPageWhereInput>;
};

export type QueryRefBlogSignUpFormBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BlogSignUpFormBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<BlogSignUpFormBlockWhereInput>;
};

export type QueryRefButtonBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ButtonBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ButtonBlockWhereInput>;
};

export type QueryRefCalculatorPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CalculatorPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CalculatorPageWhereInput>;
};

export type QueryRefCaptchaElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CaptchaElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CaptchaElementBlockWhereInput>;
};

export type QueryRefCertificateOfDepositCalculatorBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CertificateOfDepositCalculatorBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CertificateOfDepositCalculatorBlockWhereInput>;
};

export type QueryRefChoiceElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ChoiceElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ChoiceElementBlockWhereInput>;
};

export type QueryRefCodingFileArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CodingFileOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CodingFileWhereInput>;
};

export type QueryRefComplexTableBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ComplexTableBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ComplexTableBlockWhereInput>;
};

export type QueryRefComplexTableColumnBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ComplexTableColumnBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ComplexTableColumnBlockWhereInput>;
};

export type QueryRefComplexTableHeaderBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ComplexTableHeaderBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ComplexTableHeaderBlockWhereInput>;
};

export type QueryRefComplexTableRowBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ComplexTableRowBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ComplexTableRowBlockWhereInput>;
};

export type QueryRefConsentBannerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ConsentBannerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ConsentBannerBlockWhereInput>;
};

export type QueryRefContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ContainerBlockWhereInput>;
};

export type QueryRefContainerWithSideRailBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContainerWithSideRailBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ContainerWithSideRailBlockWhereInput>;
};

export type QueryRefContentArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContentOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ContentWhereInput>;
};

export type QueryRefContentBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContentBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ContentBlockWhereInput>;
};

export type QueryRefContentPanelBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContentPanelBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ContentPanelBlockWhereInput>;
};

export type QueryRefContentPodBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContentPodBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ContentPodBlockWhereInput>;
};

export type QueryRefContentPodGroupBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContentPodGroupBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ContentPodGroupBlockWhereInput>;
};

export type QueryRefContentPodMultiRateCardBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContentPodMultiRateCardBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ContentPodMultiRateCardBlockWhereInput>;
};

export type QueryRefContentPodMultiRateGroupBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContentPodMultiRateGroupBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ContentPodMultiRateGroupBlockWhereInput>;
};

export type QueryRefCookieHiddenElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CookieHiddenElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CookieHiddenElementBlockWhereInput>;
};

export type QueryRefCountrySelectionElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CountrySelectionElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CountrySelectionElementBlockWhereInput>;
};

export type QueryRefCurrencyConverterBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CurrencyConverterBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CurrencyConverterBlockWhereInput>;
};

export type QueryRefCustomFormContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CustomFormContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CustomFormContainerBlockWhereInput>;
};

export type QueryRefDataArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<System_Locales>>>;
  orderBy?: InputMaybe<DataOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DataWhereInput>;
};

export type QueryRefDocumentMediaDataArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DocumentMediaDataOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DocumentMediaDataWhereInput>;
};

export type QueryRefErrorPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ErrorPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ErrorPageWhereInput>;
};

export type QueryRefExecutableMediaDataArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ExecutableMediaDataOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ExecutableMediaDataWhereInput>;
};

export type QueryRefExitIntentModalArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ExitIntentModalOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ExitIntentModalWhereInput>;
};

export type QueryRefFaqItemArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FaqItemOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FaqItemWhereInput>;
};

export type QueryRefFaqSchemaBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FaqSchemaBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FaqSchemaBlockWhereInput>;
};

export type QueryRefFeaturedSearchIconBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FeaturedSearchIconBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FeaturedSearchIconBlockWhereInput>;
};

export type QueryRefFiftyThirtyTwentyCalculatorBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FiftyThirtyTwentyCalculatorBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FiftyThirtyTwentyCalculatorBlockWhereInput>;
};

export type QueryRefFileUploadElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FileUploadElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FileUploadElementBlockWhereInput>;
};

export type QueryRefFolderPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FolderPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FolderPageWhereInput>;
};

export type QueryRefFooterBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FooterBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FooterBlockWhereInput>;
};

export type QueryRefFooterMenuLinksBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FooterMenuLinksBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FooterMenuLinksBlockWhereInput>;
};

export type QueryRefFootnoteSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FootnoteSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FootnoteSectionBlockWhereInput>;
};

export type QueryRefFormAssemblyBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FormAssemblyBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FormAssemblyBlockWhereInput>;
};

export type QueryRefFormContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FormContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FormContainerBlockWhereInput>;
};

export type QueryRefFormStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FormStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FormStepBlockWhereInput>;
};

export type QueryRefFullWidthVideoBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FullWidthVideoBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FullWidthVideoBlockWhereInput>;
};

export type QueryRefGlobalLabelsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GlobalLabelsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GlobalLabelsBlockWhereInput>;
};

export type QueryRefHeaderBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HeaderBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<HeaderBlockWhereInput>;
};

export type QueryRefHeroBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HeroBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<HeroBlockWhereInput>;
};

export type QueryRefHeroImageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HeroImageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<HeroImageBlockWhereInput>;
};

export type QueryRefHomeAffordabilityCalculatorBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HomeAffordabilityCalculatorBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<HomeAffordabilityCalculatorBlockWhereInput>;
};

export type QueryRefHomeEquityCalculatorBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HomeEquityCalculatorBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<HomeEquityCalculatorBlockWhereInput>;
};

export type QueryRefIFrameContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IFrameContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<IFrameContainerBlockWhereInput>;
};

export type QueryRefIframeCalculatorBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IframeCalculatorBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<IframeCalculatorBlockWhereInput>;
};

export type QueryRefImageChoiceElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageChoiceElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ImageChoiceElementBlockWhereInput>;
};

export type QueryRefImageMediaDataArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageMediaDataOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ImageMediaDataWhereInput>;
};

export type QueryRefInteriorContentPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<InteriorContentPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<InteriorContentPageWhereInput>;
};

export type QueryRefLocationPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LocationPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LocationPageWhereInput>;
};

export type QueryRefLocationsListingBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LocationsListingBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LocationsListingBlockWhereInput>;
};

export type QueryRefLoginModalBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LoginModalBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LoginModalBlockWhereInput>;
};

export type QueryRefLogoImageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LogoImageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LogoImageBlockWhereInput>;
};

export type QueryRefMenuItemBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MenuItemBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MenuItemBlockWhereInput>;
};

export type QueryRefMortgagePaymentCalculatorBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MortgagePaymentCalculatorBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MortgagePaymentCalculatorBlockWhereInput>;
};

export type QueryRefMortgageRatesQuickQuoteBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MortgageRatesQuickQuoteBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MortgageRatesQuickQuoteBlockWhereInput>;
};

export type QueryRefMortgageRefinanceCalculatorBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MortgageRefinanceCalculatorBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MortgageRefinanceCalculatorBlockWhereInput>;
};

export type QueryRefMultiLogoImageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MultiLogoImageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MultiLogoImageBlockWhereInput>;
};

export type QueryRefNavigationColumnBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NavigationColumnBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NavigationColumnBlockWhereInput>;
};

export type QueryRefNavigationItemLevel1BlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NavigationItemLevel1BlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NavigationItemLevel1BlockWhereInput>;
};

export type QueryRefNavigationItemLevel2BlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NavigationItemLevel2BlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NavigationItemLevel2BlockWhereInput>;
};

export type QueryRefNavigationItemLevel3BlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NavigationItemLevel3BlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NavigationItemLevel3BlockWhereInput>;
};

export type QueryRefNavigationMenuBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NavigationMenuBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NavigationMenuBlockWhereInput>;
};

export type QueryRefNewsListingArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NewsListingOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NewsListingWhereInput>;
};

export type QueryRefNewsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NewsPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NewsPageWhereInput>;
};

export type QueryRefNumberElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NumberElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NumberElementBlockWhereInput>;
};

export type QueryRefOrgSchemaBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<OrgSchemaBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<OrgSchemaBlockWhereInput>;
};

export type QueryRefParagraphTextElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ParagraphTextElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ParagraphTextElementBlockWhereInput>;
};

export type QueryRefPersonSchemaBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PersonSchemaBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PersonSchemaBlockWhereInput>;
};

export type QueryRefPredefinedHiddenElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PredefinedHiddenElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PredefinedHiddenElementBlockWhereInput>;
};

export type QueryRefProductPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ProductPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ProductPageWhereInput>;
};

export type QueryRefProfitPayoutCalculatorBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ProfitPayoutCalculatorBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ProfitPayoutCalculatorBlockWhereInput>;
};

export type QueryRefPromoBannerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PromoBannerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PromoBannerBlockWhereInput>;
};

export type QueryRefPromoCalloutBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PromoCalloutBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PromoCalloutBlockWhereInput>;
};

export type QueryRefPromoFooterBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PromoFooterBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PromoFooterBlockWhereInput>;
};

export type QueryRefPromoHeaderBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PromoHeaderBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PromoHeaderBlockWhereInput>;
};

export type QueryRefPromoHeroBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PromoHeroBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PromoHeroBlockWhereInput>;
};

export type QueryRefQuerystringHiddenElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<QuerystringHiddenElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<QuerystringHiddenElementBlockWhereInput>;
};

export type QueryRefRangeElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<RangeElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<RangeElementBlockWhereInput>;
};

export type QueryRefReCaptchaServiceElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ReCaptchaServiceElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ReCaptchaServiceElementBlockWhereInput>;
};

export type QueryRefRequestAppointmentWithAdvisorBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<RequestAppointmentWithAdvisorBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<RequestAppointmentWithAdvisorBlockWhereInput>;
};

export type QueryRefResetButtonElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ResetButtonElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ResetButtonElementBlockWhereInput>;
};

export type QueryRefSearchListingBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SearchListingBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SearchListingBlockWhereInput>;
};

export type QueryRefSearchMenuBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SearchMenuBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SearchMenuBlockWhereInput>;
};

export type QueryRefSelectionElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SelectionElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SelectionElementBlockWhereInput>;
};

export type QueryRefSendMyResultsFormBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SendMyResultsFormBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SendMyResultsFormBlockWhereInput>;
};

export type QueryRefSideBySideVideoBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SideBySideVideoBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SideBySideVideoBlockWhereInput>;
};

export type QueryRefSiderailCtaPodBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SiderailCtaPodBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SiderailCtaPodBlockWhereInput>;
};

export type QueryRefSignUpToNewsletterFormBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SignUpToNewsletterFormBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SignUpToNewsletterFormBlockWhereInput>;
};

export type QueryRefSimpleMastheadBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SimpleMastheadBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SimpleMastheadBlockWhereInput>;
};

export type QueryRefSimpleTableBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SimpleTableBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SimpleTableBlockWhereInput>;
};

export type QueryRefSiteDefinitionArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SiteDefinitionOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SiteDefinitionWhereInput>;
};

export type QueryRefSiteUrlPredefinedHiddenElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SiteUrlPredefinedHiddenElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SiteUrlPredefinedHiddenElementBlockWhereInput>;
};

export type QueryRefSocialMediaIconBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SocialMediaIconBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SocialMediaIconBlockWhereInput>;
};

export type QueryRefSocialSharingBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SocialSharingBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SocialSharingBlockWhereInput>;
};

export type QueryRefSpacerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SpacerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SpacerBlockWhereInput>;
};

export type QueryRefStandardFileArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<StandardFileOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<StandardFileWhereInput>;
};

export type QueryRefStartPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<StartPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<StartPageWhereInput>;
};

export type QueryRefSubmitButtonElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SubmitButtonElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SubmitButtonElementBlockWhereInput>;
};

export type QueryRefTabContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TabContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TabContainerBlockWhereInput>;
};

export type QueryRefTabItemBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TabItemBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TabItemBlockWhereInput>;
};

export type QueryRefTestimonialCardBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TestimonialCardBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TestimonialCardBlockWhereInput>;
};

export type QueryRefTestimonialCarouselBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TestimonialCarouselBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TestimonialCarouselBlockWhereInput>;
};

export type QueryRefTextPanelCtaBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TextPanelCtaBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TextPanelCtaBlockWhereInput>;
};

export type QueryRefTextareaElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TextareaElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TextareaElementBlockWhereInput>;
};

export type QueryRefTextboxElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TextboxElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TextboxElementBlockWhereInput>;
};

export type QueryRefThirdPartyIFrameBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ThirdPartyIFrameBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ThirdPartyIFrameBlockWhereInput>;
};

export type QueryRefUrlElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<UrlElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<UrlElementBlockWhereInput>;
};

export type QueryRefVectorImageMediaDataArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<VectorImageMediaDataOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<VectorImageMediaDataWhereInput>;
};

export type QueryRefVideoContentPanelBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<VideoContentPanelBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<VideoContentPanelBlockWhereInput>;
};

export type QueryRefVideoFileArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<VideoFileOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<VideoFileWhereInput>;
};

export type QueryRefVisitorDataHiddenElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<VisitorDataHiddenElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<VisitorDataHiddenElementBlockWhereInput>;
};

export type QueryRefWasThisHelpfulBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<WasThisHelpfulBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<WasThisHelpfulBlockWhereInput>;
};

export type QueryRefWebImageMediaDataArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<WebImageMediaDataOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<WebImageMediaDataWhereInput>;
};

export type QuerystringHiddenElementBlock = IContent &
  IData & {
    __typename?: 'QuerystringHiddenElementBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    PredefinedValue?: Maybe<Scalars['String']['output']>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

export type QuerystringHiddenElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type QuerystringHiddenElementBlockPredefinedValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type QuerystringHiddenElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type QuerystringHiddenElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type QuerystringHiddenElementBlockAutocomplete = {
  __typename?: 'QuerystringHiddenElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type QuerystringHiddenElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type QuerystringHiddenElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type QuerystringHiddenElementBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type QuerystringHiddenElementBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type QuerystringHiddenElementBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type QuerystringHiddenElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type QuerystringHiddenElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type QuerystringHiddenElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type QuerystringHiddenElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type QuerystringHiddenElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type QuerystringHiddenElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type QuerystringHiddenElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type QuerystringHiddenElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type QuerystringHiddenElementBlockFacet = {
  __typename?: 'QuerystringHiddenElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PredefinedValue?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type QuerystringHiddenElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type QuerystringHiddenElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerystringHiddenElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type QuerystringHiddenElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerystringHiddenElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type QuerystringHiddenElementBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type QuerystringHiddenElementBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type QuerystringHiddenElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type QuerystringHiddenElementBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type QuerystringHiddenElementBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerystringHiddenElementBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type QuerystringHiddenElementBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type QuerystringHiddenElementBlockFacetPredefinedValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type QuerystringHiddenElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type QuerystringHiddenElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type QuerystringHiddenElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerystringHiddenElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type QuerystringHiddenElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type QuerystringHiddenElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type QuerystringHiddenElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerystringHiddenElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type QuerystringHiddenElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerystringHiddenElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type QuerystringHiddenElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type QuerystringHiddenElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type QuerystringHiddenElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PredefinedValue?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type QuerystringHiddenElementBlockOutput = {
  __typename?: 'QuerystringHiddenElementBlockOutput';
  autocomplete?: Maybe<QuerystringHiddenElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<QuerystringHiddenElementBlockFacet>;
  item?: Maybe<QuerystringHiddenElementBlock>;
  items?: Maybe<Array<Maybe<QuerystringHiddenElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type QuerystringHiddenElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerystringHiddenElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PredefinedValue?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<QuerystringHiddenElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<QuerystringHiddenElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<QuerystringHiddenElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type RangeElementBlock = IContent &
  IData & {
    __typename?: 'RangeElementBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ConditionCombination?: Maybe<Scalars['Int']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Label?: Maybe<Scalars['String']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Max?: Maybe<Scalars['Int']['output']>;
    Min?: Maybe<Scalars['Int']['output']>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    PredefinedValue?: Maybe<Scalars['String']['output']>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    SatisfiedAction?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    Step?: Maybe<Scalars['Int']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

export type RangeElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type RangeElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type RangeElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type RangeElementBlockPredefinedValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type RangeElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type RangeElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type RangeElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type RangeElementBlockAutocomplete = {
  __typename?: 'RangeElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type RangeElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RangeElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RangeElementBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RangeElementBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RangeElementBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RangeElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RangeElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RangeElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RangeElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RangeElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RangeElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RangeElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RangeElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RangeElementBlockFacet = {
  __typename?: 'RangeElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Max?: Maybe<Array<Maybe<NumberFacet>>>;
  Min?: Maybe<Array<Maybe<NumberFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PredefinedValue?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  Step?: Maybe<Array<Maybe<NumberFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type RangeElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RangeElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type RangeElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type RangeElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RangeElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type RangeElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RangeElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RangeElementBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RangeElementBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RangeElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RangeElementBlockFacetMaxArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type RangeElementBlockFacetMinArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type RangeElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RangeElementBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RangeElementBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type RangeElementBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RangeElementBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RangeElementBlockFacetPredefinedValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RangeElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RangeElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RangeElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RangeElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type RangeElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RangeElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RangeElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RangeElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type RangeElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RangeElementBlockFacetStepArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type RangeElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type RangeElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RangeElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RangeElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type RangeElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Max?: InputMaybe<OrderBy>;
  Min?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PredefinedValue?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  Step?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type RangeElementBlockOutput = {
  __typename?: 'RangeElementBlockOutput';
  autocomplete?: Maybe<RangeElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<RangeElementBlockFacet>;
  item?: Maybe<RangeElementBlock>;
  items?: Maybe<Array<Maybe<RangeElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type RangeElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RangeElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Max?: InputMaybe<IntFilterInput>;
  Min?: InputMaybe<IntFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PredefinedValue?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  Step?: InputMaybe<IntFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<RangeElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<RangeElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<RangeElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type RangeFacetsInput = {
  from?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Int']['input']>;
};

export enum Ranking {
  BoostOnly = 'BOOST_ONLY',
  Doc = 'DOC',
  Relevance = 'RELEVANCE',
  Semantic = 'SEMANTIC'
}

export type ReCaptchaServiceElementBlock = IContent &
  IData & {
    __typename?: 'ReCaptchaServiceElementBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    /** An element to hold form name */
    FormName?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Label?: Maybe<Scalars['String']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    /** An element to hold Recaptcha key */
    ReCaptchaKey?: Maybe<Scalars['String']['output']>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

export type ReCaptchaServiceElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ReCaptchaServiceElementBlockFormNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ReCaptchaServiceElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ReCaptchaServiceElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ReCaptchaServiceElementBlockReCaptchaKeyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ReCaptchaServiceElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ReCaptchaServiceElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ReCaptchaServiceElementBlockAutocomplete = {
  __typename?: 'ReCaptchaServiceElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ReCaptchaServiceElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ReCaptchaServiceElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ReCaptchaServiceElementBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ReCaptchaServiceElementBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ReCaptchaServiceElementBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ReCaptchaServiceElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ReCaptchaServiceElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ReCaptchaServiceElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ReCaptchaServiceElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ReCaptchaServiceElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ReCaptchaServiceElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ReCaptchaServiceElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ReCaptchaServiceElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ReCaptchaServiceElementBlockFacet = {
  __typename?: 'ReCaptchaServiceElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FormName?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  ReCaptchaKey?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type ReCaptchaServiceElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ReCaptchaServiceElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ReCaptchaServiceElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ReCaptchaServiceElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ReCaptchaServiceElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ReCaptchaServiceElementBlockFacetFormNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ReCaptchaServiceElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ReCaptchaServiceElementBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ReCaptchaServiceElementBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ReCaptchaServiceElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ReCaptchaServiceElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ReCaptchaServiceElementBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ReCaptchaServiceElementBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ReCaptchaServiceElementBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ReCaptchaServiceElementBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ReCaptchaServiceElementBlockFacetReCaptchaKeyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ReCaptchaServiceElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ReCaptchaServiceElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ReCaptchaServiceElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ReCaptchaServiceElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ReCaptchaServiceElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ReCaptchaServiceElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ReCaptchaServiceElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ReCaptchaServiceElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ReCaptchaServiceElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ReCaptchaServiceElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ReCaptchaServiceElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ReCaptchaServiceElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ReCaptchaServiceElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FormName?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ReCaptchaKey?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ReCaptchaServiceElementBlockOutput = {
  __typename?: 'ReCaptchaServiceElementBlockOutput';
  autocomplete?: Maybe<ReCaptchaServiceElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ReCaptchaServiceElementBlockFacet>;
  item?: Maybe<ReCaptchaServiceElementBlock>;
  items?: Maybe<Array<Maybe<ReCaptchaServiceElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ReCaptchaServiceElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReCaptchaServiceElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FormName?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ReCaptchaKey?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ReCaptchaServiceElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ReCaptchaServiceElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ReCaptchaServiceElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Request Appointment with Advisor form */
export type RequestAppointmentWithAdvisorBlock = IContent &
  IData & {
    __typename?: 'RequestAppointmentWithAdvisorBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    EmailAddressLabel?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    FirstNameLabel?: Maybe<Scalars['String']['output']>;
    Headline?: Maybe<Scalars['String']['output']>;
    HowDidYouHearAboutUsLabel?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    LastNameLabel?: Maybe<Scalars['String']['output']>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    MessageLabel?: Maybe<Scalars['String']['output']>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    PhoneNumberLabel?: Maybe<Scalars['String']['output']>;
    ReferenceList?: Maybe<Scalars['String']['output']>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    SubjectLabel?: Maybe<Scalars['String']['output']>;
    SubjectList?: Maybe<Scalars['String']['output']>;
    SubmitButtonText?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    UserEmail?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Request Appointment with Advisor form */
export type RequestAppointmentWithAdvisorBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Request Appointment with Advisor form */
export type RequestAppointmentWithAdvisorBlockEmailAddressLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Request Appointment with Advisor form */
export type RequestAppointmentWithAdvisorBlockFirstNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Request Appointment with Advisor form */
export type RequestAppointmentWithAdvisorBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Request Appointment with Advisor form */
export type RequestAppointmentWithAdvisorBlockHowDidYouHearAboutUsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Request Appointment with Advisor form */
export type RequestAppointmentWithAdvisorBlockLastNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Request Appointment with Advisor form */
export type RequestAppointmentWithAdvisorBlockMessageLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Request Appointment with Advisor form */
export type RequestAppointmentWithAdvisorBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Request Appointment with Advisor form */
export type RequestAppointmentWithAdvisorBlockPhoneNumberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Request Appointment with Advisor form */
export type RequestAppointmentWithAdvisorBlockReferenceListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Request Appointment with Advisor form */
export type RequestAppointmentWithAdvisorBlockSubjectLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Request Appointment with Advisor form */
export type RequestAppointmentWithAdvisorBlockSubjectListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Request Appointment with Advisor form */
export type RequestAppointmentWithAdvisorBlockSubmitButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Request Appointment with Advisor form */
export type RequestAppointmentWithAdvisorBlockUserEmailArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Request Appointment with Advisor form */
export type RequestAppointmentWithAdvisorBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Request Appointment with Advisor form */
export type RequestAppointmentWithAdvisorBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type RequestAppointmentWithAdvisorBlockAutocomplete = {
  __typename?: 'RequestAppointmentWithAdvisorBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type RequestAppointmentWithAdvisorBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RequestAppointmentWithAdvisorBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RequestAppointmentWithAdvisorBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RequestAppointmentWithAdvisorBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RequestAppointmentWithAdvisorBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RequestAppointmentWithAdvisorBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RequestAppointmentWithAdvisorBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RequestAppointmentWithAdvisorBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RequestAppointmentWithAdvisorBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RequestAppointmentWithAdvisorBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RequestAppointmentWithAdvisorBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RequestAppointmentWithAdvisorBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RequestAppointmentWithAdvisorBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RequestAppointmentWithAdvisorBlockFacet = {
  __typename?: 'RequestAppointmentWithAdvisorBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  EmailAddressLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FirstNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  HowDidYouHearAboutUsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LastNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MessageLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PhoneNumberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ReferenceList?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SubjectLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SubjectList?: Maybe<Array<Maybe<StringFacet>>>;
  SubmitButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  UserEmail?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type RequestAppointmentWithAdvisorBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RequestAppointmentWithAdvisorBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type RequestAppointmentWithAdvisorBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RequestAppointmentWithAdvisorBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type RequestAppointmentWithAdvisorBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RequestAppointmentWithAdvisorBlockFacetEmailAddressLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RequestAppointmentWithAdvisorBlockFacetFirstNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RequestAppointmentWithAdvisorBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RequestAppointmentWithAdvisorBlockFacetHowDidYouHearAboutUsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RequestAppointmentWithAdvisorBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RequestAppointmentWithAdvisorBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RequestAppointmentWithAdvisorBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RequestAppointmentWithAdvisorBlockFacetLastNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RequestAppointmentWithAdvisorBlockFacetMessageLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RequestAppointmentWithAdvisorBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RequestAppointmentWithAdvisorBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RequestAppointmentWithAdvisorBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type RequestAppointmentWithAdvisorBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RequestAppointmentWithAdvisorBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RequestAppointmentWithAdvisorBlockFacetPhoneNumberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RequestAppointmentWithAdvisorBlockFacetReferenceListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RequestAppointmentWithAdvisorBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RequestAppointmentWithAdvisorBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RequestAppointmentWithAdvisorBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type RequestAppointmentWithAdvisorBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RequestAppointmentWithAdvisorBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RequestAppointmentWithAdvisorBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RequestAppointmentWithAdvisorBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type RequestAppointmentWithAdvisorBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RequestAppointmentWithAdvisorBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type RequestAppointmentWithAdvisorBlockFacetSubjectLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RequestAppointmentWithAdvisorBlockFacetSubjectListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RequestAppointmentWithAdvisorBlockFacetSubmitButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RequestAppointmentWithAdvisorBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RequestAppointmentWithAdvisorBlockFacetUserEmailArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RequestAppointmentWithAdvisorBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RequestAppointmentWithAdvisorBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type RequestAppointmentWithAdvisorBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  EmailAddressLabel?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FirstNameLabel?: InputMaybe<OrderBy>;
  Headline?: InputMaybe<OrderBy>;
  HowDidYouHearAboutUsLabel?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LastNameLabel?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MessageLabel?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PhoneNumberLabel?: InputMaybe<OrderBy>;
  ReferenceList?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SubjectLabel?: InputMaybe<OrderBy>;
  SubjectList?: InputMaybe<OrderBy>;
  SubmitButtonText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  UserEmail?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type RequestAppointmentWithAdvisorBlockOutput = {
  __typename?: 'RequestAppointmentWithAdvisorBlockOutput';
  autocomplete?: Maybe<RequestAppointmentWithAdvisorBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<RequestAppointmentWithAdvisorBlockFacet>;
  item?: Maybe<RequestAppointmentWithAdvisorBlock>;
  items?: Maybe<Array<Maybe<RequestAppointmentWithAdvisorBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type RequestAppointmentWithAdvisorBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RequestAppointmentWithAdvisorBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  EmailAddressLabel?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FirstNameLabel?: InputMaybe<SearchableStringFilterInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  HowDidYouHearAboutUsLabel?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LastNameLabel?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MessageLabel?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PhoneNumberLabel?: InputMaybe<SearchableStringFilterInput>;
  ReferenceList?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SubjectLabel?: InputMaybe<SearchableStringFilterInput>;
  SubjectList?: InputMaybe<SearchableStringFilterInput>;
  SubmitButtonText?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  UserEmail?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<RequestAppointmentWithAdvisorBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<RequestAppointmentWithAdvisorBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<RequestAppointmentWithAdvisorBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ResetButtonElementBlock = IContent &
  IData & {
    __typename?: 'ResetButtonElementBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Label?: Maybe<Scalars['String']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

export type ResetButtonElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ResetButtonElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ResetButtonElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ResetButtonElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ResetButtonElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ResetButtonElementBlockAutocomplete = {
  __typename?: 'ResetButtonElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ResetButtonElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ResetButtonElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ResetButtonElementBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ResetButtonElementBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ResetButtonElementBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ResetButtonElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ResetButtonElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ResetButtonElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ResetButtonElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ResetButtonElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ResetButtonElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ResetButtonElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ResetButtonElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ResetButtonElementBlockFacet = {
  __typename?: 'ResetButtonElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type ResetButtonElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ResetButtonElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ResetButtonElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ResetButtonElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ResetButtonElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ResetButtonElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ResetButtonElementBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ResetButtonElementBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ResetButtonElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ResetButtonElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ResetButtonElementBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ResetButtonElementBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ResetButtonElementBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ResetButtonElementBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ResetButtonElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ResetButtonElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ResetButtonElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ResetButtonElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ResetButtonElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ResetButtonElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ResetButtonElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ResetButtonElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ResetButtonElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ResetButtonElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ResetButtonElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ResetButtonElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ResetButtonElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ResetButtonElementBlockOutput = {
  __typename?: 'ResetButtonElementBlockOutput';
  autocomplete?: Maybe<ResetButtonElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ResetButtonElementBlockFacet>;
  item?: Maybe<ResetButtonElementBlock>;
  items?: Maybe<Array<Maybe<ResetButtonElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ResetButtonElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResetButtonElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ResetButtonElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ResetButtonElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ResetButtonElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Block for displaying search results, and to be used in Interior Page. */
export type SearchListingBlock = IContent &
  IData & {
    __typename?: 'SearchListingBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /** Appears when the search returns no results. */
    CancelLastActionText?: Maybe<Scalars['String']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ClearAllFiltersLabel?: Maybe<Scalars['String']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    /** Indicates above the results the date range that the user selected. */
    DateRangeSelectedText?: Maybe<Scalars['String']['output']>;
    DateSliderLabel?: Maybe<Scalars['String']['output']>;
    DateSortLabel?: Maybe<Scalars['String']['output']>;
    ErrorLoadingResultsText?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    FacetsTypeLabel?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    MobileFilterButtonLabel?: Maybe<Scalars['String']['output']>;
    Name?: Maybe<Scalars['String']['output']>;
    /** Appears when the search returns no results. The searched keyword is append at the end. */
    NoResultsHeadline?: Maybe<Scalars['String']['output']>;
    /** Appears when no facets match the entered keyword. */
    NoValuesFoundFilterLabel?: Maybe<Scalars['String']['output']>;
    NumberOfResultsPerPage?: Maybe<Scalars['Int']['output']>;
    /** Everything after the pipe '|' will only be shown when a keyword is search. Please use the token: <br>${1} the number of results <br>${2} final results of the page <br>${3} total number of results<br>${4} keyword searched */
    NumberOfResultsText?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RelevancySortLabel?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    SearchBarPlaceholderText?: Maybe<Scalars['String']['output']>;
    /** Appears when the search returns no results. */
    SearchTips?: Maybe<Scalars['String']['output']>;
    /** Appears when the search returns no results. */
    SearchTipsHeadline?: Maybe<Scalars['String']['output']>;
    /** Appears below the types filters to select more types. */
    SearchTypesText?: Maybe<Scalars['String']['output']>;
    SelectAllFilterLabel?: Maybe<Scalars['String']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    /** Indicates above the results the types that the user has selected. */
    TypesSelectedText?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Block for displaying search results, and to be used in Interior Page. */
export type SearchListingBlockCancelLastActionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Block for displaying search results, and to be used in Interior Page. */
export type SearchListingBlockClearAllFiltersLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Block for displaying search results, and to be used in Interior Page. */
export type SearchListingBlockDateRangeSelectedTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Block for displaying search results, and to be used in Interior Page. */
export type SearchListingBlockDateSliderLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Block for displaying search results, and to be used in Interior Page. */
export type SearchListingBlockDateSortLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Block for displaying search results, and to be used in Interior Page. */
export type SearchListingBlockErrorLoadingResultsTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Block for displaying search results, and to be used in Interior Page. */
export type SearchListingBlockFacetsTypeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Block for displaying search results, and to be used in Interior Page. */
export type SearchListingBlockMobileFilterButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Block for displaying search results, and to be used in Interior Page. */
export type SearchListingBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Block for displaying search results, and to be used in Interior Page. */
export type SearchListingBlockNoResultsHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Block for displaying search results, and to be used in Interior Page. */
export type SearchListingBlockNoValuesFoundFilterLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Block for displaying search results, and to be used in Interior Page. */
export type SearchListingBlockNumberOfResultsTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Block for displaying search results, and to be used in Interior Page. */
export type SearchListingBlockRelevancySortLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Block for displaying search results, and to be used in Interior Page. */
export type SearchListingBlockSearchBarPlaceholderTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Block for displaying search results, and to be used in Interior Page. */
export type SearchListingBlockSearchTipsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Block for displaying search results, and to be used in Interior Page. */
export type SearchListingBlockSearchTipsHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Block for displaying search results, and to be used in Interior Page. */
export type SearchListingBlockSearchTypesTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Block for displaying search results, and to be used in Interior Page. */
export type SearchListingBlockSelectAllFilterLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Block for displaying search results, and to be used in Interior Page. */
export type SearchListingBlockTypesSelectedTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Block for displaying search results, and to be used in Interior Page. */
export type SearchListingBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Block for displaying search results, and to be used in Interior Page. */
export type SearchListingBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SearchListingBlockAutocomplete = {
  __typename?: 'SearchListingBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SearchListingBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SearchListingBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SearchListingBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SearchListingBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SearchListingBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SearchListingBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SearchListingBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SearchListingBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SearchListingBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SearchListingBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SearchListingBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SearchListingBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SearchListingBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SearchListingBlockFacet = {
  __typename?: 'SearchListingBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  CancelLastActionText?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ClearAllFiltersLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DateRangeSelectedText?: Maybe<Array<Maybe<StringFacet>>>;
  DateSliderLabel?: Maybe<Array<Maybe<StringFacet>>>;
  DateSortLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorLoadingResultsText?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FacetsTypeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MobileFilterButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NoResultsHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  NoValuesFoundFilterLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NumberOfResultsPerPage?: Maybe<Array<Maybe<NumberFacet>>>;
  NumberOfResultsText?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RelevancySortLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchBarPlaceholderText?: Maybe<Array<Maybe<StringFacet>>>;
  SearchTips?: Maybe<Array<Maybe<StringFacet>>>;
  SearchTipsHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  SearchTypesText?: Maybe<Array<Maybe<StringFacet>>>;
  SelectAllFilterLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TypesSelectedText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type SearchListingBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetCancelLastActionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchListingBlockFacetClearAllFiltersLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchListingBlockFacetDateRangeSelectedTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetDateSliderLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetDateSortLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetErrorLoadingResultsTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetFacetsTypeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetMobileFilterButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetNoResultsHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetNoValuesFoundFilterLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetNumberOfResultsPerPageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SearchListingBlockFacetNumberOfResultsTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchListingBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetRelevancySortLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchListingBlockFacetSearchBarPlaceholderTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetSearchTipsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetSearchTipsHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetSearchTypesTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetSelectAllFilterLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchListingBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchListingBlockFacetTypesSelectedTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchListingBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SearchListingBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  CancelLastActionText?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ClearAllFiltersLabel?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DateRangeSelectedText?: InputMaybe<OrderBy>;
  DateSliderLabel?: InputMaybe<OrderBy>;
  DateSortLabel?: InputMaybe<OrderBy>;
  ErrorLoadingResultsText?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FacetsTypeLabel?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MobileFilterButtonLabel?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NoResultsHeadline?: InputMaybe<OrderBy>;
  NoValuesFoundFilterLabel?: InputMaybe<OrderBy>;
  NumberOfResultsPerPage?: InputMaybe<OrderBy>;
  NumberOfResultsText?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RelevancySortLabel?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchBarPlaceholderText?: InputMaybe<OrderBy>;
  SearchTips?: InputMaybe<OrderBy>;
  SearchTipsHeadline?: InputMaybe<OrderBy>;
  SearchTypesText?: InputMaybe<OrderBy>;
  SelectAllFilterLabel?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TypesSelectedText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SearchListingBlockOutput = {
  __typename?: 'SearchListingBlockOutput';
  autocomplete?: Maybe<SearchListingBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SearchListingBlockFacet>;
  item?: Maybe<SearchListingBlock>;
  items?: Maybe<Array<Maybe<SearchListingBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchListingBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchListingBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  CancelLastActionText?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ClearAllFiltersLabel?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DateRangeSelectedText?: InputMaybe<SearchableStringFilterInput>;
  DateSliderLabel?: InputMaybe<SearchableStringFilterInput>;
  DateSortLabel?: InputMaybe<SearchableStringFilterInput>;
  ErrorLoadingResultsText?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FacetsTypeLabel?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MobileFilterButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NoResultsHeadline?: InputMaybe<SearchableStringFilterInput>;
  NoValuesFoundFilterLabel?: InputMaybe<SearchableStringFilterInput>;
  NumberOfResultsPerPage?: InputMaybe<IntFilterInput>;
  NumberOfResultsText?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RelevancySortLabel?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchBarPlaceholderText?: InputMaybe<SearchableStringFilterInput>;
  SearchTips?: InputMaybe<SearchableStringFilterInput>;
  SearchTipsHeadline?: InputMaybe<SearchableStringFilterInput>;
  SearchTypesText?: InputMaybe<SearchableStringFilterInput>;
  SelectAllFilterLabel?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TypesSelectedText?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SearchListingBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SearchListingBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SearchListingBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Enable users to input a keyword and perform a search on the site. */
export type SearchMenuBlock = IContent &
  IData & {
    __typename?: 'SearchMenuBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    /** Content authors have the ability to set 5 Featured Search Icons. */
    FeaturedSearchIcons?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    Heading?: Maybe<Scalars['String']['output']>;
    /** Instructive Text will now be displayed as placeholder text in the Search Bar.  */
    InstructiveText?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    /** When users start typing into the Search Bar, after they type the n character a list of Search Suggestions is displayed. */
    PredictiveSearchMinCharacters?: Maybe<Scalars['Int']['output']>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    /** Search suggestions will include page titles that contain the keyword. All content types will be treated equally, with no priority given to any specific type. */
    SearchSuggestionsNumber?: Maybe<Scalars['Int']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Enable users to input a keyword and perform a search on the site. */
export type SearchMenuBlockFeaturedSearchIconsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Enable users to input a keyword and perform a search on the site. */
export type SearchMenuBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Enable users to input a keyword and perform a search on the site. */
export type SearchMenuBlockInstructiveTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Enable users to input a keyword and perform a search on the site. */
export type SearchMenuBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Enable users to input a keyword and perform a search on the site. */
export type SearchMenuBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Enable users to input a keyword and perform a search on the site. */
export type SearchMenuBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SearchMenuBlockAutocomplete = {
  __typename?: 'SearchMenuBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SearchMenuBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SearchMenuBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SearchMenuBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SearchMenuBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SearchMenuBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SearchMenuBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SearchMenuBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SearchMenuBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SearchMenuBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SearchMenuBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SearchMenuBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SearchMenuBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SearchMenuBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SearchMenuBlockFacet = {
  __typename?: 'SearchMenuBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FeaturedSearchIcons?: Maybe<ContentAreaItemModelSearchFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  InstructiveText?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PredictiveSearchMinCharacters?: Maybe<Array<Maybe<NumberFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchSuggestionsNumber?: Maybe<Array<Maybe<NumberFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type SearchMenuBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchMenuBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchMenuBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchMenuBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchMenuBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchMenuBlockFacetInstructiveTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchMenuBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchMenuBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchMenuBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchMenuBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchMenuBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchMenuBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchMenuBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchMenuBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchMenuBlockFacetPredictiveSearchMinCharactersArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SearchMenuBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchMenuBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchMenuBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchMenuBlockFacetSearchSuggestionsNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SearchMenuBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchMenuBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchMenuBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchMenuBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchMenuBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchMenuBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchMenuBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchMenuBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchMenuBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SearchMenuBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FeaturedSearchIcons?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  InstructiveText?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PredictiveSearchMinCharacters?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchSuggestionsNumber?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SearchMenuBlockOutput = {
  __typename?: 'SearchMenuBlockOutput';
  autocomplete?: Maybe<SearchMenuBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SearchMenuBlockFacet>;
  item?: Maybe<SearchMenuBlock>;
  items?: Maybe<Array<Maybe<SearchMenuBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchMenuBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchMenuBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FeaturedSearchIcons?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  InstructiveText?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PredictiveSearchMinCharacters?: InputMaybe<IntFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchSuggestionsNumber?: InputMaybe<IntFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SearchMenuBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SearchMenuBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SearchMenuBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type SearchableStringFilterInput = {
  /** `boost` influences the weight of a field by boosting a match with a number (default: 1) — counts more towards the eventual relevance score which can be projected with `_score` — at query time. Note that `boost` cannot be a negative number. */
  boost?: InputMaybe<Scalars['Int']['input']>;
  /** `contains` performs full-text search on a word or phrase. */
  contains?: InputMaybe<Scalars['String']['input']>;
  /** `eq` matches on an exact value, but the value is case-insensitive. */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** `exist` matches results that have this field. */
  exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** enables supporting fuzzy matching on the query terms (keywords), which returns items that contain terms in the content similar to the keywords, as measured by a _Levenshtein edit distance_. An edit distance is the number of one-character changes needed to turn one term into another. The edit distance is based on the length of the term.  */
  fuzzy?: InputMaybe<Scalars['Boolean']['input']>;
  /** `in` matches with 1 or more exact values in a list. Example: `in: ["word1", "word2", "this is a phrase"]` */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** `like` matches on substrings with wildcard support: `%` to match on 0 or more characters, `_` to match on any character.  */
  like?: InputMaybe<Scalars['String']['input']>;
  /** `match` performs full-text search on a word or phrase where less relevant items are also returned. The `match` operator is only supported for `searchable` fields. It will improve fulltext search by making it easier to match on words. More exact matches will be ranked higher, less exact matches will be ranked lower. The `match` operator is supported with synonyms and fuzzy search. */
  match?: InputMaybe<Scalars['String']['input']>;
  /** `not_eq` retrieves results not matching with an exact (but case-insensitive) value. */
  notEq?: InputMaybe<Scalars['String']['input']>;
  /** `not_in` returns results that do not match with 1 or more exact values in a list. Example: `not_in: ["word1", "word2", "this is a phrase"]` */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** `starts_with` retrieves matches that start with a certain value (prefix). */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** expands query value with synonyms. Example: if `H2O` is a synonym of `water`, then querying for `water` will also return results with `H2O`. */
  synonyms?: InputMaybe<Array<InputMaybe<SynonymSlot>>>;
};

export type SelectionElementBlock = IContent &
  IData & {
    __typename?: 'SelectionElementBlock';
    AllowMultiSelect?: Maybe<Scalars['Bool']['output']>;
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    AutoComplete?: Maybe<Scalars['Int']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ConditionCombination?: Maybe<Scalars['Int']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Feed?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Label?: Maybe<Scalars['String']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    PlaceHolder?: Maybe<Scalars['String']['output']>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    SatisfiedAction?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    Validators?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

export type SelectionElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SelectionElementBlockFeedArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SelectionElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SelectionElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SelectionElementBlockPlaceHolderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SelectionElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SelectionElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SelectionElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SelectionElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SelectionElementBlockAutocomplete = {
  __typename?: 'SelectionElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SelectionElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SelectionElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SelectionElementBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SelectionElementBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SelectionElementBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SelectionElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SelectionElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SelectionElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SelectionElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SelectionElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SelectionElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SelectionElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SelectionElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SelectionElementBlockFacet = {
  __typename?: 'SelectionElementBlockFacet';
  AllowMultiSelect?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AutoComplete?: Maybe<Array<Maybe<NumberFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Feed?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PlaceHolder?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type SelectionElementBlockFacetAllowMultiSelectArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SelectionElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SelectionElementBlockFacetAutoCompleteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SelectionElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SelectionElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SelectionElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SelectionElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SelectionElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SelectionElementBlockFacetFeedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SelectionElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SelectionElementBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SelectionElementBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SelectionElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SelectionElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SelectionElementBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SelectionElementBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SelectionElementBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SelectionElementBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SelectionElementBlockFacetPlaceHolderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SelectionElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SelectionElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SelectionElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SelectionElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SelectionElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SelectionElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SelectionElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SelectionElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SelectionElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SelectionElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SelectionElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SelectionElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SelectionElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SelectionElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SelectionElementBlockOrderByInput = {
  AllowMultiSelect?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AutoComplete?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Feed?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PlaceHolder?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SelectionElementBlockOutput = {
  __typename?: 'SelectionElementBlockOutput';
  autocomplete?: Maybe<SelectionElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SelectionElementBlockFacet>;
  item?: Maybe<SelectionElementBlock>;
  items?: Maybe<Array<Maybe<SelectionElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SelectionElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SelectionElementBlockWhereInput = {
  AllowMultiSelect?: InputMaybe<BoolFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AutoComplete?: InputMaybe<IntFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Feed?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PlaceHolder?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SelectionElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SelectionElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SelectionElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Send my results form to be used with Calculator modules */
export type SendMyResultsFormBlock = IContent &
  IData & {
    __typename?: 'SendMyResultsFormBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    EmailAddressLabel?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    FirstNameLabel?: Maybe<Scalars['String']['output']>;
    HaveASpecialistCallMeLabel?: Maybe<Scalars['String']['output']>;
    InternalEmail?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    LastNameLabel?: Maybe<Scalars['String']['output']>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    PhoneNumberLabel?: Maybe<Scalars['String']['output']>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    SendMeSpecialOffersLabel?: Maybe<Scalars['String']['output']>;
    SendMyResultsLabel?: Maybe<Scalars['String']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    SubmitButtonLabel?: Maybe<Scalars['String']['output']>;
    ThankYouPage?: Maybe<LinkItemNode>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Send my results form to be used with Calculator modules */
export type SendMyResultsFormBlockEmailAddressLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Send my results form to be used with Calculator modules */
export type SendMyResultsFormBlockFirstNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Send my results form to be used with Calculator modules */
export type SendMyResultsFormBlockHaveASpecialistCallMeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Send my results form to be used with Calculator modules */
export type SendMyResultsFormBlockInternalEmailArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Send my results form to be used with Calculator modules */
export type SendMyResultsFormBlockLastNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Send my results form to be used with Calculator modules */
export type SendMyResultsFormBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Send my results form to be used with Calculator modules */
export type SendMyResultsFormBlockPhoneNumberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Send my results form to be used with Calculator modules */
export type SendMyResultsFormBlockSendMeSpecialOffersLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Send my results form to be used with Calculator modules */
export type SendMyResultsFormBlockSendMyResultsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Send my results form to be used with Calculator modules */
export type SendMyResultsFormBlockSubmitButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Send my results form to be used with Calculator modules */
export type SendMyResultsFormBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Send my results form to be used with Calculator modules */
export type SendMyResultsFormBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SendMyResultsFormBlockAutocomplete = {
  __typename?: 'SendMyResultsFormBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThankYouPage?: Maybe<LinkItemNodeAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SendMyResultsFormBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SendMyResultsFormBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SendMyResultsFormBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SendMyResultsFormBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SendMyResultsFormBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SendMyResultsFormBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SendMyResultsFormBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SendMyResultsFormBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SendMyResultsFormBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SendMyResultsFormBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SendMyResultsFormBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SendMyResultsFormBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SendMyResultsFormBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SendMyResultsFormBlockFacet = {
  __typename?: 'SendMyResultsFormBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  EmailAddressLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FirstNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  HaveASpecialistCallMeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  InternalEmail?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LastNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PhoneNumberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SendMeSpecialOffersLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SendMyResultsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SubmitButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ThankYouPage?: Maybe<LinkItemNodeFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type SendMyResultsFormBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SendMyResultsFormBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SendMyResultsFormBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SendMyResultsFormBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SendMyResultsFormBlockFacetEmailAddressLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SendMyResultsFormBlockFacetFirstNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SendMyResultsFormBlockFacetHaveASpecialistCallMeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SendMyResultsFormBlockFacetInternalEmailArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SendMyResultsFormBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SendMyResultsFormBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SendMyResultsFormBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SendMyResultsFormBlockFacetLastNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SendMyResultsFormBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SendMyResultsFormBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SendMyResultsFormBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SendMyResultsFormBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SendMyResultsFormBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SendMyResultsFormBlockFacetPhoneNumberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SendMyResultsFormBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SendMyResultsFormBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SendMyResultsFormBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SendMyResultsFormBlockFacetSendMeSpecialOffersLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SendMyResultsFormBlockFacetSendMyResultsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SendMyResultsFormBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SendMyResultsFormBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SendMyResultsFormBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SendMyResultsFormBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SendMyResultsFormBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SendMyResultsFormBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SendMyResultsFormBlockFacetSubmitButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SendMyResultsFormBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SendMyResultsFormBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SendMyResultsFormBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SendMyResultsFormBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  EmailAddressLabel?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FirstNameLabel?: InputMaybe<OrderBy>;
  HaveASpecialistCallMeLabel?: InputMaybe<OrderBy>;
  InternalEmail?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LastNameLabel?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PhoneNumberLabel?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SendMeSpecialOffersLabel?: InputMaybe<OrderBy>;
  SendMyResultsLabel?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SubmitButtonLabel?: InputMaybe<OrderBy>;
  ThankYouPage?: InputMaybe<LinkItemNodeOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SendMyResultsFormBlockOutput = {
  __typename?: 'SendMyResultsFormBlockOutput';
  autocomplete?: Maybe<SendMyResultsFormBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SendMyResultsFormBlockFacet>;
  item?: Maybe<SendMyResultsFormBlock>;
  items?: Maybe<Array<Maybe<SendMyResultsFormBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SendMyResultsFormBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SendMyResultsFormBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  EmailAddressLabel?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FirstNameLabel?: InputMaybe<SearchableStringFilterInput>;
  HaveASpecialistCallMeLabel?: InputMaybe<SearchableStringFilterInput>;
  InternalEmail?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LastNameLabel?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PhoneNumberLabel?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SendMeSpecialOffersLabel?: InputMaybe<SearchableStringFilterInput>;
  SendMyResultsLabel?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SubmitButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ThankYouPage?: InputMaybe<LinkItemNodeWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SendMyResultsFormBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SendMyResultsFormBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SendMyResultsFormBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Allow content authors to add video side by side */
export type SideBySideVideoBlock = IContent &
  IData & {
    __typename?: 'SideBySideVideoBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    LeftVideoDescription?: Maybe<Scalars['String']['output']>;
    LeftVideoEmbeddedCode?: Maybe<Scalars['String']['output']>;
    LeftVideoSalesForceId?: Maybe<Scalars['String']['output']>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RightVideoDescription?: Maybe<Scalars['String']['output']>;
    RightVideoEmbeddedCode?: Maybe<Scalars['String']['output']>;
    RightVideoSalesForceId?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Allow content authors to add video side by side */
export type SideBySideVideoBlockLeftVideoDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add video side by side */
export type SideBySideVideoBlockLeftVideoEmbeddedCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add video side by side */
export type SideBySideVideoBlockLeftVideoSalesForceIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add video side by side */
export type SideBySideVideoBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add video side by side */
export type SideBySideVideoBlockRightVideoDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add video side by side */
export type SideBySideVideoBlockRightVideoEmbeddedCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add video side by side */
export type SideBySideVideoBlockRightVideoSalesForceIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add video side by side */
export type SideBySideVideoBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add video side by side */
export type SideBySideVideoBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SideBySideVideoBlockAutocomplete = {
  __typename?: 'SideBySideVideoBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SideBySideVideoBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SideBySideVideoBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SideBySideVideoBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SideBySideVideoBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SideBySideVideoBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SideBySideVideoBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SideBySideVideoBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SideBySideVideoBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SideBySideVideoBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SideBySideVideoBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SideBySideVideoBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SideBySideVideoBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SideBySideVideoBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SideBySideVideoBlockFacet = {
  __typename?: 'SideBySideVideoBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LeftVideoDescription?: Maybe<Array<Maybe<StringFacet>>>;
  LeftVideoEmbeddedCode?: Maybe<Array<Maybe<StringFacet>>>;
  LeftVideoSalesForceId?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RightVideoDescription?: Maybe<Array<Maybe<StringFacet>>>;
  RightVideoEmbeddedCode?: Maybe<Array<Maybe<StringFacet>>>;
  RightVideoSalesForceId?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type SideBySideVideoBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SideBySideVideoBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SideBySideVideoBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SideBySideVideoBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SideBySideVideoBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SideBySideVideoBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SideBySideVideoBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SideBySideVideoBlockFacetLeftVideoDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SideBySideVideoBlockFacetLeftVideoEmbeddedCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SideBySideVideoBlockFacetLeftVideoSalesForceIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SideBySideVideoBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SideBySideVideoBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SideBySideVideoBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SideBySideVideoBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SideBySideVideoBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SideBySideVideoBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SideBySideVideoBlockFacetRightVideoDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SideBySideVideoBlockFacetRightVideoEmbeddedCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SideBySideVideoBlockFacetRightVideoSalesForceIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SideBySideVideoBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SideBySideVideoBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SideBySideVideoBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SideBySideVideoBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SideBySideVideoBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SideBySideVideoBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SideBySideVideoBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SideBySideVideoBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SideBySideVideoBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SideBySideVideoBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SideBySideVideoBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SideBySideVideoBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LeftVideoDescription?: InputMaybe<OrderBy>;
  LeftVideoEmbeddedCode?: InputMaybe<OrderBy>;
  LeftVideoSalesForceId?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RightVideoDescription?: InputMaybe<OrderBy>;
  RightVideoEmbeddedCode?: InputMaybe<OrderBy>;
  RightVideoSalesForceId?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SideBySideVideoBlockOutput = {
  __typename?: 'SideBySideVideoBlockOutput';
  autocomplete?: Maybe<SideBySideVideoBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SideBySideVideoBlockFacet>;
  item?: Maybe<SideBySideVideoBlock>;
  items?: Maybe<Array<Maybe<SideBySideVideoBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SideBySideVideoBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SideBySideVideoBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LeftVideoDescription?: InputMaybe<SearchableStringFilterInput>;
  LeftVideoEmbeddedCode?: InputMaybe<SearchableStringFilterInput>;
  LeftVideoSalesForceId?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RightVideoDescription?: InputMaybe<SearchableStringFilterInput>;
  RightVideoEmbeddedCode?: InputMaybe<SearchableStringFilterInput>;
  RightVideoSalesForceId?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SideBySideVideoBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SideBySideVideoBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SideBySideVideoBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Siderail CTA Pod component that can be used on any page. */
export type SiderailCtaPodBlock = IContent &
  IData & {
    __typename?: 'SiderailCtaPodBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    BodyText?: Maybe<Scalars['String']['output']>;
    CTA?: Maybe<LinkItemNode>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ComponentColor?: Maybe<Scalars['String']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Siderail CTA Pod component that can be used on any page. */
export type SiderailCtaPodBlockBodyTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Siderail CTA Pod component that can be used on any page. */
export type SiderailCtaPodBlockComponentColorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Siderail CTA Pod component that can be used on any page. */
export type SiderailCtaPodBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Siderail CTA Pod component that can be used on any page. */
export type SiderailCtaPodBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Siderail CTA Pod component that can be used on any page. */
export type SiderailCtaPodBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Siderail CTA Pod component that can be used on any page. */
export type SiderailCtaPodBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SiderailCtaPodBlockAutocomplete = {
  __typename?: 'SiderailCtaPodBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CTA?: Maybe<LinkItemNodeAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SiderailCtaPodBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiderailCtaPodBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiderailCtaPodBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiderailCtaPodBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiderailCtaPodBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiderailCtaPodBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiderailCtaPodBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiderailCtaPodBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiderailCtaPodBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiderailCtaPodBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiderailCtaPodBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiderailCtaPodBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiderailCtaPodBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiderailCtaPodBlockFacet = {
  __typename?: 'SiderailCtaPodBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BodyText?: Maybe<Array<Maybe<StringFacet>>>;
  CTA?: Maybe<LinkItemNodeFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ComponentColor?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type SiderailCtaPodBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiderailCtaPodBlockFacetBodyTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiderailCtaPodBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SiderailCtaPodBlockFacetComponentColorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiderailCtaPodBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiderailCtaPodBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SiderailCtaPodBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiderailCtaPodBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiderailCtaPodBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiderailCtaPodBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiderailCtaPodBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiderailCtaPodBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiderailCtaPodBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SiderailCtaPodBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiderailCtaPodBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiderailCtaPodBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiderailCtaPodBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiderailCtaPodBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SiderailCtaPodBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiderailCtaPodBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiderailCtaPodBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiderailCtaPodBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SiderailCtaPodBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiderailCtaPodBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SiderailCtaPodBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiderailCtaPodBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiderailCtaPodBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SiderailCtaPodBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BodyText?: InputMaybe<OrderBy>;
  CTA?: InputMaybe<LinkItemNodeOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ComponentColor?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SiderailCtaPodBlockOutput = {
  __typename?: 'SiderailCtaPodBlockOutput';
  autocomplete?: Maybe<SiderailCtaPodBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SiderailCtaPodBlockFacet>;
  item?: Maybe<SiderailCtaPodBlock>;
  items?: Maybe<Array<Maybe<SiderailCtaPodBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SiderailCtaPodBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SiderailCtaPodBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BodyText?: InputMaybe<SearchableStringFilterInput>;
  CTA?: InputMaybe<LinkItemNodeWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ComponentColor?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SiderailCtaPodBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SiderailCtaPodBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SiderailCtaPodBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Sign Up Form allows users to sign up for CACU newsletter. */
export type SignUpToNewsletterFormBlock = IContent &
  IData & {
    __typename?: 'SignUpToNewsletterFormBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    AppLogo?: Maybe<ContentModelReference>;
    AppStoreImage?: Maybe<ContentModelReference>;
    BodyText?: Maybe<Scalars['String']['output']>;
    /** Content-managed label for the sign-up button. */
    CTALabel?: Maybe<Scalars['String']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    /** Plain short text displayed on desktop next to App Logo. */
    DesktopAppText?: Maybe<Scalars['String']['output']>;
    EmailPlaceholder?: Maybe<Scalars['String']['output']>;
    /** Rich text displayed after an error in the form submission. */
    ErrorMessage?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    FirstNamePlaceholder?: Maybe<Scalars['String']['output']>;
    GooglePlayImage?: Maybe<ContentModelReference>;
    Headline?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    LastNamePlaceholder?: Maybe<Scalars['String']['output']>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    /** Plain short text prompting users to "Download the App" on mobile view. */
    MobileAppText?: Maybe<Scalars['String']['output']>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    Source?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    /** Rich text displayed after successful form submission. */
    SuccessMessage?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Sign Up Form allows users to sign up for CACU newsletter. */
export type SignUpToNewsletterFormBlockBodyTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Sign Up Form allows users to sign up for CACU newsletter. */
export type SignUpToNewsletterFormBlockCtaLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Sign Up Form allows users to sign up for CACU newsletter. */
export type SignUpToNewsletterFormBlockDesktopAppTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Sign Up Form allows users to sign up for CACU newsletter. */
export type SignUpToNewsletterFormBlockEmailPlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Sign Up Form allows users to sign up for CACU newsletter. */
export type SignUpToNewsletterFormBlockErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Sign Up Form allows users to sign up for CACU newsletter. */
export type SignUpToNewsletterFormBlockFirstNamePlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Sign Up Form allows users to sign up for CACU newsletter. */
export type SignUpToNewsletterFormBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Sign Up Form allows users to sign up for CACU newsletter. */
export type SignUpToNewsletterFormBlockLastNamePlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Sign Up Form allows users to sign up for CACU newsletter. */
export type SignUpToNewsletterFormBlockMobileAppTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Sign Up Form allows users to sign up for CACU newsletter. */
export type SignUpToNewsletterFormBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Sign Up Form allows users to sign up for CACU newsletter. */
export type SignUpToNewsletterFormBlockSourceArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Sign Up Form allows users to sign up for CACU newsletter. */
export type SignUpToNewsletterFormBlockSuccessMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Sign Up Form allows users to sign up for CACU newsletter. */
export type SignUpToNewsletterFormBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Sign Up Form allows users to sign up for CACU newsletter. */
export type SignUpToNewsletterFormBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SignUpToNewsletterFormBlockAutocomplete = {
  __typename?: 'SignUpToNewsletterFormBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AppLogo?: Maybe<ContentModelReferenceAutocomplete>;
  AppStoreImage?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  GooglePlayImage?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SignUpToNewsletterFormBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SignUpToNewsletterFormBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SignUpToNewsletterFormBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SignUpToNewsletterFormBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SignUpToNewsletterFormBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SignUpToNewsletterFormBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SignUpToNewsletterFormBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SignUpToNewsletterFormBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SignUpToNewsletterFormBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SignUpToNewsletterFormBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SignUpToNewsletterFormBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SignUpToNewsletterFormBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SignUpToNewsletterFormBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SignUpToNewsletterFormBlockFacet = {
  __typename?: 'SignUpToNewsletterFormBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AppLogo?: Maybe<ContentModelReferenceFacet>;
  AppStoreImage?: Maybe<ContentModelReferenceFacet>;
  BodyText?: Maybe<Array<Maybe<StringFacet>>>;
  CTALabel?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DesktopAppText?: Maybe<Array<Maybe<StringFacet>>>;
  EmailPlaceholder?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FirstNamePlaceholder?: Maybe<Array<Maybe<StringFacet>>>;
  GooglePlayImage?: Maybe<ContentModelReferenceFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LastNamePlaceholder?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MobileAppText?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  Source?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SuccessMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type SignUpToNewsletterFormBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SignUpToNewsletterFormBlockFacetBodyTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SignUpToNewsletterFormBlockFacetCtaLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SignUpToNewsletterFormBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SignUpToNewsletterFormBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SignUpToNewsletterFormBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SignUpToNewsletterFormBlockFacetDesktopAppTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SignUpToNewsletterFormBlockFacetEmailPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SignUpToNewsletterFormBlockFacetErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SignUpToNewsletterFormBlockFacetFirstNamePlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SignUpToNewsletterFormBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SignUpToNewsletterFormBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SignUpToNewsletterFormBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SignUpToNewsletterFormBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SignUpToNewsletterFormBlockFacetLastNamePlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SignUpToNewsletterFormBlockFacetMobileAppTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SignUpToNewsletterFormBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SignUpToNewsletterFormBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SignUpToNewsletterFormBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SignUpToNewsletterFormBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SignUpToNewsletterFormBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SignUpToNewsletterFormBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SignUpToNewsletterFormBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SignUpToNewsletterFormBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SignUpToNewsletterFormBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SignUpToNewsletterFormBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SignUpToNewsletterFormBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SignUpToNewsletterFormBlockFacetSourceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SignUpToNewsletterFormBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SignUpToNewsletterFormBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SignUpToNewsletterFormBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SignUpToNewsletterFormBlockFacetSuccessMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SignUpToNewsletterFormBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SignUpToNewsletterFormBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SignUpToNewsletterFormBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SignUpToNewsletterFormBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AppLogo?: InputMaybe<ContentModelReferenceOrderByInput>;
  AppStoreImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  BodyText?: InputMaybe<OrderBy>;
  CTALabel?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DesktopAppText?: InputMaybe<OrderBy>;
  EmailPlaceholder?: InputMaybe<OrderBy>;
  ErrorMessage?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FirstNamePlaceholder?: InputMaybe<OrderBy>;
  GooglePlayImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LastNamePlaceholder?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MobileAppText?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  Source?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SuccessMessage?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SignUpToNewsletterFormBlockOutput = {
  __typename?: 'SignUpToNewsletterFormBlockOutput';
  autocomplete?: Maybe<SignUpToNewsletterFormBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SignUpToNewsletterFormBlockFacet>;
  item?: Maybe<SignUpToNewsletterFormBlock>;
  items?: Maybe<Array<Maybe<SignUpToNewsletterFormBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SignUpToNewsletterFormBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SignUpToNewsletterFormBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AppLogo?: InputMaybe<ContentModelReferenceWhereInput>;
  AppStoreImage?: InputMaybe<ContentModelReferenceWhereInput>;
  BodyText?: InputMaybe<SearchableStringFilterInput>;
  CTALabel?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DesktopAppText?: InputMaybe<SearchableStringFilterInput>;
  EmailPlaceholder?: InputMaybe<SearchableStringFilterInput>;
  ErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FirstNamePlaceholder?: InputMaybe<SearchableStringFilterInput>;
  GooglePlayImage?: InputMaybe<ContentModelReferenceWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LastNamePlaceholder?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MobileAppText?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  Source?: InputMaybe<SearchableStringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SuccessMessage?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SignUpToNewsletterFormBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SignUpToNewsletterFormBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SignUpToNewsletterFormBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Simple masthead can be added to top of the pages with a title and description. */
export type SimpleMastheadBlock = IContent &
  IData & {
    __typename?: 'SimpleMastheadBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    HtmlElement?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    /** This will determine whether or not to render breadcrumbs on this page. */
    ShowBreadcrumbs?: Maybe<Scalars['Bool']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Title?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Simple masthead can be added to top of the pages with a title and description. */
export type SimpleMastheadBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Simple masthead can be added to top of the pages with a title and description. */
export type SimpleMastheadBlockHtmlElementArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Simple masthead can be added to top of the pages with a title and description. */
export type SimpleMastheadBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Simple masthead can be added to top of the pages with a title and description. */
export type SimpleMastheadBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Simple masthead can be added to top of the pages with a title and description. */
export type SimpleMastheadBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Simple masthead can be added to top of the pages with a title and description. */
export type SimpleMastheadBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SimpleMastheadBlockAutocomplete = {
  __typename?: 'SimpleMastheadBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SimpleMastheadBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SimpleMastheadBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SimpleMastheadBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SimpleMastheadBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SimpleMastheadBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SimpleMastheadBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SimpleMastheadBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SimpleMastheadBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SimpleMastheadBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SimpleMastheadBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SimpleMastheadBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SimpleMastheadBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SimpleMastheadBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SimpleMastheadBlockFacet = {
  __typename?: 'SimpleMastheadBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  HtmlElement?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  ShowBreadcrumbs?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type SimpleMastheadBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleMastheadBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SimpleMastheadBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleMastheadBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SimpleMastheadBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleMastheadBlockFacetHtmlElementArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleMastheadBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleMastheadBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleMastheadBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleMastheadBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleMastheadBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleMastheadBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SimpleMastheadBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleMastheadBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleMastheadBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleMastheadBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleMastheadBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SimpleMastheadBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleMastheadBlockFacetShowBreadcrumbsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleMastheadBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleMastheadBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleMastheadBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SimpleMastheadBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleMastheadBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SimpleMastheadBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleMastheadBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleMastheadBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleMastheadBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SimpleMastheadBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  HtmlElement?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  ShowBreadcrumbs?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SimpleMastheadBlockOutput = {
  __typename?: 'SimpleMastheadBlockOutput';
  autocomplete?: Maybe<SimpleMastheadBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SimpleMastheadBlockFacet>;
  item?: Maybe<SimpleMastheadBlock>;
  items?: Maybe<Array<Maybe<SimpleMastheadBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SimpleMastheadBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SimpleMastheadBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  HtmlElement?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  ShowBreadcrumbs?: InputMaybe<BoolFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SimpleMastheadBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SimpleMastheadBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SimpleMastheadBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Allow content authors to add simple table to display rates */
export type SimpleTableBlock = IContent &
  IData & {
    __typename?: 'SimpleTableBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    /** Rate selection from list */
    RateId?: Maybe<Scalars['String']['output']>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Allow content authors to add simple table to display rates */
export type SimpleTableBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add simple table to display rates */
export type SimpleTableBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add simple table to display rates */
export type SimpleTableBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add simple table to display rates */
export type SimpleTableBlockRateIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add simple table to display rates */
export type SimpleTableBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add simple table to display rates */
export type SimpleTableBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SimpleTableBlockAutocomplete = {
  __typename?: 'SimpleTableBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SimpleTableBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SimpleTableBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SimpleTableBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SimpleTableBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SimpleTableBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SimpleTableBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SimpleTableBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SimpleTableBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SimpleTableBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SimpleTableBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SimpleTableBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SimpleTableBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SimpleTableBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SimpleTableBlockFacet = {
  __typename?: 'SimpleTableBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RateId?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type SimpleTableBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleTableBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SimpleTableBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleTableBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SimpleTableBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleTableBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleTableBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleTableBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleTableBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleTableBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleTableBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleTableBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SimpleTableBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleTableBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleTableBlockFacetRateIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleTableBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleTableBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleTableBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SimpleTableBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleTableBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleTableBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleTableBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SimpleTableBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleTableBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SimpleTableBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleTableBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SimpleTableBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SimpleTableBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RateId?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SimpleTableBlockOutput = {
  __typename?: 'SimpleTableBlockOutput';
  autocomplete?: Maybe<SimpleTableBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SimpleTableBlockFacet>;
  item?: Maybe<SimpleTableBlock>;
  items?: Maybe<Array<Maybe<SimpleTableBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SimpleTableBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SimpleTableBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RateId?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SimpleTableBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SimpleTableBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SimpleTableBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type SiteDefinition = IData & {
  __typename?: 'SiteDefinition';
  ContentLink?: Maybe<ContentModelReference>;
  ContentRoots?: Maybe<ContentRootsModel>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  EditLocation?: Maybe<Scalars['String']['output']>;
  Hosts?: Maybe<Array<Maybe<HostDefinitionModel>>>;
  Id?: Maybe<Scalars['String']['output']>;
  Languages?: Maybe<Array<Maybe<SiteDefinitionLanguageModel>>>;
  Name?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
};

export type SiteDefinitionNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SiteDefinition_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SiteDefinition_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SiteDefinitionAutocomplete = {
  __typename?: 'SiteDefinitionAutocomplete';
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentRoots?: Maybe<ContentRootsModelAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  EditLocation?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Hosts?: Maybe<HostDefinitionModelAutocomplete>;
  Id?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Languages?: Maybe<SiteDefinitionLanguageModelAutocomplete>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SiteDefinitionAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteDefinitionAutocompleteEditLocationArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteDefinitionAutocompleteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteDefinitionAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteDefinitionFacet = {
  __typename?: 'SiteDefinitionFacet';
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentRoots?: Maybe<ContentRootsModelFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  EditLocation?: Maybe<Array<Maybe<StringFacet>>>;
  Hosts?: Maybe<HostDefinitionModelFacet>;
  Id?: Maybe<Array<Maybe<StringFacet>>>;
  Languages?: Maybe<SiteDefinitionLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
};

export type SiteDefinitionFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteDefinitionFacetEditLocationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteDefinitionFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteDefinitionFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteDefinitionFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteDefinitionLanguageModel = {
  __typename?: 'SiteDefinitionLanguageModel';
  DisplayName?: Maybe<Scalars['String']['output']>;
  IsMasterLanguage?: Maybe<Scalars['Bool']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  UrlSegment?: Maybe<Scalars['String']['output']>;
};

export type SiteDefinitionLanguageModelAutocomplete = {
  __typename?: 'SiteDefinitionLanguageModelAutocomplete';
  DisplayName?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Name?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  UrlSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SiteDefinitionLanguageModelAutocompleteDisplayNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteDefinitionLanguageModelAutocompleteNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteDefinitionLanguageModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteDefinitionLanguageModelAutocompleteUrlSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteDefinitionLanguageModelFacet = {
  __typename?: 'SiteDefinitionLanguageModelFacet';
  DisplayName?: Maybe<Array<Maybe<StringFacet>>>;
  IsMasterLanguage?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  UrlSegment?: Maybe<Array<Maybe<StringFacet>>>;
};

export type SiteDefinitionLanguageModelFacetDisplayNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteDefinitionLanguageModelFacetIsMasterLanguageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteDefinitionLanguageModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteDefinitionLanguageModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteDefinitionLanguageModelFacetUrlSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteDefinitionLanguageModelOrderByInput = {
  DisplayName?: InputMaybe<OrderBy>;
  IsMasterLanguage?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  UrlSegment?: InputMaybe<OrderBy>;
};

export type SiteDefinitionLanguageModelWhereInput = {
  DisplayName?: InputMaybe<StringFilterInput>;
  IsMasterLanguage?: InputMaybe<BoolFilterInput>;
  Name?: InputMaybe<StringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  UrlSegment?: InputMaybe<StringFilterInput>;
};

export type SiteDefinitionOrderByInput = {
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentRoots?: InputMaybe<ContentRootsModelOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  EditLocation?: InputMaybe<OrderBy>;
  Hosts?: InputMaybe<HostDefinitionModelOrderByInput>;
  Id?: InputMaybe<OrderBy>;
  Languages?: InputMaybe<SiteDefinitionLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type SiteDefinitionOutput = {
  __typename?: 'SiteDefinitionOutput';
  autocomplete?: Maybe<SiteDefinitionAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SiteDefinitionFacet>;
  item?: Maybe<SiteDefinition>;
  items?: Maybe<Array<Maybe<SiteDefinition>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SiteDefinitionOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SiteDefinitionWhereInput = {
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentRoots?: InputMaybe<ContentRootsModelWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  EditLocation?: InputMaybe<StringFilterInput>;
  Hosts?: InputMaybe<HostDefinitionModelWhereInput>;
  Id?: InputMaybe<StringFilterInput>;
  Languages?: InputMaybe<SiteDefinitionLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SiteDefinitionWhereInput>>>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SiteDefinitionWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SiteDefinitionWhereInput>>>;
};

export type SiteUrlPredefinedHiddenElementBlock = IContent &
  IData & {
    __typename?: 'SiteUrlPredefinedHiddenElementBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    PredefinedValue?: Maybe<Scalars['String']['output']>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

export type SiteUrlPredefinedHiddenElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SiteUrlPredefinedHiddenElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SiteUrlPredefinedHiddenElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SiteUrlPredefinedHiddenElementBlockAutocomplete = {
  __typename?: 'SiteUrlPredefinedHiddenElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PredefinedValue?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SiteUrlPredefinedHiddenElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteUrlPredefinedHiddenElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteUrlPredefinedHiddenElementBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteUrlPredefinedHiddenElementBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteUrlPredefinedHiddenElementBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteUrlPredefinedHiddenElementBlockAutocompletePredefinedValueArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteUrlPredefinedHiddenElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteUrlPredefinedHiddenElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteUrlPredefinedHiddenElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteUrlPredefinedHiddenElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteUrlPredefinedHiddenElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteUrlPredefinedHiddenElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteUrlPredefinedHiddenElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteUrlPredefinedHiddenElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteUrlPredefinedHiddenElementBlockFacet = {
  __typename?: 'SiteUrlPredefinedHiddenElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PredefinedValue?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type SiteUrlPredefinedHiddenElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteUrlPredefinedHiddenElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SiteUrlPredefinedHiddenElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteUrlPredefinedHiddenElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SiteUrlPredefinedHiddenElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteUrlPredefinedHiddenElementBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteUrlPredefinedHiddenElementBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteUrlPredefinedHiddenElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteUrlPredefinedHiddenElementBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteUrlPredefinedHiddenElementBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SiteUrlPredefinedHiddenElementBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteUrlPredefinedHiddenElementBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteUrlPredefinedHiddenElementBlockFacetPredefinedValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteUrlPredefinedHiddenElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteUrlPredefinedHiddenElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteUrlPredefinedHiddenElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SiteUrlPredefinedHiddenElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteUrlPredefinedHiddenElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteUrlPredefinedHiddenElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteUrlPredefinedHiddenElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SiteUrlPredefinedHiddenElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteUrlPredefinedHiddenElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SiteUrlPredefinedHiddenElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteUrlPredefinedHiddenElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteUrlPredefinedHiddenElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SiteUrlPredefinedHiddenElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PredefinedValue?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SiteUrlPredefinedHiddenElementBlockOutput = {
  __typename?: 'SiteUrlPredefinedHiddenElementBlockOutput';
  autocomplete?: Maybe<SiteUrlPredefinedHiddenElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SiteUrlPredefinedHiddenElementBlockFacet>;
  item?: Maybe<SiteUrlPredefinedHiddenElementBlock>;
  items?: Maybe<Array<Maybe<SiteUrlPredefinedHiddenElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SiteUrlPredefinedHiddenElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SiteUrlPredefinedHiddenElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PredefinedValue?: InputMaybe<StringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SiteUrlPredefinedHiddenElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SiteUrlPredefinedHiddenElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SiteUrlPredefinedHiddenElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type SocialMediaIconBlock = IContent &
  IData & {
    __typename?: 'SocialMediaIconBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    SocialMediaIcon?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

export type SocialMediaIconBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SocialMediaIconBlockSocialMediaIconArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SocialMediaIconBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SocialMediaIconBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SocialMediaIconBlockAutocomplete = {
  __typename?: 'SocialMediaIconBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SocialMediaIconBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SocialMediaIconBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SocialMediaIconBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SocialMediaIconBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SocialMediaIconBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SocialMediaIconBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SocialMediaIconBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SocialMediaIconBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SocialMediaIconBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SocialMediaIconBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SocialMediaIconBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SocialMediaIconBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SocialMediaIconBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SocialMediaIconBlockFacet = {
  __typename?: 'SocialMediaIconBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SocialMediaIcon?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type SocialMediaIconBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialMediaIconBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SocialMediaIconBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialMediaIconBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SocialMediaIconBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialMediaIconBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialMediaIconBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialMediaIconBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialMediaIconBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialMediaIconBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SocialMediaIconBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialMediaIconBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialMediaIconBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialMediaIconBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialMediaIconBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SocialMediaIconBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialMediaIconBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialMediaIconBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialMediaIconBlockFacetSocialMediaIconArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialMediaIconBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SocialMediaIconBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialMediaIconBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SocialMediaIconBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialMediaIconBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialMediaIconBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SocialMediaIconBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SocialMediaIcon?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SocialMediaIconBlockOutput = {
  __typename?: 'SocialMediaIconBlockOutput';
  autocomplete?: Maybe<SocialMediaIconBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SocialMediaIconBlockFacet>;
  item?: Maybe<SocialMediaIconBlock>;
  items?: Maybe<Array<Maybe<SocialMediaIconBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SocialMediaIconBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SocialMediaIconBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SocialMediaIcon?: InputMaybe<SearchableStringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SocialMediaIconBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SocialMediaIconBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SocialMediaIconBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Allow content authors to add social sharing block to page */
export type SocialSharingBlock = IContent &
  IData & {
    __typename?: 'SocialSharingBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Allow content authors to add social sharing block to page */
export type SocialSharingBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add social sharing block to page */
export type SocialSharingBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add social sharing block to page */
export type SocialSharingBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add social sharing block to page */
export type SocialSharingBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to add social sharing block to page */
export type SocialSharingBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SocialSharingBlockAutocomplete = {
  __typename?: 'SocialSharingBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SocialSharingBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SocialSharingBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SocialSharingBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SocialSharingBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SocialSharingBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SocialSharingBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SocialSharingBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SocialSharingBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SocialSharingBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SocialSharingBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SocialSharingBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SocialSharingBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SocialSharingBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SocialSharingBlockFacet = {
  __typename?: 'SocialSharingBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type SocialSharingBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialSharingBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SocialSharingBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialSharingBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SocialSharingBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialSharingBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialSharingBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialSharingBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialSharingBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialSharingBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialSharingBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialSharingBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SocialSharingBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialSharingBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialSharingBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialSharingBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialSharingBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SocialSharingBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialSharingBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialSharingBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialSharingBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SocialSharingBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialSharingBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SocialSharingBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialSharingBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SocialSharingBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SocialSharingBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SocialSharingBlockOutput = {
  __typename?: 'SocialSharingBlockOutput';
  autocomplete?: Maybe<SocialSharingBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SocialSharingBlockFacet>;
  item?: Maybe<SocialSharingBlock>;
  items?: Maybe<Array<Maybe<SocialSharingBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SocialSharingBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SocialSharingBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SocialSharingBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SocialSharingBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SocialSharingBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Spacer component that can be used on any page. */
export type SpacerBlock = IContent &
  IData & {
    __typename?: 'SpacerBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    BottomSpacing?: Maybe<Scalars['String']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    /** If the option is checked, a divider line will be applied; otherwise, no divider line will be displayed. */
    DividerLine?: Maybe<Scalars['Bool']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    TopSpacing?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Spacer component that can be used on any page. */
export type SpacerBlockBottomSpacingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Spacer component that can be used on any page. */
export type SpacerBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Spacer component that can be used on any page. */
export type SpacerBlockTopSpacingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Spacer component that can be used on any page. */
export type SpacerBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Spacer component that can be used on any page. */
export type SpacerBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SpacerBlockAutocomplete = {
  __typename?: 'SpacerBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SpacerBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SpacerBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SpacerBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SpacerBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SpacerBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SpacerBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SpacerBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SpacerBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SpacerBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SpacerBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SpacerBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SpacerBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SpacerBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SpacerBlockFacet = {
  __typename?: 'SpacerBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BottomSpacing?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DividerLine?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TopSpacing?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type SpacerBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SpacerBlockFacetBottomSpacingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SpacerBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SpacerBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SpacerBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SpacerBlockFacetDividerLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SpacerBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SpacerBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SpacerBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SpacerBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SpacerBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SpacerBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SpacerBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SpacerBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SpacerBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SpacerBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SpacerBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SpacerBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SpacerBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SpacerBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SpacerBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SpacerBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SpacerBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SpacerBlockFacetTopSpacingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SpacerBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SpacerBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SpacerBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SpacerBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BottomSpacing?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DividerLine?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TopSpacing?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SpacerBlockOutput = {
  __typename?: 'SpacerBlockOutput';
  autocomplete?: Maybe<SpacerBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SpacerBlockFacet>;
  item?: Maybe<SpacerBlock>;
  items?: Maybe<Array<Maybe<SpacerBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SpacerBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SpacerBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BottomSpacing?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DividerLine?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TopSpacing?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SpacerBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SpacerBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SpacerBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Used for standard file types such as Word, Excel, PowerPoint or text documents. */
export type StandardFile = IContent &
  IData & {
    __typename?: 'StandardFile';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    Content?: Maybe<Scalars['String']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    FileSize?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    MimeType?: Maybe<Scalars['String']['output']>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Thumbnail?: Maybe<BlobModel>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Used for standard file types such as Word, Excel, PowerPoint or text documents. */
export type StandardFileContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for standard file types such as Word, Excel, PowerPoint or text documents. */
export type StandardFileFileSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for standard file types such as Word, Excel, PowerPoint or text documents. */
export type StandardFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for standard file types such as Word, Excel, PowerPoint or text documents. */
export type StandardFile_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for standard file types such as Word, Excel, PowerPoint or text documents. */
export type StandardFile_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type StandardFileAutocomplete = {
  __typename?: 'StandardFileAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MimeType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Thumbnail?: Maybe<BlobModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type StandardFileAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StandardFileAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StandardFileAutocompleteMimeTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StandardFileAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StandardFileAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StandardFileAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StandardFileAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StandardFileAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StandardFileAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StandardFileAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StandardFileAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StandardFileAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StandardFileAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StandardFileAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StandardFileFacet = {
  __typename?: 'StandardFileFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileSize?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MimeType?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Thumbnail?: Maybe<BlobModelFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type StandardFileFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StandardFileFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type StandardFileFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StandardFileFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StandardFileFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type StandardFileFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StandardFileFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StandardFileFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StandardFileFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StandardFileFacetMimeTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StandardFileFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StandardFileFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StandardFileFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type StandardFileFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StandardFileFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StandardFileFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StandardFileFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StandardFileFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type StandardFileFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StandardFileFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StandardFileFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StandardFileFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type StandardFileFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StandardFileFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type StandardFileFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StandardFileFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StandardFileFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type StandardFileOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileSize?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MimeType?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Thumbnail?: InputMaybe<BlobModelOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type StandardFileOutput = {
  __typename?: 'StandardFileOutput';
  autocomplete?: Maybe<StandardFileAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<StandardFileFacet>;
  item?: Maybe<StandardFile>;
  items?: Maybe<Array<Maybe<StandardFile>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type StandardFileOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StandardFileWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileSize?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MimeType?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Thumbnail?: InputMaybe<BlobModelWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<StandardFileWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<StandardFileWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<StandardFileWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Used for home page of all sites */
export type StartPage = IContent &
  IData & {
    __typename?: 'StartPage';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    AuthorMetaData?: Maybe<Scalars['String']['output']>;
    BreadcrumbsTitle?: Maybe<Scalars['String']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    DisableIndexing?: Maybe<Scalars['Bool']['output']>;
    /** This will determine whether or not to show on search. */
    ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
    /** This will determine whether or not to show on the Sitemap. */
    ExcludeFromSitemap?: Maybe<Scalars['Bool']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    FooterOverride?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    HeaderOverride?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    /** This will determine whether or not to be dispalyed in breadcrumbs. */
    HideInBreadcrumbs?: Maybe<Scalars['Bool']['output']>;
    HideSiteFooter?: Maybe<Scalars['Bool']['output']>;
    HideSiteHeader?: Maybe<Scalars['Bool']['output']>;
    Highlight?: Maybe<Scalars['Bool']['output']>;
    Industry?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Keywords?: Maybe<Scalars['String']['output']>;
    /** Container for Schema Field */
    LDJsonContainer?: Maybe<Scalars['String']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MainContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    MetaContentType?: Maybe<Scalars['String']['output']>;
    MetaTitle?: Maybe<Scalars['String']['output']>;
    Name?: Maybe<Scalars['String']['output']>;
    NavigationTitle?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Description value that has been managed for the current page */
    OpenGraphDescription?: Maybe<Scalars['String']['output']>;
    /** Page template will always inherit the OpenGraph image from the parent page, recursively, until an image is managed for the current page */
    OpenGraphImage?: Maybe<ContentModelReference>;
    /** If managed, this field will overwrite the Image Height value that has been managed for the current page */
    OpenGraphImageHeight?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Image Type value that has been managed for the current page */
    OpenGraphImageType?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Image Width  value that has been managed for the current page */
    OpenGraphImageWidth?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Site value that has been managed for the current page */
    OpenGraphSite?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Title value that has been managed for the current page */
    OpenGraphTitle?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Url value that has been managed for the current page */
    OpenGraphUrl?: Maybe<Scalars['String']['output']>;
    /** If managed, this field will overwrite the Page Type value that has been managed for the current page */
    OpenGraphtype?: Maybe<Scalars['String']['output']>;
    PageDescription?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    TeaserText?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Used for home page of all sites */
export type StartPageAuthorMetaDataArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for home page of all sites */
export type StartPageFooterOverrideArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for home page of all sites */
export type StartPageHeaderOverrideArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for home page of all sites */
export type StartPageIndustryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for home page of all sites */
export type StartPageKeywordsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for home page of all sites */
export type StartPageLdJsonContainerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for home page of all sites */
export type StartPageMainContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for home page of all sites */
export type StartPageMetaContentTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for home page of all sites */
export type StartPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for home page of all sites */
export type StartPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for home page of all sites */
export type StartPageNavigationTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for home page of all sites */
export type StartPageOpenGraphDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for home page of all sites */
export type StartPageOpenGraphImageHeightArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for home page of all sites */
export type StartPageOpenGraphImageTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for home page of all sites */
export type StartPageOpenGraphImageWidthArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for home page of all sites */
export type StartPageOpenGraphSiteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for home page of all sites */
export type StartPageOpenGraphTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for home page of all sites */
export type StartPageOpenGraphUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for home page of all sites */
export type StartPageOpenGraphtypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for home page of all sites */
export type StartPagePageDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for home page of all sites */
export type StartPageTeaserTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for home page of all sites */
export type StartPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for home page of all sites */
export type StartPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type StartPageAutocomplete = {
  __typename?: 'StartPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  OpenGraphImage?: Maybe<ContentModelReferenceAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type StartPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StartPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StartPageAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StartPageAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StartPageAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StartPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StartPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StartPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StartPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StartPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StartPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StartPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StartPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StartPageFacet = {
  __typename?: 'StartPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AuthorMetaData?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSitemap?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FooterOverride?: Maybe<ContentAreaItemModelSearchFacet>;
  HeaderOverride?: Maybe<ContentAreaItemModelSearchFacet>;
  HideInBreadcrumbs?: Maybe<Array<Maybe<StringFacet>>>;
  HideSiteFooter?: Maybe<Array<Maybe<StringFacet>>>;
  HideSiteHeader?: Maybe<Array<Maybe<StringFacet>>>;
  Highlight?: Maybe<Array<Maybe<StringFacet>>>;
  Industry?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Keywords?: Maybe<Array<Maybe<StringFacet>>>;
  LDJsonContainer?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaContentType?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NavigationTitle?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphDescription?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphImage?: Maybe<ContentModelReferenceFacet>;
  OpenGraphImageHeight?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphImageType?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphImageWidth?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphSite?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphTitle?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphUrl?: Maybe<Array<Maybe<StringFacet>>>;
  OpenGraphtype?: Maybe<Array<Maybe<StringFacet>>>;
  PageDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TeaserText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type StartPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetAuthorMetaDataArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type StartPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type StartPageFacetDisableIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetExcludeFromSitemapArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetHideInBreadcrumbsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetHideSiteFooterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetHideSiteHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetHighlightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetIndustryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetKeywordsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetLdJsonContainerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetMetaContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetNavigationTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetOpenGraphDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetOpenGraphImageHeightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetOpenGraphImageTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetOpenGraphImageWidthArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetOpenGraphSiteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetOpenGraphTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetOpenGraphUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetOpenGraphtypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetPageDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type StartPageFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type StartPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type StartPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type StartPageFacetTeaserTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type StartPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AuthorMetaData?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExcludeFromSitemap?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FooterOverride?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  HeaderOverride?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  HideInBreadcrumbs?: InputMaybe<OrderBy>;
  HideSiteFooter?: InputMaybe<OrderBy>;
  HideSiteHeader?: InputMaybe<OrderBy>;
  Highlight?: InputMaybe<OrderBy>;
  Industry?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Keywords?: InputMaybe<OrderBy>;
  LDJsonContainer?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaContentType?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NavigationTitle?: InputMaybe<OrderBy>;
  OpenGraphDescription?: InputMaybe<OrderBy>;
  OpenGraphImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  OpenGraphImageHeight?: InputMaybe<OrderBy>;
  OpenGraphImageType?: InputMaybe<OrderBy>;
  OpenGraphImageWidth?: InputMaybe<OrderBy>;
  OpenGraphSite?: InputMaybe<OrderBy>;
  OpenGraphTitle?: InputMaybe<OrderBy>;
  OpenGraphUrl?: InputMaybe<OrderBy>;
  OpenGraphtype?: InputMaybe<OrderBy>;
  PageDescription?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TeaserText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type StartPageOutput = {
  __typename?: 'StartPageOutput';
  autocomplete?: Maybe<StartPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<StartPageFacet>;
  item?: Maybe<StartPage>;
  items?: Maybe<Array<Maybe<StartPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type StartPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StartPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AuthorMetaData?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExcludeFromSitemap?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FooterOverride?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  HeaderOverride?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  HideInBreadcrumbs?: InputMaybe<BoolFilterInput>;
  HideSiteFooter?: InputMaybe<BoolFilterInput>;
  HideSiteHeader?: InputMaybe<BoolFilterInput>;
  Highlight?: InputMaybe<BoolFilterInput>;
  Industry?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Keywords?: InputMaybe<SearchableStringFilterInput>;
  LDJsonContainer?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaContentType?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NavigationTitle?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphDescription?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphImage?: InputMaybe<ContentModelReferenceWhereInput>;
  OpenGraphImageHeight?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphImageType?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphImageWidth?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphSite?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphTitle?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphUrl?: InputMaybe<SearchableStringFilterInput>;
  OpenGraphtype?: InputMaybe<SearchableStringFilterInput>;
  PageDescription?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TeaserText?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<StartPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<StartPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<StartPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type StringFacet = {
  __typename?: 'StringFacet';
  count?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type StringFilterInput = {
  /** `boost` influences the weight of a field by boosting a match with a number (default: 1) — counts more towards the eventual relevance score which can be projected with `_score` — at query time. Note that `boost` cannot be a negative number. */
  boost?: InputMaybe<Scalars['Int']['input']>;
  /** `ends_with` retrieves matches that end with a certain value (suffix). */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** `eq` matches on an exact value, but the value is case-insensitive. */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** `exist` matches results that have this field. */
  exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** enables supporting fuzzy matching on the query terms (keywords), which returns items that contain terms in the content similar to the keywords, as measured by a _Levenshtein edit distance_. An edit distance is the number of one-character changes needed to turn one term into another. The edit distance is based on the length of the term.  */
  fuzzy?: InputMaybe<Scalars['Boolean']['input']>;
  /** `in` matches with 1 or more exact values in a list. Example: `in: ["word1", "word2", "this is a phrase"]` */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** `like` matches on substrings with wildcard support: `%` to match on 0 or more characters, `_` to match on any character.  */
  like?: InputMaybe<Scalars['String']['input']>;
  /** `not_eq` retrieves results not matching with an exact (but case-insensitive) value. */
  notEq?: InputMaybe<Scalars['String']['input']>;
  /** `not_in` returns results that do not match with 1 or more exact values in a list. Example: `not_in: ["word1", "word2", "this is a phrase"]` */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** `starts_with` retrieves matches that start with a certain value (prefix). */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** expands query value with synonyms. Example: if `H2O` is a synonym of `water`, then querying for `water` will also return results with `H2O`. */
  synonyms?: InputMaybe<Array<InputMaybe<SynonymSlot>>>;
};

export type SubmitButtonElementBlock = IContent &
  IData & {
    __typename?: 'SubmitButtonElementBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ConditionCombination?: Maybe<Scalars['Int']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    FinalizeForm?: Maybe<Scalars['Bool']['output']>;
    Image?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Label?: Maybe<Scalars['String']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RedirectToPage?: Maybe<Scalars['String']['output']>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    SatisfiedAction?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

export type SubmitButtonElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SubmitButtonElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SubmitButtonElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SubmitButtonElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SubmitButtonElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SubmitButtonElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SubmitButtonElementBlockAutocomplete = {
  __typename?: 'SubmitButtonElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RedirectToPage?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SubmitButtonElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SubmitButtonElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SubmitButtonElementBlockAutocompleteImageArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SubmitButtonElementBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SubmitButtonElementBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SubmitButtonElementBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SubmitButtonElementBlockAutocompleteRedirectToPageArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SubmitButtonElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SubmitButtonElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SubmitButtonElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SubmitButtonElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SubmitButtonElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SubmitButtonElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SubmitButtonElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SubmitButtonElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SubmitButtonElementBlockFacet = {
  __typename?: 'SubmitButtonElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FinalizeForm?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RedirectToPage?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type SubmitButtonElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SubmitButtonElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SubmitButtonElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SubmitButtonElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SubmitButtonElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SubmitButtonElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SubmitButtonElementBlockFacetFinalizeFormArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SubmitButtonElementBlockFacetImageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SubmitButtonElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SubmitButtonElementBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SubmitButtonElementBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SubmitButtonElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SubmitButtonElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SubmitButtonElementBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SubmitButtonElementBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SubmitButtonElementBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SubmitButtonElementBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SubmitButtonElementBlockFacetRedirectToPageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SubmitButtonElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SubmitButtonElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SubmitButtonElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SubmitButtonElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SubmitButtonElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SubmitButtonElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SubmitButtonElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SubmitButtonElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SubmitButtonElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SubmitButtonElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SubmitButtonElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SubmitButtonElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SubmitButtonElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SubmitButtonElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FinalizeForm?: InputMaybe<OrderBy>;
  Image?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RedirectToPage?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SubmitButtonElementBlockOutput = {
  __typename?: 'SubmitButtonElementBlockOutput';
  autocomplete?: Maybe<SubmitButtonElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SubmitButtonElementBlockFacet>;
  item?: Maybe<SubmitButtonElementBlock>;
  items?: Maybe<Array<Maybe<SubmitButtonElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SubmitButtonElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubmitButtonElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FinalizeForm?: InputMaybe<BoolFilterInput>;
  Image?: InputMaybe<StringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RedirectToPage?: InputMaybe<StringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SubmitButtonElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SubmitButtonElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SubmitButtonElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export enum SynonymSlot {
  /** synonym slot 1 */
  One = 'ONE',
  /** synonym slot 2 */
  Two = 'TWO'
}

/** Tab Container for Tab Items. */
export type TabContainerBlock = IContent &
  IData & {
    __typename?: 'TabContainerBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    TabItems?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Tab Container for Tab Items. */
export type TabContainerBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Tab Container for Tab Items. */
export type TabContainerBlockTabItemsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Tab Container for Tab Items. */
export type TabContainerBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Tab Container for Tab Items. */
export type TabContainerBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type TabContainerBlockAutocomplete = {
  __typename?: 'TabContainerBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TabContainerBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TabContainerBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TabContainerBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TabContainerBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TabContainerBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TabContainerBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TabContainerBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TabContainerBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TabContainerBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TabContainerBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TabContainerBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TabContainerBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TabContainerBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TabContainerBlockFacet = {
  __typename?: 'TabContainerBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TabItems?: Maybe<ContentAreaItemModelSearchFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type TabContainerBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabContainerBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TabContainerBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabContainerBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TabContainerBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabContainerBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabContainerBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabContainerBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabContainerBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabContainerBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TabContainerBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabContainerBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabContainerBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabContainerBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabContainerBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TabContainerBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabContainerBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabContainerBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabContainerBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TabContainerBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabContainerBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TabContainerBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabContainerBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabContainerBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type TabContainerBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TabItems?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type TabContainerBlockOutput = {
  __typename?: 'TabContainerBlockOutput';
  autocomplete?: Maybe<TabContainerBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<TabContainerBlockFacet>;
  item?: Maybe<TabContainerBlock>;
  items?: Maybe<Array<Maybe<TabContainerBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type TabContainerBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TabContainerBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TabItems?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<TabContainerBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<TabContainerBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<TabContainerBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Tab Item added to Tab Container. */
export type TabItemBlock = IContent &
  IData & {
    __typename?: 'TabItemBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Body?: Maybe<Scalars['String']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    Image?: Maybe<ContentModelReference>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    SubHeadline?: Maybe<Scalars['String']['output']>;
    TabLabel?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Tab Item added to Tab Container. */
export type TabItemBlockBodyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Tab Item added to Tab Container. */
export type TabItemBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Tab Item added to Tab Container. */
export type TabItemBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Tab Item added to Tab Container. */
export type TabItemBlockSubHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Tab Item added to Tab Container. */
export type TabItemBlockTabLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Tab Item added to Tab Container. */
export type TabItemBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Tab Item added to Tab Container. */
export type TabItemBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type TabItemBlockAutocomplete = {
  __typename?: 'TabItemBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TabItemBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TabItemBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TabItemBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TabItemBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TabItemBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TabItemBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TabItemBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TabItemBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TabItemBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TabItemBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TabItemBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TabItemBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TabItemBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TabItemBlockFacet = {
  __typename?: 'TabItemBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Body?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SubHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  TabLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type TabItemBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabItemBlockFacetBodyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabItemBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TabItemBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabItemBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TabItemBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabItemBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabItemBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabItemBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabItemBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabItemBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabItemBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TabItemBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabItemBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabItemBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabItemBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabItemBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TabItemBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabItemBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabItemBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabItemBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TabItemBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabItemBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TabItemBlockFacetSubHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabItemBlockFacetTabLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabItemBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabItemBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabItemBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type TabItemBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Body?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SubHeadline?: InputMaybe<OrderBy>;
  TabLabel?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type TabItemBlockOutput = {
  __typename?: 'TabItemBlockOutput';
  autocomplete?: Maybe<TabItemBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<TabItemBlockFacet>;
  item?: Maybe<TabItemBlock>;
  items?: Maybe<Array<Maybe<TabItemBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type TabItemBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TabItemBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Body?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SubHeadline?: InputMaybe<SearchableStringFilterInput>;
  TabLabel?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<TabItemBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<TabItemBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<TabItemBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Testimonial component that can be used on any page. */
export type TestimonialCardBlock = IContent &
  IData & {
    __typename?: 'TestimonialCardBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    ReviewDateandSource?: Maybe<Scalars['String']['output']>;
    ReviewText?: Maybe<Scalars['String']['output']>;
    ReviewTitle?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    Stars?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    TestimonialName?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Testimonial component that can be used on any page. */
export type TestimonialCardBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Testimonial component that can be used on any page. */
export type TestimonialCardBlockReviewDateandSourceArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Testimonial component that can be used on any page. */
export type TestimonialCardBlockReviewTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Testimonial component that can be used on any page. */
export type TestimonialCardBlockReviewTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Testimonial component that can be used on any page. */
export type TestimonialCardBlockStarsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Testimonial component that can be used on any page. */
export type TestimonialCardBlockTestimonialNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Testimonial component that can be used on any page. */
export type TestimonialCardBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Testimonial component that can be used on any page. */
export type TestimonialCardBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type TestimonialCardBlockAutocomplete = {
  __typename?: 'TestimonialCardBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TestimonialCardBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TestimonialCardBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TestimonialCardBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TestimonialCardBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TestimonialCardBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TestimonialCardBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TestimonialCardBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TestimonialCardBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TestimonialCardBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TestimonialCardBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TestimonialCardBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TestimonialCardBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TestimonialCardBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TestimonialCardBlockFacet = {
  __typename?: 'TestimonialCardBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  ReviewDateandSource?: Maybe<Array<Maybe<StringFacet>>>;
  ReviewText?: Maybe<Array<Maybe<StringFacet>>>;
  ReviewTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  Stars?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TestimonialName?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type TestimonialCardBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCardBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TestimonialCardBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCardBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TestimonialCardBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCardBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCardBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCardBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCardBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCardBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TestimonialCardBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCardBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCardBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCardBlockFacetReviewDateandSourceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCardBlockFacetReviewTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCardBlockFacetReviewTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCardBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCardBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TestimonialCardBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCardBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCardBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCardBlockFacetStarsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCardBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TestimonialCardBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCardBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TestimonialCardBlockFacetTestimonialNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCardBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCardBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCardBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type TestimonialCardBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  ReviewDateandSource?: InputMaybe<OrderBy>;
  ReviewText?: InputMaybe<OrderBy>;
  ReviewTitle?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  Stars?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TestimonialName?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type TestimonialCardBlockOutput = {
  __typename?: 'TestimonialCardBlockOutput';
  autocomplete?: Maybe<TestimonialCardBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<TestimonialCardBlockFacet>;
  item?: Maybe<TestimonialCardBlock>;
  items?: Maybe<Array<Maybe<TestimonialCardBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type TestimonialCardBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TestimonialCardBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  ReviewDateandSource?: InputMaybe<SearchableStringFilterInput>;
  ReviewText?: InputMaybe<SearchableStringFilterInput>;
  ReviewTitle?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  Stars?: InputMaybe<SearchableStringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TestimonialName?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<TestimonialCardBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<TestimonialCardBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<TestimonialCardBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Testimonial Carousel component that can be used on any page. */
export type TestimonialCarouselBlock = IContent &
  IData & {
    __typename?: 'TestimonialCarouselBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    BackgroundColor?: Maybe<Scalars['String']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RemoveBottomAngle?: Maybe<Scalars['Bool']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Testimonials?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Testimonial Carousel component that can be used on any page. */
export type TestimonialCarouselBlockBackgroundColorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Testimonial Carousel component that can be used on any page. */
export type TestimonialCarouselBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Testimonial Carousel component that can be used on any page. */
export type TestimonialCarouselBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Testimonial Carousel component that can be used on any page. */
export type TestimonialCarouselBlockTestimonialsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Testimonial Carousel component that can be used on any page. */
export type TestimonialCarouselBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Testimonial Carousel component that can be used on any page. */
export type TestimonialCarouselBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type TestimonialCarouselBlockAutocomplete = {
  __typename?: 'TestimonialCarouselBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TestimonialCarouselBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TestimonialCarouselBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TestimonialCarouselBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TestimonialCarouselBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TestimonialCarouselBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TestimonialCarouselBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TestimonialCarouselBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TestimonialCarouselBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TestimonialCarouselBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TestimonialCarouselBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TestimonialCarouselBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TestimonialCarouselBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TestimonialCarouselBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TestimonialCarouselBlockFacet = {
  __typename?: 'TestimonialCarouselBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BackgroundColor?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RemoveBottomAngle?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Testimonials?: Maybe<ContentAreaItemModelSearchFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type TestimonialCarouselBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCarouselBlockFacetBackgroundColorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCarouselBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TestimonialCarouselBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCarouselBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TestimonialCarouselBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCarouselBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCarouselBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCarouselBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCarouselBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCarouselBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCarouselBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TestimonialCarouselBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCarouselBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCarouselBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCarouselBlockFacetRemoveBottomAngleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCarouselBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCarouselBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TestimonialCarouselBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCarouselBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCarouselBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCarouselBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TestimonialCarouselBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCarouselBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TestimonialCarouselBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCarouselBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TestimonialCarouselBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type TestimonialCarouselBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BackgroundColor?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RemoveBottomAngle?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Testimonials?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type TestimonialCarouselBlockOutput = {
  __typename?: 'TestimonialCarouselBlockOutput';
  autocomplete?: Maybe<TestimonialCarouselBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<TestimonialCarouselBlockFacet>;
  item?: Maybe<TestimonialCarouselBlock>;
  items?: Maybe<Array<Maybe<TestimonialCarouselBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type TestimonialCarouselBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TestimonialCarouselBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BackgroundColor?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RemoveBottomAngle?: InputMaybe<BoolFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Testimonials?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<TestimonialCarouselBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<TestimonialCarouselBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<TestimonialCarouselBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Module with an headline, description and button. You can choose to add/remove the top margin & bottom angle. */
export type TextPanelCtaBlock = IContent &
  IData & {
    __typename?: 'TextPanelCtaBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    BackgroundColor?: Maybe<Scalars['String']['output']>;
    BackgroundImage?: Maybe<ContentModelReference>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RemoveBottomAngle?: Maybe<Scalars['Bool']['output']>;
    RemoveTopAngle?: Maybe<Scalars['Bool']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Module with an headline, description and button. You can choose to add/remove the top margin & bottom angle. */
export type TextPanelCtaBlockBackgroundColorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Module with an headline, description and button. You can choose to add/remove the top margin & bottom angle. */
export type TextPanelCtaBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Module with an headline, description and button. You can choose to add/remove the top margin & bottom angle. */
export type TextPanelCtaBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Module with an headline, description and button. You can choose to add/remove the top margin & bottom angle. */
export type TextPanelCtaBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Module with an headline, description and button. You can choose to add/remove the top margin & bottom angle. */
export type TextPanelCtaBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Module with an headline, description and button. You can choose to add/remove the top margin & bottom angle. */
export type TextPanelCtaBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type TextPanelCtaBlockAutocomplete = {
  __typename?: 'TextPanelCtaBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BackgroundImage?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TextPanelCtaBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextPanelCtaBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextPanelCtaBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextPanelCtaBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextPanelCtaBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextPanelCtaBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextPanelCtaBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextPanelCtaBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextPanelCtaBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextPanelCtaBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextPanelCtaBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextPanelCtaBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextPanelCtaBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextPanelCtaBlockFacet = {
  __typename?: 'TextPanelCtaBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BackgroundColor?: Maybe<Array<Maybe<StringFacet>>>;
  BackgroundImage?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RemoveBottomAngle?: Maybe<Array<Maybe<StringFacet>>>;
  RemoveTopAngle?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type TextPanelCtaBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextPanelCtaBlockFacetBackgroundColorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextPanelCtaBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TextPanelCtaBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextPanelCtaBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TextPanelCtaBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextPanelCtaBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextPanelCtaBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextPanelCtaBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextPanelCtaBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextPanelCtaBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextPanelCtaBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextPanelCtaBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TextPanelCtaBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextPanelCtaBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextPanelCtaBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextPanelCtaBlockFacetRemoveBottomAngleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextPanelCtaBlockFacetRemoveTopAngleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextPanelCtaBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextPanelCtaBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TextPanelCtaBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextPanelCtaBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextPanelCtaBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextPanelCtaBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TextPanelCtaBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextPanelCtaBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TextPanelCtaBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextPanelCtaBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextPanelCtaBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type TextPanelCtaBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BackgroundColor?: InputMaybe<OrderBy>;
  BackgroundImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RemoveBottomAngle?: InputMaybe<OrderBy>;
  RemoveTopAngle?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type TextPanelCtaBlockOutput = {
  __typename?: 'TextPanelCtaBlockOutput';
  autocomplete?: Maybe<TextPanelCtaBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<TextPanelCtaBlockFacet>;
  item?: Maybe<TextPanelCtaBlock>;
  items?: Maybe<Array<Maybe<TextPanelCtaBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type TextPanelCtaBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TextPanelCtaBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BackgroundColor?: InputMaybe<SearchableStringFilterInput>;
  BackgroundImage?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RemoveBottomAngle?: InputMaybe<BoolFilterInput>;
  RemoveTopAngle?: InputMaybe<BoolFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<TextPanelCtaBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<TextPanelCtaBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<TextPanelCtaBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type TextareaElementBlock = IContent &
  IData & {
    __typename?: 'TextareaElementBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    AutoComplete?: Maybe<Scalars['Int']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ConditionCombination?: Maybe<Scalars['Int']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Label?: Maybe<Scalars['String']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    PlaceHolder?: Maybe<Scalars['String']['output']>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    SatisfiedAction?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    Validators?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

export type TextareaElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TextareaElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TextareaElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TextareaElementBlockPlaceHolderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TextareaElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TextareaElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TextareaElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TextareaElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type TextareaElementBlockAutocomplete = {
  __typename?: 'TextareaElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TextareaElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextareaElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextareaElementBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextareaElementBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextareaElementBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextareaElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextareaElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextareaElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextareaElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextareaElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextareaElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextareaElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextareaElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextareaElementBlockFacet = {
  __typename?: 'TextareaElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AutoComplete?: Maybe<Array<Maybe<NumberFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PlaceHolder?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type TextareaElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextareaElementBlockFacetAutoCompleteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type TextareaElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TextareaElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type TextareaElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextareaElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TextareaElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextareaElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextareaElementBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextareaElementBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextareaElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextareaElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextareaElementBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextareaElementBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TextareaElementBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextareaElementBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextareaElementBlockFacetPlaceHolderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextareaElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextareaElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextareaElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextareaElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TextareaElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextareaElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextareaElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextareaElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TextareaElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextareaElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TextareaElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextareaElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextareaElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextareaElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type TextareaElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AutoComplete?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PlaceHolder?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type TextareaElementBlockOutput = {
  __typename?: 'TextareaElementBlockOutput';
  autocomplete?: Maybe<TextareaElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<TextareaElementBlockFacet>;
  item?: Maybe<TextareaElementBlock>;
  items?: Maybe<Array<Maybe<TextareaElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type TextareaElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TextareaElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AutoComplete?: InputMaybe<IntFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PlaceHolder?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<TextareaElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<TextareaElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<TextareaElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type TextboxElementBlock = IContent &
  IData & {
    __typename?: 'TextboxElementBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    AutoComplete?: Maybe<Scalars['Int']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ConditionCombination?: Maybe<Scalars['Int']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Label?: Maybe<Scalars['String']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    PlaceHolder?: Maybe<Scalars['String']['output']>;
    PredefinedValue?: Maybe<Scalars['String']['output']>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    SatisfiedAction?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    Validators?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

export type TextboxElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TextboxElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TextboxElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TextboxElementBlockPlaceHolderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TextboxElementBlockPredefinedValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TextboxElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TextboxElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TextboxElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TextboxElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type TextboxElementBlockAutocomplete = {
  __typename?: 'TextboxElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TextboxElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextboxElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextboxElementBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextboxElementBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextboxElementBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextboxElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextboxElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextboxElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextboxElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextboxElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextboxElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextboxElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextboxElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextboxElementBlockFacet = {
  __typename?: 'TextboxElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AutoComplete?: Maybe<Array<Maybe<NumberFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PlaceHolder?: Maybe<Array<Maybe<StringFacet>>>;
  PredefinedValue?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type TextboxElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextboxElementBlockFacetAutoCompleteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type TextboxElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TextboxElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type TextboxElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextboxElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TextboxElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextboxElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextboxElementBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextboxElementBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextboxElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextboxElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextboxElementBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextboxElementBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TextboxElementBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextboxElementBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextboxElementBlockFacetPlaceHolderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextboxElementBlockFacetPredefinedValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextboxElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextboxElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextboxElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextboxElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TextboxElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextboxElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextboxElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextboxElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TextboxElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextboxElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TextboxElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextboxElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextboxElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextboxElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type TextboxElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AutoComplete?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PlaceHolder?: InputMaybe<OrderBy>;
  PredefinedValue?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type TextboxElementBlockOutput = {
  __typename?: 'TextboxElementBlockOutput';
  autocomplete?: Maybe<TextboxElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<TextboxElementBlockFacet>;
  item?: Maybe<TextboxElementBlock>;
  items?: Maybe<Array<Maybe<TextboxElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type TextboxElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TextboxElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AutoComplete?: InputMaybe<IntFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PlaceHolder?: InputMaybe<SearchableStringFilterInput>;
  PredefinedValue?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<TextboxElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<TextboxElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<TextboxElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Allow content authors to display content from a 3rd party via iFrame */
export type ThirdPartyIFrameBlock = IContent &
  IData & {
    __typename?: 'ThirdPartyIFrameBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    /** Heading for 3rd Party IFrame */
    Heading?: Maybe<Scalars['String']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    /** 3rd Party iFrame Snippet for 3rd Party IFrame */
    ThirdPartyIFrameSnippet?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Allow content authors to display content from a 3rd party via iFrame */
export type ThirdPartyIFrameBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to display content from a 3rd party via iFrame */
export type ThirdPartyIFrameBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to display content from a 3rd party via iFrame */
export type ThirdPartyIFrameBlockThirdPartyIFrameSnippetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to display content from a 3rd party via iFrame */
export type ThirdPartyIFrameBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Allow content authors to display content from a 3rd party via iFrame */
export type ThirdPartyIFrameBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ThirdPartyIFrameBlockAutocomplete = {
  __typename?: 'ThirdPartyIFrameBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ThirdPartyIFrameBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ThirdPartyIFrameBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ThirdPartyIFrameBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ThirdPartyIFrameBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ThirdPartyIFrameBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ThirdPartyIFrameBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ThirdPartyIFrameBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ThirdPartyIFrameBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ThirdPartyIFrameBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ThirdPartyIFrameBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ThirdPartyIFrameBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ThirdPartyIFrameBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ThirdPartyIFrameBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ThirdPartyIFrameBlockFacet = {
  __typename?: 'ThirdPartyIFrameBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThirdPartyIFrameSnippet?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type ThirdPartyIFrameBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ThirdPartyIFrameBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ThirdPartyIFrameBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ThirdPartyIFrameBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ThirdPartyIFrameBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ThirdPartyIFrameBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ThirdPartyIFrameBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ThirdPartyIFrameBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ThirdPartyIFrameBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ThirdPartyIFrameBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ThirdPartyIFrameBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ThirdPartyIFrameBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ThirdPartyIFrameBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ThirdPartyIFrameBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ThirdPartyIFrameBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ThirdPartyIFrameBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ThirdPartyIFrameBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ThirdPartyIFrameBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ThirdPartyIFrameBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ThirdPartyIFrameBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ThirdPartyIFrameBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ThirdPartyIFrameBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ThirdPartyIFrameBlockFacetThirdPartyIFrameSnippetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ThirdPartyIFrameBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ThirdPartyIFrameBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ThirdPartyIFrameBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ThirdPartyIFrameBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThirdPartyIFrameSnippet?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ThirdPartyIFrameBlockOutput = {
  __typename?: 'ThirdPartyIFrameBlockOutput';
  autocomplete?: Maybe<ThirdPartyIFrameBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ThirdPartyIFrameBlockFacet>;
  item?: Maybe<ThirdPartyIFrameBlock>;
  items?: Maybe<Array<Maybe<ThirdPartyIFrameBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ThirdPartyIFrameBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ThirdPartyIFrameBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThirdPartyIFrameSnippet?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ThirdPartyIFrameBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ThirdPartyIFrameBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ThirdPartyIFrameBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type UrlElementBlock = IContent &
  IData & {
    __typename?: 'UrlElementBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ConditionCombination?: Maybe<Scalars['Int']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Label?: Maybe<Scalars['String']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    PlaceHolder?: Maybe<Scalars['String']['output']>;
    PredefinedValue?: Maybe<Scalars['String']['output']>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    SatisfiedAction?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    Validators?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

export type UrlElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type UrlElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type UrlElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type UrlElementBlockPlaceHolderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type UrlElementBlockPredefinedValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type UrlElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type UrlElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type UrlElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type UrlElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type UrlElementBlockAutocomplete = {
  __typename?: 'UrlElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UrlElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type UrlElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type UrlElementBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type UrlElementBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type UrlElementBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type UrlElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type UrlElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type UrlElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type UrlElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type UrlElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type UrlElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type UrlElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type UrlElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type UrlElementBlockFacet = {
  __typename?: 'UrlElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PlaceHolder?: Maybe<Array<Maybe<StringFacet>>>;
  PredefinedValue?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type UrlElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type UrlElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type UrlElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type UrlElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type UrlElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type UrlElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type UrlElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type UrlElementBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type UrlElementBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type UrlElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type UrlElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type UrlElementBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type UrlElementBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type UrlElementBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type UrlElementBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type UrlElementBlockFacetPlaceHolderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type UrlElementBlockFacetPredefinedValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type UrlElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type UrlElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type UrlElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type UrlElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type UrlElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type UrlElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type UrlElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type UrlElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type UrlElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type UrlElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type UrlElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type UrlElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type UrlElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type UrlElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type UrlElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PlaceHolder?: InputMaybe<OrderBy>;
  PredefinedValue?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type UrlElementBlockOutput = {
  __typename?: 'UrlElementBlockOutput';
  autocomplete?: Maybe<UrlElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<UrlElementBlockFacet>;
  item?: Maybe<UrlElementBlock>;
  items?: Maybe<Array<Maybe<UrlElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type UrlElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UrlElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PlaceHolder?: InputMaybe<SearchableStringFilterInput>;
  PredefinedValue?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<UrlElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<UrlElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<UrlElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Used for svg image file type */
export type VectorImageMediaData = IContent &
  IData & {
    __typename?: 'VectorImageMediaData';
    AltText?: Maybe<Scalars['String']['output']>;
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    Content?: Maybe<Scalars['String']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    /** Description of the image */
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    MimeType?: Maybe<Scalars['String']['output']>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Thumbnail?: Maybe<BlobModel>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Used for svg image file type */
export type VectorImageMediaDataAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for svg image file type */
export type VectorImageMediaDataContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for svg image file type */
export type VectorImageMediaDataDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for svg image file type */
export type VectorImageMediaDataNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for svg image file type */
export type VectorImageMediaData_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for svg image file type */
export type VectorImageMediaData_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type VectorImageMediaDataAutocomplete = {
  __typename?: 'VectorImageMediaDataAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MimeType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Thumbnail?: Maybe<BlobModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type VectorImageMediaDataAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VectorImageMediaDataAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VectorImageMediaDataAutocompleteMimeTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VectorImageMediaDataAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VectorImageMediaDataAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VectorImageMediaDataAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VectorImageMediaDataAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VectorImageMediaDataAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VectorImageMediaDataAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VectorImageMediaDataAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VectorImageMediaDataAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VectorImageMediaDataAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VectorImageMediaDataAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VectorImageMediaDataAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VectorImageMediaDataFacet = {
  __typename?: 'VectorImageMediaDataFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MimeType?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Thumbnail?: Maybe<BlobModelFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type VectorImageMediaDataFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VectorImageMediaDataFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VectorImageMediaDataFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type VectorImageMediaDataFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VectorImageMediaDataFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VectorImageMediaDataFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type VectorImageMediaDataFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VectorImageMediaDataFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VectorImageMediaDataFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VectorImageMediaDataFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VectorImageMediaDataFacetMimeTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VectorImageMediaDataFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VectorImageMediaDataFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VectorImageMediaDataFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type VectorImageMediaDataFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VectorImageMediaDataFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VectorImageMediaDataFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VectorImageMediaDataFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VectorImageMediaDataFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type VectorImageMediaDataFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VectorImageMediaDataFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VectorImageMediaDataFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VectorImageMediaDataFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type VectorImageMediaDataFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VectorImageMediaDataFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type VectorImageMediaDataFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VectorImageMediaDataFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VectorImageMediaDataFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type VectorImageMediaDataOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MimeType?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Thumbnail?: InputMaybe<BlobModelOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type VectorImageMediaDataOutput = {
  __typename?: 'VectorImageMediaDataOutput';
  autocomplete?: Maybe<VectorImageMediaDataAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<VectorImageMediaDataFacet>;
  item?: Maybe<VectorImageMediaData>;
  items?: Maybe<Array<Maybe<VectorImageMediaData>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type VectorImageMediaDataOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VectorImageMediaDataWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MimeType?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Thumbnail?: InputMaybe<BlobModelWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<VectorImageMediaDataWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<VectorImageMediaDataWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<VectorImageMediaDataWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Video Content Panel component that can be used on any page and allow content authors to add a module with an embedded video, text and button. */
export type VideoContentPanelBlock = IContent &
  IData & {
    __typename?: 'VideoContentPanelBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    DarkHeadline?: Maybe<Scalars['Bool']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    EmbeddedVideoCode?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    Headline?: Maybe<Scalars['String']['output']>;
    IsCTAButton?: Maybe<Scalars['Bool']['output']>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    VideoAlignment?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Video Content Panel component that can be used on any page and allow content authors to add a module with an embedded video, text and button. */
export type VideoContentPanelBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Video Content Panel component that can be used on any page and allow content authors to add a module with an embedded video, text and button. */
export type VideoContentPanelBlockEmbeddedVideoCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Video Content Panel component that can be used on any page and allow content authors to add a module with an embedded video, text and button. */
export type VideoContentPanelBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Video Content Panel component that can be used on any page and allow content authors to add a module with an embedded video, text and button. */
export type VideoContentPanelBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Video Content Panel component that can be used on any page and allow content authors to add a module with an embedded video, text and button. */
export type VideoContentPanelBlockVideoAlignmentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Video Content Panel component that can be used on any page and allow content authors to add a module with an embedded video, text and button. */
export type VideoContentPanelBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Video Content Panel component that can be used on any page and allow content authors to add a module with an embedded video, text and button. */
export type VideoContentPanelBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type VideoContentPanelBlockAutocomplete = {
  __typename?: 'VideoContentPanelBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type VideoContentPanelBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoContentPanelBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoContentPanelBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoContentPanelBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoContentPanelBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoContentPanelBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoContentPanelBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoContentPanelBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoContentPanelBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoContentPanelBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoContentPanelBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoContentPanelBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoContentPanelBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoContentPanelBlockFacet = {
  __typename?: 'VideoContentPanelBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DarkHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  EmbeddedVideoCode?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCTAButton?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VideoAlignment?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type VideoContentPanelBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoContentPanelBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type VideoContentPanelBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoContentPanelBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type VideoContentPanelBlockFacetDarkHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoContentPanelBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoContentPanelBlockFacetEmbeddedVideoCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoContentPanelBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoContentPanelBlockFacetIsCtaButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoContentPanelBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoContentPanelBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoContentPanelBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoContentPanelBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoContentPanelBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoContentPanelBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type VideoContentPanelBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoContentPanelBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoContentPanelBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoContentPanelBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoContentPanelBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type VideoContentPanelBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoContentPanelBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoContentPanelBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoContentPanelBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type VideoContentPanelBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoContentPanelBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type VideoContentPanelBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoContentPanelBlockFacetVideoAlignmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoContentPanelBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoContentPanelBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type VideoContentPanelBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DarkHeadline?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  EmbeddedVideoCode?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  IsCTAButton?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VideoAlignment?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type VideoContentPanelBlockOutput = {
  __typename?: 'VideoContentPanelBlockOutput';
  autocomplete?: Maybe<VideoContentPanelBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<VideoContentPanelBlockFacet>;
  item?: Maybe<VideoContentPanelBlock>;
  items?: Maybe<Array<Maybe<VideoContentPanelBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type VideoContentPanelBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VideoContentPanelBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DarkHeadline?: InputMaybe<BoolFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  EmbeddedVideoCode?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCTAButton?: InputMaybe<BoolFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VideoAlignment?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<VideoContentPanelBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<VideoContentPanelBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<VideoContentPanelBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Used for video file types such as mp4, flv, webm */
export type VideoFile = IContent &
  IData & {
    __typename?: 'VideoFile';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Autoplay?: Maybe<Scalars['Bool']['output']>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    Content?: Maybe<Scalars['String']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Copyright?: Maybe<Scalars['String']['output']>;
    Created?: Maybe<Scalars['Date']['output']>;
    DisplayControls?: Maybe<Scalars['Bool']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    MimeType?: Maybe<Scalars['String']['output']>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    PreviewImage?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Thumbnail?: Maybe<BlobModel>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Used for video file types such as mp4, flv, webm */
export type VideoFileContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for video file types such as mp4, flv, webm */
export type VideoFileCopyrightArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for video file types such as mp4, flv, webm */
export type VideoFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for video file types such as mp4, flv, webm */
export type VideoFile_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for video file types such as mp4, flv, webm */
export type VideoFile_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type VideoFileAutocomplete = {
  __typename?: 'VideoFileAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MimeType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PreviewImage?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Thumbnail?: Maybe<BlobModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type VideoFileAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoFileAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoFileAutocompleteMimeTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoFileAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoFileAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoFileAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoFileAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoFileAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoFileAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoFileAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoFileAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoFileAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoFileAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoFileAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoFileFacet = {
  __typename?: 'VideoFileFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Autoplay?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Copyright?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisplayControls?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MimeType?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreviewImage?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Thumbnail?: Maybe<BlobModelFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type VideoFileFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoFileFacetAutoplayArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoFileFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type VideoFileFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoFileFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoFileFacetCopyrightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoFileFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type VideoFileFacetDisplayControlsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoFileFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoFileFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoFileFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoFileFacetMimeTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoFileFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoFileFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoFileFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type VideoFileFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoFileFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoFileFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoFileFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoFileFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type VideoFileFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoFileFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoFileFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoFileFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type VideoFileFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoFileFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type VideoFileFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoFileFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoFileFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type VideoFileOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Autoplay?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Copyright?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisplayControls?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MimeType?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Thumbnail?: InputMaybe<BlobModelOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type VideoFileOutput = {
  __typename?: 'VideoFileOutput';
  autocomplete?: Maybe<VideoFileAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<VideoFileFacet>;
  item?: Maybe<VideoFile>;
  items?: Maybe<Array<Maybe<VideoFile>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type VideoFileOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VideoFileWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Autoplay?: InputMaybe<BoolFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Copyright?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisplayControls?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MimeType?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewImage?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Thumbnail?: InputMaybe<BlobModelWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<VideoFileWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<VideoFileWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<VideoFileWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type VisitorDataHiddenElementBlock = IContent &
  IData & {
    __typename?: 'VisitorDataHiddenElementBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    VisitorDataSources?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

export type VisitorDataHiddenElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type VisitorDataHiddenElementBlockVisitorDataSourcesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type VisitorDataHiddenElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type VisitorDataHiddenElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type VisitorDataHiddenElementBlockAutocomplete = {
  __typename?: 'VisitorDataHiddenElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type VisitorDataHiddenElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VisitorDataHiddenElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VisitorDataHiddenElementBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VisitorDataHiddenElementBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VisitorDataHiddenElementBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VisitorDataHiddenElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VisitorDataHiddenElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VisitorDataHiddenElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VisitorDataHiddenElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VisitorDataHiddenElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VisitorDataHiddenElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VisitorDataHiddenElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VisitorDataHiddenElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VisitorDataHiddenElementBlockFacet = {
  __typename?: 'VisitorDataHiddenElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VisitorDataSources?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type VisitorDataHiddenElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VisitorDataHiddenElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type VisitorDataHiddenElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VisitorDataHiddenElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type VisitorDataHiddenElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VisitorDataHiddenElementBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VisitorDataHiddenElementBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VisitorDataHiddenElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VisitorDataHiddenElementBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VisitorDataHiddenElementBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type VisitorDataHiddenElementBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VisitorDataHiddenElementBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VisitorDataHiddenElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VisitorDataHiddenElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VisitorDataHiddenElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type VisitorDataHiddenElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VisitorDataHiddenElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VisitorDataHiddenElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VisitorDataHiddenElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type VisitorDataHiddenElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VisitorDataHiddenElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type VisitorDataHiddenElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VisitorDataHiddenElementBlockFacetVisitorDataSourcesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VisitorDataHiddenElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VisitorDataHiddenElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type VisitorDataHiddenElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VisitorDataSources?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type VisitorDataHiddenElementBlockOutput = {
  __typename?: 'VisitorDataHiddenElementBlockOutput';
  autocomplete?: Maybe<VisitorDataHiddenElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<VisitorDataHiddenElementBlockFacet>;
  item?: Maybe<VisitorDataHiddenElementBlock>;
  items?: Maybe<Array<Maybe<VisitorDataHiddenElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type VisitorDataHiddenElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VisitorDataHiddenElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VisitorDataSources?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<VisitorDataHiddenElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<VisitorDataHiddenElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<VisitorDataHiddenElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Click thumbs up for marking the article is useful or not. */
export type WasThisHelpfulBlock = IContent &
  IData & {
    __typename?: 'WasThisHelpfulBlock';
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Title?: Maybe<Scalars['String']['output']>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Click thumbs up for marking the article is useful or not. */
export type WasThisHelpfulBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Click thumbs up for marking the article is useful or not. */
export type WasThisHelpfulBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Click thumbs up for marking the article is useful or not. */
export type WasThisHelpfulBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Click thumbs up for marking the article is useful or not. */
export type WasThisHelpfulBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type WasThisHelpfulBlockAutocomplete = {
  __typename?: 'WasThisHelpfulBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type WasThisHelpfulBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type WasThisHelpfulBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type WasThisHelpfulBlockAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type WasThisHelpfulBlockAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type WasThisHelpfulBlockAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type WasThisHelpfulBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type WasThisHelpfulBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type WasThisHelpfulBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type WasThisHelpfulBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type WasThisHelpfulBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type WasThisHelpfulBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type WasThisHelpfulBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type WasThisHelpfulBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type WasThisHelpfulBlockFacet = {
  __typename?: 'WasThisHelpfulBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type WasThisHelpfulBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WasThisHelpfulBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type WasThisHelpfulBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WasThisHelpfulBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type WasThisHelpfulBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WasThisHelpfulBlockFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WasThisHelpfulBlockFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WasThisHelpfulBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WasThisHelpfulBlockFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WasThisHelpfulBlockFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type WasThisHelpfulBlockFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WasThisHelpfulBlockFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WasThisHelpfulBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WasThisHelpfulBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WasThisHelpfulBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type WasThisHelpfulBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WasThisHelpfulBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WasThisHelpfulBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WasThisHelpfulBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type WasThisHelpfulBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WasThisHelpfulBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type WasThisHelpfulBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WasThisHelpfulBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WasThisHelpfulBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WasThisHelpfulBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type WasThisHelpfulBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type WasThisHelpfulBlockOutput = {
  __typename?: 'WasThisHelpfulBlockOutput';
  autocomplete?: Maybe<WasThisHelpfulBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<WasThisHelpfulBlockFacet>;
  item?: Maybe<WasThisHelpfulBlock>;
  items?: Maybe<Array<Maybe<WasThisHelpfulBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type WasThisHelpfulBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WasThisHelpfulBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<WasThisHelpfulBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<WasThisHelpfulBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<WasThisHelpfulBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Used for webp image file type */
export type WebImageMediaData = IContent &
  IData & {
    __typename?: 'WebImageMediaData';
    AltText?: Maybe<Scalars['String']['output']>;
    Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Category?: Maybe<Array<Maybe<CategoryModel>>>;
    Changed?: Maybe<Scalars['Date']['output']>;
    Content?: Maybe<Scalars['String']['output']>;
    ContentLink?: Maybe<ContentModelReference>;
    ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    Created?: Maybe<Scalars['Date']['output']>;
    /** Description of the image */
    Description?: Maybe<Scalars['String']['output']>;
    ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
    IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
    IsExcludedFromSearch?: Maybe<Scalars['Bool']['output']>;
    IsSearchableFromSettings?: Maybe<Scalars['Bool']['output']>;
    Language?: Maybe<ContentLanguageModel>;
    MasterLanguage?: Maybe<ContentLanguageModel>;
    MimeType?: Maybe<Scalars['String']['output']>;
    Name?: Maybe<Scalars['String']['output']>;
    PageImageUrl?: Maybe<Scalars['String']['output']>;
    PagePostingDate?: Maybe<Scalars['Date']['output']>;
    PageSearchHeadline?: Maybe<Scalars['String']['output']>;
    PageShortDescription?: Maybe<Scalars['String']['output']>;
    ParentLink?: Maybe<ContentModelReference>;
    RelativePath?: Maybe<Scalars['String']['output']>;
    RouteSegment?: Maybe<Scalars['String']['output']>;
    Saved?: Maybe<Scalars['Date']['output']>;
    Shortcut?: Maybe<Scalars['String']['output']>;
    SimpleAddress?: Maybe<Scalars['String']['output']>;
    SiteId?: Maybe<Scalars['String']['output']>;
    StartPublish?: Maybe<Scalars['Date']['output']>;
    Status?: Maybe<Scalars['String']['output']>;
    StopPublish?: Maybe<Scalars['Date']['output']>;
    Thumbnail?: Maybe<BlobModel>;
    Url?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use `_link` field instead */
    _children?: Maybe<QueryRef>;
    _concreteType?: Maybe<Scalars['String']['output']>;
    _deleted?: Maybe<Scalars['Bool']['output']>;
    _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    _id?: Maybe<Scalars['String']['output']>;
    _link?: Maybe<QueryRef>;
    _modified?: Maybe<Scalars['Date']['output']>;
    _score?: Maybe<Scalars['Float']['output']>;
    _sortOrder?: Maybe<Scalars['Int']['output']>;
  };

/** Used for webp image file type */
export type WebImageMediaDataAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for webp image file type */
export type WebImageMediaDataContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for webp image file type */
export type WebImageMediaDataDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for webp image file type */
export type WebImageMediaDataNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for webp image file type */
export type WebImageMediaData_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

/** Used for webp image file type */
export type WebImageMediaData_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type WebImageMediaDataAutocomplete = {
  __typename?: 'WebImageMediaDataAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MimeType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PageShortDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Thumbnail?: Maybe<BlobModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type WebImageMediaDataAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type WebImageMediaDataAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type WebImageMediaDataAutocompleteMimeTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type WebImageMediaDataAutocompletePageImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type WebImageMediaDataAutocompletePageSearchHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type WebImageMediaDataAutocompletePageShortDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type WebImageMediaDataAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type WebImageMediaDataAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type WebImageMediaDataAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type WebImageMediaDataAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type WebImageMediaDataAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type WebImageMediaDataAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type WebImageMediaDataAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type WebImageMediaDataAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type WebImageMediaDataFacet = {
  __typename?: 'WebImageMediaDataFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsExcludedFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  IsSearchableFromSettings?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MimeType?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  PagePostingDate?: Maybe<Array<Maybe<DateFacet>>>;
  PageSearchHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  PageShortDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Thumbnail?: Maybe<BlobModelFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};

export type WebImageMediaDataFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WebImageMediaDataFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WebImageMediaDataFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type WebImageMediaDataFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WebImageMediaDataFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WebImageMediaDataFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type WebImageMediaDataFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WebImageMediaDataFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WebImageMediaDataFacetIsExcludedFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WebImageMediaDataFacetIsSearchableFromSettingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WebImageMediaDataFacetMimeTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WebImageMediaDataFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WebImageMediaDataFacetPageImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WebImageMediaDataFacetPagePostingDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type WebImageMediaDataFacetPageSearchHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WebImageMediaDataFacetPageShortDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WebImageMediaDataFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WebImageMediaDataFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WebImageMediaDataFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type WebImageMediaDataFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WebImageMediaDataFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WebImageMediaDataFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WebImageMediaDataFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type WebImageMediaDataFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WebImageMediaDataFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type WebImageMediaDataFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WebImageMediaDataFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WebImageMediaDataFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type WebImageMediaDataOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsExcludedFromSearch?: InputMaybe<OrderBy>;
  IsSearchableFromSettings?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MimeType?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  PageImageUrl?: InputMaybe<OrderBy>;
  PagePostingDate?: InputMaybe<OrderBy>;
  PageSearchHeadline?: InputMaybe<OrderBy>;
  PageShortDescription?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Thumbnail?: InputMaybe<BlobModelOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type WebImageMediaDataOutput = {
  __typename?: 'WebImageMediaDataOutput';
  autocomplete?: Maybe<WebImageMediaDataAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<WebImageMediaDataFacet>;
  item?: Maybe<WebImageMediaData>;
  items?: Maybe<Array<Maybe<WebImageMediaData>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type WebImageMediaDataOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WebImageMediaDataWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsExcludedFromSearch?: InputMaybe<BoolFilterInput>;
  IsSearchableFromSettings?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MimeType?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageImageUrl?: InputMaybe<StringFilterInput>;
  PagePostingDate?: InputMaybe<DateFilterInput>;
  PageSearchHeadline?: InputMaybe<StringFilterInput>;
  PageShortDescription?: InputMaybe<StringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Thumbnail?: InputMaybe<BlobModelWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<WebImageMediaDataWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<WebImageMediaDataWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<WebImageMediaDataWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export enum System_Locales {
  All = 'ALL',
  Neutral = 'NEUTRAL'
}

export type GetAdvisorsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAdvisorsQuery = {
  __typename?: 'Query';
  AdvisorPage?: {
    __typename?: 'AdvisorPageOutput';
    items?: Array<{
      __typename?: 'AdvisorPage';
      _id?: string | null;
      FirstName?: string | null;
      LastName?: string | null;
      Certifications?: string | null;
      Url?: string | null;
      ContactEmail?: string | null;
      Picture?: { __typename?: 'ContentModelReference'; Url?: string | null } | null;
      Topic?: {
        __typename?: 'FilterCategoryModel';
        Categories?: Array<{
          __typename?: 'FilterCategoryItemModel';
          Id?: string | null;
          Title?: string | null;
        } | null> | null;
      } | null;
      PrimaryLocation?: {
        __typename?: 'ContentModelReference';
        Expanded?:
          | { __typename?: 'AboutAuthor' }
          | { __typename?: 'AccordionBlock' }
          | { __typename?: 'AccordionSectionBlock' }
          | { __typename?: 'AdvisorListingBlock' }
          | { __typename?: 'AdvisorPage' }
          | { __typename?: 'AlertBannerBlock' }
          | { __typename?: 'AnchorBlock' }
          | { __typename?: 'AreYouMemberModal' }
          | { __typename?: 'AuthorPage' }
          | { __typename?: 'AutoAffordabilityCalculatorBlock' }
          | { __typename?: 'AutoPaymentCalculatorBlock' }
          | { __typename?: 'AutoRefinanceCalculatorBlock' }
          | { __typename?: 'BlockContentPodExpandCardBlock' }
          | { __typename?: 'BlockContentPodGroupBlock' }
          | { __typename?: 'BlockContentPodIconBlock' }
          | { __typename?: 'BlockContentPodImageBlock' }
          | { __typename?: 'BlogFeaturedPodModuleBlock' }
          | { __typename?: 'BlogListing' }
          | { __typename?: 'BlogPage' }
          | { __typename?: 'BlogSignUpFormBlock' }
          | { __typename?: 'ButtonBlock' }
          | { __typename?: 'CalculatorPage' }
          | { __typename?: 'CaptchaElementBlock' }
          | { __typename?: 'CertificateOfDepositCalculatorBlock' }
          | { __typename?: 'ChoiceElementBlock' }
          | { __typename?: 'CodingFile' }
          | { __typename?: 'ComplexTableBlock' }
          | { __typename?: 'ComplexTableColumnBlock' }
          | { __typename?: 'ComplexTableHeaderBlock' }
          | { __typename?: 'ComplexTableRowBlock' }
          | { __typename?: 'ConsentBannerBlock' }
          | { __typename?: 'ContainerBlock' }
          | { __typename?: 'ContainerWithSideRailBlock' }
          | { __typename?: 'Content' }
          | { __typename?: 'ContentBlock' }
          | { __typename?: 'ContentPanelBlock' }
          | { __typename?: 'ContentPodBlock' }
          | { __typename?: 'ContentPodGroupBlock' }
          | { __typename?: 'ContentPodMultiRateCardBlock' }
          | { __typename?: 'ContentPodMultiRateGroupBlock' }
          | { __typename?: 'CookieHiddenElementBlock' }
          | { __typename?: 'CountrySelectionElementBlock' }
          | { __typename?: 'CurrencyConverterBlock' }
          | { __typename?: 'CustomFormContainerBlock' }
          | { __typename?: 'DocumentMediaData' }
          | { __typename?: 'ErrorPage' }
          | { __typename?: 'ExecutableMediaData' }
          | { __typename?: 'ExitIntentModal' }
          | { __typename?: 'FaqItem' }
          | { __typename?: 'FaqSchemaBlock' }
          | { __typename?: 'FeaturedSearchIconBlock' }
          | { __typename?: 'FiftyThirtyTwentyCalculatorBlock' }
          | { __typename?: 'FileUploadElementBlock' }
          | { __typename?: 'FolderPage' }
          | { __typename?: 'FooterBlock' }
          | { __typename?: 'FooterMenuLinksBlock' }
          | { __typename?: 'FootnoteSectionBlock' }
          | { __typename?: 'FormAssemblyBlock' }
          | { __typename?: 'FormContainerBlock' }
          | { __typename?: 'FormStepBlock' }
          | { __typename?: 'FullWidthVideoBlock' }
          | { __typename?: 'GlobalLabelsBlock' }
          | { __typename?: 'HeaderBlock' }
          | { __typename?: 'HeroBlock' }
          | { __typename?: 'HeroImageBlock' }
          | { __typename?: 'HomeAffordabilityCalculatorBlock' }
          | { __typename?: 'HomeEquityCalculatorBlock' }
          | { __typename?: 'IFrameContainerBlock' }
          | { __typename?: 'IframeCalculatorBlock' }
          | { __typename?: 'ImageChoiceElementBlock' }
          | { __typename?: 'ImageMediaData' }
          | { __typename?: 'InteriorContentPage' }
          | {
              __typename?: 'LocationPage';
              Street?: string | null;
              City?: string | null;
              Zip?: string | null;
              State?: string | null;
              Url?: string | null;
              LocationName?: string | null;
              Latitude?: string | null;
              Longitude?: string | null;
            }
          | { __typename?: 'LocationsListingBlock' }
          | { __typename?: 'LoginModalBlock' }
          | { __typename?: 'LogoImageBlock' }
          | { __typename?: 'MenuItemBlock' }
          | { __typename?: 'MortgagePaymentCalculatorBlock' }
          | { __typename?: 'MortgageRatesQuickQuoteBlock' }
          | { __typename?: 'MortgageRefinanceCalculatorBlock' }
          | { __typename?: 'MultiLogoImageBlock' }
          | { __typename?: 'NavigationColumnBlock' }
          | { __typename?: 'NavigationItemLevel1Block' }
          | { __typename?: 'NavigationItemLevel2Block' }
          | { __typename?: 'NavigationItemLevel3Block' }
          | { __typename?: 'NavigationMenuBlock' }
          | { __typename?: 'NewsListing' }
          | { __typename?: 'NewsPage' }
          | { __typename?: 'NumberElementBlock' }
          | { __typename?: 'OrgSchemaBlock' }
          | { __typename?: 'ParagraphTextElementBlock' }
          | { __typename?: 'PersonSchemaBlock' }
          | { __typename?: 'PredefinedHiddenElementBlock' }
          | { __typename?: 'ProductPage' }
          | { __typename?: 'ProfitPayoutCalculatorBlock' }
          | { __typename?: 'PromoBannerBlock' }
          | { __typename?: 'PromoCalloutBlock' }
          | { __typename?: 'PromoFooterBlock' }
          | { __typename?: 'PromoHeaderBlock' }
          | { __typename?: 'PromoHeroBlock' }
          | { __typename?: 'QuerystringHiddenElementBlock' }
          | { __typename?: 'RangeElementBlock' }
          | { __typename?: 'ReCaptchaServiceElementBlock' }
          | { __typename?: 'RequestAppointmentWithAdvisorBlock' }
          | { __typename?: 'ResetButtonElementBlock' }
          | { __typename?: 'SearchListingBlock' }
          | { __typename?: 'SearchMenuBlock' }
          | { __typename?: 'SelectionElementBlock' }
          | { __typename?: 'SendMyResultsFormBlock' }
          | { __typename?: 'SideBySideVideoBlock' }
          | { __typename?: 'SiderailCtaPodBlock' }
          | { __typename?: 'SignUpToNewsletterFormBlock' }
          | { __typename?: 'SimpleMastheadBlock' }
          | { __typename?: 'SimpleTableBlock' }
          | { __typename?: 'SiteUrlPredefinedHiddenElementBlock' }
          | { __typename?: 'SocialMediaIconBlock' }
          | { __typename?: 'SocialSharingBlock' }
          | { __typename?: 'SpacerBlock' }
          | { __typename?: 'StandardFile' }
          | { __typename?: 'StartPage' }
          | { __typename?: 'SubmitButtonElementBlock' }
          | { __typename?: 'TabContainerBlock' }
          | { __typename?: 'TabItemBlock' }
          | { __typename?: 'TestimonialCardBlock' }
          | { __typename?: 'TestimonialCarouselBlock' }
          | { __typename?: 'TextPanelCtaBlock' }
          | { __typename?: 'TextareaElementBlock' }
          | { __typename?: 'TextboxElementBlock' }
          | { __typename?: 'ThirdPartyIFrameBlock' }
          | { __typename?: 'UrlElementBlock' }
          | { __typename?: 'VectorImageMediaData' }
          | { __typename?: 'VideoContentPanelBlock' }
          | { __typename?: 'VideoFile' }
          | { __typename?: 'VisitorDataHiddenElementBlock' }
          | { __typename?: 'WasThisHelpfulBlock' }
          | { __typename?: 'WebImageMediaData' }
          | null;
      } | null;
      OtherLocationsPages?: Array<{
        __typename?: 'ContentAreaItemModelSearch';
        ContentLink?: {
          __typename?: 'ContentModelReferenceSearch';
          Expanded?:
            | { __typename?: 'AboutAuthor' }
            | { __typename?: 'AccordionBlock' }
            | { __typename?: 'AccordionSectionBlock' }
            | { __typename?: 'AdvisorListingBlock' }
            | { __typename?: 'AdvisorPage' }
            | { __typename?: 'AlertBannerBlock' }
            | { __typename?: 'AnchorBlock' }
            | { __typename?: 'AreYouMemberModal' }
            | { __typename?: 'AuthorPage' }
            | { __typename?: 'AutoAffordabilityCalculatorBlock' }
            | { __typename?: 'AutoPaymentCalculatorBlock' }
            | { __typename?: 'AutoRefinanceCalculatorBlock' }
            | { __typename?: 'BlockContentPodExpandCardBlock' }
            | { __typename?: 'BlockContentPodGroupBlock' }
            | { __typename?: 'BlockContentPodIconBlock' }
            | { __typename?: 'BlockContentPodImageBlock' }
            | { __typename?: 'BlogFeaturedPodModuleBlock' }
            | { __typename?: 'BlogListing' }
            | { __typename?: 'BlogPage' }
            | { __typename?: 'BlogSignUpFormBlock' }
            | { __typename?: 'ButtonBlock' }
            | { __typename?: 'CalculatorPage' }
            | { __typename?: 'CaptchaElementBlock' }
            | { __typename?: 'CertificateOfDepositCalculatorBlock' }
            | { __typename?: 'ChoiceElementBlock' }
            | { __typename?: 'CodingFile' }
            | { __typename?: 'ComplexTableBlock' }
            | { __typename?: 'ComplexTableColumnBlock' }
            | { __typename?: 'ComplexTableHeaderBlock' }
            | { __typename?: 'ComplexTableRowBlock' }
            | { __typename?: 'ConsentBannerBlock' }
            | { __typename?: 'ContainerBlock' }
            | { __typename?: 'ContainerWithSideRailBlock' }
            | { __typename?: 'Content' }
            | { __typename?: 'ContentBlock' }
            | { __typename?: 'ContentPanelBlock' }
            | { __typename?: 'ContentPodBlock' }
            | { __typename?: 'ContentPodGroupBlock' }
            | { __typename?: 'ContentPodMultiRateCardBlock' }
            | { __typename?: 'ContentPodMultiRateGroupBlock' }
            | { __typename?: 'CookieHiddenElementBlock' }
            | { __typename?: 'CountrySelectionElementBlock' }
            | { __typename?: 'CurrencyConverterBlock' }
            | { __typename?: 'CustomFormContainerBlock' }
            | { __typename?: 'DocumentMediaData' }
            | { __typename?: 'ErrorPage' }
            | { __typename?: 'ExecutableMediaData' }
            | { __typename?: 'ExitIntentModal' }
            | { __typename?: 'FaqItem' }
            | { __typename?: 'FaqSchemaBlock' }
            | { __typename?: 'FeaturedSearchIconBlock' }
            | { __typename?: 'FiftyThirtyTwentyCalculatorBlock' }
            | { __typename?: 'FileUploadElementBlock' }
            | { __typename?: 'FolderPage' }
            | { __typename?: 'FooterBlock' }
            | { __typename?: 'FooterMenuLinksBlock' }
            | { __typename?: 'FootnoteSectionBlock' }
            | { __typename?: 'FormAssemblyBlock' }
            | { __typename?: 'FormContainerBlock' }
            | { __typename?: 'FormStepBlock' }
            | { __typename?: 'FullWidthVideoBlock' }
            | { __typename?: 'GlobalLabelsBlock' }
            | { __typename?: 'HeaderBlock' }
            | { __typename?: 'HeroBlock' }
            | { __typename?: 'HeroImageBlock' }
            | { __typename?: 'HomeAffordabilityCalculatorBlock' }
            | { __typename?: 'HomeEquityCalculatorBlock' }
            | { __typename?: 'IFrameContainerBlock' }
            | { __typename?: 'IframeCalculatorBlock' }
            | { __typename?: 'ImageChoiceElementBlock' }
            | { __typename?: 'ImageMediaData' }
            | { __typename?: 'InteriorContentPage' }
            | {
                __typename?: 'LocationPage';
                Street?: string | null;
                City?: string | null;
                Zip?: string | null;
                State?: string | null;
                Url?: string | null;
                LocationName?: string | null;
                Latitude?: string | null;
                Longitude?: string | null;
              }
            | { __typename?: 'LocationsListingBlock' }
            | { __typename?: 'LoginModalBlock' }
            | { __typename?: 'LogoImageBlock' }
            | { __typename?: 'MenuItemBlock' }
            | { __typename?: 'MortgagePaymentCalculatorBlock' }
            | { __typename?: 'MortgageRatesQuickQuoteBlock' }
            | { __typename?: 'MortgageRefinanceCalculatorBlock' }
            | { __typename?: 'MultiLogoImageBlock' }
            | { __typename?: 'NavigationColumnBlock' }
            | { __typename?: 'NavigationItemLevel1Block' }
            | { __typename?: 'NavigationItemLevel2Block' }
            | { __typename?: 'NavigationItemLevel3Block' }
            | { __typename?: 'NavigationMenuBlock' }
            | { __typename?: 'NewsListing' }
            | { __typename?: 'NewsPage' }
            | { __typename?: 'NumberElementBlock' }
            | { __typename?: 'OrgSchemaBlock' }
            | { __typename?: 'ParagraphTextElementBlock' }
            | { __typename?: 'PersonSchemaBlock' }
            | { __typename?: 'PredefinedHiddenElementBlock' }
            | { __typename?: 'ProductPage' }
            | { __typename?: 'ProfitPayoutCalculatorBlock' }
            | { __typename?: 'PromoBannerBlock' }
            | { __typename?: 'PromoCalloutBlock' }
            | { __typename?: 'PromoFooterBlock' }
            | { __typename?: 'PromoHeaderBlock' }
            | { __typename?: 'PromoHeroBlock' }
            | { __typename?: 'QuerystringHiddenElementBlock' }
            | { __typename?: 'RangeElementBlock' }
            | { __typename?: 'ReCaptchaServiceElementBlock' }
            | { __typename?: 'RequestAppointmentWithAdvisorBlock' }
            | { __typename?: 'ResetButtonElementBlock' }
            | { __typename?: 'SearchListingBlock' }
            | { __typename?: 'SearchMenuBlock' }
            | { __typename?: 'SelectionElementBlock' }
            | { __typename?: 'SendMyResultsFormBlock' }
            | { __typename?: 'SideBySideVideoBlock' }
            | { __typename?: 'SiderailCtaPodBlock' }
            | { __typename?: 'SignUpToNewsletterFormBlock' }
            | { __typename?: 'SimpleMastheadBlock' }
            | { __typename?: 'SimpleTableBlock' }
            | { __typename?: 'SiteUrlPredefinedHiddenElementBlock' }
            | { __typename?: 'SocialMediaIconBlock' }
            | { __typename?: 'SocialSharingBlock' }
            | { __typename?: 'SpacerBlock' }
            | { __typename?: 'StandardFile' }
            | { __typename?: 'StartPage' }
            | { __typename?: 'SubmitButtonElementBlock' }
            | { __typename?: 'TabContainerBlock' }
            | { __typename?: 'TabItemBlock' }
            | { __typename?: 'TestimonialCardBlock' }
            | { __typename?: 'TestimonialCarouselBlock' }
            | { __typename?: 'TextPanelCtaBlock' }
            | { __typename?: 'TextareaElementBlock' }
            | { __typename?: 'TextboxElementBlock' }
            | { __typename?: 'ThirdPartyIFrameBlock' }
            | { __typename?: 'UrlElementBlock' }
            | { __typename?: 'VectorImageMediaData' }
            | { __typename?: 'VideoContentPanelBlock' }
            | { __typename?: 'VideoFile' }
            | { __typename?: 'VisitorDataHiddenElementBlock' }
            | { __typename?: 'WasThisHelpfulBlock' }
            | { __typename?: 'WebImageMediaData' }
            | null;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type GetBlogsListQueryQueryVariables = Exact<{
  count?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  topicId?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >;
  OrderByDate?: InputMaybe<OrderBy>;
  includefacets?: Scalars['Boolean']['input'];
}>;

export type GetBlogsListQueryQuery = {
  __typename?: 'Query';
  BlogPage?: {
    __typename?: 'BlogPageOutput';
    total?: number | null;
    facets?: {
      __typename?: 'BlogPageFacet';
      Topic?: {
        __typename?: 'FilterCategoryModelFacet';
        Categories?: {
          __typename?: 'FilterCategoryItemModelFacet';
          Title?: Array<{ __typename?: 'StringFacet'; name?: string | null } | null> | null;
        } | null;
      } | null;
    } | null;
    items?: Array<{
      __typename?: 'BlogPage';
      Headline?: string | null;
      PostingDate?: any | null;
      ShortDescription?: string | null;
      _id?: string | null;
      Url?: string | null;
      Topic?: {
        __typename?: 'FilterCategoryModel';
        Categories?: Array<{
          __typename?: 'FilterCategoryItemModel';
          Title?: string | null;
          Id?: string | null;
        } | null> | null;
      } | null;
      FeaturedImage?: {
        __typename?: 'ContentModelReference';
        Id?: number | null;
        Url?: string | null;
      } | null;
      AuthorLink?: {
        __typename?: 'LinkItemNode';
        Href?: string | null;
        Title?: string | null;
        Target?: string | null;
        Text?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetNewsListQueryQueryVariables = Exact<{
  count?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  topicId?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >;
  OrderByDate?: InputMaybe<OrderBy>;
  includefacets?: Scalars['Boolean']['input'];
}>;

export type GetNewsListQueryQuery = {
  __typename?: 'Query';
  NewsPage?: {
    __typename?: 'NewsPageOutput';
    total?: number | null;
    facets?: {
      __typename?: 'NewsPageFacet';
      Topic?: {
        __typename?: 'FilterCategoryModelFacet';
        Categories?: {
          __typename?: 'FilterCategoryItemModelFacet';
          Title?: Array<{ __typename?: 'StringFacet'; name?: string | null } | null> | null;
        } | null;
      } | null;
    } | null;
    items?: Array<{
      __typename?: 'NewsPage';
      Headline?: string | null;
      PostingDate?: any | null;
      ShortDescription?: string | null;
      _id?: string | null;
      Url?: string | null;
      Topic?: {
        __typename?: 'FilterCategoryModel';
        Categories?: Array<{
          __typename?: 'FilterCategoryItemModel';
          Title?: string | null;
          Id?: string | null;
        } | null> | null;
      } | null;
      FeaturedImage?: {
        __typename?: 'ContentModelReference';
        Url?: string | null;
        Id?: number | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetRecentBlogsQueryVariables = Exact<{
  numberOfResults?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetRecentBlogsQuery = {
  __typename?: 'Query';
  BlogPage?: {
    __typename?: 'BlogPageOutput';
    total?: number | null;
    items?: Array<{
      __typename?: 'BlogPage';
      _id?: string | null;
      Headline?: string | null;
      PostingDate?: any | null;
      Url?: string | null;
      FeaturedImage?: { __typename?: 'ContentModelReference'; Url?: string | null } | null;
    } | null> | null;
  } | null;
};

export type GetSearchFiltersQueryQueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  searchTermBoost?: InputMaybe<Scalars['String']['input']>;
  contentUidBoost?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >;
}>;

export type GetSearchFiltersQueryQuery = {
  __typename?: 'Query';
  BlogPage?: {
    __typename?: 'BlogPageOutput';
    total?: number | null;
    facets?: {
      __typename?: 'BlogPageFacet';
      PagePostingDate?: Array<{
        __typename?: 'DateFacet';
        count?: number | null;
        name?: string | null;
      } | null> | null;
    } | null;
  } | null;
  FaqItem?: { __typename?: 'FaqItemOutput'; total?: number | null } | null;
  InteriorContentPage?: { __typename?: 'InteriorContentPageOutput'; total?: number | null } | null;
  CalculatorPage?: { __typename?: 'CalculatorPageOutput'; total?: number | null } | null;
  NewsPage?: {
    __typename?: 'NewsPageOutput';
    total?: number | null;
    facets?: {
      __typename?: 'NewsPageFacet';
      PagePostingDate?: Array<{
        __typename?: 'DateFacet';
        count?: number | null;
        name?: string | null;
      } | null> | null;
    } | null;
  } | null;
  ProductPage?: { __typename?: 'ProductPageOutput'; total?: number | null } | null;
  AdvisorPage?: { __typename?: 'AdvisorPageOutput'; total?: number | null } | null;
};

export type GetSearchListingQueryQueryVariables = Exact<{
  type?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >;
  orderBy?: InputMaybe<ContentOrderByInput>;
  numberOfResults?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  searchTermBoost?: InputMaybe<Scalars['String']['input']>;
  maxDate?: InputMaybe<Scalars['Date']['input']>;
  contentUidBoost?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >;
}>;

export type GetSearchListingQueryQuery = {
  __typename?: 'Query';
  Content?: {
    __typename?: 'ContentOutput';
    total?: number | null;
    items?: Array<
      | {
          __typename?: 'AboutAuthor';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'AccordionBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'AccordionSectionBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'AdvisorListingBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'AdvisorPage';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'AlertBannerBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'AnchorBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'AreYouMemberModal';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'AuthorPage';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'AutoAffordabilityCalculatorBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'AutoPaymentCalculatorBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'AutoRefinanceCalculatorBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'BlockContentPodExpandCardBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'BlockContentPodGroupBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'BlockContentPodIconBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'BlockContentPodImageBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'BlogFeaturedPodModuleBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'BlogListing';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'BlogPage';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'BlogSignUpFormBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'ButtonBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'CalculatorPage';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'CaptchaElementBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'CertificateOfDepositCalculatorBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'ChoiceElementBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'CodingFile';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'ComplexTableBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'ComplexTableColumnBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'ComplexTableHeaderBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'ComplexTableRowBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'ConsentBannerBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'ContainerBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'ContainerWithSideRailBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'Content';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'ContentBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'ContentPanelBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'ContentPodBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'ContentPodGroupBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'ContentPodMultiRateCardBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'ContentPodMultiRateGroupBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'CookieHiddenElementBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'CountrySelectionElementBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'CurrencyConverterBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'CustomFormContainerBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'DocumentMediaData';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'ErrorPage';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'ExecutableMediaData';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'ExitIntentModal';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'FaqItem';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'FaqSchemaBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'FeaturedSearchIconBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'FiftyThirtyTwentyCalculatorBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'FileUploadElementBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'FolderPage';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'FooterBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'FooterMenuLinksBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'FootnoteSectionBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'FormAssemblyBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'FormContainerBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'FormStepBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'FullWidthVideoBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'GlobalLabelsBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'HeaderBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'HeroBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'HeroImageBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'HomeAffordabilityCalculatorBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'HomeEquityCalculatorBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'IFrameContainerBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'IframeCalculatorBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'ImageChoiceElementBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'ImageMediaData';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'InteriorContentPage';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'LocationPage';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'LocationsListingBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'LoginModalBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'LogoImageBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'MenuItemBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'MortgagePaymentCalculatorBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'MortgageRatesQuickQuoteBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'MortgageRefinanceCalculatorBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'MultiLogoImageBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'NavigationColumnBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'NavigationItemLevel1Block';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'NavigationItemLevel2Block';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'NavigationItemLevel3Block';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'NavigationMenuBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'NewsListing';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'NewsPage';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'NumberElementBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'OrgSchemaBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'ParagraphTextElementBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'PersonSchemaBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'PredefinedHiddenElementBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'ProductPage';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'ProfitPayoutCalculatorBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'PromoBannerBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'PromoCalloutBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'PromoFooterBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'PromoHeaderBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'PromoHeroBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'QuerystringHiddenElementBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'RangeElementBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'ReCaptchaServiceElementBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'RequestAppointmentWithAdvisorBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'ResetButtonElementBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'SearchListingBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'SearchMenuBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'SelectionElementBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'SendMyResultsFormBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'SideBySideVideoBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'SiderailCtaPodBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'SignUpToNewsletterFormBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'SimpleMastheadBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'SimpleTableBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'SiteUrlPredefinedHiddenElementBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'SocialMediaIconBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'SocialSharingBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'SpacerBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'StandardFile';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'StartPage';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'SubmitButtonElementBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'TabContainerBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'TabItemBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'TestimonialCardBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'TestimonialCarouselBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'TextPanelCtaBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'TextareaElementBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'TextboxElementBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'ThirdPartyIFrameBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'UrlElementBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'VectorImageMediaData';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'VideoContentPanelBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'VideoFile';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'VisitorDataHiddenElementBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'WasThisHelpfulBlock';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | {
          __typename?: 'WebImageMediaData';
          _id?: string | null;
          Name?: string | null;
          Url?: string | null;
          ContentType?: Array<string | null> | null;
          PageImageUrl?: string | null;
          PagePostingDate?: any | null;
          PageSearchHeadline?: string | null;
          PageShortDescription?: string | null;
          ContentLink?: { __typename?: 'ContentModelReference'; GuidValue?: string | null } | null;
        }
      | null
    > | null;
  } | null;
};

export type GetSearchSuggestionsQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
  numberOfResults?: Scalars['Int']['input'];
}>;

export type GetSearchSuggestionsQuery = {
  __typename?: 'Query';
  Content?: {
    __typename?: 'ContentOutput';
    autocomplete?: {
      __typename?: 'ContentAutocomplete';
      PageSearchHeadline?: Array<string | null> | null;
    } | null;
  } | null;
};

export type GetTopicsQueryVariables = Exact<{ [key: string]: never }>;

export type GetTopicsQuery = {
  __typename?: 'Query';
  AdvisorPage?: {
    __typename?: 'AdvisorPageOutput';
    facets?: {
      __typename?: 'AdvisorPageFacet';
      Topic?: {
        __typename?: 'FilterCategoryModelFacet';
        Categories?: {
          __typename?: 'FilterCategoryItemModelFacet';
          IdTitle?: Array<{ __typename?: 'StringFacet'; name?: string | null } | null> | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export const GetAdvisorsDocument = `
    query GetAdvisors {
  AdvisorPage(locale: en, orderBy: {LastName: ASC}) {
    items {
      _id
      FirstName
      LastName
      Picture {
        Url
      }
      Certifications
      Url
      ContactEmail
      Topic {
        Categories {
          Id
          Title
        }
      }
      PrimaryLocation {
        Expanded {
          ... on LocationPage {
            Street
            City
            Zip
            State
            Url
            LocationName
            Latitude
            Longitude
          }
        }
      }
      OtherLocationsPages {
        ContentLink {
          Expanded {
            ... on LocationPage {
              Street
              City
              Zip
              State
              Url
              LocationName
              Latitude
              Longitude
            }
          }
        }
      }
    }
  }
}
    `;

export const useGetAdvisorsQuery = <TData = GetAdvisorsQuery, TError = unknown>(
  variables?: GetAdvisorsQueryVariables,
  options?: Omit<UseQueryOptions<GetAdvisorsQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetAdvisorsQuery, TError, TData>['queryKey'];
  }
) => {
  return useQuery<GetAdvisorsQuery, TError, TData>({
    queryKey: variables === undefined ? ['GetAdvisors'] : ['GetAdvisors', variables],
    queryFn: fetcher<GetAdvisorsQuery, GetAdvisorsQueryVariables>(GetAdvisorsDocument, variables),
    ...options
  });
};

export const GetBlogsListQueryDocument = `
    query GetBlogsListQuery($count: Int, $skip: Int, $topicId: [String], $OrderByDate: OrderBy = DESC, $includefacets: Boolean! = true) {
  BlogPage(
    limit: $count
    skip: $skip
    where: {Topic: {Categories: {Title: {in: $topicId}}}}
    orderBy: {PostingDate: $OrderByDate}
  ) {
    total
    facets @include(if: $includefacets) {
      Topic {
        Categories {
          Title(limit: 50) {
            name
          }
        }
      }
    }
    items {
      Headline
      PostingDate
      ShortDescription
      Topic {
        Categories {
          Title
          Id
        }
      }
      FeaturedImage {
        Id
        Url
      }
      _id
      Url
      AuthorLink {
        Href
        Title
        Target
        Text
      }
    }
  }
}
    `;

export const useGetBlogsListQueryQuery = <TData = GetBlogsListQueryQuery, TError = unknown>(
  variables?: GetBlogsListQueryQueryVariables,
  options?: Omit<UseQueryOptions<GetBlogsListQueryQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetBlogsListQueryQuery, TError, TData>['queryKey'];
  }
) => {
  return useQuery<GetBlogsListQueryQuery, TError, TData>({
    queryKey: variables === undefined ? ['GetBlogsListQuery'] : ['GetBlogsListQuery', variables],
    queryFn: fetcher<GetBlogsListQueryQuery, GetBlogsListQueryQueryVariables>(
      GetBlogsListQueryDocument,
      variables
    ),
    ...options
  });
};

export const GetNewsListQueryDocument = `
    query GetNewsListQuery($count: Int, $skip: Int, $topicId: [String], $OrderByDate: OrderBy = DESC, $includefacets: Boolean! = true) {
  NewsPage(
    limit: $count
    skip: $skip
    where: {Topic: {Categories: {Title: {in: $topicId}}}}
    orderBy: {PostingDate: $OrderByDate}
  ) {
    total
    facets @include(if: $includefacets) {
      Topic {
        Categories {
          Title(limit: 50) {
            name
          }
        }
      }
    }
    items @skip(if: $includefacets) {
      Headline
      PostingDate
      ShortDescription
      Topic {
        Categories {
          Title
          Id
        }
      }
      FeaturedImage {
        Url
        Id
      }
      _id
      Url
    }
  }
}
    `;

export const useGetNewsListQueryQuery = <TData = GetNewsListQueryQuery, TError = unknown>(
  variables?: GetNewsListQueryQueryVariables,
  options?: Omit<UseQueryOptions<GetNewsListQueryQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetNewsListQueryQuery, TError, TData>['queryKey'];
  }
) => {
  return useQuery<GetNewsListQueryQuery, TError, TData>({
    queryKey: variables === undefined ? ['GetNewsListQuery'] : ['GetNewsListQuery', variables],
    queryFn: fetcher<GetNewsListQueryQuery, GetNewsListQueryQueryVariables>(
      GetNewsListQueryDocument,
      variables
    ),
    ...options
  });
};

export const GetRecentBlogsDocument = `
    query GetRecentBlogs($numberOfResults: Int) {
  BlogPage(locale: en, limit: $numberOfResults, orderBy: {PostingDate: DESC}) {
    total
    items {
      _id
      Headline
      PostingDate
      Url
      FeaturedImage {
        Url
      }
    }
  }
}
    `;

export const useGetRecentBlogsQuery = <TData = GetRecentBlogsQuery, TError = unknown>(
  variables?: GetRecentBlogsQueryVariables,
  options?: Omit<UseQueryOptions<GetRecentBlogsQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetRecentBlogsQuery, TError, TData>['queryKey'];
  }
) => {
  return useQuery<GetRecentBlogsQuery, TError, TData>({
    queryKey: variables === undefined ? ['GetRecentBlogs'] : ['GetRecentBlogs', variables],
    queryFn: fetcher<GetRecentBlogsQuery, GetRecentBlogsQueryVariables>(
      GetRecentBlogsDocument,
      variables
    ),
    ...options
  });
};

export const GetSearchFiltersQueryDocument = `
    query GetSearchFiltersQuery($searchTerm: String, $searchTermBoost: String, $contentUidBoost: [String]) {
  BlogPage(
    locale: en
    where: {_and: [{_or: [{IsSearchableFromSettings: {eq: true}}, {ContentLink: {GuidValue: {in: $contentUidBoost}}}]}, {IsExcludedFromSearch: {eq: false}}, {PageSearchHeadline: {exist: true}}, {_or: [{PageSearchHeadline: {like: $searchTermBoost, boost: 1000, fuzzy: true}}, {PageShortDescription: {like: $searchTermBoost, boost: 100, fuzzy: true}}, {ContentLink: {GuidValue: {in: $contentUidBoost, boost: 10000}}}, {_fulltext: {match: $searchTerm, fuzzy: true}}]}]}
  ) {
    total
    facets {
      PagePostingDate {
        count
        name
      }
    }
  }
  FaqItem(
    locale: en
    where: {_and: [{_or: [{IsSearchableFromSettings: {eq: true}}, {ContentLink: {GuidValue: {in: $contentUidBoost}}}]}, {IsExcludedFromSearch: {eq: false}}, {PageSearchHeadline: {exist: true}}, {_or: [{PageSearchHeadline: {like: $searchTermBoost, boost: 1000, fuzzy: true}}, {PageShortDescription: {like: $searchTermBoost, boost: 100, fuzzy: true}}, {ContentLink: {GuidValue: {in: $contentUidBoost, boost: 10000}}}, {_fulltext: {match: $searchTerm, fuzzy: true}}]}]}
  ) {
    total
  }
  InteriorContentPage(
    locale: en
    where: {_and: [{_or: [{IsSearchableFromSettings: {eq: true}}, {ContentLink: {GuidValue: {in: $contentUidBoost}}}]}, {IsExcludedFromSearch: {eq: false}}, {PageSearchHeadline: {exist: true}}, {_or: [{PageSearchHeadline: {like: $searchTermBoost, boost: 1000, fuzzy: true}}, {PageShortDescription: {like: $searchTermBoost, boost: 100, fuzzy: true}}, {ContentLink: {GuidValue: {in: $contentUidBoost, boost: 10000}}}, {_fulltext: {match: $searchTerm, fuzzy: true}}]}]}
  ) {
    total
  }
  CalculatorPage(
    locale: en
    where: {_and: [{_or: [{IsSearchableFromSettings: {eq: true}}, {ContentLink: {GuidValue: {in: $contentUidBoost}}}]}, {IsExcludedFromSearch: {eq: false}}, {PageSearchHeadline: {exist: true}}, {_or: [{PageSearchHeadline: {like: $searchTermBoost, boost: 1000, fuzzy: true}}, {PageShortDescription: {like: $searchTermBoost, boost: 100, fuzzy: true}}, {ContentLink: {GuidValue: {in: $contentUidBoost, boost: 10000}}}, {_fulltext: {match: $searchTerm, fuzzy: true}}]}]}
  ) {
    total
  }
  NewsPage(
    locale: en
    where: {_and: [{_or: [{IsSearchableFromSettings: {eq: true}}, {ContentLink: {GuidValue: {in: $contentUidBoost}}}]}, {IsExcludedFromSearch: {eq: false}}, {PageSearchHeadline: {exist: true}}, {_or: [{PageSearchHeadline: {like: $searchTermBoost, boost: 1000, fuzzy: true}}, {PageShortDescription: {like: $searchTermBoost, boost: 100, fuzzy: true}}, {ContentLink: {GuidValue: {in: $contentUidBoost, boost: 10000}}}, {_fulltext: {match: $searchTerm, fuzzy: true}}]}]}
  ) {
    total
    facets {
      PagePostingDate {
        count
        name
      }
    }
  }
  ProductPage(
    locale: en
    where: {_and: [{_or: [{IsSearchableFromSettings: {eq: true}}, {ContentLink: {GuidValue: {in: $contentUidBoost}}}]}, {IsExcludedFromSearch: {eq: false}}, {PageSearchHeadline: {exist: true}}, {_or: [{PageSearchHeadline: {like: $searchTermBoost, boost: 1000, fuzzy: true}}, {PageShortDescription: {like: $searchTermBoost, boost: 100, fuzzy: true}}, {ContentLink: {GuidValue: {in: $contentUidBoost, boost: 10000}}}, {_fulltext: {match: $searchTerm, fuzzy: true}}]}]}
  ) {
    total
  }
  AdvisorPage(
    locale: en
    where: {_and: [{_or: [{IsSearchableFromSettings: {eq: true}}, {ContentLink: {GuidValue: {in: $contentUidBoost}}}]}, {IsExcludedFromSearch: {eq: false}}, {PageSearchHeadline: {exist: true}}, {_or: [{PageSearchHeadline: {like: $searchTermBoost, boost: 1000, fuzzy: true}}, {PageShortDescription: {like: $searchTermBoost, boost: 100, fuzzy: true}}, {ContentLink: {GuidValue: {in: $contentUidBoost, boost: 10000}}}, {_fulltext: {match: $searchTerm, fuzzy: true}}]}]}
  ) {
    total
  }
}
    `;

export const useGetSearchFiltersQueryQuery = <TData = GetSearchFiltersQueryQuery, TError = unknown>(
  variables?: GetSearchFiltersQueryQueryVariables,
  options?: Omit<UseQueryOptions<GetSearchFiltersQueryQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetSearchFiltersQueryQuery, TError, TData>['queryKey'];
  }
) => {
  return useQuery<GetSearchFiltersQueryQuery, TError, TData>({
    queryKey:
      variables === undefined ? ['GetSearchFiltersQuery'] : ['GetSearchFiltersQuery', variables],
    queryFn: fetcher<GetSearchFiltersQueryQuery, GetSearchFiltersQueryQueryVariables>(
      GetSearchFiltersQueryDocument,
      variables
    ),
    ...options
  });
};

export const GetSearchListingQueryDocument = `
    query GetSearchListingQuery($type: [String], $orderBy: ContentOrderByInput, $numberOfResults: Int, $skip: Int, $searchTerm: String, $searchTermBoost: String, $maxDate: Date, $contentUidBoost: [String]) {
  Content(
    locale: en
    limit: $numberOfResults
    skip: $skip
    orderBy: $orderBy
    where: {_and: [{_or: [{IsSearchableFromSettings: {eq: true}}, {ContentLink: {GuidValue: {in: $contentUidBoost}}}]}, {IsExcludedFromSearch: {eq: false}}, {ContentType: {in: $type}}, {PageSearchHeadline: {exist: true}}, {_or: [{PageSearchHeadline: {like: $searchTermBoost, boost: 1000, fuzzy: true}}, {PageShortDescription: {like: $searchTermBoost, boost: 100, fuzzy: true}}, {ContentLink: {GuidValue: {in: $contentUidBoost, boost: 10000}}}, {_fulltext: {match: $searchTerm, fuzzy: true}}]}, {PagePostingDate: {lte: $maxDate}}, {ContentType: {in: ["BlogPage", "FaqItem", "InteriorContentPage", "CalculatorPage", "NewsPage", "ProductPage", "AdvisorPage"]}}]}
  ) {
    total
    items {
      _id
      Name
      Url
      ContentType
      PageImageUrl
      PagePostingDate
      PageSearchHeadline
      PageShortDescription
      ContentLink {
        GuidValue
      }
    }
  }
}
    `;

export const useGetSearchListingQueryQuery = <TData = GetSearchListingQueryQuery, TError = unknown>(
  variables?: GetSearchListingQueryQueryVariables,
  options?: Omit<UseQueryOptions<GetSearchListingQueryQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetSearchListingQueryQuery, TError, TData>['queryKey'];
  }
) => {
  return useQuery<GetSearchListingQueryQuery, TError, TData>({
    queryKey:
      variables === undefined ? ['GetSearchListingQuery'] : ['GetSearchListingQuery', variables],
    queryFn: fetcher<GetSearchListingQueryQuery, GetSearchListingQueryQueryVariables>(
      GetSearchListingQueryDocument,
      variables
    ),
    ...options
  });
};

export const GetSearchSuggestionsDocument = `
    query GetSearchSuggestions($searchTerm: String!, $numberOfResults: Int! = 3) {
  Content(limit: 0) {
    autocomplete {
      PageSearchHeadline(value: $searchTerm, limit: $numberOfResults)
    }
  }
}
    `;

export const useGetSearchSuggestionsQuery = <TData = GetSearchSuggestionsQuery, TError = unknown>(
  variables: GetSearchSuggestionsQueryVariables,
  options?: Omit<UseQueryOptions<GetSearchSuggestionsQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetSearchSuggestionsQuery, TError, TData>['queryKey'];
  }
) => {
  return useQuery<GetSearchSuggestionsQuery, TError, TData>({
    queryKey: ['GetSearchSuggestions', variables],
    queryFn: fetcher<GetSearchSuggestionsQuery, GetSearchSuggestionsQueryVariables>(
      GetSearchSuggestionsDocument,
      variables
    ),
    ...options
  });
};

export const GetTopicsDocument = `
    query GetTopics {
  AdvisorPage {
    facets {
      Topic {
        Categories {
          IdTitle {
            name
          }
        }
      }
    }
  }
}
    `;

export const useGetTopicsQuery = <TData = GetTopicsQuery, TError = unknown>(
  variables?: GetTopicsQueryVariables,
  options?: Omit<UseQueryOptions<GetTopicsQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetTopicsQuery, TError, TData>['queryKey'];
  }
) => {
  return useQuery<GetTopicsQuery, TError, TData>({
    queryKey: variables === undefined ? ['GetTopics'] : ['GetTopics', variables],
    queryFn: fetcher<GetTopicsQuery, GetTopicsQueryVariables>(GetTopicsDocument, variables),
    ...options
  });
};
